"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('../site/global');

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuToggle: $(".menu-toggle"),
				mainNavigation: $(".main-navigation")
			},

			vars: {
				arrowDownHTML: "<i class='icon-angle-down' aria-hidden='true'></i>",
				arrowRightHTML: "<i class='icon-angle-right' aria-hidden='true'></i>",
				arrowLefttHTML: "<i class='icon-angle-left' aria-hidden='true'></i>",
				selectors: {
					mainMenuWrapper: '.logo-menu-wrapper',
					triggerMenu: ".menu-toggle, .menu-toggle span",
					navItemsWithChildren: 'li.menu-item-has-children'
				},
				menuOpened: false
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				_this = this;
				_this.setup();
				_this.bind();
			},

			toggle: function toggle(e, close) {

				if (typeof e !== 'undefined') e.preventDefault();

				if (close) {

					Global.$dom.body.removeClass('menu-opened');
					Global.functions.enableScroll();
					_this.$dom.mainNavigation.attr('area-expanded', 'false');
					_this.vars.menuOpened = false;

					return false;
				}

				_this.$dom.mainNavigation.attr('area-expanded', function (index, attr) {
					return attr === 'true' ? 'false' : 'true';
				});

				_this.vars.menuOpened = !_this.vars.menuOpened;

				if (_this.vars.menuOpened) Global.functions.disableScroll();else Global.functions.enableScroll();

				Global.$dom.body.toggleClass('menu-opened');
			},

			bind: function bind() {

				_this.$dom.menuToggle.on('click', _this.toggle);

				// Close the menu when we press escape button
				Global.functions.escKey(function () {
					_this.toggle(undefined, true);
				});

				// Close the menu when we click outside the container
				Global.functions.clickOutsideContainer(_this.vars.selectors.mainMenuWrapper, _this.$dom.mainNavigation, _this.vars.selectors.triggerMenu, function () {
					_this.toggle(undefined, true);
				});

				Global.$dom.window.on('resize', Global.functions.throttle(function () {
					_this.setup();
					_this.toggleSubmenuArrows();
				}, 200));
			},

			setup: function setup() {
				//No menu present on the website
				if (!_this.$dom.mainNavigation.length) return;

				_this.$dom.mainNavigation.attr('area-expanded', 'false');

				_this.toggleSubmenuArrows();
			},

			toggleSubmenuArrows: function toggleSubmenuArrows() {

				if (Global.device.isPortable === false) {
					$('.sub-menu').removeAttr('style');
					_this.toggle(undefined, true);
				}

				_this.$dom.mainNavigation.find(_this.vars.selectors.navItemsWithChildren).each(function () {

					var $parent = this;
					var $arrow = void 0;

					if ($(this).find(' > a').has('.arrow-toggle').length === 0) {

						if ($(this).parent().parent().is('div')) {
							$arrow = $("<span class='arrow-toggle'>" + _this.vars.arrowDownHTML + "</span>");
						} else {
							$arrow = $("<span class='arrow-toggle'>" + _this.vars.arrowRightHTML + "</span>");
						}

						$(this).find('> a').append($arrow);
					} else {
						$arrow = $(this).find('.arrow-toggle');
					}

					if (Global.device.isPortable) {

						$arrow.html(_this.vars.arrowDownHTML);

						$(this).find('> a').unbind('click').on('click', function (e) {

							var attr = $(this).attr('href').trim();

							if (attr === '#' || $(e.target).is($arrow) || $(e.target).is($('i'))) {

								e.preventDefault();

								if (Global.device.isPortable) {
									$($parent).toggleClass("sub-menu-open");
									$($parent).find('> .sub-menu').slideToggle(400);
									$arrow.find('i').toggleClass('icon-angle-up icon-angle-down');
								}
							}
						});
					} else {
						if ($(this).parent().parent().is('div')) {
							$arrow.html(_this.vars.arrowDownHTML);
						} else {
							$arrow.html(_this.vars.arrowRightHTML);
						}
					}
				});
			}

		};
	}, { "../site/global": 9 }], 2: [function (require, module, exports) {
		'use strict';

		$ = require('jquery');

		var Navigation = require('./core/navigation');
		var example = require('./site/example');
		var imgtosvg = require('./site/imgtosvg');
		var regions = require('./site/regions');
		var stickyHeader = require('./site/stickyHeader');
		var slickSlider = require('./site/slick');
		var shareLinks = require('./site/share-links');
		var scrollToForm = require('./site/scrolltoform');
		var googleMap = require('./site/map');
		var ProductFilters = require('./site/productfilters');
		var Select2 = require('./site/select2');
		var CoursesCalendar = require('./site/courses-calendar');
		var Accordion = require('./site/accordion');
		var InputNumber = require('./site/input-number');
		var AgeGate = require('./site/age-gate');
		var Featherlight = require('./site/featherlight');
		var EqualHeight = require('./site/equalheight');

		jQuery(function () {

			Navigation.init();

			imgtosvg.init();

			regions.init();

			stickyHeader.init();

			slickSlider.init();

			shareLinks.init();

			scrollToForm.init();

			googleMap.init();

			ProductFilters.init();

			Select2.init();

			CoursesCalendar.init();

			Accordion.init();

			InputNumber.init();

			AgeGate.init();

			Featherlight.init();

			EqualHeight.init();
		});
	}, { "./core/navigation": 1, "./site/accordion": 3, "./site/age-gate": 4, "./site/courses-calendar": 5, "./site/equalheight": 6, "./site/example": 7, "./site/featherlight": 8, "./site/imgtosvg": 10, "./site/input-number": 11, "./site/map": 12, "./site/productfilters": 13, "./site/regions": 14, "./site/scrolltoform": 15, "./site/select2": 16, "./site/share-links": 17, "./site/slick": 18, "./site/stickyHeader": 19, "jquery": 23 }], 3: [function (require, module, exports) {
		"use strict";

		/**  
   * 1. Add [ "select2": "^4.0.8" ], to package.json
   * 2. npm install
   * 3. Import scss file in assets/scss/plugins/select2.scss => @import '../../../node_modules/select2/dist/css/select2.min';
   * 4. Add require("select2")($);
   * 5. Initialize select2
   * 
  */

		require("select2")($);

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				title: $('.accordion-title'),
				content: $('.accordion-content')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				if (_this) {

					_this.$dom.title.on('click', function (e) {
						var $this = $(this);

						if ($this.hasClass('open')) {
							_this.$dom.title.removeClass('open');
							_this.$dom.content.slideUp(300);
						} else {
							_this.$dom.title.removeClass('open');
							_this.$dom.content.slideUp(300);
							$this.addClass('open');
							$this.next().slideDown(300);
						}
					});
				}
			}
		};
	}, { "select2": 24 }], 4: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				body: $('body'),
				checkbox: $('.checkbox-wrap label'),
				// video: $('.age-gate-video video')[0],
				ageGate: $('.age-gate-wrap')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {

					_this.$dom.checkbox.on('click', function (e) {
						_this.$dom.body.addClass('removing-age-gate');
						// setTimeout(function () {
						//     _this.$dom.video.play();
						// }, 500);

						setTimeout(function () {
							_this.$dom.body.removeClass('age-gate-active');
						}, 1200);

						setTimeout(function () {

							$.ajax({
								url: theme.ajaxurl,
								data: {
									action: 'remove_age_gate'
								},
								type: 'POST',
								success: function success(data) {
									_this.$dom.ageGate.remove();
								}
							});
						}, 2000);
					});
				}
			}

		};
	}, {}], 5: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				course: $('.course-calendar-value-row'),
				openForm: $('.open-form'),
				closeForm: $('.close-form'),
				coursesForm: $('.course-form-wrap'),
				courseFormInner: $('.course-inner-form-wrap'),
				coursesFormHtml: $('.course-form-wrap').html()
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {

					_this.$dom.openForm.on('click', function (e) {
						e.preventDefault();
						var $this = $(this),
						    parent = $this.parents('.course-calendar-value-row');

						_this.$dom.course.removeClass('show-form');

						parent.addClass('show-form');

						var startdatum = parent.find('.startdatum-val').text(),
						    lesmomenten = parent.find('.lesmomenten-val').text(),
						    uur = parent.find('.uur-val').text(),
						    cursusnaam = parent.find('.cursusnaam-val').text(),
						    locatie = parent.find('.locatie-val').text();

						setTimeout(function () {
							$('#field_startdatum').val(startdatum);
							$('#field_lesmomenten').val(lesmomenten);
							$('#field_uur').val(uur);
							$('#field_cursusnaam').val(cursusnaam);
							$('#field_locatie').val(locatie);
						}, 200);

						_this.$dom.courseFormInner.html('');

						parent.find('.course-inner-form-wrap').html(_this.$dom.coursesFormHtml);

						_this.$dom.coursesForm.html('');

						$('select').each(function () {
							var $this = $(this),
							    placeholder = $(this).data('placeholder');

							$(this).select2({
								minimumResultsForSearch: -1,
								placeholder: placeholder,
								dropdownParent: $this.parent()
							});
						});
					});

					_this.$dom.closeForm.on('click', function (e) {
						e.preventDefault();
						var $this = $(this),
						    parent = $this.parents('.course-calendar-value-row'),
						    formHtml = parent.find('.course-inner-form-wrap').html();

						parent.removeClass('show-form');

						_this.$dom.coursesForm.html(formHtml);

						parent.find('.course-inner-form-wrap').html('');
					});
				}
			}

		};
	}, {}], 6: [function (require, module, exports) {
		"use strict";

		/**  
   * 1. Copy equalheight.js from __js_snippets to assets/js/site
   * 2. Add const equalheight = require('./site/equalheight');
   * 3. Initialize equalheight => equalheight.init();
   * 4. Add [ data-equal='{somename}' ] on each element that you want to have same height
   * 
  */

		var Global = require('./global');

		var _this = void 0;

		module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				equalElements: $("[data-equal], [class*='data-equal-']")
			},

			defaults: {
				heights: {
					'full': {}
				}
			},

			vars: {
				heights: {}
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				_this = this;
				_this.bind();
			},

			reset: function reset() {

				_this.vars.heights = _this.defaults.heights;
				_this.$dom.equalElements.css('height', 'auto');
			},

			calculate: function calculate() {

				_this.$dom.equalElements.each(function () {

					var dataType = $(this).is("[class*='data-equal-']") ? 'class' : 'data';
					var refElement = void 0,
					    size = void 0;

					if (dataType === 'data') {
						refElement = $(this).attr('data-equal');
						size = $(this).attr('data-equal-width');
					} else {

						var classes = this.className.split(/\s+/);

						for (var i = 0; i < classes.length; i++) {
							if (classes[i].indexOf('data-equal-') > -1) {
								refElement = classes[i].replace('data-equal-', '');
							}
							if (classes[i].indexOf('data-equal-width-') > -1) {
								size = classes[i].replace('data-equal-width-', '');
							}
						}
					}

					if (size === undefined) size = 'full';

					if (_this.vars.heights[size] === undefined) {
						_this.vars.heights[size] = {};
					}

					if (_this.vars.heights[size][refElement] === undefined) {
						_this.vars.heights[size][refElement] = 0;
					}

					if ($(this).outerHeight() > _this.vars.heights[size][refElement]) {
						_this.vars.heights[size][refElement] = $(this).outerHeight();
					}
				});
			},

			render: function render() {

				for (var breakpoint in _this.vars.heights) {

					var elementDataValue = _this.vars.heights[breakpoint];

					for (var element in elementDataValue) {

						if (Global.device.width > parseInt(breakpoint) || breakpoint === 'full') {
							$("[data-equal='" + element + "'], [class*='data-equal-" + element + "']").css('height', elementDataValue[element]);
						}
					}
				}
			},

			bind: function bind() {
				Global.$dom.window.on('load', _this.recalculate);
				Global.$dom.window.on('resize', Global.functions.throttle(_this.recalculate, 100));
			},

			recalculate: function recalculate() {
				_this.reset();
				_this.calculate();
				_this.render();
			}
		};
	}, { "./global": 9 }], 7: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				body: $('body')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {}
			}

		};
	}, {}], 8: [function (require, module, exports) {
		"use strict";

		/**  
   * 1. Add [ "featherlight": "1.7.14" ], to package.json
   * 2. npm install
   * 3. Import scss file in assets/scss/plugins/featherlight.scss => @import '../../../node_modules/featherlight/release/featherlight.min';
   * 4. Add require('featherlight/src/featherlight')($);
   * 5. Initialize featherlight
   * 
  */

		require('featherlight/src/featherlight')($);
		require('featherlight/src/featherlight.gallery')($);

		module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				lightbox: $('.gallery a')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				// this.$dom.lightbox.featherlight();
				this.$dom.lightbox.featherlightGallery({
					// gallery: {
					//     next: 'next »',
					//     previous: '« previous'
					// }
				});
			}
		};
	}, { "featherlight/src/featherlight": 21, "featherlight/src/featherlight.gallery": 20 }], 9: [function (require, module, exports) {
		// "use strict";
		var Global = module.exports = {

			$dom: {
				window: $(window),
				body: $('body')
			},

			device: {
				isMobile: false,
				isTablet: false,
				isPortable: false,
				width: window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
				height: window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
			},

			vars: {
				keys: { 37: 1, 38: 1, 39: 1, 40: 1 },
				scrollAllowed: [$('.main-navigation')]
			},

			functions: {

				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {

					Global.privateFunctions.convertToObject(arguments);

					$(selector).on('mouseup', function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !$(closeBtn).is($(e.target))) {
							callback();
						}
					});
				},

				throttle: function throttle(fn, wait) {

					var time = Date.now();

					return function () {
						if (time + wait - Date.now() < 0) {
							fn();
							time = Date.now();
						}
					};
				},

				disableScroll: function disableScroll() {
					if (window.addEventListener) {
						window.addEventListener('DOMMouseScroll', Global.privateFunctions.preventDefault, { passive: false });
					}

					document.addEventListener('wheel', Global.privateFunctions.preventDefault, { passive: false }); // Disable scrolling in Chrome
					document.onkeydown = Global.privateFunctions.preventDefaultForScrollKeys;

					window.addEventListener('touchmove', Global.privateFunctions.preventDefault, { passive: false });
					window.addEventListener('mousewheel', Global.privateFunctions.preventDefault, { passive: false });
					document.addEventListener('mousewheel', Global.privateFunctions.preventDefault, { passive: false });
					window.addEventListener('wheel', Global.privateFunctions.preventDefault, { passive: false });
				},

				enableScroll: function enableScroll() {
					if (window.removeEventListener) {
						window.removeEventListener('DOMMouseScroll', Global.privateFunctions.preventDefault, { passive: false });
					}

					document.removeEventListener('wheel', Global.privateFunctions.preventDefault, { passive: false }); // Enable scrolling in Chrome

					window.removeEventListener('touchmove', Global.privateFunctions.preventDefault, { passive: false });
					window.removeEventListener('mousewheel', Global.privateFunctions.preventDefault, { passive: false });
					document.removeEventListener('mousewheel', Global.privateFunctions.preventDefault, { passive: false });
					window.removeEventListener('wheel', Global.privateFunctions.preventDefault, { passive: false });
				}

			},

			privateFunctions: {

				init: function init() {
					Global.privateFunctions.setupSizes();
					Global.privateFunctions.setupEvents();
				},

				setupSizes: function setupSizes() {

					Global.device.width = $(window).outerWidth();
					Global.device.height = $(window).outerHeight();

					if (Global.device.width <= 1199 && Global.device.width >= 768) {
						Global.device.isTablet = true;
						Global.device.isMobile = false;
						Global.device.isPortable = true;
					} else if (Global.device.width >= 1199) {
						Global.device.iTablet = false;
						Global.device.isMobile = false;
						Global.device.isPortable = false;
					} else if (Global.device.width < 768) {
						Global.device.iTablet = false;
						Global.device.isMobile = true;
						Global.device.isPortable = true;
					}
				},
				setupEvents: function setupEvents() {
					Global.$dom.window.on('resize', Global.functions.throttle(this.setupSizes, 200));
				},
				convertToObject: function convertToObject(items) {

					for (var i = 0; i < items.length; i++) {

						if (items[i] instanceof Function) break;

						if (items[i] instanceof jQuery === false) {
							items[i] = $(items[i]);
						}
					}
				},

				preventDefault: function preventDefault(e) {

					for (var allowedElement in Global.vars.scrollAllowed) {
						var $element = Global.vars.scrollAllowed[allowedElement];

						if ($element.is(e.target) || $element.has($(e.target)).length > 0) {
							return;
						}
					}

					e = e || window.event;
					if (e.preventDefault) e.preventDefault();
					e.returnValue = false;
				},

				preventDefaultForScrollKeys: function preventDefaultForScrollKeys(e) {
					if (Global.vars.keys[e.keyCode]) {
						Global.preventDefault(e);
						return false;
					}
				}
			}
		};

		Global.privateFunctions.init();
	}, {}], 10: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				body: $('body')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				$('.site-branding-main-logo img[src$=".svg"]').each(function () {
					var $img = jQuery(this);
					var imgURL = $img.attr('src');
					var attributes = $img.prop("attributes");

					$.get(imgURL, function (data) {
						// Get the SVG tag, ignore the rest
						var $svg = jQuery(data).find('svg');

						// Remove any invalid XML tags
						$svg = $svg.removeAttr('xmlns:a');

						// Loop through IMG attributes and apply on SVG
						$.each(attributes, function () {
							$svg.attr(this.name, this.value);
						});

						// Replace IMG with SVG
						$img.replaceWith($svg);

						var svg_id = $svg.attr('id');
					}, 'xml');
				});
			}

		};
	}, {}], 11: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				number: $('.quantity')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {
					var inputNumber = function inputNumber(number) {
						number.append('<div class="quantity-button quantity-up"></div>');
						number.prepend('<div class="quantity-button quantity-down"></div>');
						number.each(function () {
							var spinner = $(this),
							    input = spinner.find('input'),
							    btnUp = spinner.find('.quantity-up'),
							    btnDown = spinner.find('.quantity-down'),
							    min = input.attr('min'),
							    max = input.attr('max');

							btnUp.on('click', function () {
								var oldValue = parseFloat(input.val());
								if (max && oldValue >= max) {
									var newVal = oldValue;
								} else {
									var newVal = oldValue + 1;
								}
								spinner.find("input").val(newVal);
								jQuery('.input-text').trigger("change");
							});

							btnDown.on('click', function () {
								var oldValue = parseFloat(input.val());
								if (oldValue <= min) {
									var newVal = oldValue;
								} else {
									var newVal = oldValue - 1;
								}
								spinner.find("input").val(newVal);
								jQuery('.input-text').trigger("change");
							});
						});
					};

					inputNumber($('.quantity'));

					jQuery(document.body).on('updated_cart_totals', function () {
						inputNumber(jQuery('.quantity'));
					});
				}
			}

		};
	}, {}], 12: [function (require, module, exports) {
		"use strict";

		var GoogleMapsLoader = require('google-maps'); // only for common js environments
		GoogleMapsLoader.KEY = theme.google_api_key;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				map: $('.acf-map')
			},

			vars: {
				map: null,

				googleMapOptions: [{ "featureType": "all", "elementType": "geometry.fill", "stylers": [{ "color": "#e3dfd6" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "color": "#d3cdc3" }] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#f3f1ee" }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }, { "saturation": "0" }] }, { "featureType": "landscape.man_made", "elementType": "labels.text.fill", "stylers": [{ "saturation": "0" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "lightness": 21 }, { "visibility": "off" }, { "color": "#f5f5f5" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e5de" }, { "lightness": 17 }] }]
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				GoogleMapsLoader.load(function (google) {

					_this.$dom.map.each(function () {

						// create map
						_this.vars.map = _this.new_map($(this));
					});
				});
			},

			center_map: function center_map(map) {

				// vars
				var bounds = new google.maps.LatLngBounds();

				// loop through all markers and create bounds
				$.each(map.markers, function (i, marker) {

					var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

					bounds.extend(latlng);
				});

				// only 1 marker?
				if (map.markers.length === 1) {
					// set center of map
					map.setCenter(bounds.getCenter());
					map.setZoom(18);
				} else {
					// fit to bounds
					map.fitBounds(bounds);
				}
			},

			add_marker: function add_marker($marker, map) {

				// var
				var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

				// create marker
				var marker = new google.maps.Marker({
					position: latlng,
					map: map,
					icon: theme.theme_url + '/assets/images/marker.png'
				});

				// add to array
				map.markers.push(marker);

				// if marker contains HTML, add it to an infoWindow
				if ($marker.html()) {
					// create info window
					var infowindow = new google.maps.InfoWindow({
						content: $marker.html()
					});

					// show info window when marker is clicked
					google.maps.event.addListener(marker, 'click', function () {

						infowindow.open(map, marker);
					});
				}
			},

			new_map: function new_map($el) {

				// var
				var $markers = $el.find('.marker');

				// vars
				var args = {
					zoom: 16,
					center: new google.maps.LatLng(0, 0),
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					styles: _this.vars.googleMapOptions
				};

				// create map	        	
				var map = new google.maps.Map($el[0], args);

				// add a markers reference
				map.markers = [];

				// add markers
				$markers.each(function () {

					_this.add_marker($(this), map);
				});

				// center map
				_this.center_map(map);

				// return
				return map;
			}

		};
	}, { "google-maps": 22 }], 13: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				body: $('body'),
				customPPP: $('#js-custom-ppp'),
				sfPPPOption: $('.sf-field-posts_per_page select option'),
				sfPPP: $('.sf-field-posts_per_page select'),
				customSortPorducts: $('#js-custom-sort'),
				sfSortProductsOption: $('.sf-field-sort_order select option'),
				sfSortProducts: $('.sf-field-sort_order select'),
				filtersTitle: $('.product-archive-sidebar-title'),
				closeFilters: $('.close-filters')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {
					// populate custom select for products per page
					_this.$dom.sfPPPOption.each(function () {
						$(this).clone().appendTo(_this.$dom.customPPP);
					});

					// populate custom select for Sort Products
					_this.$dom.sfSortProductsOption.each(function () {
						$(this).clone().appendTo(_this.$dom.customSortPorducts);
					});

					// trigger real select for PPP based on custom PPP select option
					(function ($) {
						_this.$dom.customPPP.on('change', function () {
							var customPPPValue = this.value;

							$('.sf-field-posts_per_page select').val(customPPPValue).trigger('change');
						});

						_this.$dom.customSortPorducts.on('change', function () {
							var customSortPorductsValue = this.value;

							$('.sf-field-sort_order select').val(customSortPorductsValue).trigger('change');
						});
					})(jQuery);

					if ($(window).width() < 1200) {
						_this.$dom.filtersTitle.on('click', function () {
							_this.$dom.body.addClass('show-filters');
						});

						_this.$dom.closeFilters.on('click', function () {
							_this.$dom.body.removeClass('show-filters');
						});
					}

					$('.product-archive-sidebar-filters .sf-input-select').on('change', function () {
						console.log($(this).val());
						jQuery('.product-archive-sidebar-filters .searchandfilter').trigger('submit');
					});
				}
			}

		};
	}, {}], 14: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				path: $('.reg-and-content-left-path'),
				vine: $('.reg-and-content-wines'),

				regio: $('.regios-content-list-link'),
				path2: $('.regio-path')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {

					// HP Section
					_this.$dom.path.each(function () {
						if ($(this).hasClass('active')) {
							var id = $(this).attr('id');
							_this.$dom.vine.each(function () {
								var vineid = $(this).data('id');

								if (id == vineid) {
									$(this).fadeIn();
								}
							});
						}

						$(this).on('click', function () {
							_this.$dom.path.not(this).removeClass('active');
							$(this).addClass('active');
							var id = $(this).attr('id');
							_this.$dom.vine.each(function () {
								var vineid = $(this).data('id');
								if (id == vineid) {
									_this.$dom.vine.fadeOut(300);
									$(this).delay(300).fadeIn(300);
								}
							});
						});
					});

					// Regios Page
					_this.$dom.regio.on('mouseover', function () {
						var id = $(this).data('id'),
						    ids = id.split(',');
						_this.$dom.path2.not(this).removeClass('active');
						$.each(ids, function (index, value) {
							var testId = value;
							_this.$dom.path2.each(function () {
								var idOfPath = $(this).attr('id');
								if (testId == idOfPath) {
									$(this).addClass('active');
								}
							});
						});
					});
				}
			}

		};
	}, {}], 15: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				cta: $('.js-scroll-to-travel-form'),
				form: $('.js-form-travel')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				if (_this) {
					_this.$dom.cta.on('click', _this.scrollToForm);
				}
			},

			scrollToForm: function scrollToForm(e) {
				e.preventDefault();
				$('html, body').animate({ scrollTop: _this.$dom.form.offset().top - 110 }, 1000);
			}

		};
	}, {}], 16: [function (require, module, exports) {
		"use strict";

		/**  
   * 1. Add [ "select2": "^4.0.8" ], to package.json
   * 2. npm install
   * 3. Import scss file in assets/scss/plugins/select2.scss => @import '../../../node_modules/select2/dist/css/select2.min';
   * 4. Add require("select2")($);
   * 5. Initialize select2
   * 
   */

		require("select2")($);

		module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				select: $("select:not(.country_select):not(#billing_state)")
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				this.$dom.select.each(function () {
					var $this = $(this),
					    placeholder = $(this).data('placeholder');

					if (!$this.parent().hasClass('variation-select-wrap')) {
						$(this).select2({
							minimumResultsForSearch: -1,
							placeholder: placeholder,
							dropdownParent: $this.parent()
						});
					}
				});
			}
		};
	}, { "select2": 24 }], 17: [function (require, module, exports) {
		(function ($) {
			"use strict";

			var Global = require('./global');

			var _this = module.exports = {

				/*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/
				$dom: {
					body: $('body'),
					shareButtonsPopup: $(".social-share-links .social-share-link-popup a"),
					shareLinksWrapper: $('.social-share-links'),
					shareLinksOuterWrapper: $('.single-post-share')
				},

				vars: {},

				/*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
				init: function init() {

					_this.$dom.shareButtonsPopup.on('click', function (e) {
						e.preventDefault();
						_this.popupCenter($(this).attr('href'), $(this).attr('title'), 500, 300);
					});

					// Global.$dom.window.on( 'load scroll', _this.checkPositionOfSharelinks );
				},

				popupCenter: function popupCenter(url, title, w, h) {
					// Fixes dual-screen position                         Most browsers      Firefox
					var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
					var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

					var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
					var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

					var left = width / 2 - w / 2 + dualScreenLeft;
					var top = height / 2 - h / 2 + dualScreenTop;
					var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

					// Puts focus on the newWindow
					if (window.focus) {
						newWindow.focus();
					}
				},

				checkPositionOfSharelinks: function checkPositionOfSharelinks() {

					if (_this.$dom.shareLinksOuterWrapper.length && Global.$dom.window.width() >= 1200) {
						var elemToScrollTopPos = _this.$dom.shareLinksOuterWrapper.offset().top - 200;
						var windowHalfHeight = Global.$dom.window.innerHeight();
						var elemToScrollBottPos = _this.$dom.shareLinksOuterWrapper.offset().top + _this.$dom.shareLinksOuterWrapper.innerHeight() - windowHalfHeight;
						var elemePositionBottom = windowHalfHeight - 200 - _this.$dom.shareLinksWrapper.innerHeight();

						if (Global.$dom.window.scrollTop() > elemToScrollTopPos && Global.$dom.window.scrollTop() < elemToScrollBottPos) {

							_this.$dom.shareLinksWrapper.addClass('fixed').css('top', '200px');
							_this.$dom.shareLinksWrapper.removeClass('fixed-bottom').css('bottom', 'inherit');
						} else if (Global.$dom.window.scrollTop() > elemToScrollBottPos) {
							_this.$dom.shareLinksWrapper.removeClass('fixed').css('top', 'inherit');
							_this.$dom.shareLinksWrapper.addClass('fixed-bottom').css('bottom', elemePositionBottom);
						} else {
							_this.$dom.shareLinksWrapper.removeClass('fixed').css('top', 'inherit');
							_this.$dom.shareLinksWrapper.removeClass('fixed-bottom').css('bottom', 'inherit');
						}
					}
				}

			};
		})(jQuery);
	}, { "./global": 9 }], 18: [function (require, module, exports) {
		"use strict";

		/**  
   * 1. Add [ "slick-carousel": "1.8.1" ], to package.json
   * 2. npm install
   * 3. Import slick scss file in assets/scss/plugins/slick.scss => @import "../../../node_modules/slick-carousel/slick/slick.scss";
   * 4. Add require('slick-carousel');
   * 5. Initialize slick
   * 
   */

		require('slick-carousel');

		module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				productsSlider: $(".products-slider-wrapper"),
				coursesSlider: $(".courses-slider-wrapper"),
				singleTravelSlider: $(".js-gallery-slider"),
				regioProductSlider: $('.product-list-slider'),
				productGallerySlider: $('.product-gallery-slider'),
				testimonialsSlider: $('.testimonials-slider')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				this.$dom.productsSlider.slick({
					slidesToScroll: 1,
					slidesToShow: 6,
					autoplay: false,
					infinite: true,
					speed: 1500,
					// centerPadding: '10px',
					dots: false,
					variableWidth: true,
					arrows: false,
					responsive: [{
						breakpoint: 1400,
						settings: {
							slidesToShow: 4
						}
					}, {
						breakpoint: 991,
						settings: {
							slidesToShow: 1
						}
					}]
				});

				this.$dom.coursesSlider.slick({
					slidesToScroll: 1,
					slidesToShow: 3,
					autoplay: false,
					centerMode: true,
					centerPadding: '0',
					dots: false,
					arrows: true,
					variableWidth: true,
					prevArrow: "<button type='button' class='slick-prev pull-left'><i class='icon-arrow-left-solid' aria-hidden='true'></i></button>",
					nextArrow: "<button type='button' class='slick-next pull-right'><i class='icon-arrow-right-solid' aria-hidden='true'></i></button>"
				});

				this.$dom.singleTravelSlider.slick({
					slidesToScroll: 1,
					slidesToShow: 1,
					autoplay: false,
					centerMode: true,
					dots: false,
					arrows: true,
					variableWidth: true,
					prevArrow: "<button type='button' class='slick-prev single-left pull-left'><i class='icon-arrow-left-solid' aria-hidden='true'></i></button>",
					nextArrow: "<button type='button' class='slick-next single-right pull-right'><i class='icon-arrow-right-solid' aria-hidden='true'></i></button>"
				});

				this.$dom.regioProductSlider.slick({
					dots: false,
					arrows: false,
					variableWidth: false,
					slidesToShow: 6,
					responsive: [{
						breakpoint: 1680,
						settings: {
							slidesToShow: 5
						}
					}, {
						breakpoint: 1400,
						settings: {
							slidesToShow: 4
						}
					}, {
						breakpoint: 1024,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 600,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 480,
						settings: {
							slidesToShow: 1
						}
					}]

				});

				this.$dom.productGallerySlider.slick({
					dots: false,
					arrows: true,
					slidesToShow: 1,
					prevArrow: "<button type='button' class='slick-prev single-left pull-left'><i class='icon-arrow-left-solid' aria-hidden='true'></i></button>",
					nextArrow: "<button type='button' class='slick-next single-right pull-right'><i class='icon-arrow-right-solid' aria-hidden='true'></i></button>"
				});

				this.$dom.testimonialsSlider.slick({
					dots: false,
					arrows: true,
					speed: 500,
					fade: true,
					cssEase: 'linear',
					prevArrow: "<button type='button' class='slick-prev single-left'><i class='icon-arrow-left-solid' aria-hidden='true'></i></button>",
					nextArrow: "<button type='button' class='slick-next single-right'><i class='icon-arrow-right-solid' aria-hidden='true'></i></button>",
					responsive: [{
						breakpoint: 767,
						settings: {
							adaptiveHeight: true
						}
					}]
				});
			}
		};
	}, { "slick-carousel": 25 }], 19: [function (require, module, exports) {
		"use strict";

		// const Global = require('./global');

		// let	_this;

		var _this = module.exports = {

			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				body: $('body')
			},

			vars: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				if ($(window).width() > 1199) {

					$(document).on('scroll', function () {
						if ($(this).scrollTop() > 0) {
							$('.site-header').addClass('site-header__sticky');
						} else {
							$('.site-header').removeClass('site-header__sticky');
						}
					});

					if (navigator.userAgent.match(/Trident\/7\./)) {
						// if IE
						$('body').on("mousewheel", function (event) {
							// remove default behavior
							event.preventDefault();

							//scroll without smoothing
							var wheelDelta = event.wheelDelta;
							var currentScrollPosition = window.pageYOffset;
							window.scrollTo(0, currentScrollPosition - wheelDelta);
						});
					}
					$(document).trigger('scroll');
				}
			}

		};
	}, {}], 20: [function (require, module, exports) {
		/**
   * Featherlight Gallery – an extension for the ultra slim jQuery lightbox
   * Version 1.7.14-UMD - http://noelboss.github.io/featherlight/
   *
   * Copyright 2019, Noël Raoul Bossart (http://www.noelboss.com)
   * MIT Licensed.
  **/
		(function (factory) {
			if (typeof define === 'function' && define.amd) {
				// AMD. Register as an anonymous module.
				define(['jquery'], factory);
			} else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
				// Node/CommonJS
				module.exports = function (root, jQuery) {
					if (jQuery === undefined) {
						// require('jQuery') returns a factory that requires window to
						// build a jQuery instance, we normalize how we use modules
						// that require this pattern but the window provided is a noop
						// if it's defined (how jquery works)
						if (typeof window !== 'undefined') {
							jQuery = require('jquery');
						} else {
							jQuery = require('jquery')(root);
						}
					}
					factory(jQuery);
					return jQuery;
				};
			} else {
				// Browser globals
				factory(jQuery);
			}
		})(function ($) {
			"use strict";

			var warn = function warn(m) {
				if (window.console && window.console.warn) {
					window.console.warn('FeatherlightGallery: ' + m);
				}
			};

			if ('undefined' === typeof $) {
				return warn('Too much lightness, Featherlight needs jQuery.');
			} else if (!$.featherlight) {
				return warn('Load the featherlight plugin before the gallery plugin');
			}

			var isTouchAware = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
			    jQueryConstructor = $.event && $.event.special.swipeleft && $,
			    hammerConstructor = window.Hammer && function ($el) {
				var mc = new window.Hammer.Manager($el[0]);
				mc.add(new window.Hammer.Swipe());
				return mc;
			},
			    swipeAwareConstructor = isTouchAware && (jQueryConstructor || hammerConstructor);
			if (isTouchAware && !swipeAwareConstructor) {
				warn('No compatible swipe library detected; one must be included before featherlightGallery for swipe motions to navigate the galleries.');
			}

			var callbackChain = {
				afterClose: function afterClose(_super, event) {
					var self = this;
					self.$instance.off('next.' + self.namespace + ' previous.' + self.namespace);
					if (self._swiper) {
						self._swiper.off('swipeleft', self._swipeleft) /* See http://stackoverflow.com/questions/17367198/hammer-js-cant-remove-event-listener */
						.off('swiperight', self._swiperight);
						self._swiper = null;
					}
					return _super(event);
				},
				beforeOpen: function beforeOpen(_super, event) {
					var self = this;

					self.$instance.on('next.' + self.namespace + ' previous.' + self.namespace, function (event) {
						var offset = event.type === 'next' ? +1 : -1;
						self.navigateTo(self.currentNavigation() + offset);
					});

					if (swipeAwareConstructor) {
						self._swiper = swipeAwareConstructor(self.$instance).on('swipeleft', self._swipeleft = function () {
							self.$instance.trigger('next');
						}).on('swiperight', self._swiperight = function () {
							self.$instance.trigger('previous');
						});

						self.$instance.addClass(this.namespace + '-swipe-aware', swipeAwareConstructor);
					}

					self.$instance.find('.' + self.namespace + '-content').append(self.createNavigation('previous')).append(self.createNavigation('next'));

					return _super(event);
				},
				beforeContent: function beforeContent(_super, event) {
					var index = this.currentNavigation();
					var len = this.slides().length;
					this.$instance.toggleClass(this.namespace + '-first-slide', index === 0).toggleClass(this.namespace + '-last-slide', index === len - 1);
					return _super(event);
				},
				onKeyUp: function onKeyUp(_super, event) {
					var dir = {
						37: 'previous', /* Left arrow */
						39: 'next' /* Rigth arrow */
					}[event.keyCode];
					if (dir) {
						this.$instance.trigger(dir);
						return false;
					} else {
						return _super(event);
					}
				}
			};

			function FeatherlightGallery($source, config) {
				if (this instanceof FeatherlightGallery) {
					/* called with new */
					$.featherlight.apply(this, arguments);
					this.chainCallbacks(callbackChain);
				} else {
					var flg = new FeatherlightGallery($.extend({ $source: $source, $currentTarget: $source.first() }, config));
					flg.open();
					return flg;
				}
			}

			$.featherlight.extend(FeatherlightGallery, {
				autoBind: '[data-featherlight-gallery]'
			});

			$.extend(FeatherlightGallery.prototype, {
				/** Additional settings for Gallery **/
				previousIcon: '&#9664;', /* Code that is used as previous icon */
				nextIcon: '&#9654;', /* Code that is used as next icon */
				galleryFadeIn: 100, /* fadeIn speed when image is loaded */
				galleryFadeOut: 300, /* fadeOut speed before image is loaded */

				slides: function slides() {
					if (this.filter) {
						return this.$source.find(this.filter);
					}
					return this.$source;
				},

				images: function images() {
					warn('images is deprecated, please use slides instead');
					return this.slides();
				},

				currentNavigation: function currentNavigation() {
					return this.slides().index(this.$currentTarget);
				},

				navigateTo: function navigateTo(index) {
					var self = this,
					    source = self.slides(),
					    len = source.length,
					    $inner = self.$instance.find('.' + self.namespace + '-inner');
					index = (index % len + len) % len; /* pin index to [0, len[ */

					this.$instance.addClass(this.namespace + '-loading');
					self.$currentTarget = source.eq(index);
					self.beforeContent();
					return $.when(self.getContent(), $inner.fadeTo(self.galleryFadeOut, 0.2)).always(function ($newContent) {
						self.setContent($newContent);
						self.afterContent();
						$newContent.fadeTo(self.galleryFadeIn, 1);
					});
				},

				createNavigation: function createNavigation(target) {
					var self = this;
					return $('<span title="' + target + '" class="' + this.namespace + '-' + target + '"><span>' + this[target + 'Icon'] + '</span></span>').click(function (evt) {
						$(this).trigger(target + '.' + self.namespace);
						evt.preventDefault();
					});
				}
			});

			$.featherlightGallery = FeatherlightGallery;

			/* extend jQuery with selector featherlight method $(elm).featherlight(config, elm); */
			$.fn.featherlightGallery = function (config) {
				FeatherlightGallery.attach(this, config);
				return this;
			};

			/* bind featherlight on ready if config autoBind is set */
			$(document).ready(function () {
				FeatherlightGallery._onReady();
			});
		});
	}, { "jquery": 23 }], 21: [function (require, module, exports) {
		/**
   * Featherlight - ultra slim jQuery lightbox
   * Version 1.7.14-UMD - http://noelboss.github.io/featherlight/
   *
   * Copyright 2019, Noël Raoul Bossart (http://www.noelboss.com)
   * MIT Licensed.
  **/
		(function (factory) {
			if (typeof define === 'function' && define.amd) {
				// AMD. Register as an anonymous module.
				define(['jquery'], factory);
			} else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
				// Node/CommonJS
				module.exports = function (root, jQuery) {
					if (jQuery === undefined) {
						// require('jQuery') returns a factory that requires window to
						// build a jQuery instance, we normalize how we use modules
						// that require this pattern but the window provided is a noop
						// if it's defined (how jquery works)
						if (typeof window !== 'undefined') {
							jQuery = require('jquery');
						} else {
							jQuery = require('jquery')(root);
						}
					}
					factory(jQuery);
					return jQuery;
				};
			} else {
				// Browser globals
				factory(jQuery);
			}
		})(function ($) {
			"use strict";

			if ('undefined' === typeof $) {
				if ('console' in window) {
					window.console.info('Too much lightness, Featherlight needs jQuery.');
				}
				return;
			}
			if ($.fn.jquery.match(/-ajax/)) {
				if ('console' in window) {
					window.console.info('Featherlight needs regular jQuery, not the slim version.');
				}
				return;
			}
			/* Featherlight is exported as $.featherlight.
      It is a function used to open a featherlight lightbox.
   	   [tech]
      Featherlight uses prototype inheritance.
      Each opened lightbox will have a corresponding object.
      That object may have some attributes that override the
      prototype's.
      Extensions created with Featherlight.extend will have their
      own prototype that inherits from Featherlight's prototype,
      thus attributes can be overriden either at the object level,
      or at the extension level.
      To create callbacks that chain themselves instead of overriding,
      use chainCallbacks.
      For those familiar with CoffeeScript, this correspond to
      Featherlight being a class and the Gallery being a class
      extending Featherlight.
      The chainCallbacks is used since we don't have access to
      CoffeeScript's `super`.
   */

			function Featherlight($content, config) {
				if (this instanceof Featherlight) {
					/* called with new */
					this.id = Featherlight.id++;
					this.setup($content, config);
					this.chainCallbacks(Featherlight._callbackChain);
				} else {
					var fl = new Featherlight($content, config);
					fl.open();
					return fl;
				}
			}

			var _opened = [],
			    pruneOpened = function pruneOpened(remove) {
				_opened = $.grep(_opened, function (fl) {
					return fl !== remove && fl.$instance.closest('body').length > 0;
				});
				return _opened;
			};

			// Removes keys of `set` from `obj` and returns the removed key/values.
			function slice(obj, set) {
				var r = {};
				for (var key in obj) {
					if (key in set) {
						r[key] = obj[key];
						delete obj[key];
					}
				}
				return r;
			}

			// NOTE: List of available [iframe attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe).
			var iFrameAttributeSet = {
				allow: 1, allowfullscreen: 1, frameborder: 1, height: 1, longdesc: 1, marginheight: 1, marginwidth: 1,
				mozallowfullscreen: 1, name: 1, referrerpolicy: 1, sandbox: 1, scrolling: 1, src: 1, srcdoc: 1, style: 1,
				webkitallowfullscreen: 1, width: 1
			};

			// Converts camelCased attributes to dasherized versions for given prefix:
			//   parseAttrs({hello: 1, hellFrozeOver: 2}, 'hell') => {froze-over: 2}
			function parseAttrs(obj, prefix) {
				var attrs = {},
				    regex = new RegExp('^' + prefix + '([A-Z])(.*)');
				for (var key in obj) {
					var match = key.match(regex);
					if (match) {
						var dasherized = (match[1] + match[2].replace(/([A-Z])/g, '-$1')).toLowerCase();
						attrs[dasherized] = obj[key];
					}
				}
				return attrs;
			}

			/* document wide key handler */
			var eventMap = { keyup: 'onKeyUp', resize: 'onResize' };

			var globalEventHandler = function globalEventHandler(event) {
				$.each(Featherlight.opened().reverse(), function () {
					if (!event.isDefaultPrevented()) {
						if (false === this[eventMap[event.type]](event)) {
							event.preventDefault();event.stopPropagation();return false;
						}
					}
				});
			};

			var toggleGlobalEvents = function toggleGlobalEvents(set) {
				if (set !== Featherlight._globalHandlerInstalled) {
					Featherlight._globalHandlerInstalled = set;
					var events = $.map(eventMap, function (_, name) {
						return name + '.' + Featherlight.prototype.namespace;
					}).join(' ');
					$(window)[set ? 'on' : 'off'](events, globalEventHandler);
				}
			};

			Featherlight.prototype = {
				constructor: Featherlight,
				/*** defaults ***/
				/* extend featherlight with defaults and methods */
				namespace: 'featherlight', /* Name of the events and css class prefix */
				targetAttr: 'data-featherlight', /* Attribute of the triggered element that contains the selector to the lightbox content */
				variant: null, /* Class that will be added to change look of the lightbox */
				resetCss: false, /* Reset all css */
				background: null, /* Custom DOM for the background, wrapper and the closebutton */
				openTrigger: 'click', /* Event that triggers the lightbox */
				closeTrigger: 'click', /* Event that triggers the closing of the lightbox */
				filter: null, /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
				root: 'body', /* Where to append featherlights */
				openSpeed: 250, /* Duration of opening animation */
				closeSpeed: 250, /* Duration of closing animation */
				closeOnClick: 'background', /* Close lightbox on click ('background', 'anywhere' or false) */
				closeOnEsc: true, /* Close lightbox when pressing esc */
				closeIcon: '&#10005;', /* Close icon */
				loading: '', /* Content to show while initial content is loading */
				persist: false, /* If set, the content will persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
				otherClose: null, /* Selector for alternate close buttons (e.g. "a.close") */
				beforeOpen: $.noop, /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
				beforeContent: $.noop, /* Called when content is loaded. Gets event as parameter, this contains all data */
				beforeClose: $.noop, /* Called before close. can return false to prevent closing of lightbox. Gets event as parameter, this contains all data */
				afterOpen: $.noop, /* Called after open. Gets event as parameter, this contains all data */
				afterContent: $.noop, /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
				afterClose: $.noop, /* Called after close. Gets event as parameter, this contains all data */
				onKeyUp: $.noop, /* Called on key up for the frontmost featherlight */
				onResize: $.noop, /* Called after new content and when a window is resized */
				type: null, /* Specify type of lightbox. If unset, it will check for the targetAttrs value. */
				contentFilters: ['jquery', 'image', 'html', 'ajax', 'iframe', 'text'], /* List of content filters to use to determine the content */

				/*** methods ***/
				/* setup iterates over a single instance of featherlight and prepares the background and binds the events */
				setup: function setup(target, config) {
					/* all arguments are optional */
					if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === 'object' && target instanceof $ === false && !config) {
						config = target;
						target = undefined;
					}

					var self = $.extend(this, config, { target: target }),
					    css = !self.resetCss ? self.namespace : self.namespace + '-reset',
					    /* by adding -reset to the classname, we reset all the default css */
					$background = $(self.background || ['<div class="' + css + '-loading ' + css + '">', '<div class="' + css + '-content">', '<button class="' + css + '-close-icon ' + self.namespace + '-close" aria-label="Close">', self.closeIcon, '</button>', '<div class="' + self.namespace + '-inner">' + self.loading + '</div>', '</div>', '</div>'].join('')),
					    closeButtonSelector = '.' + self.namespace + '-close' + (self.otherClose ? ',' + self.otherClose : '');

					self.$instance = $background.clone().addClass(self.variant); /* clone DOM for the background, wrapper and the close button */

					/* close when click on background/anywhere/null or closebox */
					self.$instance.on(self.closeTrigger + '.' + self.namespace, function (event) {
						if (event.isDefaultPrevented()) {
							return;
						}
						var $target = $(event.target);
						if ('background' === self.closeOnClick && $target.is('.' + self.namespace) || 'anywhere' === self.closeOnClick || $target.closest(closeButtonSelector).length) {
							self.close(event);
							event.preventDefault();
						}
					});

					return this;
				},

				/* this method prepares the content and converts it into a jQuery object or a promise */
				getContent: function getContent() {
					if (this.persist !== false && this.$content) {
						return this.$content;
					}
					var self = this,
					    filters = this.constructor.contentFilters,
					    readTargetAttr = function readTargetAttr(name) {
						return self.$currentTarget && self.$currentTarget.attr(name);
					},
					    targetValue = readTargetAttr(self.targetAttr),
					    data = self.target || targetValue || '';

					/* Find which filter applies */
					var filter = filters[self.type]; /* check explicit type like {type: 'image'} */

					/* check explicit type like data-featherlight="image" */
					if (!filter && data in filters) {
						filter = filters[data];
						data = self.target && targetValue;
					}
					data = data || readTargetAttr('href') || '';

					/* check explicity type & content like {image: 'photo.jpg'} */
					if (!filter) {
						for (var filterName in filters) {
							if (self[filterName]) {
								filter = filters[filterName];
								data = self[filterName];
							}
						}
					}

					/* otherwise it's implicit, run checks */
					if (!filter) {
						var target = data;
						data = null;
						$.each(self.contentFilters, function () {
							filter = filters[this];
							if (filter.test) {
								data = filter.test(target);
							}
							if (!data && filter.regex && target.match && target.match(filter.regex)) {
								data = target;
							}
							return !data;
						});
						if (!data) {
							if ('console' in window) {
								window.console.error('Featherlight: no content filter found ' + (target ? ' for "' + target + '"' : ' (no target specified)'));
							}
							return false;
						}
					}
					/* Process it */
					return filter.process.call(self, data);
				},

				/* sets the content of $instance to $content */
				setContent: function setContent($content) {
					this.$instance.removeClass(this.namespace + '-loading');

					/* we need a special class for the iframe */
					this.$instance.toggleClass(this.namespace + '-iframe', $content.is('iframe'));

					/* replace content by appending to existing one before it is removed
        this insures that featherlight-inner remain at the same relative
        position to any other items added to featherlight-content */
					this.$instance.find('.' + this.namespace + '-inner').not($content) /* excluded new content, important if persisted */
					.slice(1).remove().end() /* In the unexpected event where there are many inner elements, remove all but the first one */
					.replaceWith($.contains(this.$instance[0], $content[0]) ? '' : $content);

					this.$content = $content.addClass(this.namespace + '-inner');

					return this;
				},

				/* opens the lightbox. "this" contains $instance with the lightbox, and with the config.
    	Returns a promise that is resolved after is successfully opened. */
				open: function open(event) {
					var self = this;
					self.$instance.hide().appendTo(self.root);
					if ((!event || !event.isDefaultPrevented()) && self.beforeOpen(event) !== false) {

						if (event) {
							event.preventDefault();
						}
						var $content = self.getContent();

						if ($content) {
							_opened.push(self);

							toggleGlobalEvents(true);

							self.$instance.fadeIn(self.openSpeed);
							self.beforeContent(event);

							/* Set content and show */
							return $.when($content).always(function ($openendContent) {
								if ($openendContent) {
									self.setContent($openendContent);
									self.afterContent(event);
								}
							}).then(self.$instance.promise())
							/* Call afterOpen after fadeIn is done */
							.done(function () {
								self.afterOpen(event);
							});
						}
					}
					self.$instance.detach();
					return $.Deferred().reject().promise();
				},

				/* closes the lightbox. "this" contains $instance with the lightbox, and with the config
    	returns a promise, resolved after the lightbox is successfully closed. */
				close: function close(event) {
					var self = this,
					    deferred = $.Deferred();

					if (self.beforeClose(event) === false) {
						deferred.reject();
					} else {

						if (0 === pruneOpened(self).length) {
							toggleGlobalEvents(false);
						}

						self.$instance.fadeOut(self.closeSpeed, function () {
							self.$instance.detach();
							self.afterClose(event);
							deferred.resolve();
						});
					}
					return deferred.promise();
				},

				/* resizes the content so it fits in visible area and keeps the same aspect ratio.
    		Does nothing if either the width or the height is not specified.
    		Called automatically on window resize.
    		Override if you want different behavior. */
				resize: function resize(w, h) {
					if (w && h) {
						/* Reset apparent image size first so container grows */
						this.$content.css('width', '').css('height', '');
						/* Calculate the worst ratio so that dimensions fit */
						/* Note: -1 to avoid rounding errors */
						var ratio = Math.max(w / (this.$content.parent().width() - 1), h / (this.$content.parent().height() - 1));
						/* Resize content */
						if (ratio > 1) {
							ratio = h / Math.floor(h / ratio); /* Round ratio down so height calc works */
							this.$content.css('width', '' + w / ratio + 'px').css('height', '' + h / ratio + 'px');
						}
					}
				},

				/* Utility function to chain callbacks
       [Warning: guru-level]
       Used be extensions that want to let users specify callbacks but
       also need themselves to use the callbacks.
       The argument 'chain' has callback names as keys and function(super, event)
       as values. That function is meant to call `super` at some point.
    */
				chainCallbacks: function chainCallbacks(chain) {
					for (var name in chain) {
						this[name] = $.proxy(chain[name], this, $.proxy(this[name], this));
					}
				}
			};

			$.extend(Featherlight, {
				id: 0, /* Used to id single featherlight instances */
				autoBind: '[data-featherlight]', /* Will automatically bind elements matching this selector. Clear or set before onReady */
				defaults: Featherlight.prototype, /* You can access and override all defaults using $.featherlight.defaults, which is just a synonym for $.featherlight.prototype */
				/* Contains the logic to determine content */
				contentFilters: {
					jquery: {
						regex: /^[#.]\w/, /* Anything that starts with a class name or identifiers */
						test: function test(elem) {
							return elem instanceof $ && elem;
						},
						process: function process(elem) {
							return this.persist !== false ? $(elem) : $(elem).clone(true);
						}
					},
					image: {
						regex: /\.(png|jpg|jpeg|gif|tiff?|bmp|svg)(\?\S*)?$/i,
						process: function process(url) {
							var self = this,
							    deferred = $.Deferred(),
							    img = new Image(),
							    $img = $('<img src="' + url + '" alt="" class="' + self.namespace + '-image" />');
							img.onload = function () {
								/* Store naturalWidth & height for IE8 */
								$img.naturalWidth = img.width;$img.naturalHeight = img.height;
								deferred.resolve($img);
							};
							img.onerror = function () {
								deferred.reject($img);
							};
							img.src = url;
							return deferred.promise();
						}
					},
					html: {
						regex: /^\s*<[\w!][^<]*>/, /* Anything that starts with some kind of valid tag */
						process: function process(html) {
							return $(html);
						}
					},
					ajax: {
						regex: /./, /* At this point, any content is assumed to be an URL */
						process: function process(url) {
							var self = this,
							    deferred = $.Deferred();
							/* we are using load so one can specify a target with: url.html #targetelement */
							var $container = $('<div></div>').load(url, function (response, status) {
								if (status !== "error") {
									deferred.resolve($container.contents());
								}
								deferred.reject();
							});
							return deferred.promise();
						}
					},
					iframe: {
						process: function process(url) {
							var deferred = new $.Deferred();
							var $content = $('<iframe/>');
							var css = parseAttrs(this, 'iframe');
							var attrs = slice(css, iFrameAttributeSet);
							$content.hide().attr('src', url).attr(attrs).css(css).on('load', function () {
								deferred.resolve($content.show());
							})
							// We can't move an <iframe> and avoid reloading it,
							// so let's put it in place ourselves right now:
							.appendTo(this.$instance.find('.' + this.namespace + '-content'));
							return deferred.promise();
						}
					},
					text: {
						process: function process(text) {
							return $('<div>', { text: text });
						}
					}
				},

				functionAttributes: ['beforeOpen', 'afterOpen', 'beforeContent', 'afterContent', 'beforeClose', 'afterClose'],

				/*** class methods ***/
				/* read element's attributes starting with data-featherlight- */
				readElementConfig: function readElementConfig(element, namespace) {
					var Klass = this,
					    regexp = new RegExp('^data-' + namespace + '-(.*)'),
					    config = {};
					if (element && element.attributes) {
						$.each(element.attributes, function () {
							var match = this.name.match(regexp);
							if (match) {
								var val = this.value,
								    name = $.camelCase(match[1]);
								if ($.inArray(name, Klass.functionAttributes) >= 0) {
									/* jshint -W054 */
									val = new Function(val); /* jshint +W054 */
								} else {
									try {
										val = JSON.parse(val);
									} catch (e) {}
								}
								config[name] = val;
							}
						});
					}
					return config;
				},

				/* Used to create a Featherlight extension
       [Warning: guru-level]
       Creates the extension's prototype that in turn
       inherits Featherlight's prototype.
       Could be used to extend an extension too...
       This is pretty high level wizardy, it comes pretty much straight
       from CoffeeScript and won't teach you anything about Featherlight
       as it's not really specific to this library.
       My suggestion: move along and keep your sanity.
    */
				extend: function extend(child, defaults) {
					/* Setup class hierarchy, adapted from CoffeeScript */
					var Ctor = function Ctor() {
						this.constructor = child;
					};
					Ctor.prototype = this.prototype;
					child.prototype = new Ctor();
					child.__super__ = this.prototype;
					/* Copy class methods & attributes */
					$.extend(child, this, defaults);
					child.defaults = child.prototype;
					return child;
				},

				attach: function attach($source, $content, config) {
					var Klass = this;
					if ((typeof $content === "undefined" ? "undefined" : _typeof($content)) === 'object' && $content instanceof $ === false && !config) {
						config = $content;
						$content = undefined;
					}
					/* make a copy */
					config = $.extend({}, config);

					/* Only for openTrigger, filter & namespace... */
					var namespace = config.namespace || Klass.defaults.namespace,
					    tempConfig = $.extend({}, Klass.defaults, Klass.readElementConfig($source[0], namespace), config),
					    sharedPersist;
					var handler = function handler(event) {
						var $target = $(event.currentTarget);
						/* ... since we might as well compute the config on the actual target */
						var elemConfig = $.extend({ $source: $source, $currentTarget: $target }, Klass.readElementConfig($source[0], tempConfig.namespace), Klass.readElementConfig(event.currentTarget, tempConfig.namespace), config);
						var fl = sharedPersist || $target.data('featherlight-persisted') || new Klass($content, elemConfig);
						if (fl.persist === 'shared') {
							sharedPersist = fl;
						} else if (fl.persist !== false) {
							$target.data('featherlight-persisted', fl);
						}
						if (elemConfig.$currentTarget.blur) {
							elemConfig.$currentTarget.blur(); // Otherwise 'enter' key might trigger the dialog again
						}
						fl.open(event);
					};

					$source.on(tempConfig.openTrigger + '.' + tempConfig.namespace, tempConfig.filter, handler);

					return { filter: tempConfig.filter, handler: handler };
				},

				current: function current() {
					var all = this.opened();
					return all[all.length - 1] || null;
				},

				opened: function opened() {
					var klass = this;
					pruneOpened();
					return $.grep(_opened, function (fl) {
						return fl instanceof klass;
					});
				},

				close: function close(event) {
					var cur = this.current();
					if (cur) {
						return cur.close(event);
					}
				},

				/* Does the auto binding on startup.
       Meant only to be used by Featherlight and its extensions
    */
				_onReady: function _onReady() {
					var Klass = this;
					if (Klass.autoBind) {
						var $autobound = $(Klass.autoBind);
						/* Bind existing elements */
						$autobound.each(function () {
							Klass.attach($(this));
						});
						/* If a click propagates to the document level, then we have an item that was added later on */
						$(document).on('click', Klass.autoBind, function (evt) {
							if (evt.isDefaultPrevented()) {
								return;
							}
							var $cur = $(evt.currentTarget);
							var len = $autobound.length;
							$autobound = $autobound.add($cur);
							if (len === $autobound.length) {
								return; /* already bound */
							}
							/* Bind featherlight */
							var data = Klass.attach($cur);
							/* Dispatch event directly */
							if (!data.filter || $(evt.target).parentsUntil($cur, data.filter).length > 0) {
								data.handler(evt);
							}
						});
					}
				},

				/* Featherlight uses the onKeyUp callback to intercept the escape key.
       Private to Featherlight.
    */
				_callbackChain: {
					onKeyUp: function onKeyUp(_super, event) {
						if (27 === event.keyCode) {
							if (this.closeOnEsc) {
								$.featherlight.close(event);
							}
							return false;
						} else {
							return _super(event);
						}
					},

					beforeOpen: function beforeOpen(_super, event) {
						// Used to disable scrolling
						$(document.documentElement).addClass('with-featherlight');

						// Remember focus:
						this._previouslyActive = document.activeElement;

						// Disable tabbing:
						// See http://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
						this._$previouslyTabbable = $("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]").not('[tabindex]').not(this.$instance.find('button'));

						this._$previouslyWithTabIndex = $('[tabindex]').not('[tabindex="-1"]');
						this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function (_i, elem) {
							return $(elem).attr('tabindex');
						});

						this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr('tabindex', -1);

						if (document.activeElement.blur) {
							document.activeElement.blur();
						}
						return _super(event);
					},

					afterClose: function afterClose(_super, event) {
						var r = _super(event);
						// Restore focus
						var self = this;
						this._$previouslyTabbable.removeAttr('tabindex');
						this._$previouslyWithTabIndex.each(function (i, elem) {
							$(elem).attr('tabindex', self._previousWithTabIndices[i]);
						});
						this._previouslyActive.focus();
						// Restore scroll
						if (Featherlight.opened().length === 0) {
							$(document.documentElement).removeClass('with-featherlight');
						}
						return r;
					},

					onResize: function onResize(_super, event) {
						this.resize(this.$content.naturalWidth, this.$content.naturalHeight);
						return _super(event);
					},

					afterContent: function afterContent(_super, event) {
						var r = _super(event);
						this.$instance.find('[autofocus]:not([disabled])').focus();
						this.onResize(event);
						return r;
					}
				}
			});

			$.featherlight = Featherlight;

			/* bind jQuery elements to trigger featherlight */
			$.fn.featherlight = function ($content, config) {
				Featherlight.attach(this, $content, config);
				return this;
			};

			/* bind featherlight on ready if config autoBind is set */
			$(document).ready(function () {
				Featherlight._onReady();
			});
		});
	}, { "jquery": 23 }], 22: [function (require, module, exports) {
		(function (root, factory) {

			if (root === null) {
				throw new Error('Google-maps package can be used only in browser');
			}

			if (typeof define === 'function' && define.amd) {
				define(factory);
			} else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
				module.exports = factory();
			} else {
				root.GoogleMapsLoader = factory();
			}
		})(typeof window !== 'undefined' ? window : null, function () {

			'use strict';

			var googleVersion = '3.31';

			var script = null;

			var google = null;

			var loading = false;

			var callbacks = [];

			var onLoadEvents = [];

			var originalCreateLoaderMethod = null;

			var GoogleMapsLoader = {};

			GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';

			GoogleMapsLoader.KEY = null;

			GoogleMapsLoader.LIBRARIES = [];

			GoogleMapsLoader.CLIENT = null;

			GoogleMapsLoader.CHANNEL = null;

			GoogleMapsLoader.LANGUAGE = null;

			GoogleMapsLoader.REGION = null;

			GoogleMapsLoader.VERSION = googleVersion;

			GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';

			GoogleMapsLoader._googleMockApiObject = {};

			GoogleMapsLoader.load = function (fn) {
				if (google === null) {
					if (loading === true) {
						if (fn) {
							callbacks.push(fn);
						}
					} else {
						loading = true;

						window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function () {
							ready(fn);
						};

						GoogleMapsLoader.createLoader();
					}
				} else if (fn) {
					fn(google);
				}
			};

			GoogleMapsLoader.createLoader = function () {
				script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = GoogleMapsLoader.createUrl();

				document.body.appendChild(script);
			};

			GoogleMapsLoader.isLoaded = function () {
				return google !== null;
			};

			GoogleMapsLoader.createUrl = function () {
				var url = GoogleMapsLoader.URL;

				url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;

				if (GoogleMapsLoader.KEY) {
					url += '&key=' + GoogleMapsLoader.KEY;
				}

				if (GoogleMapsLoader.LIBRARIES.length > 0) {
					url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
				}

				if (GoogleMapsLoader.CLIENT) {
					url += '&client=' + GoogleMapsLoader.CLIENT;
				}

				if (GoogleMapsLoader.CHANNEL) {
					url += '&channel=' + GoogleMapsLoader.CHANNEL;
				}

				if (GoogleMapsLoader.LANGUAGE) {
					url += '&language=' + GoogleMapsLoader.LANGUAGE;
				}

				if (GoogleMapsLoader.REGION) {
					url += '&region=' + GoogleMapsLoader.REGION;
				}

				if (GoogleMapsLoader.VERSION) {
					url += '&v=' + GoogleMapsLoader.VERSION;
				}

				return url;
			};

			GoogleMapsLoader.release = function (fn) {
				var release = function release() {
					GoogleMapsLoader.KEY = null;
					GoogleMapsLoader.LIBRARIES = [];
					GoogleMapsLoader.CLIENT = null;
					GoogleMapsLoader.CHANNEL = null;
					GoogleMapsLoader.LANGUAGE = null;
					GoogleMapsLoader.REGION = null;
					GoogleMapsLoader.VERSION = googleVersion;

					google = null;
					loading = false;
					callbacks = [];
					onLoadEvents = [];

					if (typeof window.google !== 'undefined') {
						delete window.google;
					}

					if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
						delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
					}

					if (originalCreateLoaderMethod !== null) {
						GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
						originalCreateLoaderMethod = null;
					}

					if (script !== null) {
						script.parentElement.removeChild(script);
						script = null;
					}

					if (fn) {
						fn();
					}
				};

				if (loading) {
					GoogleMapsLoader.load(function () {
						release();
					});
				} else {
					release();
				}
			};

			GoogleMapsLoader.onLoad = function (fn) {
				onLoadEvents.push(fn);
			};

			GoogleMapsLoader.makeMock = function () {
				originalCreateLoaderMethod = GoogleMapsLoader.createLoader;

				GoogleMapsLoader.createLoader = function () {
					window.google = GoogleMapsLoader._googleMockApiObject;
					window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
				};
			};

			var ready = function ready(fn) {
				var i;

				loading = false;

				if (google === null) {
					google = window.google;
				}

				for (i = 0; i < onLoadEvents.length; i++) {
					onLoadEvents[i](google);
				}

				if (fn) {
					fn(google);
				}

				for (i = 0; i < callbacks.length; i++) {
					callbacks[i](google);
				}

				callbacks = [];
			};

			return GoogleMapsLoader;
		});
	}, {}], 23: [function (require, module, exports) {
		/*!
   * jQuery JavaScript Library v3.5.1
   * https://jquery.com/
   *
   * Includes Sizzle.js
   * https://sizzlejs.com/
   *
   * Copyright JS Foundation and other contributors
   * Released under the MIT license
   * https://jquery.org/license
   *
   * Date: 2020-05-04T22:49Z
   */
		(function (global, factory) {

			"use strict";

			if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {

				// For CommonJS and CommonJS-like environments where a proper `window`
				// is present, execute the factory and get jQuery.
				// For environments that do not have a `window` with a `document`
				// (such as Node.js), expose a factory as module.exports.
				// This accentuates the need for the creation of a real `window`.
				// e.g. var jQuery = require("jquery")(window);
				// See ticket #14549 for more info.
				module.exports = global.document ? factory(global, true) : function (w) {
					if (!w.document) {
						throw new Error("jQuery requires a window with a document");
					}
					return factory(w);
				};
			} else {
				factory(global);
			}

			// Pass this if window is not defined yet
		})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

			// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
			// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
			// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
			// enough that all such attempts are guarded in a try block.
			"use strict";

			var arr = [];

			var getProto = Object.getPrototypeOf;

			var _slice = arr.slice;

			var flat = arr.flat ? function (array) {
				return arr.flat.call(array);
			} : function (array) {
				return arr.concat.apply([], array);
			};

			var push = arr.push;

			var indexOf = arr.indexOf;

			var class2type = {};

			var toString = class2type.toString;

			var hasOwn = class2type.hasOwnProperty;

			var fnToString = hasOwn.toString;

			var ObjectFunctionString = fnToString.call(Object);

			var support = {};

			var isFunction = function isFunction(obj) {

				// Support: Chrome <=57, Firefox <=52
				// In some browsers, typeof returns "function" for HTML <object> elements
				// (i.e., `typeof document.createElement( "object" ) === "function"`).
				// We don't want to classify *any* DOM node as a function.
				return typeof obj === "function" && typeof obj.nodeType !== "number";
			};

			var isWindow = function isWindow(obj) {
				return obj != null && obj === obj.window;
			};

			var document = window.document;

			var preservedScriptAttributes = {
				type: true,
				src: true,
				nonce: true,
				noModule: true
			};

			function DOMEval(code, node, doc) {
				doc = doc || document;

				var i,
				    val,
				    script = doc.createElement("script");

				script.text = code;
				if (node) {
					for (i in preservedScriptAttributes) {

						// Support: Firefox 64+, Edge 18+
						// Some browsers don't support the "nonce" property on scripts.
						// On the other hand, just using `getAttribute` is not enough as
						// the `nonce` attribute is reset to an empty string whenever it
						// becomes browsing-context connected.
						// See https://github.com/whatwg/html/issues/2369
						// See https://html.spec.whatwg.org/#nonce-attributes
						// The `node.getAttribute` check was added for the sake of
						// `jQuery.globalEval` so that it can fake a nonce-containing node
						// via an object.
						val = node[i] || node.getAttribute && node.getAttribute(i);
						if (val) {
							script.setAttribute(i, val);
						}
					}
				}
				doc.head.appendChild(script).parentNode.removeChild(script);
			}

			function toType(obj) {
				if (obj == null) {
					return obj + "";
				}

				// Support: Android <=2.3 only (functionish RegExp)
				return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
			}
			/* global Symbol */
			// Defining this global in .eslintrc.json would create a danger of using the global
			// unguarded in another place, it seems safer to define global only for this module


			var version = "3.5.1",


			// Define a local copy of jQuery
			jQuery = function jQuery(selector, context) {

				// The jQuery object is actually just the init constructor 'enhanced'
				// Need init if jQuery is called (just allow error to be thrown if not included)
				return new jQuery.fn.init(selector, context);
			};

			jQuery.fn = jQuery.prototype = {

				// The current version of jQuery being used
				jquery: version,

				constructor: jQuery,

				// The default length of a jQuery object is 0
				length: 0,

				toArray: function toArray() {
					return _slice.call(this);
				},

				// Get the Nth element in the matched element set OR
				// Get the whole matched element set as a clean array
				get: function get(num) {

					// Return all the elements in a clean array
					if (num == null) {
						return _slice.call(this);
					}

					// Return just the one element from the set
					return num < 0 ? this[num + this.length] : this[num];
				},

				// Take an array of elements and push it onto the stack
				// (returning the new matched element set)
				pushStack: function pushStack(elems) {

					// Build a new jQuery matched element set
					var ret = jQuery.merge(this.constructor(), elems);

					// Add the old object onto the stack (as a reference)
					ret.prevObject = this;

					// Return the newly-formed element set
					return ret;
				},

				// Execute a callback for every element in the matched set.
				each: function each(callback) {
					return jQuery.each(this, callback);
				},

				map: function map(callback) {
					return this.pushStack(jQuery.map(this, function (elem, i) {
						return callback.call(elem, i, elem);
					}));
				},

				slice: function slice() {
					return this.pushStack(_slice.apply(this, arguments));
				},

				first: function first() {
					return this.eq(0);
				},

				last: function last() {
					return this.eq(-1);
				},

				even: function even() {
					return this.pushStack(jQuery.grep(this, function (_elem, i) {
						return (i + 1) % 2;
					}));
				},

				odd: function odd() {
					return this.pushStack(jQuery.grep(this, function (_elem, i) {
						return i % 2;
					}));
				},

				eq: function eq(i) {
					var len = this.length,
					    j = +i + (i < 0 ? len : 0);
					return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
				},

				end: function end() {
					return this.prevObject || this.constructor();
				},

				// For internal use only.
				// Behaves like an Array's method, not like a jQuery method.
				push: push,
				sort: arr.sort,
				splice: arr.splice
			};

			jQuery.extend = jQuery.fn.extend = function () {
				var options,
				    name,
				    src,
				    copy,
				    copyIsArray,
				    clone,
				    target = arguments[0] || {},
				    i = 1,
				    length = arguments.length,
				    deep = false;

				// Handle a deep copy situation
				if (typeof target === "boolean") {
					deep = target;

					// Skip the boolean and the target
					target = arguments[i] || {};
					i++;
				}

				// Handle case when target is a string or something (possible in deep copy)
				if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
					target = {};
				}

				// Extend jQuery itself if only one argument is passed
				if (i === length) {
					target = this;
					i--;
				}

				for (; i < length; i++) {

					// Only deal with non-null/undefined values
					if ((options = arguments[i]) != null) {

						// Extend the base object
						for (name in options) {
							copy = options[name];

							// Prevent Object.prototype pollution
							// Prevent never-ending loop
							if (name === "__proto__" || target === copy) {
								continue;
							}

							// Recurse if we're merging plain objects or arrays
							if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
								src = target[name];

								// Ensure proper type for the source value
								if (copyIsArray && !Array.isArray(src)) {
									clone = [];
								} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
									clone = {};
								} else {
									clone = src;
								}
								copyIsArray = false;

								// Never move original objects, clone them
								target[name] = jQuery.extend(deep, clone, copy);

								// Don't bring in undefined values
							} else if (copy !== undefined) {
								target[name] = copy;
							}
						}
					}
				}

				// Return the modified object
				return target;
			};

			jQuery.extend({

				// Unique for each copy of jQuery on the page
				expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

				// Assume jQuery is ready without the ready module
				isReady: true,

				error: function error(msg) {
					throw new Error(msg);
				},

				noop: function noop() {},

				isPlainObject: function isPlainObject(obj) {
					var proto, Ctor;

					// Detect obvious negatives
					// Use toString instead of jQuery.type to catch host objects
					if (!obj || toString.call(obj) !== "[object Object]") {
						return false;
					}

					proto = getProto(obj);

					// Objects with no prototype (e.g., `Object.create( null )`) are plain
					if (!proto) {
						return true;
					}

					// Objects with prototype are plain iff they were constructed by a global Object function
					Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
					return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
				},

				isEmptyObject: function isEmptyObject(obj) {
					var name;

					for (name in obj) {
						return false;
					}
					return true;
				},

				// Evaluates a script in a provided context; falls back to the global one
				// if not specified.
				globalEval: function globalEval(code, options, doc) {
					DOMEval(code, { nonce: options && options.nonce }, doc);
				},

				each: function each(obj, callback) {
					var length,
					    i = 0;

					if (isArrayLike(obj)) {
						length = obj.length;
						for (; i < length; i++) {
							if (callback.call(obj[i], i, obj[i]) === false) {
								break;
							}
						}
					} else {
						for (i in obj) {
							if (callback.call(obj[i], i, obj[i]) === false) {
								break;
							}
						}
					}

					return obj;
				},

				// results is for internal usage only
				makeArray: function makeArray(arr, results) {
					var ret = results || [];

					if (arr != null) {
						if (isArrayLike(Object(arr))) {
							jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
						} else {
							push.call(ret, arr);
						}
					}

					return ret;
				},

				inArray: function inArray(elem, arr, i) {
					return arr == null ? -1 : indexOf.call(arr, elem, i);
				},

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				merge: function merge(first, second) {
					var len = +second.length,
					    j = 0,
					    i = first.length;

					for (; j < len; j++) {
						first[i++] = second[j];
					}

					first.length = i;

					return first;
				},

				grep: function grep(elems, callback, invert) {
					var callbackInverse,
					    matches = [],
					    i = 0,
					    length = elems.length,
					    callbackExpect = !invert;

					// Go through the array, only saving the items
					// that pass the validator function
					for (; i < length; i++) {
						callbackInverse = !callback(elems[i], i);
						if (callbackInverse !== callbackExpect) {
							matches.push(elems[i]);
						}
					}

					return matches;
				},

				// arg is for internal usage only
				map: function map(elems, callback, arg) {
					var length,
					    value,
					    i = 0,
					    ret = [];

					// Go through the array, translating each of the items to their new values
					if (isArrayLike(elems)) {
						length = elems.length;
						for (; i < length; i++) {
							value = callback(elems[i], i, arg);

							if (value != null) {
								ret.push(value);
							}
						}

						// Go through every key on the object,
					} else {
						for (i in elems) {
							value = callback(elems[i], i, arg);

							if (value != null) {
								ret.push(value);
							}
						}
					}

					// Flatten any nested arrays
					return flat(ret);
				},

				// A global GUID counter for objects
				guid: 1,

				// jQuery.support is not used in Core but other projects attach their
				// properties to it so it needs to exist.
				support: support
			});

			if (typeof Symbol === "function") {
				jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
			}

			// Populate the class2type map
			jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
				class2type["[object " + name + "]"] = name.toLowerCase();
			});

			function isArrayLike(obj) {

				// Support: real iOS 8.2 only (not reproducible in simulator)
				// `in` check used to prevent JIT error (gh-2145)
				// hasOwn isn't used here due to false negatives
				// regarding Nodelist length in IE
				var length = !!obj && "length" in obj && obj.length,
				    type = toType(obj);

				if (isFunction(obj) || isWindow(obj)) {
					return false;
				}

				return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
			}
			var Sizzle =
			/*!
    * Sizzle CSS Selector Engine v2.3.5
    * https://sizzlejs.com/
    *
    * Copyright JS Foundation and other contributors
    * Released under the MIT license
    * https://js.foundation/
    *
    * Date: 2020-03-14
    */
			function (window) {
				var i,
				    support,
				    Expr,
				    getText,
				    isXML,
				    tokenize,
				    compile,
				    select,
				    outermostContext,
				    sortInput,
				    hasDuplicate,


				// Local document vars
				setDocument,
				    document,
				    docElem,
				    documentIsHTML,
				    rbuggyQSA,
				    rbuggyMatches,
				    matches,
				    contains,


				// Instance-specific data
				expando = "sizzle" + 1 * new Date(),
				    preferredDoc = window.document,
				    dirruns = 0,
				    done = 0,
				    classCache = createCache(),
				    tokenCache = createCache(),
				    compilerCache = createCache(),
				    nonnativeSelectorCache = createCache(),
				    sortOrder = function sortOrder(a, b) {
					if (a === b) {
						hasDuplicate = true;
					}
					return 0;
				},


				// Instance methods
				hasOwn = {}.hasOwnProperty,
				    arr = [],
				    pop = arr.pop,
				    pushNative = arr.push,
				    push = arr.push,
				    slice = arr.slice,


				// Use a stripped-down indexOf as it's faster than native
				// https://jsperf.com/thor-indexof-vs-for/5
				indexOf = function indexOf(list, elem) {
					var i = 0,
					    len = list.length;
					for (; i < len; i++) {
						if (list[i] === elem) {
							return i;
						}
					}
					return -1;
				},
				    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" + "ismap|loop|multiple|open|readonly|required|scoped",


				// Regular expressions

				// http://www.w3.org/TR/css3-selectors/#whitespace
				whitespace = "[\\x20\\t\\r\\n\\f]",


				// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
				identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",


				// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
				attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

				// Operator (capture 2)
				"*([*^$|!~]?=)" + whitespace +

				// "Attribute values must be CSS identifiers [capture 5]
				// or strings [capture 3 or capture 4]"
				"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
				    pseudos = ":(" + identifier + ")(?:\\((" +

				// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
				// 1. quoted (capture 3; capture 4 or capture 5)
				"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

				// 2. simple (capture 6)
				"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

				// 3. anything else (capture 2)
				".*" + ")\\)|)",


				// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
				rwhitespace = new RegExp(whitespace + "+", "g"),
				    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
				    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
				    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
				    rdescend = new RegExp(whitespace + "|>"),
				    rpseudo = new RegExp(pseudos),
				    ridentifier = new RegExp("^" + identifier + "$"),
				    matchExpr = {
					"ID": new RegExp("^#(" + identifier + ")"),
					"CLASS": new RegExp("^\\.(" + identifier + ")"),
					"TAG": new RegExp("^(" + identifier + "|[*])"),
					"ATTR": new RegExp("^" + attributes),
					"PSEUDO": new RegExp("^" + pseudos),
					"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
					"bool": new RegExp("^(?:" + booleans + ")$", "i"),

					// For use in libraries implementing .is()
					// We use this for POS matching in `select`
					"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
				},
				    rhtml = /HTML$/i,
				    rinputs = /^(?:input|select|textarea|button)$/i,
				    rheader = /^h\d$/i,
				    rnative = /^[^{]+\{\s*\[native \w/,


				// Easily-parseable/retrievable ID or TAG or CLASS selectors
				rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
				    rsibling = /[+~]/,


				// CSS escapes
				// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
				runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
				    funescape = function funescape(escape, nonHex) {
					var high = "0x" + escape.slice(1) - 0x10000;

					return nonHex ?

					// Strip the backslash prefix from a non-hex escape sequence
					nonHex :

					// Replace a hexadecimal escape sequence with the encoded Unicode code point
					// Support: IE <=11+
					// For values outside the Basic Multilingual Plane (BMP), manually construct a
					// surrogate pair
					high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
				},


				// CSS string/identifier serialization
				// https://drafts.csswg.org/cssom/#common-serializing-idioms
				rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
				    fcssescape = function fcssescape(ch, asCodePoint) {
					if (asCodePoint) {

						// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
						if (ch === "\0") {
							return "\uFFFD";
						}

						// Control characters and (dependent upon position) numbers get escaped as code points
						return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
					}

					// Other potentially-special ASCII characters get backslash-escaped
					return "\\" + ch;
				},


				// Used for iframes
				// See setDocument()
				// Removing the function wrapper causes a "Permission Denied"
				// error in IE
				unloadHandler = function unloadHandler() {
					setDocument();
				},
				    inDisabledFieldset = addCombinator(function (elem) {
					return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
				}, { dir: "parentNode", next: "legend" });

				// Optimize for push.apply( _, NodeList )
				try {
					push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

					// Support: Android<4.0
					// Detect silently failing push.apply
					// eslint-disable-next-line no-unused-expressions
					arr[preferredDoc.childNodes.length].nodeType;
				} catch (e) {
					push = { apply: arr.length ?

						// Leverage slice if possible
						function (target, els) {
							pushNative.apply(target, slice.call(els));
						} :

						// Support: IE<9
						// Otherwise append directly
						function (target, els) {
							var j = target.length,
							    i = 0;

							// Can't trust NodeList.length
							while (target[j++] = els[i++]) {}
							target.length = j - 1;
						}
					};
				}

				function Sizzle(selector, context, results, seed) {
					var m,
					    i,
					    elem,
					    nid,
					    match,
					    groups,
					    newSelector,
					    newContext = context && context.ownerDocument,


					// nodeType defaults to 9, since context defaults to document
					nodeType = context ? context.nodeType : 9;

					results = results || [];

					// Return early from calls with invalid selector or context
					if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

						return results;
					}

					// Try to shortcut find operations (as opposed to filters) in HTML documents
					if (!seed) {
						setDocument(context);
						context = context || document;

						if (documentIsHTML) {

							// If the selector is sufficiently simple, try using a "get*By*" DOM method
							// (excepting DocumentFragment context, where the methods don't exist)
							if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

								// ID selector
								if (m = match[1]) {

									// Document context
									if (nodeType === 9) {
										if (elem = context.getElementById(m)) {

											// Support: IE, Opera, Webkit
											// TODO: identify versions
											// getElementById can match elements by name instead of ID
											if (elem.id === m) {
												results.push(elem);
												return results;
											}
										} else {
											return results;
										}

										// Element context
									} else {

										// Support: IE, Opera, Webkit
										// TODO: identify versions
										// getElementById can match elements by name instead of ID
										if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {

											results.push(elem);
											return results;
										}
									}

									// Type selector
								} else if (match[2]) {
									push.apply(results, context.getElementsByTagName(selector));
									return results;

									// Class selector
								} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {

									push.apply(results, context.getElementsByClassName(m));
									return results;
								}
							}

							// Take advantage of querySelectorAll
							if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && (

							// Support: IE 8 only
							// Exclude object elements
							nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {

								newSelector = selector;
								newContext = context;

								// qSA considers elements outside a scoping root when evaluating child or
								// descendant combinators, which is not what we want.
								// In such cases, we work around the behavior by prefixing every selector in the
								// list with an ID selector referencing the scope context.
								// The technique has to be used as well when a leading combinator is used
								// as such selectors are not recognized by querySelectorAll.
								// Thanks to Andrew Dupont for this technique.
								if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {

									// Expand context for sibling selectors
									newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

									// We can use :scope instead of the ID hack if the browser
									// supports it & if we're not changing the context.
									if (newContext !== context || !support.scope) {

										// Capture the context ID, setting it first if necessary
										if (nid = context.getAttribute("id")) {
											nid = nid.replace(rcssescape, fcssescape);
										} else {
											context.setAttribute("id", nid = expando);
										}
									}

									// Prefix every selector in the list
									groups = tokenize(selector);
									i = groups.length;
									while (i--) {
										groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
									}
									newSelector = groups.join(",");
								}

								try {
									push.apply(results, newContext.querySelectorAll(newSelector));
									return results;
								} catch (qsaError) {
									nonnativeSelectorCache(selector, true);
								} finally {
									if (nid === expando) {
										context.removeAttribute("id");
									}
								}
							}
						}
					}

					// All others
					return select(selector.replace(rtrim, "$1"), context, results, seed);
				}

				/**
     * Create key-value caches of limited size
     * @returns {function(string, object)} Returns the Object data after storing it on itself with
     *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
     *	deleting the oldest entry
     */
				function createCache() {
					var keys = [];

					function cache(key, value) {

						// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
						if (keys.push(key + " ") > Expr.cacheLength) {

							// Only keep the most recent entries
							delete cache[keys.shift()];
						}
						return cache[key + " "] = value;
					}
					return cache;
				}

				/**
     * Mark a function for special use by Sizzle
     * @param {Function} fn The function to mark
     */
				function markFunction(fn) {
					fn[expando] = true;
					return fn;
				}

				/**
     * Support testing using an element
     * @param {Function} fn Passed the created element and returns a boolean result
     */
				function assert(fn) {
					var el = document.createElement("fieldset");

					try {
						return !!fn(el);
					} catch (e) {
						return false;
					} finally {

						// Remove from its parent by default
						if (el.parentNode) {
							el.parentNode.removeChild(el);
						}

						// release memory in IE
						el = null;
					}
				}

				/**
     * Adds the same handler for all of the specified attrs
     * @param {String} attrs Pipe-separated list of attributes
     * @param {Function} handler The method that will be applied
     */
				function addHandle(attrs, handler) {
					var arr = attrs.split("|"),
					    i = arr.length;

					while (i--) {
						Expr.attrHandle[arr[i]] = handler;
					}
				}

				/**
     * Checks document order of two siblings
     * @param {Element} a
     * @param {Element} b
     * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
     */
				function siblingCheck(a, b) {
					var cur = b && a,
					    diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;

					// Use IE sourceIndex if available on both nodes
					if (diff) {
						return diff;
					}

					// Check if b follows a
					if (cur) {
						while (cur = cur.nextSibling) {
							if (cur === b) {
								return -1;
							}
						}
					}

					return a ? 1 : -1;
				}

				/**
     * Returns a function to use in pseudos for input types
     * @param {String} type
     */
				function createInputPseudo(type) {
					return function (elem) {
						var name = elem.nodeName.toLowerCase();
						return name === "input" && elem.type === type;
					};
				}

				/**
     * Returns a function to use in pseudos for buttons
     * @param {String} type
     */
				function createButtonPseudo(type) {
					return function (elem) {
						var name = elem.nodeName.toLowerCase();
						return (name === "input" || name === "button") && elem.type === type;
					};
				}

				/**
     * Returns a function to use in pseudos for :enabled/:disabled
     * @param {Boolean} disabled true for :disabled; false for :enabled
     */
				function createDisabledPseudo(disabled) {

					// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
					return function (elem) {

						// Only certain elements can match :enabled or :disabled
						// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
						// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
						if ("form" in elem) {

							// Check for inherited disabledness on relevant non-disabled elements:
							// * listed form-associated elements in a disabled fieldset
							//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
							//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
							// * option elements in a disabled optgroup
							//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
							// All such elements have a "form" property.
							if (elem.parentNode && elem.disabled === false) {

								// Option elements defer to a parent optgroup if present
								if ("label" in elem) {
									if ("label" in elem.parentNode) {
										return elem.parentNode.disabled === disabled;
									} else {
										return elem.disabled === disabled;
									}
								}

								// Support: IE 6 - 11
								// Use the isDisabled shortcut property to check for disabled fieldset ancestors
								return elem.isDisabled === disabled ||

								// Where there is no isDisabled, check manually
								/* jshint -W018 */
								elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
							}

							return elem.disabled === disabled;

							// Try to winnow out elements that can't be disabled before trusting the disabled property.
							// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
							// even exist on them, let alone have a boolean value.
						} else if ("label" in elem) {
							return elem.disabled === disabled;
						}

						// Remaining elements are neither :enabled nor :disabled
						return false;
					};
				}

				/**
     * Returns a function to use in pseudos for positionals
     * @param {Function} fn
     */
				function createPositionalPseudo(fn) {
					return markFunction(function (argument) {
						argument = +argument;
						return markFunction(function (seed, matches) {
							var j,
							    matchIndexes = fn([], seed.length, argument),
							    i = matchIndexes.length;

							// Match elements found at the specified indexes
							while (i--) {
								if (seed[j = matchIndexes[i]]) {
									seed[j] = !(matches[j] = seed[j]);
								}
							}
						});
					});
				}

				/**
     * Checks a node for validity as a Sizzle context
     * @param {Element|Object=} context
     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
     */
				function testContext(context) {
					return context && typeof context.getElementsByTagName !== "undefined" && context;
				}

				// Expose support vars for convenience
				support = Sizzle.support = {};

				/**
     * Detects XML nodes
     * @param {Element|Object} elem An element or a document
     * @returns {Boolean} True iff elem is a non-HTML XML node
     */
				isXML = Sizzle.isXML = function (elem) {
					var namespace = elem.namespaceURI,
					    docElem = (elem.ownerDocument || elem).documentElement;

					// Support: IE <=8
					// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
					// https://bugs.jquery.com/ticket/4833
					return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
				};

				/**
     * Sets document-related variables once based on the current document
     * @param {Element|Object} [doc] An element or document object to use to set the document
     * @returns {Object} Returns the current document
     */
				setDocument = Sizzle.setDocument = function (node) {
					var hasCompare,
					    subWindow,
					    doc = node ? node.ownerDocument || node : preferredDoc;

					// Return early if doc is invalid or already selected
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
						return document;
					}

					// Update global variables
					document = doc;
					docElem = document.documentElement;
					documentIsHTML = !isXML(document);

					// Support: IE 9 - 11+, Edge 12 - 18+
					// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {

						// Support: IE 11, Edge
						if (subWindow.addEventListener) {
							subWindow.addEventListener("unload", unloadHandler, false);

							// Support: IE 9 - 10 only
						} else if (subWindow.attachEvent) {
							subWindow.attachEvent("onunload", unloadHandler);
						}
					}

					// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
					// Safari 4 - 5 only, Opera <=11.6 - 12.x only
					// IE/Edge & older browsers don't support the :scope pseudo-class.
					// Support: Safari 6.0 only
					// Safari 6.0 supports :scope but it's an alias of :root there.
					support.scope = assert(function (el) {
						docElem.appendChild(el).appendChild(document.createElement("div"));
						return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
					});

					/* Attributes
     ---------------------------------------------------------------------- */

					// Support: IE<8
					// Verify that getAttribute really returns attributes and not properties
					// (excepting IE8 booleans)
					support.attributes = assert(function (el) {
						el.className = "i";
						return !el.getAttribute("className");
					});

					/* getElement(s)By*
     ---------------------------------------------------------------------- */

					// Check if getElementsByTagName("*") returns only elements
					support.getElementsByTagName = assert(function (el) {
						el.appendChild(document.createComment(""));
						return !el.getElementsByTagName("*").length;
					});

					// Support: IE<9
					support.getElementsByClassName = rnative.test(document.getElementsByClassName);

					// Support: IE<10
					// Check if getElementById returns elements by name
					// The broken getElementById methods don't pick up programmatically-set names,
					// so use a roundabout getElementsByName test
					support.getById = assert(function (el) {
						docElem.appendChild(el).id = expando;
						return !document.getElementsByName || !document.getElementsByName(expando).length;
					});

					// ID filter and find
					if (support.getById) {
						Expr.filter["ID"] = function (id) {
							var attrId = id.replace(runescape, funescape);
							return function (elem) {
								return elem.getAttribute("id") === attrId;
							};
						};
						Expr.find["ID"] = function (id, context) {
							if (typeof context.getElementById !== "undefined" && documentIsHTML) {
								var elem = context.getElementById(id);
								return elem ? [elem] : [];
							}
						};
					} else {
						Expr.filter["ID"] = function (id) {
							var attrId = id.replace(runescape, funescape);
							return function (elem) {
								var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
								return node && node.value === attrId;
							};
						};

						// Support: IE 6 - 7 only
						// getElementById is not reliable as a find shortcut
						Expr.find["ID"] = function (id, context) {
							if (typeof context.getElementById !== "undefined" && documentIsHTML) {
								var node,
								    i,
								    elems,
								    elem = context.getElementById(id);

								if (elem) {

									// Verify the id attribute
									node = elem.getAttributeNode("id");
									if (node && node.value === id) {
										return [elem];
									}

									// Fall back on getElementsByName
									elems = context.getElementsByName(id);
									i = 0;
									while (elem = elems[i++]) {
										node = elem.getAttributeNode("id");
										if (node && node.value === id) {
											return [elem];
										}
									}
								}

								return [];
							}
						};
					}

					// Tag
					Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
						if (typeof context.getElementsByTagName !== "undefined") {
							return context.getElementsByTagName(tag);

							// DocumentFragment nodes don't have gEBTN
						} else if (support.qsa) {
							return context.querySelectorAll(tag);
						}
					} : function (tag, context) {
						var elem,
						    tmp = [],
						    i = 0,


						// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
						results = context.getElementsByTagName(tag);

						// Filter out possible comments
						if (tag === "*") {
							while (elem = results[i++]) {
								if (elem.nodeType === 1) {
									tmp.push(elem);
								}
							}

							return tmp;
						}
						return results;
					};

					// Class
					Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
						if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
							return context.getElementsByClassName(className);
						}
					};

					/* QSA/matchesSelector
     ---------------------------------------------------------------------- */

					// QSA and matchesSelector support

					// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
					rbuggyMatches = [];

					// qSa(:focus) reports false when true (Chrome 21)
					// We allow this because of a bug in IE8/9 that throws an error
					// whenever `document.activeElement` is accessed on an iframe
					// So, we allow :focus to pass through QSA all the time to avoid the IE error
					// See https://bugs.jquery.com/ticket/13378
					rbuggyQSA = [];

					if (support.qsa = rnative.test(document.querySelectorAll)) {

						// Build QSA regex
						// Regex strategy adopted from Diego Perini
						assert(function (el) {

							var input;

							// Select is set to empty string on purpose
							// This is to test IE's treatment of not explicitly
							// setting a boolean content attribute,
							// since its presence should be enough
							// https://bugs.jquery.com/ticket/12359
							docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";

							// Support: IE8, Opera 11-12.16
							// Nothing should be selected when empty strings follow ^= or $= or *=
							// The test attribute must be unknown in Opera but "safe" for WinRT
							// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
							if (el.querySelectorAll("[msallowcapture^='']").length) {
								rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
							}

							// Support: IE8
							// Boolean attributes and "value" are not treated correctly
							if (!el.querySelectorAll("[selected]").length) {
								rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
							}

							// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
							if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
								rbuggyQSA.push("~=");
							}

							// Support: IE 11+, Edge 15 - 18+
							// IE 11/Edge don't find elements on a `[name='']` query in some cases.
							// Adding a temporary attribute to the document before the selection works
							// around the issue.
							// Interestingly, IE 10 & older don't seem to have the issue.
							input = document.createElement("input");
							input.setAttribute("name", "");
							el.appendChild(input);
							if (!el.querySelectorAll("[name='']").length) {
								rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
							}

							// Webkit/Opera - :checked should return selected option elements
							// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
							// IE8 throws error here and will not see later tests
							if (!el.querySelectorAll(":checked").length) {
								rbuggyQSA.push(":checked");
							}

							// Support: Safari 8+, iOS 8+
							// https://bugs.webkit.org/show_bug.cgi?id=136851
							// In-page `selector#id sibling-combinator selector` fails
							if (!el.querySelectorAll("a#" + expando + "+*").length) {
								rbuggyQSA.push(".#.+[+~]");
							}

							// Support: Firefox <=3.6 - 5 only
							// Old Firefox doesn't throw on a badly-escaped identifier.
							el.querySelectorAll("\\\f");
							rbuggyQSA.push("[\\r\\n\\f]");
						});

						assert(function (el) {
							el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";

							// Support: Windows 8 Native Apps
							// The type and name attributes are restricted during .innerHTML assignment
							var input = document.createElement("input");
							input.setAttribute("type", "hidden");
							el.appendChild(input).setAttribute("name", "D");

							// Support: IE8
							// Enforce case-sensitivity of name attribute
							if (el.querySelectorAll("[name=d]").length) {
								rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
							}

							// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
							// IE8 throws error here and will not see later tests
							if (el.querySelectorAll(":enabled").length !== 2) {
								rbuggyQSA.push(":enabled", ":disabled");
							}

							// Support: IE9-11+
							// IE's :disabled selector does not pick up the children of disabled fieldsets
							docElem.appendChild(el).disabled = true;
							if (el.querySelectorAll(":disabled").length !== 2) {
								rbuggyQSA.push(":enabled", ":disabled");
							}

							// Support: Opera 10 - 11 only
							// Opera 10-11 does not throw on post-comma invalid pseudos
							el.querySelectorAll("*,:x");
							rbuggyQSA.push(",.*:");
						});
					}

					if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {

						assert(function (el) {

							// Check to see if it's possible to do matchesSelector
							// on a disconnected node (IE 9)
							support.disconnectedMatch = matches.call(el, "*");

							// This should fail with an exception
							// Gecko does not error, returns false instead
							matches.call(el, "[s!='']:x");
							rbuggyMatches.push("!=", pseudos);
						});
					}

					rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
					rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

					/* Contains
     ---------------------------------------------------------------------- */
					hasCompare = rnative.test(docElem.compareDocumentPosition);

					// Element contains another
					// Purposefully self-exclusive
					// As in, an element does not contain itself
					contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
						var adown = a.nodeType === 9 ? a.documentElement : a,
						    bup = b && b.parentNode;
						return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
					} : function (a, b) {
						if (b) {
							while (b = b.parentNode) {
								if (b === a) {
									return true;
								}
							}
						}
						return false;
					};

					/* Sorting
     ---------------------------------------------------------------------- */

					// Document order sorting
					sortOrder = hasCompare ? function (a, b) {

						// Flag for duplicate removal
						if (a === b) {
							hasDuplicate = true;
							return 0;
						}

						// Sort on method existence if only one input has compareDocumentPosition
						var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
						if (compare) {
							return compare;
						}

						// Calculate position if both inputs belong to the same document
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :

						// Otherwise we know they are disconnected
						1;

						// Disconnected nodes
						if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {

							// Choose the first element that is related to our preferred document
							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) {
								return -1;
							}

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) {
								return 1;
							}

							// Maintain original order
							return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
						}

						return compare & 4 ? -1 : 1;
					} : function (a, b) {

						// Exit early if the nodes are identical
						if (a === b) {
							hasDuplicate = true;
							return 0;
						}

						var cur,
						    i = 0,
						    aup = a.parentNode,
						    bup = b.parentNode,
						    ap = [a],
						    bp = [b];

						// Parentless nodes are either documents or disconnected
						if (!aup || !bup) {

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							/* eslint-disable eqeqeq */
							return a == document ? -1 : b == document ? 1 :
							/* eslint-enable eqeqeq */
							aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;

							// If the nodes are siblings, we can do a quick check
						} else if (aup === bup) {
							return siblingCheck(a, b);
						}

						// Otherwise we need full lists of their ancestors for comparison
						cur = a;
						while (cur = cur.parentNode) {
							ap.unshift(cur);
						}
						cur = b;
						while (cur = cur.parentNode) {
							bp.unshift(cur);
						}

						// Walk down the tree looking for a discrepancy
						while (ap[i] === bp[i]) {
							i++;
						}

						return i ?

						// Do a sibling check if the nodes have a common ancestor
						siblingCheck(ap[i], bp[i]) :

						// Otherwise nodes in our document sort first
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						/* eslint-disable eqeqeq */
						ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 :
						/* eslint-enable eqeqeq */
						0;
					};

					return document;
				};

				Sizzle.matches = function (expr, elements) {
					return Sizzle(expr, null, null, elements);
				};

				Sizzle.matchesSelector = function (elem, expr) {
					setDocument(elem);

					if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {

						try {
							var ret = matches.call(elem, expr);

							// IE 9's matchesSelector returns false on disconnected nodes
							if (ret || support.disconnectedMatch ||

							// As well, disconnected nodes are said to be in a document
							// fragment in IE 9
							elem.document && elem.document.nodeType !== 11) {
								return ret;
							}
						} catch (e) {
							nonnativeSelectorCache(expr, true);
						}
					}

					return Sizzle(expr, document, null, [elem]).length > 0;
				};

				Sizzle.contains = function (context, elem) {

					// Set document vars if needed
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ((context.ownerDocument || context) != document) {
						setDocument(context);
					}
					return contains(context, elem);
				};

				Sizzle.attr = function (elem, name) {

					// Set document vars if needed
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ((elem.ownerDocument || elem) != document) {
						setDocument(elem);
					}

					var fn = Expr.attrHandle[name.toLowerCase()],


					// Don't get fooled by Object.prototype properties (jQuery #13807)
					val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

					return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
				};

				Sizzle.escape = function (sel) {
					return (sel + "").replace(rcssescape, fcssescape);
				};

				Sizzle.error = function (msg) {
					throw new Error("Syntax error, unrecognized expression: " + msg);
				};

				/**
     * Document sorting and removing duplicates
     * @param {ArrayLike} results
     */
				Sizzle.uniqueSort = function (results) {
					var elem,
					    duplicates = [],
					    j = 0,
					    i = 0;

					// Unless we *know* we can detect duplicates, assume their presence
					hasDuplicate = !support.detectDuplicates;
					sortInput = !support.sortStable && results.slice(0);
					results.sort(sortOrder);

					if (hasDuplicate) {
						while (elem = results[i++]) {
							if (elem === results[i]) {
								j = duplicates.push(i);
							}
						}
						while (j--) {
							results.splice(duplicates[j], 1);
						}
					}

					// Clear input after sorting to release objects
					// See https://github.com/jquery/sizzle/pull/225
					sortInput = null;

					return results;
				};

				/**
     * Utility function for retrieving the text value of an array of DOM nodes
     * @param {Array|Element} elem
     */
				getText = Sizzle.getText = function (elem) {
					var node,
					    ret = "",
					    i = 0,
					    nodeType = elem.nodeType;

					if (!nodeType) {

						// If no nodeType, this is expected to be an array
						while (node = elem[i++]) {

							// Do not traverse comment nodes
							ret += getText(node);
						}
					} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {

						// Use textContent for elements
						// innerText usage removed for consistency of new lines (jQuery #11153)
						if (typeof elem.textContent === "string") {
							return elem.textContent;
						} else {

							// Traverse its children
							for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
								ret += getText(elem);
							}
						}
					} else if (nodeType === 3 || nodeType === 4) {
						return elem.nodeValue;
					}

					// Do not include comment or processing instruction nodes

					return ret;
				};

				Expr = Sizzle.selectors = {

					// Can be adjusted by the user
					cacheLength: 50,

					createPseudo: markFunction,

					match: matchExpr,

					attrHandle: {},

					find: {},

					relative: {
						">": { dir: "parentNode", first: true },
						" ": { dir: "parentNode" },
						"+": { dir: "previousSibling", first: true },
						"~": { dir: "previousSibling" }
					},

					preFilter: {
						"ATTR": function ATTR(match) {
							match[1] = match[1].replace(runescape, funescape);

							// Move the given value to match[3] whether quoted or unquoted
							match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

							if (match[2] === "~=") {
								match[3] = " " + match[3] + " ";
							}

							return match.slice(0, 4);
						},

						"CHILD": function CHILD(match) {

							/* matches from matchExpr["CHILD"]
       	1 type (only|nth|...)
       	2 what (child|of-type)
       	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
       	4 xn-component of xn+y argument ([+-]?\d*n|)
       	5 sign of xn-component
       	6 x of xn-component
       	7 sign of y-component
       	8 y of y-component
       */
							match[1] = match[1].toLowerCase();

							if (match[1].slice(0, 3) === "nth") {

								// nth-* requires argument
								if (!match[3]) {
									Sizzle.error(match[0]);
								}

								// numeric x and y parameters for Expr.filter.CHILD
								// remember that false/true cast respectively to 0/1
								match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
								match[5] = +(match[7] + match[8] || match[3] === "odd");

								// other types prohibit arguments
							} else if (match[3]) {
								Sizzle.error(match[0]);
							}

							return match;
						},

						"PSEUDO": function PSEUDO(match) {
							var excess,
							    unquoted = !match[6] && match[2];

							if (matchExpr["CHILD"].test(match[0])) {
								return null;
							}

							// Accept quoted arguments as-is
							if (match[3]) {
								match[2] = match[4] || match[5] || "";

								// Strip excess characters from unquoted arguments
							} else if (unquoted && rpseudo.test(unquoted) && (

							// Get excess from tokenize (recursively)
							excess = tokenize(unquoted, true)) && (

							// advance to the next closing parenthesis
							excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

								// excess is a negative index
								match[0] = match[0].slice(0, excess);
								match[2] = unquoted.slice(0, excess);
							}

							// Return only captures needed by the pseudo filter method (type and argument)
							return match.slice(0, 3);
						}
					},

					filter: {

						"TAG": function TAG(nodeNameSelector) {
							var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
							return nodeNameSelector === "*" ? function () {
								return true;
							} : function (elem) {
								return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
							};
						},

						"CLASS": function CLASS(className) {
							var pattern = classCache[className + " "];

							return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
								return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
							});
						},

						"ATTR": function ATTR(name, operator, check) {
							return function (elem) {
								var result = Sizzle.attr(elem, name);

								if (result == null) {
									return operator === "!=";
								}
								if (!operator) {
									return true;
								}

								result += "";

								/* eslint-disable max-len */

								return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
								/* eslint-enable max-len */
							};
						},

						"CHILD": function CHILD(type, what, _argument, first, last) {
							var simple = type.slice(0, 3) !== "nth",
							    forward = type.slice(-4) !== "last",
							    ofType = what === "of-type";

							return first === 1 && last === 0 ?

							// Shortcut for :nth-*(n)
							function (elem) {
								return !!elem.parentNode;
							} : function (elem, _context, xml) {
								var cache,
								    uniqueCache,
								    outerCache,
								    node,
								    nodeIndex,
								    start,
								    dir = simple !== forward ? "nextSibling" : "previousSibling",
								    parent = elem.parentNode,
								    name = ofType && elem.nodeName.toLowerCase(),
								    useCache = !xml && !ofType,
								    diff = false;

								if (parent) {

									// :(first|last|only)-(child|of-type)
									if (simple) {
										while (dir) {
											node = elem;
											while (node = node[dir]) {
												if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {

													return false;
												}
											}

											// Reverse direction for :only-* (if we haven't yet done so)
											start = dir = type === "only" && !start && "nextSibling";
										}
										return true;
									}

									start = [forward ? parent.firstChild : parent.lastChild];

									// non-xml :nth-child(...) stores cache data on `parent`
									if (forward && useCache) {

										// Seek `elem` from a previously-cached index

										// ...in a gzip-friendly way
										node = parent;
										outerCache = node[expando] || (node[expando] = {});

										// Support: IE <9 only
										// Defend against cloned attroperties (jQuery gh-1709)
										uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

										cache = uniqueCache[type] || [];
										nodeIndex = cache[0] === dirruns && cache[1];
										diff = nodeIndex && cache[2];
										node = nodeIndex && parent.childNodes[nodeIndex];

										while (node = ++nodeIndex && node && node[dir] || (

										// Fallback to seeking `elem` from the start
										diff = nodeIndex = 0) || start.pop()) {

											// When found, cache indexes on `parent` and break
											if (node.nodeType === 1 && ++diff && node === elem) {
												uniqueCache[type] = [dirruns, nodeIndex, diff];
												break;
											}
										}
									} else {

										// Use previously-cached element index if available
										if (useCache) {

											// ...in a gzip-friendly way
											node = elem;
											outerCache = node[expando] || (node[expando] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

											cache = uniqueCache[type] || [];
											nodeIndex = cache[0] === dirruns && cache[1];
											diff = nodeIndex;
										}

										// xml :nth-child(...)
										// or :nth-last-child(...) or :nth(-last)?-of-type(...)
										if (diff === false) {

											// Use the same loop as above to seek `elem` from the start
											while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {

												if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {

													// Cache the index of each encountered element
													if (useCache) {
														outerCache = node[expando] || (node[expando] = {});

														// Support: IE <9 only
														// Defend against cloned attroperties (jQuery gh-1709)
														uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

														uniqueCache[type] = [dirruns, diff];
													}

													if (node === elem) {
														break;
													}
												}
											}
										}
									}

									// Incorporate the offset, then check against cycle size
									diff -= last;
									return diff === first || diff % first === 0 && diff / first >= 0;
								}
							};
						},

						"PSEUDO": function PSEUDO(pseudo, argument) {

							// pseudo-class names are case-insensitive
							// http://www.w3.org/TR/selectors/#pseudo-classes
							// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
							// Remember that setFilters inherits from pseudos
							var args,
							    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);

							// The user may use createPseudo to indicate that
							// arguments are needed to create the filter function
							// just as Sizzle does
							if (fn[expando]) {
								return fn(argument);
							}

							// But maintain support for old signatures
							if (fn.length > 1) {
								args = [pseudo, pseudo, "", argument];
								return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
									var idx,
									    matched = fn(seed, argument),
									    i = matched.length;
									while (i--) {
										idx = indexOf(seed, matched[i]);
										seed[idx] = !(matches[idx] = matched[i]);
									}
								}) : function (elem) {
									return fn(elem, 0, args);
								};
							}

							return fn;
						}
					},

					pseudos: {

						// Potentially complex pseudos
						"not": markFunction(function (selector) {

							// Trim the selector passed to compile
							// to avoid treating leading and trailing
							// spaces as combinators
							var input = [],
							    results = [],
							    matcher = compile(selector.replace(rtrim, "$1"));

							return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
								var elem,
								    unmatched = matcher(seed, null, xml, []),
								    i = seed.length;

								// Match elements unmatched by `matcher`
								while (i--) {
									if (elem = unmatched[i]) {
										seed[i] = !(matches[i] = elem);
									}
								}
							}) : function (elem, _context, xml) {
								input[0] = elem;
								matcher(input, null, xml, results);

								// Don't keep the element (issue #299)
								input[0] = null;
								return !results.pop();
							};
						}),

						"has": markFunction(function (selector) {
							return function (elem) {
								return Sizzle(selector, elem).length > 0;
							};
						}),

						"contains": markFunction(function (text) {
							text = text.replace(runescape, funescape);
							return function (elem) {
								return (elem.textContent || getText(elem)).indexOf(text) > -1;
							};
						}),

						// "Whether an element is represented by a :lang() selector
						// is based solely on the element's language value
						// being equal to the identifier C,
						// or beginning with the identifier C immediately followed by "-".
						// The matching of C against the element's language value is performed case-insensitively.
						// The identifier C does not have to be a valid language name."
						// http://www.w3.org/TR/selectors/#lang-pseudo
						"lang": markFunction(function (lang) {

							// lang value must be a valid identifier
							if (!ridentifier.test(lang || "")) {
								Sizzle.error("unsupported lang: " + lang);
							}
							lang = lang.replace(runescape, funescape).toLowerCase();
							return function (elem) {
								var elemLang;
								do {
									if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {

										elemLang = elemLang.toLowerCase();
										return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
									}
								} while ((elem = elem.parentNode) && elem.nodeType === 1);
								return false;
							};
						}),

						// Miscellaneous
						"target": function target(elem) {
							var hash = window.location && window.location.hash;
							return hash && hash.slice(1) === elem.id;
						},

						"root": function root(elem) {
							return elem === docElem;
						},

						"focus": function focus(elem) {
							return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
						},

						// Boolean properties
						"enabled": createDisabledPseudo(false),
						"disabled": createDisabledPseudo(true),

						"checked": function checked(elem) {

							// In CSS3, :checked should return both checked and selected elements
							// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
							var nodeName = elem.nodeName.toLowerCase();
							return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
						},

						"selected": function selected(elem) {

							// Accessing this property makes selected-by-default
							// options in Safari work properly
							if (elem.parentNode) {
								// eslint-disable-next-line no-unused-expressions
								elem.parentNode.selectedIndex;
							}

							return elem.selected === true;
						},

						// Contents
						"empty": function empty(elem) {

							// http://www.w3.org/TR/selectors/#empty-pseudo
							// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
							//   but not by others (comment: 8; processing instruction: 7; etc.)
							// nodeType < 6 works because attributes (2) do not appear as children
							for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
								if (elem.nodeType < 6) {
									return false;
								}
							}
							return true;
						},

						"parent": function parent(elem) {
							return !Expr.pseudos["empty"](elem);
						},

						// Element/input types
						"header": function header(elem) {
							return rheader.test(elem.nodeName);
						},

						"input": function input(elem) {
							return rinputs.test(elem.nodeName);
						},

						"button": function button(elem) {
							var name = elem.nodeName.toLowerCase();
							return name === "input" && elem.type === "button" || name === "button";
						},

						"text": function text(elem) {
							var attr;
							return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (

							// Support: IE<8
							// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
							(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
						},

						// Position-in-collection
						"first": createPositionalPseudo(function () {
							return [0];
						}),

						"last": createPositionalPseudo(function (_matchIndexes, length) {
							return [length - 1];
						}),

						"eq": createPositionalPseudo(function (_matchIndexes, length, argument) {
							return [argument < 0 ? argument + length : argument];
						}),

						"even": createPositionalPseudo(function (matchIndexes, length) {
							var i = 0;
							for (; i < length; i += 2) {
								matchIndexes.push(i);
							}
							return matchIndexes;
						}),

						"odd": createPositionalPseudo(function (matchIndexes, length) {
							var i = 1;
							for (; i < length; i += 2) {
								matchIndexes.push(i);
							}
							return matchIndexes;
						}),

						"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
							var i = argument < 0 ? argument + length : argument > length ? length : argument;
							for (; --i >= 0;) {
								matchIndexes.push(i);
							}
							return matchIndexes;
						}),

						"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
							var i = argument < 0 ? argument + length : argument;
							for (; ++i < length;) {
								matchIndexes.push(i);
							}
							return matchIndexes;
						})
					}
				};

				Expr.pseudos["nth"] = Expr.pseudos["eq"];

				// Add button/input type pseudos
				for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
					Expr.pseudos[i] = createInputPseudo(i);
				}
				for (i in { submit: true, reset: true }) {
					Expr.pseudos[i] = createButtonPseudo(i);
				}

				// Easy API for creating new setFilters
				function setFilters() {}
				setFilters.prototype = Expr.filters = Expr.pseudos;
				Expr.setFilters = new setFilters();

				tokenize = Sizzle.tokenize = function (selector, parseOnly) {
					var matched,
					    match,
					    tokens,
					    type,
					    soFar,
					    groups,
					    preFilters,
					    cached = tokenCache[selector + " "];

					if (cached) {
						return parseOnly ? 0 : cached.slice(0);
					}

					soFar = selector;
					groups = [];
					preFilters = Expr.preFilter;

					while (soFar) {

						// Comma and first run
						if (!matched || (match = rcomma.exec(soFar))) {
							if (match) {

								// Don't consume trailing commas as valid
								soFar = soFar.slice(match[0].length) || soFar;
							}
							groups.push(tokens = []);
						}

						matched = false;

						// Combinators
						if (match = rcombinators.exec(soFar)) {
							matched = match.shift();
							tokens.push({
								value: matched,

								// Cast descendant combinators to space
								type: match[0].replace(rtrim, " ")
							});
							soFar = soFar.slice(matched.length);
						}

						// Filters
						for (type in Expr.filter) {
							if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
								matched = match.shift();
								tokens.push({
									value: matched,
									type: type,
									matches: match
								});
								soFar = soFar.slice(matched.length);
							}
						}

						if (!matched) {
							break;
						}
					}

					// Return the length of the invalid excess
					// if we're just parsing
					// Otherwise, throw an error or return tokens
					return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :

					// Cache the tokens
					tokenCache(selector, groups).slice(0);
				};

				function toSelector(tokens) {
					var i = 0,
					    len = tokens.length,
					    selector = "";
					for (; i < len; i++) {
						selector += tokens[i].value;
					}
					return selector;
				}

				function addCombinator(matcher, combinator, base) {
					var dir = combinator.dir,
					    skip = combinator.next,
					    key = skip || dir,
					    checkNonElements = base && key === "parentNode",
					    doneName = done++;

					return combinator.first ?

					// Check against closest ancestor/preceding element
					function (elem, context, xml) {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								return matcher(elem, context, xml);
							}
						}
						return false;
					} :

					// Check against all ancestor/preceding elements
					function (elem, context, xml) {
						var oldCache,
						    uniqueCache,
						    outerCache,
						    newCache = [dirruns, doneName];

						// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
						if (xml) {
							while (elem = elem[dir]) {
								if (elem.nodeType === 1 || checkNonElements) {
									if (matcher(elem, context, xml)) {
										return true;
									}
								}
							}
						} else {
							while (elem = elem[dir]) {
								if (elem.nodeType === 1 || checkNonElements) {
									outerCache = elem[expando] || (elem[expando] = {});

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

									if (skip && skip === elem.nodeName.toLowerCase()) {
										elem = elem[dir] || elem;
									} else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {

										// Assign to newCache so results back-propagate to previous elements
										return newCache[2] = oldCache[2];
									} else {

										// Reuse newcache so results back-propagate to previous elements
										uniqueCache[key] = newCache;

										// A match means we're done; a fail means we have to keep checking
										if (newCache[2] = matcher(elem, context, xml)) {
											return true;
										}
									}
								}
							}
						}
						return false;
					};
				}

				function elementMatcher(matchers) {
					return matchers.length > 1 ? function (elem, context, xml) {
						var i = matchers.length;
						while (i--) {
							if (!matchers[i](elem, context, xml)) {
								return false;
							}
						}
						return true;
					} : matchers[0];
				}

				function multipleContexts(selector, contexts, results) {
					var i = 0,
					    len = contexts.length;
					for (; i < len; i++) {
						Sizzle(selector, contexts[i], results);
					}
					return results;
				}

				function condense(unmatched, map, filter, context, xml) {
					var elem,
					    newUnmatched = [],
					    i = 0,
					    len = unmatched.length,
					    mapped = map != null;

					for (; i < len; i++) {
						if (elem = unmatched[i]) {
							if (!filter || filter(elem, context, xml)) {
								newUnmatched.push(elem);
								if (mapped) {
									map.push(i);
								}
							}
						}
					}

					return newUnmatched;
				}

				function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
					if (postFilter && !postFilter[expando]) {
						postFilter = setMatcher(postFilter);
					}
					if (postFinder && !postFinder[expando]) {
						postFinder = setMatcher(postFinder, postSelector);
					}
					return markFunction(function (seed, results, context, xml) {
						var temp,
						    i,
						    elem,
						    preMap = [],
						    postMap = [],
						    preexisting = results.length,


						// Get initial elements from seed or context
						elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),


						// Prefilter to get matcher input, preserving a map for seed-results synchronization
						matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
						    matcherOut = matcher ?

						// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
						postFinder || (seed ? preFilter : preexisting || postFilter) ?

						// ...intermediate processing is necessary
						[] :

						// ...otherwise use results directly
						results : matcherIn;

						// Find primary matches
						if (matcher) {
							matcher(matcherIn, matcherOut, context, xml);
						}

						// Apply postFilter
						if (postFilter) {
							temp = condense(matcherOut, postMap);
							postFilter(temp, [], context, xml);

							// Un-match failing elements by moving them back to matcherIn
							i = temp.length;
							while (i--) {
								if (elem = temp[i]) {
									matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
								}
							}
						}

						if (seed) {
							if (postFinder || preFilter) {
								if (postFinder) {

									// Get the final matcherOut by condensing this intermediate into postFinder contexts
									temp = [];
									i = matcherOut.length;
									while (i--) {
										if (elem = matcherOut[i]) {

											// Restore matcherIn since elem is not yet a final match
											temp.push(matcherIn[i] = elem);
										}
									}
									postFinder(null, matcherOut = [], temp, xml);
								}

								// Move matched elements from seed to results to keep them synchronized
								i = matcherOut.length;
								while (i--) {
									if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

										seed[temp] = !(results[temp] = elem);
									}
								}
							}

							// Add elements to results, through postFinder if defined
						} else {
							matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
							if (postFinder) {
								postFinder(null, results, matcherOut, xml);
							} else {
								push.apply(results, matcherOut);
							}
						}
					});
				}

				function matcherFromTokens(tokens) {
					var checkContext,
					    matcher,
					    j,
					    len = tokens.length,
					    leadingRelative = Expr.relative[tokens[0].type],
					    implicitRelative = leadingRelative || Expr.relative[" "],
					    i = leadingRelative ? 1 : 0,


					// The foundational matcher ensures that elements are reachable from top-level context(s)
					matchContext = addCombinator(function (elem) {
						return elem === checkContext;
					}, implicitRelative, true),
					    matchAnyContext = addCombinator(function (elem) {
						return indexOf(checkContext, elem) > -1;
					}, implicitRelative, true),
					    matchers = [function (elem, context, xml) {
						var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

						// Avoid hanging onto element (issue #299)
						checkContext = null;
						return ret;
					}];

					for (; i < len; i++) {
						if (matcher = Expr.relative[tokens[i].type]) {
							matchers = [addCombinator(elementMatcher(matchers), matcher)];
						} else {
							matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

							// Return special upon seeing a positional matcher
							if (matcher[expando]) {

								// Find the next relative operator (if any) for proper handling
								j = ++i;
								for (; j < len; j++) {
									if (Expr.relative[tokens[j].type]) {
										break;
									}
								}
								return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(

								// If the preceding token was a descendant combinator, insert an implicit any-element `*`
								tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
							}
							matchers.push(matcher);
						}
					}

					return elementMatcher(matchers);
				}

				function matcherFromGroupMatchers(elementMatchers, setMatchers) {
					var bySet = setMatchers.length > 0,
					    byElement = elementMatchers.length > 0,
					    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
						var elem,
						    j,
						    matcher,
						    matchedCount = 0,
						    i = "0",
						    unmatched = seed && [],
						    setMatched = [],
						    contextBackup = outermostContext,


						// We must always have either seed elements or outermost context
						elems = seed || byElement && Expr.find["TAG"]("*", outermost),


						// Use integer dirruns iff this is the outermost matcher
						dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
						    len = elems.length;

						if (outermost) {

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							outermostContext = context == document || context || outermost;
						}

						// Add elements passing elementMatchers directly to results
						// Support: IE<9, Safari
						// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
						for (; i !== len && (elem = elems[i]) != null; i++) {
							if (byElement && elem) {
								j = 0;

								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if (!context && elem.ownerDocument != document) {
									setDocument(elem);
									xml = !documentIsHTML;
								}
								while (matcher = elementMatchers[j++]) {
									if (matcher(elem, context || document, xml)) {
										results.push(elem);
										break;
									}
								}
								if (outermost) {
									dirruns = dirrunsUnique;
								}
							}

							// Track unmatched elements for set filters
							if (bySet) {

								// They will have gone through all possible matchers
								if (elem = !matcher && elem) {
									matchedCount--;
								}

								// Lengthen the array for every element, matched or not
								if (seed) {
									unmatched.push(elem);
								}
							}
						}

						// `i` is now the count of elements visited above, and adding it to `matchedCount`
						// makes the latter nonnegative.
						matchedCount += i;

						// Apply set filters to unmatched elements
						// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
						// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
						// no element matchers and no seed.
						// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
						// case, which will result in a "00" `matchedCount` that differs from `i` but is also
						// numerically zero.
						if (bySet && i !== matchedCount) {
							j = 0;
							while (matcher = setMatchers[j++]) {
								matcher(unmatched, setMatched, context, xml);
							}

							if (seed) {

								// Reintegrate element matches to eliminate the need for sorting
								if (matchedCount > 0) {
									while (i--) {
										if (!(unmatched[i] || setMatched[i])) {
											setMatched[i] = pop.call(results);
										}
									}
								}

								// Discard index placeholder values to get only actual matches
								setMatched = condense(setMatched);
							}

							// Add matches to results
							push.apply(results, setMatched);

							// Seedless set matches succeeding multiple successful matchers stipulate sorting
							if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {

								Sizzle.uniqueSort(results);
							}
						}

						// Override manipulation of globals by nested matchers
						if (outermost) {
							dirruns = dirrunsUnique;
							outermostContext = contextBackup;
						}

						return unmatched;
					};

					return bySet ? markFunction(superMatcher) : superMatcher;
				}

				compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
					var i,
					    setMatchers = [],
					    elementMatchers = [],
					    cached = compilerCache[selector + " "];

					if (!cached) {

						// Generate a function of recursive functions that can be used to check each element
						if (!match) {
							match = tokenize(selector);
						}
						i = match.length;
						while (i--) {
							cached = matcherFromTokens(match[i]);
							if (cached[expando]) {
								setMatchers.push(cached);
							} else {
								elementMatchers.push(cached);
							}
						}

						// Cache the compiled function
						cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

						// Save selector and tokenization
						cached.selector = selector;
					}
					return cached;
				};

				/**
     * A low-level selection function that works with Sizzle's compiled
     *  selector functions
     * @param {String|Function} selector A selector or a pre-compiled
     *  selector function built with Sizzle.compile
     * @param {Element} context
     * @param {Array} [results]
     * @param {Array} [seed] A set of elements to match against
     */
				select = Sizzle.select = function (selector, context, results, seed) {
					var i,
					    tokens,
					    token,
					    type,
					    find,
					    compiled = typeof selector === "function" && selector,
					    match = !seed && tokenize(selector = compiled.selector || selector);

					results = results || [];

					// Try to minimize operations if there is only one selector in the list and no seed
					// (the latter of which guarantees us context)
					if (match.length === 1) {

						// Reduce context if the leading compound selector is an ID
						tokens = match[0] = match[0].slice(0);
						if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

							context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
							if (!context) {
								return results;

								// Precompiled matchers will still verify ancestry, so step up a level
							} else if (compiled) {
								context = context.parentNode;
							}

							selector = selector.slice(tokens.shift().value.length);
						}

						// Fetch a seed set for right-to-left matching
						i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
						while (i--) {
							token = tokens[i];

							// Abort if we hit a combinator
							if (Expr.relative[type = token.type]) {
								break;
							}
							if (find = Expr.find[type]) {

								// Search, expanding context for leading sibling combinators
								if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {

									// If seed is empty or no tokens remain, we can return early
									tokens.splice(i, 1);
									selector = seed.length && toSelector(tokens);
									if (!selector) {
										push.apply(results, seed);
										return results;
									}

									break;
								}
							}
						}
					}

					// Compile and execute a filtering function if one is not provided
					// Provide `match` to avoid retokenization if we modified the selector above
					(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
					return results;
				};

				// One-time assignments

				// Sort stability
				support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

				// Support: Chrome 14-35+
				// Always assume duplicates if they aren't passed to the comparison function
				support.detectDuplicates = !!hasDuplicate;

				// Initialize against the default document
				setDocument();

				// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
				// Detached nodes confoundingly follow *each other*
				support.sortDetached = assert(function (el) {

					// Should return 1, but returns 4 (following)
					return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
				});

				// Support: IE<8
				// Prevent attribute/property "interpolation"
				// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
				if (!assert(function (el) {
					el.innerHTML = "<a href='#'></a>";
					return el.firstChild.getAttribute("href") === "#";
				})) {
					addHandle("type|href|height|width", function (elem, name, isXML) {
						if (!isXML) {
							return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
						}
					});
				}

				// Support: IE<9
				// Use defaultValue in place of getAttribute("value")
				if (!support.attributes || !assert(function (el) {
					el.innerHTML = "<input/>";
					el.firstChild.setAttribute("value", "");
					return el.firstChild.getAttribute("value") === "";
				})) {
					addHandle("value", function (elem, _name, isXML) {
						if (!isXML && elem.nodeName.toLowerCase() === "input") {
							return elem.defaultValue;
						}
					});
				}

				// Support: IE<9
				// Use getAttributeNode to fetch booleans when getAttribute lies
				if (!assert(function (el) {
					return el.getAttribute("disabled") == null;
				})) {
					addHandle(booleans, function (elem, name, isXML) {
						var val;
						if (!isXML) {
							return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
						}
					});
				}

				return Sizzle;
			}(window);

			jQuery.find = Sizzle;
			jQuery.expr = Sizzle.selectors;

			// Deprecated
			jQuery.expr[":"] = jQuery.expr.pseudos;
			jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
			jQuery.text = Sizzle.getText;
			jQuery.isXMLDoc = Sizzle.isXML;
			jQuery.contains = Sizzle.contains;
			jQuery.escapeSelector = Sizzle.escape;

			var dir = function dir(elem, _dir, until) {
				var matched = [],
				    truncate = until !== undefined;

				while ((elem = elem[_dir]) && elem.nodeType !== 9) {
					if (elem.nodeType === 1) {
						if (truncate && jQuery(elem).is(until)) {
							break;
						}
						matched.push(elem);
					}
				}
				return matched;
			};

			var _siblings = function _siblings(n, elem) {
				var matched = [];

				for (; n; n = n.nextSibling) {
					if (n.nodeType === 1 && n !== elem) {
						matched.push(n);
					}
				}

				return matched;
			};

			var rneedsContext = jQuery.expr.match.needsContext;

			function nodeName(elem, name) {

				return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
			};
			var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

			// Implement the identical functionality for filter and not
			function winnow(elements, qualifier, not) {
				if (isFunction(qualifier)) {
					return jQuery.grep(elements, function (elem, i) {
						return !!qualifier.call(elem, i, elem) !== not;
					});
				}

				// Single element
				if (qualifier.nodeType) {
					return jQuery.grep(elements, function (elem) {
						return elem === qualifier !== not;
					});
				}

				// Arraylike of elements (jQuery, arguments, Array)
				if (typeof qualifier !== "string") {
					return jQuery.grep(elements, function (elem) {
						return indexOf.call(qualifier, elem) > -1 !== not;
					});
				}

				// Filtered directly for both simple and complex selectors
				return jQuery.filter(qualifier, elements, not);
			}

			jQuery.filter = function (expr, elems, not) {
				var elem = elems[0];

				if (not) {
					expr = ":not(" + expr + ")";
				}

				if (elems.length === 1 && elem.nodeType === 1) {
					return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
				}

				return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
					return elem.nodeType === 1;
				}));
			};

			jQuery.fn.extend({
				find: function find(selector) {
					var i,
					    ret,
					    len = this.length,
					    self = this;

					if (typeof selector !== "string") {
						return this.pushStack(jQuery(selector).filter(function () {
							for (i = 0; i < len; i++) {
								if (jQuery.contains(self[i], this)) {
									return true;
								}
							}
						}));
					}

					ret = this.pushStack([]);

					for (i = 0; i < len; i++) {
						jQuery.find(selector, self[i], ret);
					}

					return len > 1 ? jQuery.uniqueSort(ret) : ret;
				},
				filter: function filter(selector) {
					return this.pushStack(winnow(this, selector || [], false));
				},
				not: function not(selector) {
					return this.pushStack(winnow(this, selector || [], true));
				},
				is: function is(selector) {
					return !!winnow(this,

					// If this is a positional/relative selector, check membership in the returned set
					// so $("p:first").is("p:last") won't return true for a doc with two "p".
					typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
				}
			});

			// Initialize a jQuery object


			// A central reference to the root jQuery(document)
			var rootjQuery,


			// A simple way to check for HTML strings
			// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
			// Strict HTML recognition (#11290: must start with <)
			// Shortcut simple #id case for speed
			rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
			    init = jQuery.fn.init = function (selector, context, root) {
				var match, elem;

				// HANDLE: $(""), $(null), $(undefined), $(false)
				if (!selector) {
					return this;
				}

				// Method init() accepts an alternate rootjQuery
				// so migrate can support jQuery.sub (gh-2101)
				root = root || rootjQuery;

				// Handle HTML strings
				if (typeof selector === "string") {
					if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {

						// Assume that strings that start and end with <> are HTML and skip the regex check
						match = [null, selector, null];
					} else {
						match = rquickExpr.exec(selector);
					}

					// Match html or make sure no context is specified for #id
					if (match && (match[1] || !context)) {

						// HANDLE: $(html) -> $(array)
						if (match[1]) {
							context = context instanceof jQuery ? context[0] : context;

							// Option to run scripts is true for back-compat
							// Intentionally let the error be thrown if parseHTML is not present
							jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

							// HANDLE: $(html, props)
							if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
								for (match in context) {

									// Properties of context are called as methods if possible
									if (isFunction(this[match])) {
										this[match](context[match]);

										// ...and otherwise set as attributes
									} else {
										this.attr(match, context[match]);
									}
								}
							}

							return this;

							// HANDLE: $(#id)
						} else {
							elem = document.getElementById(match[2]);

							if (elem) {

								// Inject the element directly into the jQuery object
								this[0] = elem;
								this.length = 1;
							}
							return this;
						}

						// HANDLE: $(expr, $(...))
					} else if (!context || context.jquery) {
						return (context || root).find(selector);

						// HANDLE: $(expr, context)
						// (which is just equivalent to: $(context).find(expr)
					} else {
						return this.constructor(context).find(selector);
					}

					// HANDLE: $(DOMElement)
				} else if (selector.nodeType) {
					this[0] = selector;
					this.length = 1;
					return this;

					// HANDLE: $(function)
					// Shortcut for document ready
				} else if (isFunction(selector)) {
					return root.ready !== undefined ? root.ready(selector) :

					// Execute immediately if ready is not present
					selector(jQuery);
				}

				return jQuery.makeArray(selector, this);
			};

			// Give the init function the jQuery prototype for later instantiation
			init.prototype = jQuery.fn;

			// Initialize central reference
			rootjQuery = jQuery(document);

			var rparentsprev = /^(?:parents|prev(?:Until|All))/,


			// Methods guaranteed to produce a unique set when starting from a unique set
			guaranteedUnique = {
				children: true,
				contents: true,
				next: true,
				prev: true
			};

			jQuery.fn.extend({
				has: function has(target) {
					var targets = jQuery(target, this),
					    l = targets.length;

					return this.filter(function () {
						var i = 0;
						for (; i < l; i++) {
							if (jQuery.contains(this, targets[i])) {
								return true;
							}
						}
					});
				},

				closest: function closest(selectors, context) {
					var cur,
					    i = 0,
					    l = this.length,
					    matched = [],
					    targets = typeof selectors !== "string" && jQuery(selectors);

					// Positional selectors never match, since there's no _selection_ context
					if (!rneedsContext.test(selectors)) {
						for (; i < l; i++) {
							for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

								// Always skip document fragments
								if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :

								// Don't pass non-elements to Sizzle
								cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {

									matched.push(cur);
									break;
								}
							}
						}
					}

					return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
				},

				// Determine the position of an element within the set
				index: function index(elem) {

					// No argument, return index in parent
					if (!elem) {
						return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
					}

					// Index in selector
					if (typeof elem === "string") {
						return indexOf.call(jQuery(elem), this[0]);
					}

					// Locate the position of the desired element
					return indexOf.call(this,

					// If it receives a jQuery object, the first element is used
					elem.jquery ? elem[0] : elem);
				},

				add: function add(selector, context) {
					return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
				},

				addBack: function addBack(selector) {
					return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
				}
			});

			function sibling(cur, dir) {
				while ((cur = cur[dir]) && cur.nodeType !== 1) {}
				return cur;
			}

			jQuery.each({
				parent: function parent(elem) {
					var parent = elem.parentNode;
					return parent && parent.nodeType !== 11 ? parent : null;
				},
				parents: function parents(elem) {
					return dir(elem, "parentNode");
				},
				parentsUntil: function parentsUntil(elem, _i, until) {
					return dir(elem, "parentNode", until);
				},
				next: function next(elem) {
					return sibling(elem, "nextSibling");
				},
				prev: function prev(elem) {
					return sibling(elem, "previousSibling");
				},
				nextAll: function nextAll(elem) {
					return dir(elem, "nextSibling");
				},
				prevAll: function prevAll(elem) {
					return dir(elem, "previousSibling");
				},
				nextUntil: function nextUntil(elem, _i, until) {
					return dir(elem, "nextSibling", until);
				},
				prevUntil: function prevUntil(elem, _i, until) {
					return dir(elem, "previousSibling", until);
				},
				siblings: function siblings(elem) {
					return _siblings((elem.parentNode || {}).firstChild, elem);
				},
				children: function children(elem) {
					return _siblings(elem.firstChild);
				},
				contents: function contents(elem) {
					if (elem.contentDocument != null &&

					// Support: IE 11+
					// <object> elements with no `data` attribute has an object
					// `contentDocument` with a `null` prototype.
					getProto(elem.contentDocument)) {

						return elem.contentDocument;
					}

					// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
					// Treat the template element as a regular one in browsers that
					// don't support it.
					if (nodeName(elem, "template")) {
						elem = elem.content || elem;
					}

					return jQuery.merge([], elem.childNodes);
				}
			}, function (name, fn) {
				jQuery.fn[name] = function (until, selector) {
					var matched = jQuery.map(this, fn, until);

					if (name.slice(-5) !== "Until") {
						selector = until;
					}

					if (selector && typeof selector === "string") {
						matched = jQuery.filter(selector, matched);
					}

					if (this.length > 1) {

						// Remove duplicates
						if (!guaranteedUnique[name]) {
							jQuery.uniqueSort(matched);
						}

						// Reverse order for parents* and prev-derivatives
						if (rparentsprev.test(name)) {
							matched.reverse();
						}
					}

					return this.pushStack(matched);
				};
			});
			var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

			// Convert String-formatted options into Object-formatted ones
			function createOptions(options) {
				var object = {};
				jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
					object[flag] = true;
				});
				return object;
			}

			/*
    * Create a callback list using the following parameters:
    *
    *	options: an optional list of space-separated options that will change how
    *			the callback list behaves or a more traditional option object
    *
    * By default a callback list will act like an event callback list and can be
    * "fired" multiple times.
    *
    * Possible options:
    *
    *	once:			will ensure the callback list can only be fired once (like a Deferred)
    *
    *	memory:			will keep track of previous values and will call any callback added
    *					after the list has been fired right away with the latest "memorized"
    *					values (like a Deferred)
    *
    *	unique:			will ensure a callback can only be added once (no duplicate in the list)
    *
    *	stopOnFalse:	interrupt callings when a callback returns false
    *
    */
			jQuery.Callbacks = function (options) {

				// Convert options from String-formatted to Object-formatted if needed
				// (we check in cache first)
				options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

				var // Flag to know if list is currently firing
				firing,


				// Last fire value for non-forgettable lists
				memory,


				// Flag to know if list was already fired
				_fired,


				// Flag to prevent firing
				_locked,


				// Actual callback list
				list = [],


				// Queue of execution data for repeatable lists
				queue = [],


				// Index of currently firing callback (modified by add/remove as needed)
				firingIndex = -1,


				// Fire callbacks
				fire = function fire() {

					// Enforce single-firing
					_locked = _locked || options.once;

					// Execute callbacks for all pending executions,
					// respecting firingIndex overrides and runtime changes
					_fired = firing = true;
					for (; queue.length; firingIndex = -1) {
						memory = queue.shift();
						while (++firingIndex < list.length) {

							// Run callback and check for early termination
							if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {

								// Jump to end and forget the data so .add doesn't re-fire
								firingIndex = list.length;
								memory = false;
							}
						}
					}

					// Forget the data if we're done with it
					if (!options.memory) {
						memory = false;
					}

					firing = false;

					// Clean up if we're done firing for good
					if (_locked) {

						// Keep an empty list if we have data for future add calls
						if (memory) {
							list = [];

							// Otherwise, this object is spent
						} else {
							list = "";
						}
					}
				},


				// Actual Callbacks object
				self = {

					// Add a callback or a collection of callbacks to the list
					add: function add() {
						if (list) {

							// If we have memory from a past run, we should fire after adding
							if (memory && !firing) {
								firingIndex = list.length - 1;
								queue.push(memory);
							}

							(function add(args) {
								jQuery.each(args, function (_, arg) {
									if (isFunction(arg)) {
										if (!options.unique || !self.has(arg)) {
											list.push(arg);
										}
									} else if (arg && arg.length && toType(arg) !== "string") {

										// Inspect recursively
										add(arg);
									}
								});
							})(arguments);

							if (memory && !firing) {
								fire();
							}
						}
						return this;
					},

					// Remove a callback from the list
					remove: function remove() {
						jQuery.each(arguments, function (_, arg) {
							var index;
							while ((index = jQuery.inArray(arg, list, index)) > -1) {
								list.splice(index, 1);

								// Handle firing indexes
								if (index <= firingIndex) {
									firingIndex--;
								}
							}
						});
						return this;
					},

					// Check if a given callback is in the list.
					// If no argument is given, return whether or not list has callbacks attached.
					has: function has(fn) {
						return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
					},

					// Remove all callbacks from the list
					empty: function empty() {
						if (list) {
							list = [];
						}
						return this;
					},

					// Disable .fire and .add
					// Abort any current/pending executions
					// Clear all callbacks and values
					disable: function disable() {
						_locked = queue = [];
						list = memory = "";
						return this;
					},
					disabled: function disabled() {
						return !list;
					},

					// Disable .fire
					// Also disable .add unless we have memory (since it would have no effect)
					// Abort any pending executions
					lock: function lock() {
						_locked = queue = [];
						if (!memory && !firing) {
							list = memory = "";
						}
						return this;
					},
					locked: function locked() {
						return !!_locked;
					},

					// Call all callbacks with the given context and arguments
					fireWith: function fireWith(context, args) {
						if (!_locked) {
							args = args || [];
							args = [context, args.slice ? args.slice() : args];
							queue.push(args);
							if (!firing) {
								fire();
							}
						}
						return this;
					},

					// Call all the callbacks with the given arguments
					fire: function fire() {
						self.fireWith(this, arguments);
						return this;
					},

					// To know if the callbacks have already been called at least once
					fired: function fired() {
						return !!_fired;
					}
				};

				return self;
			};

			function Identity(v) {
				return v;
			}
			function Thrower(ex) {
				throw ex;
			}

			function adoptValue(value, resolve, reject, noValue) {
				var method;

				try {

					// Check for promise aspect first to privilege synchronous behavior
					if (value && isFunction(method = value.promise)) {
						method.call(value).done(resolve).fail(reject);

						// Other thenables
					} else if (value && isFunction(method = value.then)) {
						method.call(value, resolve, reject);

						// Other non-thenables
					} else {

						// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
						// * false: [ value ].slice( 0 ) => resolve( value )
						// * true: [ value ].slice( 1 ) => resolve()
						resolve.apply(undefined, [value].slice(noValue));
					}

					// For Promises/A+, convert exceptions into rejections
					// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
					// Deferred#then to conditionally suppress rejection.
				} catch (value) {

					// Support: Android 4.0 only
					// Strict mode functions invoked without .call/.apply get global-object context
					reject.apply(undefined, [value]);
				}
			}

			jQuery.extend({

				Deferred: function Deferred(func) {
					var tuples = [

					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
					    _state = "pending",
					    _promise = {
						state: function state() {
							return _state;
						},
						always: function always() {
							deferred.done(arguments).fail(arguments);
							return this;
						},
						"catch": function _catch(fn) {
							return _promise.then(null, fn);
						},

						// Keep pipe for back-compat
						pipe: function pipe() /* fnDone, fnFail, fnProgress */{
							var fns = arguments;

							return jQuery.Deferred(function (newDefer) {
								jQuery.each(tuples, function (_i, tuple) {

									// Map tuples (progress, done, fail) to arguments (done, fail, progress)
									var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

									// deferred.progress(function() { bind to newDefer or newDefer.notify })
									// deferred.done(function() { bind to newDefer or newDefer.resolve })
									// deferred.fail(function() { bind to newDefer or newDefer.reject })
									deferred[tuple[1]](function () {
										var returned = fn && fn.apply(this, arguments);
										if (returned && isFunction(returned.promise)) {
											returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
										} else {
											newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
										}
									});
								});
								fns = null;
							}).promise();
						},
						then: function then(onFulfilled, onRejected, onProgress) {
							var maxDepth = 0;
							function resolve(depth, deferred, handler, special) {
								return function () {
									var that = this,
									    args = arguments,
									    mightThrow = function mightThrow() {
										var returned, then;

										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if (depth < maxDepth) {
											return;
										}

										returned = handler.apply(that, args);

										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if (returned === deferred.promise()) {
											throw new TypeError("Thenable self-resolution");
										}

										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned && (

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;

										// Handle a returned thenable
										if (isFunction(then)) {

											// Special processors (notify) just wait for resolution
											if (special) {
												then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

												// Normal processors (resolve) also hook into progress
											} else {

												// ...and disregard older resolution values
												maxDepth++;

												then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
											}

											// Handle all other returned values
										} else {

											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if (handler !== Identity) {
												that = undefined;
												args = [returned];
											}

											// Process the value(s)
											// Default process is resolve
											(special || deferred.resolveWith)(that, args);
										}
									},


									// Only normal processors (resolve) catch and reject exceptions
									process = special ? mightThrow : function () {
										try {
											mightThrow();
										} catch (e) {

											if (jQuery.Deferred.exceptionHook) {
												jQuery.Deferred.exceptionHook(e, process.stackTrace);
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if (depth + 1 >= maxDepth) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if (handler !== Thrower) {
													that = undefined;
													args = [e];
												}

												deferred.rejectWith(that, args);
											}
										}
									};

									// Support: Promises/A+ section 2.3.3.3.1
									// https://promisesaplus.com/#point-57
									// Re-resolve promises immediately to dodge false rejection from
									// subsequent errors
									if (depth) {
										process();
									} else {

										// Call an optional hook to record the stack, in case of exception
										// since it's otherwise lost when execution goes async
										if (jQuery.Deferred.getStackHook) {
											process.stackTrace = jQuery.Deferred.getStackHook();
										}
										window.setTimeout(process);
									}
								};
							}

							return jQuery.Deferred(function (newDefer) {

								// progress_handlers.add( ... )
								tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

								// fulfilled_handlers.add( ... )
								tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

								// rejected_handlers.add( ... )
								tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
							}).promise();
						},

						// Get a promise for this deferred
						// If obj is provided, the promise aspect is added to the object
						promise: function promise(obj) {
							return obj != null ? jQuery.extend(obj, _promise) : _promise;
						}
					},
					    deferred = {};

					// Add list-specific methods
					jQuery.each(tuples, function (i, tuple) {
						var list = tuple[2],
						    stateString = tuple[5];

						// promise.progress = list.add
						// promise.done = list.add
						// promise.fail = list.add
						_promise[tuple[1]] = list.add;

						// Handle state
						if (stateString) {
							list.add(function () {

								// state = "resolved" (i.e., fulfilled)
								// state = "rejected"
								_state = stateString;
							},

							// rejected_callbacks.disable
							// fulfilled_callbacks.disable
							tuples[3 - i][2].disable,

							// rejected_handlers.disable
							// fulfilled_handlers.disable
							tuples[3 - i][3].disable,

							// progress_callbacks.lock
							tuples[0][2].lock,

							// progress_handlers.lock
							tuples[0][3].lock);
						}

						// progress_handlers.fire
						// fulfilled_handlers.fire
						// rejected_handlers.fire
						list.add(tuple[3].fire);

						// deferred.notify = function() { deferred.notifyWith(...) }
						// deferred.resolve = function() { deferred.resolveWith(...) }
						// deferred.reject = function() { deferred.rejectWith(...) }
						deferred[tuple[0]] = function () {
							deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
							return this;
						};

						// deferred.notifyWith = list.fireWith
						// deferred.resolveWith = list.fireWith
						// deferred.rejectWith = list.fireWith
						deferred[tuple[0] + "With"] = list.fireWith;
					});

					// Make the deferred a promise
					_promise.promise(deferred);

					// Call given func if any
					if (func) {
						func.call(deferred, deferred);
					}

					// All done!
					return deferred;
				},

				// Deferred helper
				when: function when(singleValue) {
					var

					// count of uncompleted subordinates
					remaining = arguments.length,


					// count of unprocessed arguments
					i = remaining,


					// subordinate fulfillment data
					resolveContexts = Array(i),
					    resolveValues = _slice.call(arguments),


					// the master Deferred
					master = jQuery.Deferred(),


					// subordinate callback factory
					updateFunc = function updateFunc(i) {
						return function (value) {
							resolveContexts[i] = this;
							resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
							if (! --remaining) {
								master.resolveWith(resolveContexts, resolveValues);
							}
						};
					};

					// Single- and empty arguments are adopted like Promise.resolve
					if (remaining <= 1) {
						adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);

						// Use .then() to unwrap secondary thenables (cf. gh-3000)
						if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {

							return master.then();
						}
					}

					// Multiple arguments are aggregated like Promise.all array elements
					while (i--) {
						adoptValue(resolveValues[i], updateFunc(i), master.reject);
					}

					return master.promise();
				}
			});

			// These usually indicate a programmer mistake during development,
			// warn about them ASAP rather than swallowing them by default.
			var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

			jQuery.Deferred.exceptionHook = function (error, stack) {

				// Support: IE 8 - 9 only
				// Console exists when dev tools are open, which can happen at any time
				if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
					window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
				}
			};

			jQuery.readyException = function (error) {
				window.setTimeout(function () {
					throw error;
				});
			};

			// The deferred used on DOM ready
			var readyList = jQuery.Deferred();

			jQuery.fn.ready = function (fn) {

				readyList.then(fn)

				// Wrap jQuery.readyException in a function so that the lookup
				// happens at the time of error handling instead of callback
				// registration.
				.catch(function (error) {
					jQuery.readyException(error);
				});

				return this;
			};

			jQuery.extend({

				// Is the DOM ready to be used? Set to true once it occurs.
				isReady: false,

				// A counter to track how many items to wait for before
				// the ready event fires. See #6781
				readyWait: 1,

				// Handle when the DOM is ready
				ready: function ready(wait) {

					// Abort if there are pending holds or we're already ready
					if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
						return;
					}

					// Remember that the DOM is ready
					jQuery.isReady = true;

					// If a normal DOM Ready event fired, decrement, and wait if need be
					if (wait !== true && --jQuery.readyWait > 0) {
						return;
					}

					// If there are functions bound, to execute
					readyList.resolveWith(document, [jQuery]);
				}
			});

			jQuery.ready.then = readyList.then;

			// The ready event handler and self cleanup method
			function completed() {
				document.removeEventListener("DOMContentLoaded", completed);
				window.removeEventListener("load", completed);
				jQuery.ready();
			}

			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE <=9 - 10 only
			// Older IE sometimes signals "interactive" too soon
			if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {

				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout(jQuery.ready);
			} else {

				// Use the handy event callback
				document.addEventListener("DOMContentLoaded", completed);

				// A fallback to window.onload, that will always work
				window.addEventListener("load", completed);
			}

			// Multifunctional method to get and set values of a collection
			// The value/s can optionally be executed if it's a function
			var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
				var i = 0,
				    len = elems.length,
				    bulk = key == null;

				// Sets many values
				if (toType(key) === "object") {
					chainable = true;
					for (i in key) {
						access(elems, fn, i, key[i], true, emptyGet, raw);
					}

					// Sets one value
				} else if (value !== undefined) {
					chainable = true;

					if (!isFunction(value)) {
						raw = true;
					}

					if (bulk) {

						// Bulk operations run against the entire set
						if (raw) {
							fn.call(elems, value);
							fn = null;

							// ...except when executing function values
						} else {
							bulk = fn;
							fn = function fn(elem, _key, value) {
								return bulk.call(jQuery(elem), value);
							};
						}
					}

					if (fn) {
						for (; i < len; i++) {
							fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
						}
					}
				}

				if (chainable) {
					return elems;
				}

				// Gets
				if (bulk) {
					return fn.call(elems);
				}

				return len ? fn(elems[0], key) : emptyGet;
			};

			// Matches dashed string for camelizing
			var rmsPrefix = /^-ms-/,
			    rdashAlpha = /-([a-z])/g;

			// Used by camelCase as callback to replace()
			function fcamelCase(_all, letter) {
				return letter.toUpperCase();
			}

			// Convert dashed to camelCase; used by the css and data modules
			// Support: IE <=9 - 11, Edge 12 - 15
			// Microsoft forgot to hump their vendor prefix (#9572)
			function camelCase(string) {
				return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
			}
			var acceptData = function acceptData(owner) {

				// Accepts only:
				//  - Node
				//    - Node.ELEMENT_NODE
				//    - Node.DOCUMENT_NODE
				//  - Object
				//    - Any
				return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
			};

			function Data() {
				this.expando = jQuery.expando + Data.uid++;
			}

			Data.uid = 1;

			Data.prototype = {

				cache: function cache(owner) {

					// Check if the owner object already has a cache
					var value = owner[this.expando];

					// If not, create one
					if (!value) {
						value = {};

						// We can accept data for non-element nodes in modern browsers,
						// but we should not, see #8335.
						// Always return an empty object.
						if (acceptData(owner)) {

							// If it is a node unlikely to be stringify-ed or looped over
							// use plain assignment
							if (owner.nodeType) {
								owner[this.expando] = value;

								// Otherwise secure it in a non-enumerable property
								// configurable must be true to allow the property to be
								// deleted when data is removed
							} else {
								Object.defineProperty(owner, this.expando, {
									value: value,
									configurable: true
								});
							}
						}
					}

					return value;
				},
				set: function set(owner, data, value) {
					var prop,
					    cache = this.cache(owner);

					// Handle: [ owner, key, value ] args
					// Always use camelCase key (gh-2257)
					if (typeof data === "string") {
						cache[camelCase(data)] = value;

						// Handle: [ owner, { properties } ] args
					} else {

						// Copy the properties one-by-one to the cache object
						for (prop in data) {
							cache[camelCase(prop)] = data[prop];
						}
					}
					return cache;
				},
				get: function get(owner, key) {
					return key === undefined ? this.cache(owner) :

					// Always use camelCase key (gh-2257)
					owner[this.expando] && owner[this.expando][camelCase(key)];
				},
				access: function access(owner, key, value) {

					// In cases where either:
					//
					//   1. No key was specified
					//   2. A string key was specified, but no value provided
					//
					// Take the "read" path and allow the get method to determine
					// which value to return, respectively either:
					//
					//   1. The entire cache object
					//   2. The data stored at the key
					//
					if (key === undefined || key && typeof key === "string" && value === undefined) {

						return this.get(owner, key);
					}

					// When the key is not a string, or both a key and value
					// are specified, set or extend (existing objects) with either:
					//
					//   1. An object of properties
					//   2. A key and value
					//
					this.set(owner, key, value);

					// Since the "set" path can have two possible entry points
					// return the expected data based on which path was taken[*]
					return value !== undefined ? value : key;
				},
				remove: function remove(owner, key) {
					var i,
					    cache = owner[this.expando];

					if (cache === undefined) {
						return;
					}

					if (key !== undefined) {

						// Support array or space separated string of keys
						if (Array.isArray(key)) {

							// If key is an array of keys...
							// We always set camelCase keys, so remove that.
							key = key.map(camelCase);
						} else {
							key = camelCase(key);

							// If a key with the spaces exists, use it.
							// Otherwise, create an array by matching non-whitespace
							key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
						}

						i = key.length;

						while (i--) {
							delete cache[key[i]];
						}
					}

					// Remove the expando if there's no more data
					if (key === undefined || jQuery.isEmptyObject(cache)) {

						// Support: Chrome <=35 - 45
						// Webkit & Blink performance suffers when deleting properties
						// from DOM nodes, so set to undefined instead
						// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
						if (owner.nodeType) {
							owner[this.expando] = undefined;
						} else {
							delete owner[this.expando];
						}
					}
				},
				hasData: function hasData(owner) {
					var cache = owner[this.expando];
					return cache !== undefined && !jQuery.isEmptyObject(cache);
				}
			};
			var dataPriv = new Data();

			var dataUser = new Data();

			//	Implementation Summary
			//
			//	1. Enforce API surface and semantic compatibility with 1.9.x branch
			//	2. Improve the module's maintainability by reducing the storage
			//		paths to a single mechanism.
			//	3. Use the same single mechanism to support "private" and "user" data.
			//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
			//	5. Avoid exposing implementation details on user objects (eg. expando properties)
			//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

			var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			    rmultiDash = /[A-Z]/g;

			function getData(data) {
				if (data === "true") {
					return true;
				}

				if (data === "false") {
					return false;
				}

				if (data === "null") {
					return null;
				}

				// Only convert to a number if it doesn't change the string
				if (data === +data + "") {
					return +data;
				}

				if (rbrace.test(data)) {
					return JSON.parse(data);
				}

				return data;
			}

			function dataAttr(elem, key, data) {
				var name;

				// If nothing was found internally, try to fetch any
				// data from the HTML5 data-* attribute
				if (data === undefined && elem.nodeType === 1) {
					name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
					data = elem.getAttribute(name);

					if (typeof data === "string") {
						try {
							data = getData(data);
						} catch (e) {}

						// Make sure we set the data so it isn't changed later
						dataUser.set(elem, key, data);
					} else {
						data = undefined;
					}
				}
				return data;
			}

			jQuery.extend({
				hasData: function hasData(elem) {
					return dataUser.hasData(elem) || dataPriv.hasData(elem);
				},

				data: function data(elem, name, _data) {
					return dataUser.access(elem, name, _data);
				},

				removeData: function removeData(elem, name) {
					dataUser.remove(elem, name);
				},

				// TODO: Now that all calls to _data and _removeData have been replaced
				// with direct calls to dataPriv methods, these can be deprecated.
				_data: function _data(elem, name, data) {
					return dataPriv.access(elem, name, data);
				},

				_removeData: function _removeData(elem, name) {
					dataPriv.remove(elem, name);
				}
			});

			jQuery.fn.extend({
				data: function data(key, value) {
					var i,
					    name,
					    data,
					    elem = this[0],
					    attrs = elem && elem.attributes;

					// Gets all values
					if (key === undefined) {
						if (this.length) {
							data = dataUser.get(elem);

							if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
								i = attrs.length;
								while (i--) {

									// Support: IE 11 only
									// The attrs elements can be null (#14894)
									if (attrs[i]) {
										name = attrs[i].name;
										if (name.indexOf("data-") === 0) {
											name = camelCase(name.slice(5));
											dataAttr(elem, name, data[name]);
										}
									}
								}
								dataPriv.set(elem, "hasDataAttrs", true);
							}
						}

						return data;
					}

					// Sets multiple values
					if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
						return this.each(function () {
							dataUser.set(this, key);
						});
					}

					return access(this, function (value) {
						var data;

						// The calling jQuery object (element matches) is not empty
						// (and therefore has an element appears at this[ 0 ]) and the
						// `value` parameter was not undefined. An empty jQuery object
						// will result in `undefined` for elem = this[ 0 ] which will
						// throw an exception if an attempt to read a data cache is made.
						if (elem && value === undefined) {

							// Attempt to get data from the cache
							// The key will always be camelCased in Data
							data = dataUser.get(elem, key);
							if (data !== undefined) {
								return data;
							}

							// Attempt to "discover" the data in
							// HTML5 custom data-* attrs
							data = dataAttr(elem, key);
							if (data !== undefined) {
								return data;
							}

							// We tried really hard, but the data doesn't exist.
							return;
						}

						// Set the data...
						this.each(function () {

							// We always store the camelCased key
							dataUser.set(this, key, value);
						});
					}, null, value, arguments.length > 1, null, true);
				},

				removeData: function removeData(key) {
					return this.each(function () {
						dataUser.remove(this, key);
					});
				}
			});

			jQuery.extend({
				queue: function queue(elem, type, data) {
					var queue;

					if (elem) {
						type = (type || "fx") + "queue";
						queue = dataPriv.get(elem, type);

						// Speed up dequeue by getting out quickly if this is just a lookup
						if (data) {
							if (!queue || Array.isArray(data)) {
								queue = dataPriv.access(elem, type, jQuery.makeArray(data));
							} else {
								queue.push(data);
							}
						}
						return queue || [];
					}
				},

				dequeue: function dequeue(elem, type) {
					type = type || "fx";

					var queue = jQuery.queue(elem, type),
					    startLength = queue.length,
					    fn = queue.shift(),
					    hooks = jQuery._queueHooks(elem, type),
					    next = function next() {
						jQuery.dequeue(elem, type);
					};

					// If the fx queue is dequeued, always remove the progress sentinel
					if (fn === "inprogress") {
						fn = queue.shift();
						startLength--;
					}

					if (fn) {

						// Add a progress sentinel to prevent the fx queue from being
						// automatically dequeued
						if (type === "fx") {
							queue.unshift("inprogress");
						}

						// Clear up the last queue stop function
						delete hooks.stop;
						fn.call(elem, next, hooks);
					}

					if (!startLength && hooks) {
						hooks.empty.fire();
					}
				},

				// Not public - generate a queueHooks object, or return the current one
				_queueHooks: function _queueHooks(elem, type) {
					var key = type + "queueHooks";
					return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
						empty: jQuery.Callbacks("once memory").add(function () {
							dataPriv.remove(elem, [type + "queue", key]);
						})
					});
				}
			});

			jQuery.fn.extend({
				queue: function queue(type, data) {
					var setter = 2;

					if (typeof type !== "string") {
						data = type;
						type = "fx";
						setter--;
					}

					if (arguments.length < setter) {
						return jQuery.queue(this[0], type);
					}

					return data === undefined ? this : this.each(function () {
						var queue = jQuery.queue(this, type, data);

						// Ensure a hooks for this queue
						jQuery._queueHooks(this, type);

						if (type === "fx" && queue[0] !== "inprogress") {
							jQuery.dequeue(this, type);
						}
					});
				},
				dequeue: function dequeue(type) {
					return this.each(function () {
						jQuery.dequeue(this, type);
					});
				},
				clearQueue: function clearQueue(type) {
					return this.queue(type || "fx", []);
				},

				// Get a promise resolved when queues of a certain type
				// are emptied (fx is the type by default)
				promise: function promise(type, obj) {
					var tmp,
					    count = 1,
					    defer = jQuery.Deferred(),
					    elements = this,
					    i = this.length,
					    resolve = function resolve() {
						if (! --count) {
							defer.resolveWith(elements, [elements]);
						}
					};

					if (typeof type !== "string") {
						obj = type;
						type = undefined;
					}
					type = type || "fx";

					while (i--) {
						tmp = dataPriv.get(elements[i], type + "queueHooks");
						if (tmp && tmp.empty) {
							count++;
							tmp.empty.add(resolve);
						}
					}
					resolve();
					return defer.promise(obj);
				}
			});
			var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

			var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

			var cssExpand = ["Top", "Right", "Bottom", "Left"];

			var documentElement = document.documentElement;

			var isAttached = function isAttached(elem) {
				return jQuery.contains(elem.ownerDocument, elem);
			},
			    composed = { composed: true };

			// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
			// Check attachment across shadow DOM boundaries when possible (gh-3504)
			// Support: iOS 10.0-10.2 only
			// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
			// leading to errors. We need to check for `getRootNode`.
			if (documentElement.getRootNode) {
				isAttached = function isAttached(elem) {
					return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
				};
			}
			var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {

				// isHiddenWithinTree might be called from jQuery#filter function;
				// in that case, element will be second argument
				elem = el || elem;

				// Inline style trumps all
				return elem.style.display === "none" || elem.style.display === "" &&

				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached(elem) && jQuery.css(elem, "display") === "none";
			};

			function adjustCSS(elem, prop, valueParts, tween) {
				var adjusted,
				    scale,
				    maxIterations = 20,
				    currentValue = tween ? function () {
					return tween.cur();
				} : function () {
					return jQuery.css(elem, prop, "");
				},
				    initial = currentValue(),
				    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),


				// Starting value computation is required for potential unit mismatches
				initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

				if (initialInUnit && initialInUnit[3] !== unit) {

					// Support: Firefox <=54
					// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
					initial = initial / 2;

					// Trust units reported by jQuery.css
					unit = unit || initialInUnit[3];

					// Iteratively approximate from a nonzero starting point
					initialInUnit = +initial || 1;

					while (maxIterations--) {

						// Evaluate and update our best guess (doubling guesses that zero out).
						// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
						jQuery.style(elem, prop, initialInUnit + unit);
						if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
							maxIterations = 0;
						}
						initialInUnit = initialInUnit / scale;
					}

					initialInUnit = initialInUnit * 2;
					jQuery.style(elem, prop, initialInUnit + unit);

					// Make sure we update the tween properties later on
					valueParts = valueParts || [];
				}

				if (valueParts) {
					initialInUnit = +initialInUnit || +initial || 0;

					// Apply relative offset (+=/-=) if specified
					adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
					if (tween) {
						tween.unit = unit;
						tween.start = initialInUnit;
						tween.end = adjusted;
					}
				}
				return adjusted;
			}

			var defaultDisplayMap = {};

			function getDefaultDisplay(elem) {
				var temp,
				    doc = elem.ownerDocument,
				    nodeName = elem.nodeName,
				    display = defaultDisplayMap[nodeName];

				if (display) {
					return display;
				}

				temp = doc.body.appendChild(doc.createElement(nodeName));
				display = jQuery.css(temp, "display");

				temp.parentNode.removeChild(temp);

				if (display === "none") {
					display = "block";
				}
				defaultDisplayMap[nodeName] = display;

				return display;
			}

			function showHide(elements, show) {
				var display,
				    elem,
				    values = [],
				    index = 0,
				    length = elements.length;

				// Determine new display value for elements that need to change
				for (; index < length; index++) {
					elem = elements[index];
					if (!elem.style) {
						continue;
					}

					display = elem.style.display;
					if (show) {

						// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
						// check is required in this first loop unless we have a nonempty display value (either
						// inline or about-to-be-restored)
						if (display === "none") {
							values[index] = dataPriv.get(elem, "display") || null;
							if (!values[index]) {
								elem.style.display = "";
							}
						}
						if (elem.style.display === "" && isHiddenWithinTree(elem)) {
							values[index] = getDefaultDisplay(elem);
						}
					} else {
						if (display !== "none") {
							values[index] = "none";

							// Remember what we're overwriting
							dataPriv.set(elem, "display", display);
						}
					}
				}

				// Set the display of the elements in a second loop to avoid constant reflow
				for (index = 0; index < length; index++) {
					if (values[index] != null) {
						elements[index].style.display = values[index];
					}
				}

				return elements;
			}

			jQuery.fn.extend({
				show: function show() {
					return showHide(this, true);
				},
				hide: function hide() {
					return showHide(this);
				},
				toggle: function toggle(state) {
					if (typeof state === "boolean") {
						return state ? this.show() : this.hide();
					}

					return this.each(function () {
						if (isHiddenWithinTree(this)) {
							jQuery(this).show();
						} else {
							jQuery(this).hide();
						}
					});
				}
			});
			var rcheckableType = /^(?:checkbox|radio)$/i;

			var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

			var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

			(function () {
				var fragment = document.createDocumentFragment(),
				    div = fragment.appendChild(document.createElement("div")),
				    input = document.createElement("input");

				// Support: Android 4.0 - 4.3 only
				// Check state lost if the name is set (#11217)
				// Support: Windows Web Apps (WWA)
				// `name` and `type` must use .setAttribute for WWA (#14901)
				input.setAttribute("type", "radio");
				input.setAttribute("checked", "checked");
				input.setAttribute("name", "t");

				div.appendChild(input);

				// Support: Android <=4.1 only
				// Older WebKit doesn't clone checked state correctly in fragments
				support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

				// Support: IE <=11 only
				// Make sure textarea (and checkbox) defaultValue is properly cloned
				div.innerHTML = "<textarea>x</textarea>";
				support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

				// Support: IE <=9 only
				// IE <=9 replaces <option> tags with their contents when inserted outside of
				// the select element.
				div.innerHTML = "<option></option>";
				support.option = !!div.lastChild;
			})();

			// We have to close these tags to support XHTML (#13200)
			var wrapMap = {

				// XHTML parsers do not magically insert elements in the
				// same way that tag soup parsers do. So we cannot shorten
				// this by omitting <tbody> or other required elements.
				thead: [1, "<table>", "</table>"],
				col: [2, "<table><colgroup>", "</colgroup></table>"],
				tr: [2, "<table><tbody>", "</tbody></table>"],
				td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

				_default: [0, "", ""]
			};

			wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
			wrapMap.th = wrapMap.td;

			// Support: IE <=9 only
			if (!support.option) {
				wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
			}

			function getAll(context, tag) {

				// Support: IE <=9 - 11 only
				// Use typeof to avoid zero-argument method invocation on host objects (#15151)
				var ret;

				if (typeof context.getElementsByTagName !== "undefined") {
					ret = context.getElementsByTagName(tag || "*");
				} else if (typeof context.querySelectorAll !== "undefined") {
					ret = context.querySelectorAll(tag || "*");
				} else {
					ret = [];
				}

				if (tag === undefined || tag && nodeName(context, tag)) {
					return jQuery.merge([context], ret);
				}

				return ret;
			}

			// Mark scripts as having already been evaluated
			function setGlobalEval(elems, refElements) {
				var i = 0,
				    l = elems.length;

				for (; i < l; i++) {
					dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
				}
			}

			var rhtml = /<|&#?\w+;/;

			function buildFragment(elems, context, scripts, selection, ignored) {
				var elem,
				    tmp,
				    tag,
				    wrap,
				    attached,
				    j,
				    fragment = context.createDocumentFragment(),
				    nodes = [],
				    i = 0,
				    l = elems.length;

				for (; i < l; i++) {
					elem = elems[i];

					if (elem || elem === 0) {

						// Add nodes directly
						if (toType(elem) === "object") {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

							// Convert non-html into a text node
						} else if (!rhtml.test(elem)) {
							nodes.push(context.createTextNode(elem));

							// Convert html into DOM nodes
						} else {
							tmp = tmp || fragment.appendChild(context.createElement("div"));

							// Deserialize a standard representation
							tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
							wrap = wrapMap[tag] || wrapMap._default;
							tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

							// Descend through wrappers to the right content
							j = wrap[0];
							while (j--) {
								tmp = tmp.lastChild;
							}

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge(nodes, tmp.childNodes);

							// Remember the top-level container
							tmp = fragment.firstChild;

							// Ensure the created nodes are orphaned (#12392)
							tmp.textContent = "";
						}
					}
				}

				// Remove wrapper from fragment
				fragment.textContent = "";

				i = 0;
				while (elem = nodes[i++]) {

					// Skip elements already in the context collection (trac-4087)
					if (selection && jQuery.inArray(elem, selection) > -1) {
						if (ignored) {
							ignored.push(elem);
						}
						continue;
					}

					attached = isAttached(elem);

					// Append to fragment
					tmp = getAll(fragment.appendChild(elem), "script");

					// Preserve script evaluation history
					if (attached) {
						setGlobalEval(tmp);
					}

					// Capture executables
					if (scripts) {
						j = 0;
						while (elem = tmp[j++]) {
							if (rscriptType.test(elem.type || "")) {
								scripts.push(elem);
							}
						}
					}
				}

				return fragment;
			}

			var rkeyEvent = /^key/,
			    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
			    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

			function returnTrue() {
				return true;
			}

			function returnFalse() {
				return false;
			}

			// Support: IE <=9 - 11+
			// focus() and blur() are asynchronous, except when they are no-op.
			// So expect focus to be synchronous when the element is already active,
			// and blur to be synchronous when the element is not already active.
			// (focus and blur are always synchronous in other supported browsers,
			// this just defines when we can count on it).
			function expectSync(elem, type) {
				return elem === safeActiveElement() === (type === "focus");
			}

			// Support: IE <=9 only
			// Accessing document.activeElement can throw unexpectedly
			// https://bugs.jquery.com/ticket/13393
			function safeActiveElement() {
				try {
					return document.activeElement;
				} catch (err) {}
			}

			function _on(elem, types, selector, data, fn, one) {
				var origFn, type;

				// Types can be a map of types/handlers
				if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

					// ( types-Object, selector, data )
					if (typeof selector !== "string") {

						// ( types-Object, data )
						data = data || selector;
						selector = undefined;
					}
					for (type in types) {
						_on(elem, type, selector, data, types[type], one);
					}
					return elem;
				}

				if (data == null && fn == null) {

					// ( types, fn )
					fn = selector;
					data = selector = undefined;
				} else if (fn == null) {
					if (typeof selector === "string") {

						// ( types, selector, fn )
						fn = data;
						data = undefined;
					} else {

						// ( types, data, fn )
						fn = data;
						data = selector;
						selector = undefined;
					}
				}
				if (fn === false) {
					fn = returnFalse;
				} else if (!fn) {
					return elem;
				}

				if (one === 1) {
					origFn = fn;
					fn = function fn(event) {

						// Can use an empty set, since event contains the info
						jQuery().off(event);
						return origFn.apply(this, arguments);
					};

					// Use same guid so caller can remove using origFn
					fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
				}
				return elem.each(function () {
					jQuery.event.add(this, types, fn, data, selector);
				});
			}

			/*
    * Helper functions for managing events -- not part of the public interface.
    * Props to Dean Edwards' addEvent library for many of the ideas.
    */
			jQuery.event = {

				global: {},

				add: function add(elem, types, handler, data, selector) {

					var handleObjIn,
					    eventHandle,
					    tmp,
					    events,
					    t,
					    handleObj,
					    special,
					    handlers,
					    type,
					    namespaces,
					    origType,
					    elemData = dataPriv.get(elem);

					// Only attach events to objects that accept data
					if (!acceptData(elem)) {
						return;
					}

					// Caller can pass in an object of custom data in lieu of the handler
					if (handler.handler) {
						handleObjIn = handler;
						handler = handleObjIn.handler;
						selector = handleObjIn.selector;
					}

					// Ensure that invalid selectors throw exceptions at attach time
					// Evaluate against documentElement in case elem is a non-element node (e.g., document)
					if (selector) {
						jQuery.find.matchesSelector(documentElement, selector);
					}

					// Make sure that the handler has a unique ID, used to find/remove it later
					if (!handler.guid) {
						handler.guid = jQuery.guid++;
					}

					// Init the element's event structure and main handler, if this is the first
					if (!(events = elemData.events)) {
						events = elemData.events = Object.create(null);
					}
					if (!(eventHandle = elemData.handle)) {
						eventHandle = elemData.handle = function (e) {

							// Discard the second event of a jQuery.event.trigger() and
							// when an event is called after a page has unloaded
							return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
						};
					}

					// Handle multiple events separated by a space
					types = (types || "").match(rnothtmlwhite) || [""];
					t = types.length;
					while (t--) {
						tmp = rtypenamespace.exec(types[t]) || [];
						type = origType = tmp[1];
						namespaces = (tmp[2] || "").split(".").sort();

						// There *must* be a type, no attaching namespace-only handlers
						if (!type) {
							continue;
						}

						// If event changes its type, use the special event handlers for the changed type
						special = jQuery.event.special[type] || {};

						// If selector defined, determine special event api type, otherwise given type
						type = (selector ? special.delegateType : special.bindType) || type;

						// Update special based on newly reset type
						special = jQuery.event.special[type] || {};

						// handleObj is passed to all event handlers
						handleObj = jQuery.extend({
							type: type,
							origType: origType,
							data: data,
							handler: handler,
							guid: handler.guid,
							selector: selector,
							needsContext: selector && jQuery.expr.match.needsContext.test(selector),
							namespace: namespaces.join(".")
						}, handleObjIn);

						// Init the event handler queue if we're the first
						if (!(handlers = events[type])) {
							handlers = events[type] = [];
							handlers.delegateCount = 0;

							// Only use addEventListener if the special events handler returns false
							if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {

								if (elem.addEventListener) {
									elem.addEventListener(type, eventHandle);
								}
							}
						}

						if (special.add) {
							special.add.call(elem, handleObj);

							if (!handleObj.handler.guid) {
								handleObj.handler.guid = handler.guid;
							}
						}

						// Add to the element's handler list, delegates in front
						if (selector) {
							handlers.splice(handlers.delegateCount++, 0, handleObj);
						} else {
							handlers.push(handleObj);
						}

						// Keep track of which events have ever been used, for event optimization
						jQuery.event.global[type] = true;
					}
				},

				// Detach an event or set of events from an element
				remove: function remove(elem, types, handler, selector, mappedTypes) {

					var j,
					    origCount,
					    tmp,
					    events,
					    t,
					    handleObj,
					    special,
					    handlers,
					    type,
					    namespaces,
					    origType,
					    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

					if (!elemData || !(events = elemData.events)) {
						return;
					}

					// Once for each type.namespace in types; type may be omitted
					types = (types || "").match(rnothtmlwhite) || [""];
					t = types.length;
					while (t--) {
						tmp = rtypenamespace.exec(types[t]) || [];
						type = origType = tmp[1];
						namespaces = (tmp[2] || "").split(".").sort();

						// Unbind all events (on this namespace, if provided) for the element
						if (!type) {
							for (type in events) {
								jQuery.event.remove(elem, type + types[t], handler, selector, true);
							}
							continue;
						}

						special = jQuery.event.special[type] || {};
						type = (selector ? special.delegateType : special.bindType) || type;
						handlers = events[type] || [];
						tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

						// Remove matching events
						origCount = j = handlers.length;
						while (j--) {
							handleObj = handlers[j];

							if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
								handlers.splice(j, 1);

								if (handleObj.selector) {
									handlers.delegateCount--;
								}
								if (special.remove) {
									special.remove.call(elem, handleObj);
								}
							}
						}

						// Remove generic event handler if we removed something and no more handlers exist
						// (avoids potential for endless recursion during removal of special event handlers)
						if (origCount && !handlers.length) {
							if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {

								jQuery.removeEvent(elem, type, elemData.handle);
							}

							delete events[type];
						}
					}

					// Remove data and the expando if it's no longer used
					if (jQuery.isEmptyObject(events)) {
						dataPriv.remove(elem, "handle events");
					}
				},

				dispatch: function dispatch(nativeEvent) {

					var i,
					    j,
					    ret,
					    matched,
					    handleObj,
					    handlerQueue,
					    args = new Array(arguments.length),


					// Make a writable jQuery.Event from the native event object
					event = jQuery.event.fix(nativeEvent),
					    handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
					    special = jQuery.event.special[event.type] || {};

					// Use the fix-ed jQuery.Event rather than the (read-only) native event
					args[0] = event;

					for (i = 1; i < arguments.length; i++) {
						args[i] = arguments[i];
					}

					event.delegateTarget = this;

					// Call the preDispatch hook for the mapped type, and let it bail if desired
					if (special.preDispatch && special.preDispatch.call(this, event) === false) {
						return;
					}

					// Determine handlers
					handlerQueue = jQuery.event.handlers.call(this, event, handlers);

					// Run delegates first; they may want to stop propagation beneath us
					i = 0;
					while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
						event.currentTarget = matched.elem;

						j = 0;
						while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {

							// If the event is namespaced, then each handler is only invoked if it is
							// specially universal or its namespaces are a superset of the event's.
							if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {

								event.handleObj = handleObj;
								event.data = handleObj.data;

								ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

								if (ret !== undefined) {
									if ((event.result = ret) === false) {
										event.preventDefault();
										event.stopPropagation();
									}
								}
							}
						}
					}

					// Call the postDispatch hook for the mapped type
					if (special.postDispatch) {
						special.postDispatch.call(this, event);
					}

					return event.result;
				},

				handlers: function handlers(event, _handlers) {
					var i,
					    handleObj,
					    sel,
					    matchedHandlers,
					    matchedSelectors,
					    handlerQueue = [],
					    delegateCount = _handlers.delegateCount,
					    cur = event.target;

					// Find delegate handlers
					if (delegateCount &&

					// Support: IE <=9
					// Black-hole SVG <use> instance trees (trac-13180)
					cur.nodeType &&

					// Support: Firefox <=42
					// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
					// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
					// Support: IE 11 only
					// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
					!(event.type === "click" && event.button >= 1)) {

						for (; cur !== this; cur = cur.parentNode || this) {

							// Don't check non-elements (#13208)
							// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
							if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
								matchedHandlers = [];
								matchedSelectors = {};
								for (i = 0; i < delegateCount; i++) {
									handleObj = _handlers[i];

									// Don't conflict with Object.prototype properties (#13203)
									sel = handleObj.selector + " ";

									if (matchedSelectors[sel] === undefined) {
										matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
									}
									if (matchedSelectors[sel]) {
										matchedHandlers.push(handleObj);
									}
								}
								if (matchedHandlers.length) {
									handlerQueue.push({ elem: cur, handlers: matchedHandlers });
								}
							}
						}
					}

					// Add the remaining (directly-bound) handlers
					cur = this;
					if (delegateCount < _handlers.length) {
						handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
					}

					return handlerQueue;
				},

				addProp: function addProp(name, hook) {
					Object.defineProperty(jQuery.Event.prototype, name, {
						enumerable: true,
						configurable: true,

						get: isFunction(hook) ? function () {
							if (this.originalEvent) {
								return hook(this.originalEvent);
							}
						} : function () {
							if (this.originalEvent) {
								return this.originalEvent[name];
							}
						},

						set: function set(value) {
							Object.defineProperty(this, name, {
								enumerable: true,
								configurable: true,
								writable: true,
								value: value
							});
						}
					});
				},

				fix: function fix(originalEvent) {
					return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
				},

				special: {
					load: {

						// Prevent triggered image.load events from bubbling to window.load
						noBubble: true
					},
					click: {

						// Utilize native event to ensure correct state for checkable inputs
						setup: function setup(data) {

							// For mutual compressibility with _default, replace `this` access with a local var.
							// `|| data` is dead code meant only to preserve the variable through minification.
							var el = this || data;

							// Claim the first handler
							if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

								// dataPriv.set( el, "click", ... )
								leverageNative(el, "click", returnTrue);
							}

							// Return false to allow normal processing in the caller
							return false;
						},
						trigger: function trigger(data) {

							// For mutual compressibility with _default, replace `this` access with a local var.
							// `|| data` is dead code meant only to preserve the variable through minification.
							var el = this || data;

							// Force setup before triggering a click
							if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

								leverageNative(el, "click");
							}

							// Return non-false to allow normal event-path propagation
							return true;
						},

						// For cross-browser consistency, suppress native .click() on links
						// Also prevent it if we're currently inside a leveraged native-event stack
						_default: function _default(event) {
							var target = event.target;
							return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
						}
					},

					beforeunload: {
						postDispatch: function postDispatch(event) {

							// Support: Firefox 20+
							// Firefox doesn't alert if the returnValue field is not set.
							if (event.result !== undefined && event.originalEvent) {
								event.originalEvent.returnValue = event.result;
							}
						}
					}
				}
			};

			// Ensure the presence of an event listener that handles manually-triggered
			// synthetic events by interrupting progress until reinvoked in response to
			// *native* events that it fires directly, ensuring that state changes have
			// already occurred before other listeners are invoked.
			function leverageNative(el, type, expectSync) {

				// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
				if (!expectSync) {
					if (dataPriv.get(el, type) === undefined) {
						jQuery.event.add(el, type, returnTrue);
					}
					return;
				}

				// Register the controller as a special universal handler for all event namespaces
				dataPriv.set(el, type, false);
				jQuery.event.add(el, type, {
					namespace: false,
					handler: function handler(event) {
						var notAsync,
						    result,
						    saved = dataPriv.get(this, type);

						if (event.isTrigger & 1 && this[type]) {

							// Interrupt processing of the outer synthetic .trigger()ed event
							// Saved data should be false in such cases, but might be a leftover capture object
							// from an async native handler (gh-4350)
							if (!saved.length) {

								// Store arguments for use when handling the inner native event
								// There will always be at least one argument (an event object), so this array
								// will not be confused with a leftover capture object.
								saved = _slice.call(arguments);
								dataPriv.set(this, type, saved);

								// Trigger the native event and capture its result
								// Support: IE <=9 - 11+
								// focus() and blur() are asynchronous
								notAsync = expectSync(this, type);
								this[type]();
								result = dataPriv.get(this, type);
								if (saved !== result || notAsync) {
									dataPriv.set(this, type, false);
								} else {
									result = {};
								}
								if (saved !== result) {

									// Cancel the outer synthetic event
									event.stopImmediatePropagation();
									event.preventDefault();
									return result.value;
								}

								// If this is an inner synthetic event for an event with a bubbling surrogate
								// (focus or blur), assume that the surrogate already propagated from triggering the
								// native event and prevent that from happening again here.
								// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
								// bubbling surrogate propagates *after* the non-bubbling base), but that seems
								// less bad than duplication.
							} else if ((jQuery.event.special[type] || {}).delegateType) {
								event.stopPropagation();
							}

							// If this is a native event triggered above, everything is now in order
							// Fire an inner synthetic event with the original arguments
						} else if (saved.length) {

							// ...and capture the result
							dataPriv.set(this, type, {
								value: jQuery.event.trigger(

								// Support: IE <=9 - 11+
								// Extend with the prototype to reset the above stopImmediatePropagation()
								jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
							});

							// Abort handling of the native event
							event.stopImmediatePropagation();
						}
					}
				});
			}

			jQuery.removeEvent = function (elem, type, handle) {

				// This "if" is needed for plain objects
				if (elem.removeEventListener) {
					elem.removeEventListener(type, handle);
				}
			};

			jQuery.Event = function (src, props) {

				// Allow instantiation without the 'new' keyword
				if (!(this instanceof jQuery.Event)) {
					return new jQuery.Event(src, props);
				}

				// Event object
				if (src && src.type) {
					this.originalEvent = src;
					this.type = src.type;

					// Events bubbling up the document may have been marked as prevented
					// by a handler lower down the tree; reflect the correct value.
					this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&

					// Support: Android <=2.3 only
					src.returnValue === false ? returnTrue : returnFalse;

					// Create target properties
					// Support: Safari <=6 - 7 only
					// Target should not be a text node (#504, #13143)
					this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

					this.currentTarget = src.currentTarget;
					this.relatedTarget = src.relatedTarget;

					// Event type
				} else {
					this.type = src;
				}

				// Put explicitly provided properties onto the event object
				if (props) {
					jQuery.extend(this, props);
				}

				// Create a timestamp if incoming event doesn't have one
				this.timeStamp = src && src.timeStamp || Date.now();

				// Mark it as fixed
				this[jQuery.expando] = true;
			};

			// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
			// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
			jQuery.Event.prototype = {
				constructor: jQuery.Event,
				isDefaultPrevented: returnFalse,
				isPropagationStopped: returnFalse,
				isImmediatePropagationStopped: returnFalse,
				isSimulated: false,

				preventDefault: function preventDefault() {
					var e = this.originalEvent;

					this.isDefaultPrevented = returnTrue;

					if (e && !this.isSimulated) {
						e.preventDefault();
					}
				},
				stopPropagation: function stopPropagation() {
					var e = this.originalEvent;

					this.isPropagationStopped = returnTrue;

					if (e && !this.isSimulated) {
						e.stopPropagation();
					}
				},
				stopImmediatePropagation: function stopImmediatePropagation() {
					var e = this.originalEvent;

					this.isImmediatePropagationStopped = returnTrue;

					if (e && !this.isSimulated) {
						e.stopImmediatePropagation();
					}

					this.stopPropagation();
				}
			};

			// Includes all common event props including KeyEvent and MouseEvent specific props
			jQuery.each({
				altKey: true,
				bubbles: true,
				cancelable: true,
				changedTouches: true,
				ctrlKey: true,
				detail: true,
				eventPhase: true,
				metaKey: true,
				pageX: true,
				pageY: true,
				shiftKey: true,
				view: true,
				"char": true,
				code: true,
				charCode: true,
				key: true,
				keyCode: true,
				button: true,
				buttons: true,
				clientX: true,
				clientY: true,
				offsetX: true,
				offsetY: true,
				pointerId: true,
				pointerType: true,
				screenX: true,
				screenY: true,
				targetTouches: true,
				toElement: true,
				touches: true,

				which: function which(event) {
					var button = event.button;

					// Add which for key events
					if (event.which == null && rkeyEvent.test(event.type)) {
						return event.charCode != null ? event.charCode : event.keyCode;
					}

					// Add which for click: 1 === left; 2 === middle; 3 === right
					if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
						if (button & 1) {
							return 1;
						}

						if (button & 2) {
							return 3;
						}

						if (button & 4) {
							return 2;
						}

						return 0;
					}

					return event.which;
				}
			}, jQuery.event.addProp);

			jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {
				jQuery.event.special[type] = {

					// Utilize native event if possible so blur/focus sequence is correct
					setup: function setup() {

						// Claim the first handler
						// dataPriv.set( this, "focus", ... )
						// dataPriv.set( this, "blur", ... )
						leverageNative(this, type, expectSync);

						// Return false to allow normal processing in the caller
						return false;
					},
					trigger: function trigger() {

						// Force setup before trigger
						leverageNative(this, type);

						// Return non-false to allow normal event-path propagation
						return true;
					},

					delegateType: delegateType
				};
			});

			// Create mouseenter/leave events using mouseover/out and event-time checks
			// so that event delegation works in jQuery.
			// Do the same for pointerenter/pointerleave and pointerover/pointerout
			//
			// Support: Safari 7 only
			// Safari sends mouseenter too often; see:
			// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
			// for the description of the bug (it existed in older Chrome versions as well).
			jQuery.each({
				mouseenter: "mouseover",
				mouseleave: "mouseout",
				pointerenter: "pointerover",
				pointerleave: "pointerout"
			}, function (orig, fix) {
				jQuery.event.special[orig] = {
					delegateType: fix,
					bindType: fix,

					handle: function handle(event) {
						var ret,
						    target = this,
						    related = event.relatedTarget,
						    handleObj = event.handleObj;

						// For mouseenter/leave call the handler if related is outside the target.
						// NB: No relatedTarget if the mouse left/entered the browser window
						if (!related || related !== target && !jQuery.contains(target, related)) {
							event.type = handleObj.origType;
							ret = handleObj.handler.apply(this, arguments);
							event.type = fix;
						}
						return ret;
					}
				};
			});

			jQuery.fn.extend({

				on: function on(types, selector, data, fn) {
					return _on(this, types, selector, data, fn);
				},
				one: function one(types, selector, data, fn) {
					return _on(this, types, selector, data, fn, 1);
				},
				off: function off(types, selector, fn) {
					var handleObj, type;
					if (types && types.preventDefault && types.handleObj) {

						// ( event )  dispatched jQuery.Event
						handleObj = types.handleObj;
						jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
						return this;
					}
					if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

						// ( types-object [, selector] )
						for (type in types) {
							this.off(type, selector, types[type]);
						}
						return this;
					}
					if (selector === false || typeof selector === "function") {

						// ( types [, fn] )
						fn = selector;
						selector = undefined;
					}
					if (fn === false) {
						fn = returnFalse;
					}
					return this.each(function () {
						jQuery.event.remove(this, types, fn, selector);
					});
				}
			});

			var

			// Support: IE <=10 - 11, Edge 12 - 13 only
			// In IE/Edge using regex groups here causes severe slowdowns.
			// See https://connect.microsoft.com/IE/feedback/details/1736512/
			rnoInnerhtml = /<script|<style|<link/i,


			// checked="checked" or checked
			rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
			    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

			// Prefer a tbody over its parent table for containing new rows
			function manipulationTarget(elem, content) {
				if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

					return jQuery(elem).children("tbody")[0] || elem;
				}

				return elem;
			}

			// Replace/restore the type attribute of script elements for safe DOM manipulation
			function disableScript(elem) {
				elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
				return elem;
			}
			function restoreScript(elem) {
				if ((elem.type || "").slice(0, 5) === "true/") {
					elem.type = elem.type.slice(5);
				} else {
					elem.removeAttribute("type");
				}

				return elem;
			}

			function cloneCopyEvent(src, dest) {
				var i, l, type, pdataOld, udataOld, udataCur, events;

				if (dest.nodeType !== 1) {
					return;
				}

				// 1. Copy private data: events, handlers, etc.
				if (dataPriv.hasData(src)) {
					pdataOld = dataPriv.get(src);
					events = pdataOld.events;

					if (events) {
						dataPriv.remove(dest, "handle events");

						for (type in events) {
							for (i = 0, l = events[type].length; i < l; i++) {
								jQuery.event.add(dest, type, events[type][i]);
							}
						}
					}
				}

				// 2. Copy user data
				if (dataUser.hasData(src)) {
					udataOld = dataUser.access(src);
					udataCur = jQuery.extend({}, udataOld);

					dataUser.set(dest, udataCur);
				}
			}

			// Fix IE bugs, see support tests
			function fixInput(src, dest) {
				var nodeName = dest.nodeName.toLowerCase();

				// Fails to persist the checked state of a cloned checkbox or radio button.
				if (nodeName === "input" && rcheckableType.test(src.type)) {
					dest.checked = src.checked;

					// Fails to return the selected option to the default selected state when cloning options
				} else if (nodeName === "input" || nodeName === "textarea") {
					dest.defaultValue = src.defaultValue;
				}
			}

			function domManip(collection, args, callback, ignored) {

				// Flatten any nested arrays
				args = flat(args);

				var fragment,
				    first,
				    scripts,
				    hasScripts,
				    node,
				    doc,
				    i = 0,
				    l = collection.length,
				    iNoClone = l - 1,
				    value = args[0],
				    valueIsFunction = isFunction(value);

				// We can't cloneNode fragments that contain checked, in WebKit
				if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
					return collection.each(function (index) {
						var self = collection.eq(index);
						if (valueIsFunction) {
							args[0] = value.call(this, index, self.html());
						}
						domManip(self, args, callback, ignored);
					});
				}

				if (l) {
					fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
					first = fragment.firstChild;

					if (fragment.childNodes.length === 1) {
						fragment = first;
					}

					// Require either new content or an interest in ignored elements to invoke the callback
					if (first || ignored) {
						scripts = jQuery.map(getAll(fragment, "script"), disableScript);
						hasScripts = scripts.length;

						// Use the original fragment for the last item
						// instead of the first because it can end up
						// being emptied incorrectly in certain situations (#8070).
						for (; i < l; i++) {
							node = fragment;

							if (i !== iNoClone) {
								node = jQuery.clone(node, true, true);

								// Keep references to cloned scripts for later restoration
								if (hasScripts) {

									// Support: Android <=4.0 only, PhantomJS 1 only
									// push.apply(_, arraylike) throws on ancient WebKit
									jQuery.merge(scripts, getAll(node, "script"));
								}
							}

							callback.call(collection[i], node, i);
						}

						if (hasScripts) {
							doc = scripts[scripts.length - 1].ownerDocument;

							// Reenable scripts
							jQuery.map(scripts, restoreScript);

							// Evaluate executable scripts on first document insertion
							for (i = 0; i < hasScripts; i++) {
								node = scripts[i];
								if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {

									if (node.src && (node.type || "").toLowerCase() !== "module") {

										// Optional AJAX dependency, but won't run scripts if not present
										if (jQuery._evalUrl && !node.noModule) {
											jQuery._evalUrl(node.src, {
												nonce: node.nonce || node.getAttribute("nonce")
											}, doc);
										}
									} else {
										DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
									}
								}
							}
						}
					}
				}

				return collection;
			}

			function _remove(elem, selector, keepData) {
				var node,
				    nodes = selector ? jQuery.filter(selector, elem) : elem,
				    i = 0;

				for (; (node = nodes[i]) != null; i++) {
					if (!keepData && node.nodeType === 1) {
						jQuery.cleanData(getAll(node));
					}

					if (node.parentNode) {
						if (keepData && isAttached(node)) {
							setGlobalEval(getAll(node, "script"));
						}
						node.parentNode.removeChild(node);
					}
				}

				return elem;
			}

			jQuery.extend({
				htmlPrefilter: function htmlPrefilter(html) {
					return html;
				},

				clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
					var i,
					    l,
					    srcElements,
					    destElements,
					    clone = elem.cloneNode(true),
					    inPage = isAttached(elem);

					// Fix IE cloning issues
					if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {

						// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
						destElements = getAll(clone);
						srcElements = getAll(elem);

						for (i = 0, l = srcElements.length; i < l; i++) {
							fixInput(srcElements[i], destElements[i]);
						}
					}

					// Copy the events from the original to the clone
					if (dataAndEvents) {
						if (deepDataAndEvents) {
							srcElements = srcElements || getAll(elem);
							destElements = destElements || getAll(clone);

							for (i = 0, l = srcElements.length; i < l; i++) {
								cloneCopyEvent(srcElements[i], destElements[i]);
							}
						} else {
							cloneCopyEvent(elem, clone);
						}
					}

					// Preserve script evaluation history
					destElements = getAll(clone, "script");
					if (destElements.length > 0) {
						setGlobalEval(destElements, !inPage && getAll(elem, "script"));
					}

					// Return the cloned set
					return clone;
				},

				cleanData: function cleanData(elems) {
					var data,
					    elem,
					    type,
					    special = jQuery.event.special,
					    i = 0;

					for (; (elem = elems[i]) !== undefined; i++) {
						if (acceptData(elem)) {
							if (data = elem[dataPriv.expando]) {
								if (data.events) {
									for (type in data.events) {
										if (special[type]) {
											jQuery.event.remove(elem, type);

											// This is a shortcut to avoid jQuery.event.remove's overhead
										} else {
											jQuery.removeEvent(elem, type, data.handle);
										}
									}
								}

								// Support: Chrome <=35 - 45+
								// Assign undefined instead of using delete, see Data#remove
								elem[dataPriv.expando] = undefined;
							}
							if (elem[dataUser.expando]) {

								// Support: Chrome <=35 - 45+
								// Assign undefined instead of using delete, see Data#remove
								elem[dataUser.expando] = undefined;
							}
						}
					}
				}
			});

			jQuery.fn.extend({
				detach: function detach(selector) {
					return _remove(this, selector, true);
				},

				remove: function remove(selector) {
					return _remove(this, selector);
				},

				text: function text(value) {
					return access(this, function (value) {
						return value === undefined ? jQuery.text(this) : this.empty().each(function () {
							if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
								this.textContent = value;
							}
						});
					}, null, value, arguments.length);
				},

				append: function append() {
					return domManip(this, arguments, function (elem) {
						if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
							var target = manipulationTarget(this, elem);
							target.appendChild(elem);
						}
					});
				},

				prepend: function prepend() {
					return domManip(this, arguments, function (elem) {
						if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
							var target = manipulationTarget(this, elem);
							target.insertBefore(elem, target.firstChild);
						}
					});
				},

				before: function before() {
					return domManip(this, arguments, function (elem) {
						if (this.parentNode) {
							this.parentNode.insertBefore(elem, this);
						}
					});
				},

				after: function after() {
					return domManip(this, arguments, function (elem) {
						if (this.parentNode) {
							this.parentNode.insertBefore(elem, this.nextSibling);
						}
					});
				},

				empty: function empty() {
					var elem,
					    i = 0;

					for (; (elem = this[i]) != null; i++) {
						if (elem.nodeType === 1) {

							// Prevent memory leaks
							jQuery.cleanData(getAll(elem, false));

							// Remove any remaining nodes
							elem.textContent = "";
						}
					}

					return this;
				},

				clone: function clone(dataAndEvents, deepDataAndEvents) {
					dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
					deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

					return this.map(function () {
						return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
					});
				},

				html: function html(value) {
					return access(this, function (value) {
						var elem = this[0] || {},
						    i = 0,
						    l = this.length;

						if (value === undefined && elem.nodeType === 1) {
							return elem.innerHTML;
						}

						// See if we can take a shortcut and just use innerHTML
						if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

							value = jQuery.htmlPrefilter(value);

							try {
								for (; i < l; i++) {
									elem = this[i] || {};

									// Remove element nodes and prevent memory leaks
									if (elem.nodeType === 1) {
										jQuery.cleanData(getAll(elem, false));
										elem.innerHTML = value;
									}
								}

								elem = 0;

								// If using innerHTML throws an exception, use the fallback method
							} catch (e) {}
						}

						if (elem) {
							this.empty().append(value);
						}
					}, null, value, arguments.length);
				},

				replaceWith: function replaceWith() {
					var ignored = [];

					// Make the changes, replacing each non-ignored context element with the new content
					return domManip(this, arguments, function (elem) {
						var parent = this.parentNode;

						if (jQuery.inArray(this, ignored) < 0) {
							jQuery.cleanData(getAll(this));
							if (parent) {
								parent.replaceChild(elem, this);
							}
						}

						// Force callback invocation
					}, ignored);
				}
			});

			jQuery.each({
				appendTo: "append",
				prependTo: "prepend",
				insertBefore: "before",
				insertAfter: "after",
				replaceAll: "replaceWith"
			}, function (name, original) {
				jQuery.fn[name] = function (selector) {
					var elems,
					    ret = [],
					    insert = jQuery(selector),
					    last = insert.length - 1,
					    i = 0;

					for (; i <= last; i++) {
						elems = i === last ? this : this.clone(true);
						jQuery(insert[i])[original](elems);

						// Support: Android <=4.0 only, PhantomJS 1 only
						// .get() because push.apply(_, arraylike) throws on ancient WebKit
						push.apply(ret, elems.get());
					}

					return this.pushStack(ret);
				};
			});
			var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

			var getStyles = function getStyles(elem) {

				// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
				// IE throws on elements created in popups
				// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
				var view = elem.ownerDocument.defaultView;

				if (!view || !view.opener) {
					view = window;
				}

				return view.getComputedStyle(elem);
			};

			var swap = function swap(elem, options, callback) {
				var ret,
				    name,
				    old = {};

				// Remember the old values, and insert the new ones
				for (name in options) {
					old[name] = elem.style[name];
					elem.style[name] = options[name];
				}

				ret = callback.call(elem);

				// Revert the old values
				for (name in options) {
					elem.style[name] = old[name];
				}

				return ret;
			};

			var rboxStyle = new RegExp(cssExpand.join("|"), "i");

			(function () {

				// Executing both pixelPosition & boxSizingReliable tests require only one layout
				// so they're executed at the same time to save the second computation.
				function computeStyleTests() {

					// This is a singleton, we need to execute it only once
					if (!div) {
						return;
					}

					container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
					div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
					documentElement.appendChild(container).appendChild(div);

					var divStyle = window.getComputedStyle(div);
					pixelPositionVal = divStyle.top !== "1%";

					// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
					reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

					// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
					// Some styles come back with percentage values, even though they shouldn't
					div.style.right = "60%";
					pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

					// Support: IE 9 - 11 only
					// Detect misreporting of content dimensions for box-sizing:border-box elements
					boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

					// Support: IE 9 only
					// Detect overflow:scroll screwiness (gh-3699)
					// Support: Chrome <=64
					// Don't get tricked when zoom affects offsetWidth (gh-4029)
					div.style.position = "absolute";
					scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

					documentElement.removeChild(container);

					// Nullify the div so it wouldn't be stored in the memory and
					// it will also be a sign that checks already performed
					div = null;
				}

				function roundPixelMeasures(measure) {
					return Math.round(parseFloat(measure));
				}

				var pixelPositionVal,
				    boxSizingReliableVal,
				    scrollboxSizeVal,
				    pixelBoxStylesVal,
				    reliableTrDimensionsVal,
				    reliableMarginLeftVal,
				    container = document.createElement("div"),
				    div = document.createElement("div");

				// Finish early in limited (non-browser) environments
				if (!div.style) {
					return;
				}

				// Support: IE <=9 - 11 only
				// Style of cloned element affects source element cloned (#8908)
				div.style.backgroundClip = "content-box";
				div.cloneNode(true).style.backgroundClip = "";
				support.clearCloneStyle = div.style.backgroundClip === "content-box";

				jQuery.extend(support, {
					boxSizingReliable: function boxSizingReliable() {
						computeStyleTests();
						return boxSizingReliableVal;
					},
					pixelBoxStyles: function pixelBoxStyles() {
						computeStyleTests();
						return pixelBoxStylesVal;
					},
					pixelPosition: function pixelPosition() {
						computeStyleTests();
						return pixelPositionVal;
					},
					reliableMarginLeft: function reliableMarginLeft() {
						computeStyleTests();
						return reliableMarginLeftVal;
					},
					scrollboxSize: function scrollboxSize() {
						computeStyleTests();
						return scrollboxSizeVal;
					},

					// Support: IE 9 - 11+, Edge 15 - 18+
					// IE/Edge misreport `getComputedStyle` of table rows with width/height
					// set in CSS while `offset*` properties report correct values.
					// Behavior in IE 9 is more subtle than in newer versions & it passes
					// some versions of this test; make sure not to make it pass there!
					reliableTrDimensions: function reliableTrDimensions() {
						var table, tr, trChild, trStyle;
						if (reliableTrDimensionsVal == null) {
							table = document.createElement("table");
							tr = document.createElement("tr");
							trChild = document.createElement("div");

							table.style.cssText = "position:absolute;left:-11111px";
							tr.style.height = "1px";
							trChild.style.height = "9px";

							documentElement.appendChild(table).appendChild(tr).appendChild(trChild);

							trStyle = window.getComputedStyle(tr);
							reliableTrDimensionsVal = parseInt(trStyle.height) > 3;

							documentElement.removeChild(table);
						}
						return reliableTrDimensionsVal;
					}
				});
			})();

			function curCSS(elem, name, computed) {
				var width,
				    minWidth,
				    maxWidth,
				    ret,


				// Support: Firefox 51+
				// Retrieving style before computed somehow
				// fixes an issue with getting wrong values
				// on detached elements
				style = elem.style;

				computed = computed || getStyles(elem);

				// getPropertyValue is needed for:
				//   .css('filter') (IE 9 only, #12537)
				//   .css('--customProperty) (#3144)
				if (computed) {
					ret = computed.getPropertyValue(name) || computed[name];

					if (ret === "" && !isAttached(elem)) {
						ret = jQuery.style(elem, name);
					}

					// A tribute to the "awesome hack by Dean Edwards"
					// Android Browser returns percentage for some values,
					// but width seems to be reliably pixels.
					// This is against the CSSOM draft spec:
					// https://drafts.csswg.org/cssom/#resolved-values
					if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

						// Remember the original values
						width = style.width;
						minWidth = style.minWidth;
						maxWidth = style.maxWidth;

						// Put in the new values to get a computed value out
						style.minWidth = style.maxWidth = style.width = ret;
						ret = computed.width;

						// Revert the changed values
						style.width = width;
						style.minWidth = minWidth;
						style.maxWidth = maxWidth;
					}
				}

				return ret !== undefined ?

				// Support: IE <=9 - 11 only
				// IE returns zIndex value as an integer.
				ret + "" : ret;
			}

			function addGetHookIf(conditionFn, hookFn) {

				// Define the hook, we'll check on the first run if it's really needed.
				return {
					get: function get() {
						if (conditionFn()) {

							// Hook not needed (or it's not possible to use it due
							// to missing dependency), remove it.
							delete this.get;
							return;
						}

						// Hook needed; redefine it so that the support test is not executed again.
						return (this.get = hookFn).apply(this, arguments);
					}
				};
			}

			var cssPrefixes = ["Webkit", "Moz", "ms"],
			    emptyStyle = document.createElement("div").style,
			    vendorProps = {};

			// Return a vendor-prefixed property or undefined
			function vendorPropName(name) {

				// Check for vendor prefixed names
				var capName = name[0].toUpperCase() + name.slice(1),
				    i = cssPrefixes.length;

				while (i--) {
					name = cssPrefixes[i] + capName;
					if (name in emptyStyle) {
						return name;
					}
				}
			}

			// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
			function finalPropName(name) {
				var final = jQuery.cssProps[name] || vendorProps[name];

				if (final) {
					return final;
				}
				if (name in emptyStyle) {
					return name;
				}
				return vendorProps[name] = vendorPropName(name) || name;
			}

			var

			// Swappable if display is none or starts with table
			// except "table", "table-cell", or "table-caption"
			// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
			rdisplayswap = /^(none|table(?!-c[ea]).+)/,
			    rcustomProp = /^--/,
			    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
			    cssNormalTransform = {
				letterSpacing: "0",
				fontWeight: "400"
			};

			function setPositiveNumber(_elem, value, subtract) {

				// Any relative (+/-) values have already been
				// normalized at this point
				var matches = rcssNum.exec(value);
				return matches ?

				// Guard against undefined "subtract", e.g., when used as in cssHooks
				Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
			}

			function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
				var i = dimension === "width" ? 1 : 0,
				    extra = 0,
				    delta = 0;

				// Adjustment may not be necessary
				if (box === (isBorderBox ? "border" : "content")) {
					return 0;
				}

				for (; i < 4; i += 2) {

					// Both box models exclude margin
					if (box === "margin") {
						delta += jQuery.css(elem, box + cssExpand[i], true, styles);
					}

					// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
					if (!isBorderBox) {

						// Add padding
						delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

						// For "border" or "margin", add border
						if (box !== "padding") {
							delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

							// But still keep track of it otherwise
						} else {
							extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
						}

						// If we get here with a border-box (content + padding + border), we're seeking "content" or
						// "padding" or "margin"
					} else {

						// For "content", subtract padding
						if (box === "content") {
							delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
						}

						// For "content" or "padding", subtract border
						if (box !== "margin") {
							delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
						}
					}
				}

				// Account for positive content-box scroll gutter when requested by providing computedVal
				if (!isBorderBox && computedVal >= 0) {

					// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
					// Assuming integer scroll gutter, subtract the rest and round down
					delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

					// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
					// Use an explicit zero to avoid NaN (gh-3964)
					)) || 0;
				}

				return delta;
			}

			function getWidthOrHeight(elem, dimension, extra) {

				// Start with computed style
				var styles = getStyles(elem),


				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
				// Fake content-box until we know it's needed to know the true value.
				boxSizingNeeded = !support.boxSizingReliable() || extra,
				    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
				    valueIsBorderBox = isBorderBox,
				    val = curCSS(elem, dimension, styles),
				    offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

				// Support: Firefox <=54
				// Return a confounding non-pixel value or feign ignorance, as appropriate.
				if (rnumnonpx.test(val)) {
					if (!extra) {
						return val;
					}
					val = "auto";
				}

				// Support: IE 9 - 11 only
				// Use offsetWidth/offsetHeight for when box sizing is unreliable.
				// In those cases, the computed value can be trusted to be border-box.
				if ((!support.boxSizingReliable() && isBorderBox ||

				// Support: IE 10 - 11+, Edge 15 - 18+
				// IE/Edge misreport `getComputedStyle` of table rows with width/height
				// set in CSS while `offset*` properties report correct values.
				// Interestingly, in some cases IE 9 doesn't suffer from this issue.
				!support.reliableTrDimensions() && nodeName(elem, "tr") ||

				// Fall back to offsetWidth/offsetHeight when value is "auto"
				// This happens for inline elements with no explicit setting (gh-3571)
				val === "auto" ||

				// Support: Android <=4.1 - 4.3 only
				// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
				!parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&

				// Make sure the element is visible & connected
				elem.getClientRects().length) {

					isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

					// Where available, offsetWidth/offsetHeight approximate border box dimensions.
					// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
					// retrieved value as a content box dimension.
					valueIsBorderBox = offsetProp in elem;
					if (valueIsBorderBox) {
						val = elem[offsetProp];
					}
				}

				// Normalize "" and auto
				val = parseFloat(val) || 0;

				// Adjust for the element's box model
				return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,

				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val) + "px";
			}

			jQuery.extend({

				// Add in style property hooks for overriding the default
				// behavior of getting and setting a style property
				cssHooks: {
					opacity: {
						get: function get(elem, computed) {
							if (computed) {

								// We should always get a number back from opacity
								var ret = curCSS(elem, "opacity");
								return ret === "" ? "1" : ret;
							}
						}
					}
				},

				// Don't automatically add "px" to these possibly-unitless properties
				cssNumber: {
					"animationIterationCount": true,
					"columnCount": true,
					"fillOpacity": true,
					"flexGrow": true,
					"flexShrink": true,
					"fontWeight": true,
					"gridArea": true,
					"gridColumn": true,
					"gridColumnEnd": true,
					"gridColumnStart": true,
					"gridRow": true,
					"gridRowEnd": true,
					"gridRowStart": true,
					"lineHeight": true,
					"opacity": true,
					"order": true,
					"orphans": true,
					"widows": true,
					"zIndex": true,
					"zoom": true
				},

				// Add in properties whose names you wish to fix before
				// setting or getting the value
				cssProps: {},

				// Get and set the style property on a DOM Node
				style: function style(elem, name, value, extra) {

					// Don't set styles on text and comment nodes
					if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
						return;
					}

					// Make sure that we're working with the right name
					var ret,
					    type,
					    hooks,
					    origName = camelCase(name),
					    isCustomProp = rcustomProp.test(name),
					    style = elem.style;

					// Make sure that we're working with the right name. We don't
					// want to query the value if it is a CSS custom property
					// since they are user-defined.
					if (!isCustomProp) {
						name = finalPropName(origName);
					}

					// Gets hook for the prefixed version, then unprefixed version
					hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

					// Check if we're setting a value
					if (value !== undefined) {
						type = typeof value === "undefined" ? "undefined" : _typeof(value);

						// Convert "+=" or "-=" to relative numbers (#7345)
						if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
							value = adjustCSS(elem, name, ret);

							// Fixes bug #9237
							type = "number";
						}

						// Make sure that null and NaN values aren't set (#7116)
						if (value == null || value !== value) {
							return;
						}

						// If a number was passed in, add the unit (except for certain CSS properties)
						// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
						// "px" to a few hardcoded values.
						if (type === "number" && !isCustomProp) {
							value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
						}

						// background-* props affect original clone's values
						if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
							style[name] = "inherit";
						}

						// If a hook was provided, use that value, otherwise just set the specified value
						if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {

							if (isCustomProp) {
								style.setProperty(name, value);
							} else {
								style[name] = value;
							}
						}
					} else {

						// If a hook was provided get the non-computed value from there
						if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {

							return ret;
						}

						// Otherwise just get the value from the style object
						return style[name];
					}
				},

				css: function css(elem, name, extra, styles) {
					var val,
					    num,
					    hooks,
					    origName = camelCase(name),
					    isCustomProp = rcustomProp.test(name);

					// Make sure that we're working with the right name. We don't
					// want to modify the value if it is a CSS custom property
					// since they are user-defined.
					if (!isCustomProp) {
						name = finalPropName(origName);
					}

					// Try prefixed name followed by the unprefixed name
					hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

					// If a hook was provided get the computed value from there
					if (hooks && "get" in hooks) {
						val = hooks.get(elem, true, extra);
					}

					// Otherwise, if a way to get the computed value exists, use that
					if (val === undefined) {
						val = curCSS(elem, name, styles);
					}

					// Convert "normal" to computed value
					if (val === "normal" && name in cssNormalTransform) {
						val = cssNormalTransform[name];
					}

					// Make numeric if forced or a qualifier was provided and val looks numeric
					if (extra === "" || extra) {
						num = parseFloat(val);
						return extra === true || isFinite(num) ? num || 0 : val;
					}

					return val;
				}
			});

			jQuery.each(["height", "width"], function (_i, dimension) {
				jQuery.cssHooks[dimension] = {
					get: function get(elem, computed, extra) {
						if (computed) {

							// Certain elements can have dimension info if we invisibly show them
							// but it must have a current display style that would benefit
							return rdisplayswap.test(jQuery.css(elem, "display")) && (

							// Support: Safari 8+
							// Table columns in Safari have non-zero offsetWidth & zero
							// getBoundingClientRect().width unless display is changed.
							// Support: IE <=11 only
							// Running getBoundingClientRect on a disconnected node
							// in IE throws an error.
							!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
								return getWidthOrHeight(elem, dimension, extra);
							}) : getWidthOrHeight(elem, dimension, extra);
						}
					},

					set: function set(elem, value, extra) {
						var matches,
						    styles = getStyles(elem),


						// Only read styles.position if the test has a chance to fail
						// to avoid forcing a reflow.
						scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",


						// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
						boxSizingNeeded = scrollboxSizeBuggy || extra,
						    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
						    subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

						// Account for unreliable border-box dimensions by comparing offset* to computed and
						// faking a content-box to get border and padding (gh-3699)
						if (isBorderBox && scrollboxSizeBuggy) {
							subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
						}

						// Convert to pixels if value adjustment is needed
						if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {

							elem.style[dimension] = value;
							value = jQuery.css(elem, dimension);
						}

						return setPositiveNumber(elem, value, subtract);
					}
				};
			});

			jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
				if (computed) {
					return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
						return elem.getBoundingClientRect().left;
					})) + "px";
				}
			});

			// These hooks are used by animate to expand properties
			jQuery.each({
				margin: "",
				padding: "",
				border: "Width"
			}, function (prefix, suffix) {
				jQuery.cssHooks[prefix + suffix] = {
					expand: function expand(value) {
						var i = 0,
						    expanded = {},


						// Assumes a single number if not a string
						parts = typeof value === "string" ? value.split(" ") : [value];

						for (; i < 4; i++) {
							expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
						}

						return expanded;
					}
				};

				if (prefix !== "margin") {
					jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
				}
			});

			jQuery.fn.extend({
				css: function css(name, value) {
					return access(this, function (elem, name, value) {
						var styles,
						    len,
						    map = {},
						    i = 0;

						if (Array.isArray(name)) {
							styles = getStyles(elem);
							len = name.length;

							for (; i < len; i++) {
								map[name[i]] = jQuery.css(elem, name[i], false, styles);
							}

							return map;
						}

						return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
					}, name, value, arguments.length > 1);
				}
			});

			function Tween(elem, options, prop, end, easing) {
				return new Tween.prototype.init(elem, options, prop, end, easing);
			}
			jQuery.Tween = Tween;

			Tween.prototype = {
				constructor: Tween,
				init: function init(elem, options, prop, end, easing, unit) {
					this.elem = elem;
					this.prop = prop;
					this.easing = easing || jQuery.easing._default;
					this.options = options;
					this.start = this.now = this.cur();
					this.end = end;
					this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
				},
				cur: function cur() {
					var hooks = Tween.propHooks[this.prop];

					return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
				},
				run: function run(percent) {
					var eased,
					    hooks = Tween.propHooks[this.prop];

					if (this.options.duration) {
						this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
					} else {
						this.pos = eased = percent;
					}
					this.now = (this.end - this.start) * eased + this.start;

					if (this.options.step) {
						this.options.step.call(this.elem, this.now, this);
					}

					if (hooks && hooks.set) {
						hooks.set(this);
					} else {
						Tween.propHooks._default.set(this);
					}
					return this;
				}
			};

			Tween.prototype.init.prototype = Tween.prototype;

			Tween.propHooks = {
				_default: {
					get: function get(tween) {
						var result;

						// Use a property on the element directly when it is not a DOM element,
						// or when there is no matching style property that exists.
						if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
							return tween.elem[tween.prop];
						}

						// Passing an empty string as a 3rd parameter to .css will automatically
						// attempt a parseFloat and fallback to a string if the parse fails.
						// Simple values such as "10px" are parsed to Float;
						// complex values such as "rotate(1rad)" are returned as-is.
						result = jQuery.css(tween.elem, tween.prop, "");

						// Empty strings, null, undefined and "auto" are converted to 0.
						return !result || result === "auto" ? 0 : result;
					},
					set: function set(tween) {

						// Use step hook for back compat.
						// Use cssHook if its there.
						// Use .style if available and use plain properties where available.
						if (jQuery.fx.step[tween.prop]) {
							jQuery.fx.step[tween.prop](tween);
						} else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
							jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
						} else {
							tween.elem[tween.prop] = tween.now;
						}
					}
				}
			};

			// Support: IE <=9 only
			// Panic based approach to setting things on disconnected nodes
			Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
				set: function set(tween) {
					if (tween.elem.nodeType && tween.elem.parentNode) {
						tween.elem[tween.prop] = tween.now;
					}
				}
			};

			jQuery.easing = {
				linear: function linear(p) {
					return p;
				},
				swing: function swing(p) {
					return 0.5 - Math.cos(p * Math.PI) / 2;
				},
				_default: "swing"
			};

			jQuery.fx = Tween.prototype.init;

			// Back compat <1.8 extension point
			jQuery.fx.step = {};

			var fxNow,
			    inProgress,
			    rfxtypes = /^(?:toggle|show|hide)$/,
			    rrun = /queueHooks$/;

			function schedule() {
				if (inProgress) {
					if (document.hidden === false && window.requestAnimationFrame) {
						window.requestAnimationFrame(schedule);
					} else {
						window.setTimeout(schedule, jQuery.fx.interval);
					}

					jQuery.fx.tick();
				}
			}

			// Animations created synchronously will run synchronously
			function createFxNow() {
				window.setTimeout(function () {
					fxNow = undefined;
				});
				return fxNow = Date.now();
			}

			// Generate parameters to create a standard animation
			function genFx(type, includeWidth) {
				var which,
				    i = 0,
				    attrs = { height: type };

				// If we include width, step value is 1 to do all cssExpand values,
				// otherwise step value is 2 to skip over Left and Right
				includeWidth = includeWidth ? 1 : 0;
				for (; i < 4; i += 2 - includeWidth) {
					which = cssExpand[i];
					attrs["margin" + which] = attrs["padding" + which] = type;
				}

				if (includeWidth) {
					attrs.opacity = attrs.width = type;
				}

				return attrs;
			}

			function createTween(value, prop, animation) {
				var tween,
				    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
				    index = 0,
				    length = collection.length;
				for (; index < length; index++) {
					if (tween = collection[index].call(animation, prop, value)) {

						// We're done with this property
						return tween;
					}
				}
			}

			function defaultPrefilter(elem, props, opts) {
				var prop,
				    value,
				    toggle,
				    hooks,
				    oldfire,
				    propTween,
				    restoreDisplay,
				    display,
				    isBox = "width" in props || "height" in props,
				    anim = this,
				    orig = {},
				    style = elem.style,
				    hidden = elem.nodeType && isHiddenWithinTree(elem),
				    dataShow = dataPriv.get(elem, "fxshow");

				// Queue-skipping animations hijack the fx hooks
				if (!opts.queue) {
					hooks = jQuery._queueHooks(elem, "fx");
					if (hooks.unqueued == null) {
						hooks.unqueued = 0;
						oldfire = hooks.empty.fire;
						hooks.empty.fire = function () {
							if (!hooks.unqueued) {
								oldfire();
							}
						};
					}
					hooks.unqueued++;

					anim.always(function () {

						// Ensure the complete handler is called before this completes
						anim.always(function () {
							hooks.unqueued--;
							if (!jQuery.queue(elem, "fx").length) {
								hooks.empty.fire();
							}
						});
					});
				}

				// Detect show/hide animations
				for (prop in props) {
					value = props[prop];
					if (rfxtypes.test(value)) {
						delete props[prop];
						toggle = toggle || value === "toggle";
						if (value === (hidden ? "hide" : "show")) {

							// Pretend to be hidden if this is a "show" and
							// there is still data from a stopped show/hide
							if (value === "show" && dataShow && dataShow[prop] !== undefined) {
								hidden = true;

								// Ignore all other no-op show/hide data
							} else {
								continue;
							}
						}
						orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
					}
				}

				// Bail out if this is a no-op like .hide().hide()
				propTween = !jQuery.isEmptyObject(props);
				if (!propTween && jQuery.isEmptyObject(orig)) {
					return;
				}

				// Restrict "overflow" and "display" styles during box animations
				if (isBox && elem.nodeType === 1) {

					// Support: IE <=9 - 11, Edge 12 - 15
					// Record all 3 overflow attributes because IE does not infer the shorthand
					// from identically-valued overflowX and overflowY and Edge just mirrors
					// the overflowX value there.
					opts.overflow = [style.overflow, style.overflowX, style.overflowY];

					// Identify a display type, preferring old show/hide data over the CSS cascade
					restoreDisplay = dataShow && dataShow.display;
					if (restoreDisplay == null) {
						restoreDisplay = dataPriv.get(elem, "display");
					}
					display = jQuery.css(elem, "display");
					if (display === "none") {
						if (restoreDisplay) {
							display = restoreDisplay;
						} else {

							// Get nonempty value(s) by temporarily forcing visibility
							showHide([elem], true);
							restoreDisplay = elem.style.display || restoreDisplay;
							display = jQuery.css(elem, "display");
							showHide([elem]);
						}
					}

					// Animate inline elements as inline-block
					if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
						if (jQuery.css(elem, "float") === "none") {

							// Restore the original display value at the end of pure show/hide animations
							if (!propTween) {
								anim.done(function () {
									style.display = restoreDisplay;
								});
								if (restoreDisplay == null) {
									display = style.display;
									restoreDisplay = display === "none" ? "" : display;
								}
							}
							style.display = "inline-block";
						}
					}
				}

				if (opts.overflow) {
					style.overflow = "hidden";
					anim.always(function () {
						style.overflow = opts.overflow[0];
						style.overflowX = opts.overflow[1];
						style.overflowY = opts.overflow[2];
					});
				}

				// Implement show/hide animations
				propTween = false;
				for (prop in orig) {

					// General show/hide setup for this element animation
					if (!propTween) {
						if (dataShow) {
							if ("hidden" in dataShow) {
								hidden = dataShow.hidden;
							}
						} else {
							dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
						}

						// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
						if (toggle) {
							dataShow.hidden = !hidden;
						}

						// Show elements before animating them
						if (hidden) {
							showHide([elem], true);
						}

						/* eslint-disable no-loop-func */

						anim.done(function () {

							/* eslint-enable no-loop-func */

							// The final step of a "hide" animation is actually hiding the element
							if (!hidden) {
								showHide([elem]);
							}
							dataPriv.remove(elem, "fxshow");
							for (prop in orig) {
								jQuery.style(elem, prop, orig[prop]);
							}
						});
					}

					// Per-property setup
					propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
					if (!(prop in dataShow)) {
						dataShow[prop] = propTween.start;
						if (hidden) {
							propTween.end = propTween.start;
							propTween.start = 0;
						}
					}
				}
			}

			function propFilter(props, specialEasing) {
				var index, name, easing, value, hooks;

				// camelCase, specialEasing and expand cssHook pass
				for (index in props) {
					name = camelCase(index);
					easing = specialEasing[name];
					value = props[index];
					if (Array.isArray(value)) {
						easing = value[1];
						value = props[index] = value[0];
					}

					if (index !== name) {
						props[name] = value;
						delete props[index];
					}

					hooks = jQuery.cssHooks[name];
					if (hooks && "expand" in hooks) {
						value = hooks.expand(value);
						delete props[name];

						// Not quite $.extend, this won't overwrite existing keys.
						// Reusing 'index' because we have the correct "name"
						for (index in value) {
							if (!(index in props)) {
								props[index] = value[index];
								specialEasing[index] = easing;
							}
						}
					} else {
						specialEasing[name] = easing;
					}
				}
			}

			function Animation(elem, properties, options) {
				var result,
				    stopped,
				    index = 0,
				    length = Animation.prefilters.length,
				    deferred = jQuery.Deferred().always(function () {

					// Don't match elem in the :animated selector
					delete tick.elem;
				}),
				    tick = function tick() {
					if (stopped) {
						return false;
					}
					var currentTime = fxNow || createFxNow(),
					    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),


					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					    percent = 1 - temp,
					    index = 0,
					    length = animation.tweens.length;

					for (; index < length; index++) {
						animation.tweens[index].run(percent);
					}

					deferred.notifyWith(elem, [animation, percent, remaining]);

					// If there's more to do, yield
					if (percent < 1 && length) {
						return remaining;
					}

					// If this was an empty animation, synthesize a final progress notification
					if (!length) {
						deferred.notifyWith(elem, [animation, 1, 0]);
					}

					// Resolve the animation and report its conclusion
					deferred.resolveWith(elem, [animation]);
					return false;
				},
				    animation = deferred.promise({
					elem: elem,
					props: jQuery.extend({}, properties),
					opts: jQuery.extend(true, {
						specialEasing: {},
						easing: jQuery.easing._default
					}, options),
					originalProperties: properties,
					originalOptions: options,
					startTime: fxNow || createFxNow(),
					duration: options.duration,
					tweens: [],
					createTween: function createTween(prop, end) {
						var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
						animation.tweens.push(tween);
						return tween;
					},
					stop: function stop(gotoEnd) {
						var index = 0,


						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
						if (stopped) {
							return this;
						}
						stopped = true;
						for (; index < length; index++) {
							animation.tweens[index].run(1);
						}

						// Resolve when we played the last frame; otherwise, reject
						if (gotoEnd) {
							deferred.notifyWith(elem, [animation, 1, 0]);
							deferred.resolveWith(elem, [animation, gotoEnd]);
						} else {
							deferred.rejectWith(elem, [animation, gotoEnd]);
						}
						return this;
					}
				}),
				    props = animation.props;

				propFilter(props, animation.opts.specialEasing);

				for (; index < length; index++) {
					result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
					if (result) {
						if (isFunction(result.stop)) {
							jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
						}
						return result;
					}
				}

				jQuery.map(props, createTween, animation);

				if (isFunction(animation.opts.start)) {
					animation.opts.start.call(elem, animation);
				}

				// Attach callbacks from options
				animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);

				jQuery.fx.timer(jQuery.extend(tick, {
					elem: elem,
					anim: animation,
					queue: animation.opts.queue
				}));

				return animation;
			}

			jQuery.Animation = jQuery.extend(Animation, {

				tweeners: {
					"*": [function (prop, value) {
						var tween = this.createTween(prop, value);
						adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
						return tween;
					}]
				},

				tweener: function tweener(props, callback) {
					if (isFunction(props)) {
						callback = props;
						props = ["*"];
					} else {
						props = props.match(rnothtmlwhite);
					}

					var prop,
					    index = 0,
					    length = props.length;

					for (; index < length; index++) {
						prop = props[index];
						Animation.tweeners[prop] = Animation.tweeners[prop] || [];
						Animation.tweeners[prop].unshift(callback);
					}
				},

				prefilters: [defaultPrefilter],

				prefilter: function prefilter(callback, prepend) {
					if (prepend) {
						Animation.prefilters.unshift(callback);
					} else {
						Animation.prefilters.push(callback);
					}
				}
			});

			jQuery.speed = function (speed, easing, fn) {
				var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
					complete: fn || !fn && easing || isFunction(speed) && speed,
					duration: speed,
					easing: fn && easing || easing && !isFunction(easing) && easing
				};

				// Go to the end state if fx are off
				if (jQuery.fx.off) {
					opt.duration = 0;
				} else {
					if (typeof opt.duration !== "number") {
						if (opt.duration in jQuery.fx.speeds) {
							opt.duration = jQuery.fx.speeds[opt.duration];
						} else {
							opt.duration = jQuery.fx.speeds._default;
						}
					}
				}

				// Normalize opt.queue - true/undefined/null -> "fx"
				if (opt.queue == null || opt.queue === true) {
					opt.queue = "fx";
				}

				// Queueing
				opt.old = opt.complete;

				opt.complete = function () {
					if (isFunction(opt.old)) {
						opt.old.call(this);
					}

					if (opt.queue) {
						jQuery.dequeue(this, opt.queue);
					}
				};

				return opt;
			};

			jQuery.fn.extend({
				fadeTo: function fadeTo(speed, to, easing, callback) {

					// Show any hidden elements after setting opacity to 0
					return this.filter(isHiddenWithinTree).css("opacity", 0).show()

					// Animate to the value specified
					.end().animate({ opacity: to }, speed, easing, callback);
				},
				animate: function animate(prop, speed, easing, callback) {
					var empty = jQuery.isEmptyObject(prop),
					    optall = jQuery.speed(speed, easing, callback),
					    doAnimation = function doAnimation() {

						// Operate on a copy of prop so per-property easing won't be lost
						var anim = Animation(this, jQuery.extend({}, prop), optall);

						// Empty animations, or finishing resolves immediately
						if (empty || dataPriv.get(this, "finish")) {
							anim.stop(true);
						}
					};
					doAnimation.finish = doAnimation;

					return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
				},
				stop: function stop(type, clearQueue, gotoEnd) {
					var stopQueue = function stopQueue(hooks) {
						var stop = hooks.stop;
						delete hooks.stop;
						stop(gotoEnd);
					};

					if (typeof type !== "string") {
						gotoEnd = clearQueue;
						clearQueue = type;
						type = undefined;
					}
					if (clearQueue) {
						this.queue(type || "fx", []);
					}

					return this.each(function () {
						var dequeue = true,
						    index = type != null && type + "queueHooks",
						    timers = jQuery.timers,
						    data = dataPriv.get(this);

						if (index) {
							if (data[index] && data[index].stop) {
								stopQueue(data[index]);
							}
						} else {
							for (index in data) {
								if (data[index] && data[index].stop && rrun.test(index)) {
									stopQueue(data[index]);
								}
							}
						}

						for (index = timers.length; index--;) {
							if (timers[index].elem === this && (type == null || timers[index].queue === type)) {

								timers[index].anim.stop(gotoEnd);
								dequeue = false;
								timers.splice(index, 1);
							}
						}

						// Start the next in the queue if the last step wasn't forced.
						// Timers currently will call their complete callbacks, which
						// will dequeue but only if they were gotoEnd.
						if (dequeue || !gotoEnd) {
							jQuery.dequeue(this, type);
						}
					});
				},
				finish: function finish(type) {
					if (type !== false) {
						type = type || "fx";
					}
					return this.each(function () {
						var index,
						    data = dataPriv.get(this),
						    queue = data[type + "queue"],
						    hooks = data[type + "queueHooks"],
						    timers = jQuery.timers,
						    length = queue ? queue.length : 0;

						// Enable finishing flag on private data
						data.finish = true;

						// Empty the queue first
						jQuery.queue(this, type, []);

						if (hooks && hooks.stop) {
							hooks.stop.call(this, true);
						}

						// Look for any active animations, and finish them
						for (index = timers.length; index--;) {
							if (timers[index].elem === this && timers[index].queue === type) {
								timers[index].anim.stop(true);
								timers.splice(index, 1);
							}
						}

						// Look for any animations in the old queue and finish them
						for (index = 0; index < length; index++) {
							if (queue[index] && queue[index].finish) {
								queue[index].finish.call(this);
							}
						}

						// Turn off finishing flag
						delete data.finish;
					});
				}
			});

			jQuery.each(["toggle", "show", "hide"], function (_i, name) {
				var cssFn = jQuery.fn[name];
				jQuery.fn[name] = function (speed, easing, callback) {
					return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
				};
			});

			// Generate shortcuts for custom animations
			jQuery.each({
				slideDown: genFx("show"),
				slideUp: genFx("hide"),
				slideToggle: genFx("toggle"),
				fadeIn: { opacity: "show" },
				fadeOut: { opacity: "hide" },
				fadeToggle: { opacity: "toggle" }
			}, function (name, props) {
				jQuery.fn[name] = function (speed, easing, callback) {
					return this.animate(props, speed, easing, callback);
				};
			});

			jQuery.timers = [];
			jQuery.fx.tick = function () {
				var timer,
				    i = 0,
				    timers = jQuery.timers;

				fxNow = Date.now();

				for (; i < timers.length; i++) {
					timer = timers[i];

					// Run the timer and safely remove it when done (allowing for external removal)
					if (!timer() && timers[i] === timer) {
						timers.splice(i--, 1);
					}
				}

				if (!timers.length) {
					jQuery.fx.stop();
				}
				fxNow = undefined;
			};

			jQuery.fx.timer = function (timer) {
				jQuery.timers.push(timer);
				jQuery.fx.start();
			};

			jQuery.fx.interval = 13;
			jQuery.fx.start = function () {
				if (inProgress) {
					return;
				}

				inProgress = true;
				schedule();
			};

			jQuery.fx.stop = function () {
				inProgress = null;
			};

			jQuery.fx.speeds = {
				slow: 600,
				fast: 200,

				// Default speed
				_default: 400
			};

			// Based off of the plugin by Clint Helfers, with permission.
			// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
			jQuery.fn.delay = function (time, type) {
				time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
				type = type || "fx";

				return this.queue(type, function (next, hooks) {
					var timeout = window.setTimeout(next, time);
					hooks.stop = function () {
						window.clearTimeout(timeout);
					};
				});
			};

			(function () {
				var input = document.createElement("input"),
				    select = document.createElement("select"),
				    opt = select.appendChild(document.createElement("option"));

				input.type = "checkbox";

				// Support: Android <=4.3 only
				// Default value for a checkbox should be "on"
				support.checkOn = input.value !== "";

				// Support: IE <=11 only
				// Must access selectedIndex to make default options select
				support.optSelected = opt.selected;

				// Support: IE <=11 only
				// An input loses its value after becoming a radio
				input = document.createElement("input");
				input.value = "t";
				input.type = "radio";
				support.radioValue = input.value === "t";
			})();

			var boolHook,
			    attrHandle = jQuery.expr.attrHandle;

			jQuery.fn.extend({
				attr: function attr(name, value) {
					return access(this, jQuery.attr, name, value, arguments.length > 1);
				},

				removeAttr: function removeAttr(name) {
					return this.each(function () {
						jQuery.removeAttr(this, name);
					});
				}
			});

			jQuery.extend({
				attr: function attr(elem, name, value) {
					var ret,
					    hooks,
					    nType = elem.nodeType;

					// Don't get/set attributes on text, comment and attribute nodes
					if (nType === 3 || nType === 8 || nType === 2) {
						return;
					}

					// Fallback to prop when attributes are not supported
					if (typeof elem.getAttribute === "undefined") {
						return jQuery.prop(elem, name, value);
					}

					// Attribute hooks are determined by the lowercase version
					// Grab necessary hook if one is defined
					if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
						hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
					}

					if (value !== undefined) {
						if (value === null) {
							jQuery.removeAttr(elem, name);
							return;
						}

						if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
							return ret;
						}

						elem.setAttribute(name, value + "");
						return value;
					}

					if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
						return ret;
					}

					ret = jQuery.find.attr(elem, name);

					// Non-existent attributes return null, we normalize to undefined
					return ret == null ? undefined : ret;
				},

				attrHooks: {
					type: {
						set: function set(elem, value) {
							if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
								var val = elem.value;
								elem.setAttribute("type", value);
								if (val) {
									elem.value = val;
								}
								return value;
							}
						}
					}
				},

				removeAttr: function removeAttr(elem, value) {
					var name,
					    i = 0,


					// Attribute names can contain non-HTML whitespace characters
					// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
					attrNames = value && value.match(rnothtmlwhite);

					if (attrNames && elem.nodeType === 1) {
						while (name = attrNames[i++]) {
							elem.removeAttribute(name);
						}
					}
				}
			});

			// Hooks for boolean attributes
			boolHook = {
				set: function set(elem, value, name) {
					if (value === false) {

						// Remove boolean attributes when set to false
						jQuery.removeAttr(elem, name);
					} else {
						elem.setAttribute(name, name);
					}
					return name;
				}
			};

			jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
				var getter = attrHandle[name] || jQuery.find.attr;

				attrHandle[name] = function (elem, name, isXML) {
					var ret,
					    handle,
					    lowercaseName = name.toLowerCase();

					if (!isXML) {

						// Avoid an infinite loop by temporarily removing this function from the getter
						handle = attrHandle[lowercaseName];
						attrHandle[lowercaseName] = ret;
						ret = getter(elem, name, isXML) != null ? lowercaseName : null;
						attrHandle[lowercaseName] = handle;
					}
					return ret;
				};
			});

			var rfocusable = /^(?:input|select|textarea|button)$/i,
			    rclickable = /^(?:a|area)$/i;

			jQuery.fn.extend({
				prop: function prop(name, value) {
					return access(this, jQuery.prop, name, value, arguments.length > 1);
				},

				removeProp: function removeProp(name) {
					return this.each(function () {
						delete this[jQuery.propFix[name] || name];
					});
				}
			});

			jQuery.extend({
				prop: function prop(elem, name, value) {
					var ret,
					    hooks,
					    nType = elem.nodeType;

					// Don't get/set properties on text, comment and attribute nodes
					if (nType === 3 || nType === 8 || nType === 2) {
						return;
					}

					if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

						// Fix name and attach hooks
						name = jQuery.propFix[name] || name;
						hooks = jQuery.propHooks[name];
					}

					if (value !== undefined) {
						if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
							return ret;
						}

						return elem[name] = value;
					}

					if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
						return ret;
					}

					return elem[name];
				},

				propHooks: {
					tabIndex: {
						get: function get(elem) {

							// Support: IE <=9 - 11 only
							// elem.tabIndex doesn't always return the
							// correct value when it hasn't been explicitly set
							// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
							// Use proper attribute retrieval(#12072)
							var tabindex = jQuery.find.attr(elem, "tabindex");

							if (tabindex) {
								return parseInt(tabindex, 10);
							}

							if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
								return 0;
							}

							return -1;
						}
					}
				},

				propFix: {
					"for": "htmlFor",
					"class": "className"
				}
			});

			// Support: IE <=11 only
			// Accessing the selectedIndex property
			// forces the browser to respect setting selected
			// on the option
			// The getter ensures a default option is selected
			// when in an optgroup
			// eslint rule "no-unused-expressions" is disabled for this code
			// since it considers such accessions noop
			if (!support.optSelected) {
				jQuery.propHooks.selected = {
					get: function get(elem) {

						/* eslint no-unused-expressions: "off" */

						var parent = elem.parentNode;
						if (parent && parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
						return null;
					},
					set: function set(elem) {

						/* eslint no-unused-expressions: "off" */

						var parent = elem.parentNode;
						if (parent) {
							parent.selectedIndex;

							if (parent.parentNode) {
								parent.parentNode.selectedIndex;
							}
						}
					}
				};
			}

			jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
				jQuery.propFix[this.toLowerCase()] = this;
			});

			// Strip and collapse whitespace according to HTML spec
			// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
			function stripAndCollapse(value) {
				var tokens = value.match(rnothtmlwhite) || [];
				return tokens.join(" ");
			}

			function getClass(elem) {
				return elem.getAttribute && elem.getAttribute("class") || "";
			}

			function classesToArray(value) {
				if (Array.isArray(value)) {
					return value;
				}
				if (typeof value === "string") {
					return value.match(rnothtmlwhite) || [];
				}
				return [];
			}

			jQuery.fn.extend({
				addClass: function addClass(value) {
					var classes,
					    elem,
					    cur,
					    curValue,
					    clazz,
					    j,
					    finalValue,
					    i = 0;

					if (isFunction(value)) {
						return this.each(function (j) {
							jQuery(this).addClass(value.call(this, j, getClass(this)));
						});
					}

					classes = classesToArray(value);

					if (classes.length) {
						while (elem = this[i++]) {
							curValue = getClass(elem);
							cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

							if (cur) {
								j = 0;
								while (clazz = classes[j++]) {
									if (cur.indexOf(" " + clazz + " ") < 0) {
										cur += clazz + " ";
									}
								}

								// Only assign if different to avoid unneeded rendering.
								finalValue = stripAndCollapse(cur);
								if (curValue !== finalValue) {
									elem.setAttribute("class", finalValue);
								}
							}
						}
					}

					return this;
				},

				removeClass: function removeClass(value) {
					var classes,
					    elem,
					    cur,
					    curValue,
					    clazz,
					    j,
					    finalValue,
					    i = 0;

					if (isFunction(value)) {
						return this.each(function (j) {
							jQuery(this).removeClass(value.call(this, j, getClass(this)));
						});
					}

					if (!arguments.length) {
						return this.attr("class", "");
					}

					classes = classesToArray(value);

					if (classes.length) {
						while (elem = this[i++]) {
							curValue = getClass(elem);

							// This expression is here for better compressibility (see addClass)
							cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

							if (cur) {
								j = 0;
								while (clazz = classes[j++]) {

									// Remove *all* instances
									while (cur.indexOf(" " + clazz + " ") > -1) {
										cur = cur.replace(" " + clazz + " ", " ");
									}
								}

								// Only assign if different to avoid unneeded rendering.
								finalValue = stripAndCollapse(cur);
								if (curValue !== finalValue) {
									elem.setAttribute("class", finalValue);
								}
							}
						}
					}

					return this;
				},

				toggleClass: function toggleClass(value, stateVal) {
					var type = typeof value === "undefined" ? "undefined" : _typeof(value),
					    isValidValue = type === "string" || Array.isArray(value);

					if (typeof stateVal === "boolean" && isValidValue) {
						return stateVal ? this.addClass(value) : this.removeClass(value);
					}

					if (isFunction(value)) {
						return this.each(function (i) {
							jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
						});
					}

					return this.each(function () {
						var className, i, self, classNames;

						if (isValidValue) {

							// Toggle individual class names
							i = 0;
							self = jQuery(this);
							classNames = classesToArray(value);

							while (className = classNames[i++]) {

								// Check each className given, space separated list
								if (self.hasClass(className)) {
									self.removeClass(className);
								} else {
									self.addClass(className);
								}
							}

							// Toggle whole class name
						} else if (value === undefined || type === "boolean") {
							className = getClass(this);
							if (className) {

								// Store className if set
								dataPriv.set(this, "__className__", className);
							}

							// If the element has a class name or if we're passed `false`,
							// then remove the whole classname (if there was one, the above saved it).
							// Otherwise bring back whatever was previously saved (if anything),
							// falling back to the empty string if nothing was stored.
							if (this.setAttribute) {
								this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
							}
						}
					});
				},

				hasClass: function hasClass(selector) {
					var className,
					    elem,
					    i = 0;

					className = " " + selector + " ";
					while (elem = this[i++]) {
						if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
							return true;
						}
					}

					return false;
				}
			});

			var rreturn = /\r/g;

			jQuery.fn.extend({
				val: function val(value) {
					var hooks,
					    ret,
					    valueIsFunction,
					    elem = this[0];

					if (!arguments.length) {
						if (elem) {
							hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

							if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
								return ret;
							}

							ret = elem.value;

							// Handle most common string cases
							if (typeof ret === "string") {
								return ret.replace(rreturn, "");
							}

							// Handle cases where value is null/undef or number
							return ret == null ? "" : ret;
						}

						return;
					}

					valueIsFunction = isFunction(value);

					return this.each(function (i) {
						var val;

						if (this.nodeType !== 1) {
							return;
						}

						if (valueIsFunction) {
							val = value.call(this, i, jQuery(this).val());
						} else {
							val = value;
						}

						// Treat null/undefined as ""; convert numbers to string
						if (val == null) {
							val = "";
						} else if (typeof val === "number") {
							val += "";
						} else if (Array.isArray(val)) {
							val = jQuery.map(val, function (value) {
								return value == null ? "" : value + "";
							});
						}

						hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

						// If set returns undefined, fall back to normal setting
						if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
							this.value = val;
						}
					});
				}
			});

			jQuery.extend({
				valHooks: {
					option: {
						get: function get(elem) {

							var val = jQuery.find.attr(elem, "value");
							return val != null ? val :

							// Support: IE <=10 - 11 only
							// option.text throws exceptions (#14686, #14858)
							// Strip and collapse whitespace
							// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
							stripAndCollapse(jQuery.text(elem));
						}
					},
					select: {
						get: function get(elem) {
							var value,
							    option,
							    i,
							    options = elem.options,
							    index = elem.selectedIndex,
							    one = elem.type === "select-one",
							    values = one ? null : [],
							    max = one ? index + 1 : options.length;

							if (index < 0) {
								i = max;
							} else {
								i = one ? index : 0;
							}

							// Loop through all the selected options
							for (; i < max; i++) {
								option = options[i];

								// Support: IE <=9 only
								// IE8-9 doesn't update selected after form reset (#2551)
								if ((option.selected || i === index) &&

								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {

									// Get the specific value for the option
									value = jQuery(option).val();

									// We don't need an array for one selects
									if (one) {
										return value;
									}

									// Multi-Selects return an array
									values.push(value);
								}
							}

							return values;
						},

						set: function set(elem, value) {
							var optionSet,
							    option,
							    options = elem.options,
							    values = jQuery.makeArray(value),
							    i = options.length;

							while (i--) {
								option = options[i];

								/* eslint-disable no-cond-assign */

								if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
									optionSet = true;
								}

								/* eslint-enable no-cond-assign */
							}

							// Force browsers to behave consistently when non-matching value is set
							if (!optionSet) {
								elem.selectedIndex = -1;
							}
							return values;
						}
					}
				}
			});

			// Radios and checkboxes getter/setter
			jQuery.each(["radio", "checkbox"], function () {
				jQuery.valHooks[this] = {
					set: function set(elem, value) {
						if (Array.isArray(value)) {
							return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
						}
					}
				};
				if (!support.checkOn) {
					jQuery.valHooks[this].get = function (elem) {
						return elem.getAttribute("value") === null ? "on" : elem.value;
					};
				}
			});

			// Return jQuery for attributes-only inclusion


			support.focusin = "onfocusin" in window;

			var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
			    stopPropagationCallback = function stopPropagationCallback(e) {
				e.stopPropagation();
			};

			jQuery.extend(jQuery.event, {

				trigger: function trigger(event, data, elem, onlyHandlers) {

					var i,
					    cur,
					    tmp,
					    bubbleType,
					    ontype,
					    handle,
					    special,
					    lastElement,
					    eventPath = [elem || document],
					    type = hasOwn.call(event, "type") ? event.type : event,
					    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

					cur = lastElement = tmp = elem = elem || document;

					// Don't do events on text and comment nodes
					if (elem.nodeType === 3 || elem.nodeType === 8) {
						return;
					}

					// focus/blur morphs to focusin/out; ensure we're not firing them right now
					if (rfocusMorph.test(type + jQuery.event.triggered)) {
						return;
					}

					if (type.indexOf(".") > -1) {

						// Namespaced trigger; create a regexp to match event type in handle()
						namespaces = type.split(".");
						type = namespaces.shift();
						namespaces.sort();
					}
					ontype = type.indexOf(":") < 0 && "on" + type;

					// Caller can pass in a jQuery.Event object, Object, or just an event type string
					event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);

					// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
					event.isTrigger = onlyHandlers ? 2 : 3;
					event.namespace = namespaces.join(".");
					event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

					// Clean up the event in case it is being reused
					event.result = undefined;
					if (!event.target) {
						event.target = elem;
					}

					// Clone any incoming data and prepend the event, creating the handler arg list
					data = data == null ? [event] : jQuery.makeArray(data, [event]);

					// Allow special events to draw outside the lines
					special = jQuery.event.special[type] || {};
					if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
						return;
					}

					// Determine event propagation path in advance, per W3C events spec (#9951)
					// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
					if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

						bubbleType = special.delegateType || type;
						if (!rfocusMorph.test(bubbleType + type)) {
							cur = cur.parentNode;
						}
						for (; cur; cur = cur.parentNode) {
							eventPath.push(cur);
							tmp = cur;
						}

						// Only add window if we got to document (e.g., not plain obj or detached DOM)
						if (tmp === (elem.ownerDocument || document)) {
							eventPath.push(tmp.defaultView || tmp.parentWindow || window);
						}
					}

					// Fire handlers on the event path
					i = 0;
					while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
						lastElement = cur;
						event.type = i > 1 ? bubbleType : special.bindType || type;

						// jQuery handler
						handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
						if (handle) {
							handle.apply(cur, data);
						}

						// Native handler
						handle = ontype && cur[ontype];
						if (handle && handle.apply && acceptData(cur)) {
							event.result = handle.apply(cur, data);
							if (event.result === false) {
								event.preventDefault();
							}
						}
					}
					event.type = type;

					// If nobody prevented the default action, do it now
					if (!onlyHandlers && !event.isDefaultPrevented()) {

						if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {

							// Call a native DOM method on the target with the same name as the event.
							// Don't do default actions on window, that's where global variables be (#6170)
							if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

								// Don't re-trigger an onFOO event when we call its FOO() method
								tmp = elem[ontype];

								if (tmp) {
									elem[ontype] = null;
								}

								// Prevent re-triggering of the same event, since we already bubbled it above
								jQuery.event.triggered = type;

								if (event.isPropagationStopped()) {
									lastElement.addEventListener(type, stopPropagationCallback);
								}

								elem[type]();

								if (event.isPropagationStopped()) {
									lastElement.removeEventListener(type, stopPropagationCallback);
								}

								jQuery.event.triggered = undefined;

								if (tmp) {
									elem[ontype] = tmp;
								}
							}
						}
					}

					return event.result;
				},

				// Piggyback on a donor event to simulate a different one
				// Used only for `focus(in | out)` events
				simulate: function simulate(type, elem, event) {
					var e = jQuery.extend(new jQuery.Event(), event, {
						type: type,
						isSimulated: true
					});

					jQuery.event.trigger(e, null, elem);
				}

			});

			jQuery.fn.extend({

				trigger: function trigger(type, data) {
					return this.each(function () {
						jQuery.event.trigger(type, data, this);
					});
				},
				triggerHandler: function triggerHandler(type, data) {
					var elem = this[0];
					if (elem) {
						return jQuery.event.trigger(type, data, elem, true);
					}
				}
			});

			// Support: Firefox <=44
			// Firefox doesn't have focus(in | out) events
			// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
			//
			// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
			// focus(in | out) events fire after focus & blur events,
			// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
			// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
			if (!support.focusin) {
				jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

					// Attach a single capturing handler on the document while someone wants focusin/focusout
					var handler = function handler(event) {
						jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
					};

					jQuery.event.special[fix] = {
						setup: function setup() {

							// Handle: regular nodes (via `this.ownerDocument`), window
							// (via `this.document`) & document (via `this`).
							var doc = this.ownerDocument || this.document || this,
							    attaches = dataPriv.access(doc, fix);

							if (!attaches) {
								doc.addEventListener(orig, handler, true);
							}
							dataPriv.access(doc, fix, (attaches || 0) + 1);
						},
						teardown: function teardown() {
							var doc = this.ownerDocument || this.document || this,
							    attaches = dataPriv.access(doc, fix) - 1;

							if (!attaches) {
								doc.removeEventListener(orig, handler, true);
								dataPriv.remove(doc, fix);
							} else {
								dataPriv.access(doc, fix, attaches);
							}
						}
					};
				});
			}
			var location = window.location;

			var nonce = { guid: Date.now() };

			var rquery = /\?/;

			// Cross-browser xml parsing
			jQuery.parseXML = function (data) {
				var xml;
				if (!data || typeof data !== "string") {
					return null;
				}

				// Support: IE 9 - 11 only
				// IE throws on parseFromString with invalid input.
				try {
					xml = new window.DOMParser().parseFromString(data, "text/xml");
				} catch (e) {
					xml = undefined;
				}

				if (!xml || xml.getElementsByTagName("parsererror").length) {
					jQuery.error("Invalid XML: " + data);
				}
				return xml;
			};

			var rbracket = /\[\]$/,
			    rCRLF = /\r?\n/g,
			    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
			    rsubmittable = /^(?:input|select|textarea|keygen)/i;

			function buildParams(prefix, obj, traditional, add) {
				var name;

				if (Array.isArray(obj)) {

					// Serialize array item.
					jQuery.each(obj, function (i, v) {
						if (traditional || rbracket.test(prefix)) {

							// Treat each array item as a scalar.
							add(prefix, v);
						} else {

							// Item is non-scalar (array or object), encode its numeric index.
							buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
						}
					});
				} else if (!traditional && toType(obj) === "object") {

					// Serialize object item.
					for (name in obj) {
						buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
					}
				} else {

					// Serialize scalar item.
					add(prefix, obj);
				}
			}

			// Serialize an array of form elements or a set of
			// key/values into a query string
			jQuery.param = function (a, traditional) {
				var prefix,
				    s = [],
				    add = function add(key, valueOrFunction) {

					// If value is a function, invoke it and use its return value
					var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

					s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
				};

				if (a == null) {
					return "";
				}

				// If an array was passed in, assume that it is an array of form elements.
				if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {

					// Serialize the form elements
					jQuery.each(a, function () {
						add(this.name, this.value);
					});
				} else {

					// If traditional, encode the "old" way (the way 1.3.2 or older
					// did it), otherwise encode params recursively.
					for (prefix in a) {
						buildParams(prefix, a[prefix], traditional, add);
					}
				}

				// Return the resulting serialization
				return s.join("&");
			};

			jQuery.fn.extend({
				serialize: function serialize() {
					return jQuery.param(this.serializeArray());
				},
				serializeArray: function serializeArray() {
					return this.map(function () {

						// Can add propHook for "elements" to filter or add form elements
						var elements = jQuery.prop(this, "elements");
						return elements ? jQuery.makeArray(elements) : this;
					}).filter(function () {
						var type = this.type;

						// Use .is( ":disabled" ) so that fieldset[disabled] works
						return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
					}).map(function (_i, elem) {
						var val = jQuery(this).val();

						if (val == null) {
							return null;
						}

						if (Array.isArray(val)) {
							return jQuery.map(val, function (val) {
								return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
							});
						}

						return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
					}).get();
				}
			});

			var r20 = /%20/g,
			    rhash = /#.*$/,
			    rantiCache = /([?&])_=[^&]*/,
			    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,


			// #7653, #8125, #8152: local protocol detection
			rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			    rnoContent = /^(?:GET|HEAD)$/,
			    rprotocol = /^\/\//,


			/* Prefilters
    * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
    * 2) These are called:
    *    - BEFORE asking for a transport
    *    - AFTER param serialization (s.data is a string if s.processData is true)
    * 3) key is the dataType
    * 4) the catchall symbol "*" can be used
    * 5) execution will start with transport dataType and THEN continue down to "*" if needed
    */
			prefilters = {},


			/* Transports bindings
    * 1) key is the dataType
    * 2) the catchall symbol "*" can be used
    * 3) selection will start with transport dataType and THEN go to "*" if needed
    */
			transports = {},


			// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
			allTypes = "*/".concat("*"),


			// Anchor tag for parsing the document origin
			originAnchor = document.createElement("a");
			originAnchor.href = location.href;

			// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
			function addToPrefiltersOrTransports(structure) {

				// dataTypeExpression is optional and defaults to "*"
				return function (dataTypeExpression, func) {

					if (typeof dataTypeExpression !== "string") {
						func = dataTypeExpression;
						dataTypeExpression = "*";
					}

					var dataType,
					    i = 0,
					    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

					if (isFunction(func)) {

						// For each dataType in the dataTypeExpression
						while (dataType = dataTypes[i++]) {

							// Prepend if requested
							if (dataType[0] === "+") {
								dataType = dataType.slice(1) || "*";
								(structure[dataType] = structure[dataType] || []).unshift(func);

								// Otherwise append
							} else {
								(structure[dataType] = structure[dataType] || []).push(func);
							}
						}
					}
				};
			}

			// Base inspection function for prefilters and transports
			function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

				var inspected = {},
				    seekingTransport = structure === transports;

				function inspect(dataType) {
					var selected;
					inspected[dataType] = true;
					jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
						var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
						if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {

							options.dataTypes.unshift(dataTypeOrTransport);
							inspect(dataTypeOrTransport);
							return false;
						} else if (seekingTransport) {
							return !(selected = dataTypeOrTransport);
						}
					});
					return selected;
				}

				return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
			}

			// A special extend for ajax options
			// that takes "flat" options (not to be deep extended)
			// Fixes #9887
			function ajaxExtend(target, src) {
				var key,
				    deep,
				    flatOptions = jQuery.ajaxSettings.flatOptions || {};

				for (key in src) {
					if (src[key] !== undefined) {
						(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
					}
				}
				if (deep) {
					jQuery.extend(true, target, deep);
				}

				return target;
			}

			/* Handles responses to an ajax request:
    * - finds the right dataType (mediates between content-type and expected dataType)
    * - returns the corresponding response
    */
			function ajaxHandleResponses(s, jqXHR, responses) {

				var ct,
				    type,
				    finalDataType,
				    firstDataType,
				    contents = s.contents,
				    dataTypes = s.dataTypes;

				// Remove auto dataType and get content-type in the process
				while (dataTypes[0] === "*") {
					dataTypes.shift();
					if (ct === undefined) {
						ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
					}
				}

				// Check if we're dealing with a known content-type
				if (ct) {
					for (type in contents) {
						if (contents[type] && contents[type].test(ct)) {
							dataTypes.unshift(type);
							break;
						}
					}
				}

				// Check to see if we have a response for the expected dataType
				if (dataTypes[0] in responses) {
					finalDataType = dataTypes[0];
				} else {

					// Try convertible dataTypes
					for (type in responses) {
						if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
							finalDataType = type;
							break;
						}
						if (!firstDataType) {
							firstDataType = type;
						}
					}

					// Or just use first one
					finalDataType = finalDataType || firstDataType;
				}

				// If we found a dataType
				// We add the dataType to the list if needed
				// and return the corresponding response
				if (finalDataType) {
					if (finalDataType !== dataTypes[0]) {
						dataTypes.unshift(finalDataType);
					}
					return responses[finalDataType];
				}
			}

			/* Chain conversions given the request and the original response
    * Also sets the responseXXX fields on the jqXHR instance
    */
			function ajaxConvert(s, response, jqXHR, isSuccess) {
				var conv2,
				    current,
				    conv,
				    tmp,
				    prev,
				    converters = {},


				// Work with a copy of dataTypes in case we need to modify it for conversion
				dataTypes = s.dataTypes.slice();

				// Create converters map with lowercased keys
				if (dataTypes[1]) {
					for (conv in s.converters) {
						converters[conv.toLowerCase()] = s.converters[conv];
					}
				}

				current = dataTypes.shift();

				// Convert to each sequential dataType
				while (current) {

					if (s.responseFields[current]) {
						jqXHR[s.responseFields[current]] = response;
					}

					// Apply the dataFilter if provided
					if (!prev && isSuccess && s.dataFilter) {
						response = s.dataFilter(response, s.dataType);
					}

					prev = current;
					current = dataTypes.shift();

					if (current) {

						// There's only work to do if current dataType is non-auto
						if (current === "*") {

							current = prev;

							// Convert response if prev dataType is non-auto and differs from current
						} else if (prev !== "*" && prev !== current) {

							// Seek a direct converter
							conv = converters[prev + " " + current] || converters["* " + current];

							// If none found, seek a pair
							if (!conv) {
								for (conv2 in converters) {

									// If conv2 outputs current
									tmp = conv2.split(" ");
									if (tmp[1] === current) {

										// If prev can be converted to accepted input
										conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
										if (conv) {

											// Condense equivalence converters
											if (conv === true) {
												conv = converters[conv2];

												// Otherwise, insert the intermediate dataType
											} else if (converters[conv2] !== true) {
												current = tmp[0];
												dataTypes.unshift(tmp[1]);
											}
											break;
										}
									}
								}
							}

							// Apply converter (if not an equivalence)
							if (conv !== true) {

								// Unless errors are allowed to bubble, catch and return them
								if (conv && s.throws) {
									response = conv(response);
								} else {
									try {
										response = conv(response);
									} catch (e) {
										return {
											state: "parsererror",
											error: conv ? e : "No conversion from " + prev + " to " + current
										};
									}
								}
							}
						}
					}
				}

				return { state: "success", data: response };
			}

			jQuery.extend({

				// Counter for holding the number of active queries
				active: 0,

				// Last-Modified header cache for next request
				lastModified: {},
				etag: {},

				ajaxSettings: {
					url: location.href,
					type: "GET",
					isLocal: rlocalProtocol.test(location.protocol),
					global: true,
					processData: true,
					async: true,
					contentType: "application/x-www-form-urlencoded; charset=UTF-8",

					/*
     timeout: 0,
     data: null,
     dataType: null,
     username: null,
     password: null,
     cache: null,
     throws: false,
     traditional: false,
     headers: {},
     */

					accepts: {
						"*": allTypes,
						text: "text/plain",
						html: "text/html",
						xml: "application/xml, text/xml",
						json: "application/json, text/javascript"
					},

					contents: {
						xml: /\bxml\b/,
						html: /\bhtml/,
						json: /\bjson\b/
					},

					responseFields: {
						xml: "responseXML",
						text: "responseText",
						json: "responseJSON"
					},

					// Data converters
					// Keys separate source (or catchall "*") and destination types with a single space
					converters: {

						// Convert anything to text
						"* text": String,

						// Text to html (true = no transformation)
						"text html": true,

						// Evaluate text as a json expression
						"text json": JSON.parse,

						// Parse text as xml
						"text xml": jQuery.parseXML
					},

					// For options that shouldn't be deep extended:
					// you can add your own custom options here if
					// and when you create one that shouldn't be
					// deep extended (see ajaxExtend)
					flatOptions: {
						url: true,
						context: true
					}
				},

				// Creates a full fledged settings object into target
				// with both ajaxSettings and settings fields.
				// If target is omitted, writes into ajaxSettings.
				ajaxSetup: function ajaxSetup(target, settings) {
					return settings ?

					// Building a settings object
					ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

					// Extending ajaxSettings
					ajaxExtend(jQuery.ajaxSettings, target);
				},

				ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
				ajaxTransport: addToPrefiltersOrTransports(transports),

				// Main method
				ajax: function ajax(url, options) {

					// If url is an object, simulate pre-1.5 signature
					if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
						options = url;
						url = undefined;
					}

					// Force options to be an object
					options = options || {};

					var transport,


					// URL without anti-cache param
					cacheURL,


					// Response headers
					responseHeadersString,
					    responseHeaders,


					// timeout handle
					timeoutTimer,


					// Url cleanup var
					urlAnchor,


					// Request state (becomes false upon send and true upon completion)
					completed,


					// To know if global events are to be dispatched
					fireGlobals,


					// Loop variable
					i,


					// uncached part of the url
					uncached,


					// Create the final options object
					s = jQuery.ajaxSetup({}, options),


					// Callbacks context
					callbackContext = s.context || s,


					// Context for global events is callbackContext if it is a DOM node or jQuery collection
					globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,


					// Deferreds
					deferred = jQuery.Deferred(),
					    completeDeferred = jQuery.Callbacks("once memory"),


					// Status-dependent callbacks
					_statusCode = s.statusCode || {},


					// Headers (they are sent all at once)
					requestHeaders = {},
					    requestHeadersNames = {},


					// Default abort message
					strAbort = "canceled",


					// Fake xhr
					jqXHR = {
						readyState: 0,

						// Builds headers hashtable if needed
						getResponseHeader: function getResponseHeader(key) {
							var match;
							if (completed) {
								if (!responseHeaders) {
									responseHeaders = {};
									while (match = rheaders.exec(responseHeadersString)) {
										responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
									}
								}
								match = responseHeaders[key.toLowerCase() + " "];
							}
							return match == null ? null : match.join(", ");
						},

						// Raw string
						getAllResponseHeaders: function getAllResponseHeaders() {
							return completed ? responseHeadersString : null;
						},

						// Caches the header
						setRequestHeader: function setRequestHeader(name, value) {
							if (completed == null) {
								name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
								requestHeaders[name] = value;
							}
							return this;
						},

						// Overrides response content-type header
						overrideMimeType: function overrideMimeType(type) {
							if (completed == null) {
								s.mimeType = type;
							}
							return this;
						},

						// Status-dependent callbacks
						statusCode: function statusCode(map) {
							var code;
							if (map) {
								if (completed) {

									// Execute the appropriate callbacks
									jqXHR.always(map[jqXHR.status]);
								} else {

									// Lazy-add the new callbacks in a way that preserves old ones
									for (code in map) {
										_statusCode[code] = [_statusCode[code], map[code]];
									}
								}
							}
							return this;
						},

						// Cancel the request
						abort: function abort(statusText) {
							var finalText = statusText || strAbort;
							if (transport) {
								transport.abort(finalText);
							}
							done(0, finalText);
							return this;
						}
					};

					// Attach deferreds
					deferred.promise(jqXHR);

					// Add protocol if not provided (prefilters might expect it)
					// Handle falsy url in the settings object (#10093: consistency with old signature)
					// We also use the url parameter if available
					s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

					// Alias method option to type as per ticket #12004
					s.type = options.method || options.type || s.method || s.type;

					// Extract dataTypes list
					s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

					// A cross-domain request is in order when the origin doesn't match the current origin.
					if (s.crossDomain == null) {
						urlAnchor = document.createElement("a");

						// Support: IE <=8 - 11, Edge 12 - 15
						// IE throws exception on accessing the href property if url is malformed,
						// e.g. http://example.com:80x/
						try {
							urlAnchor.href = s.url;

							// Support: IE <=8 - 11 only
							// Anchor's host property isn't correctly set when s.url is relative
							urlAnchor.href = urlAnchor.href;
							s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
						} catch (e) {

							// If there is an error parsing the URL, assume it is crossDomain,
							// it can be rejected by the transport if it is invalid
							s.crossDomain = true;
						}
					}

					// Convert data if not already a string
					if (s.data && s.processData && typeof s.data !== "string") {
						s.data = jQuery.param(s.data, s.traditional);
					}

					// Apply prefilters
					inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

					// If request was aborted inside a prefilter, stop there
					if (completed) {
						return jqXHR;
					}

					// We can fire global events as of now if asked to
					// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
					fireGlobals = jQuery.event && s.global;

					// Watch for a new set of requests
					if (fireGlobals && jQuery.active++ === 0) {
						jQuery.event.trigger("ajaxStart");
					}

					// Uppercase the type
					s.type = s.type.toUpperCase();

					// Determine if request has content
					s.hasContent = !rnoContent.test(s.type);

					// Save the URL in case we're toying with the If-Modified-Since
					// and/or If-None-Match header later on
					// Remove hash to simplify url manipulation
					cacheURL = s.url.replace(rhash, "");

					// More options handling for requests with no content
					if (!s.hasContent) {

						// Remember the hash so we can put it back
						uncached = s.url.slice(cacheURL.length);

						// If data is available and should be processed, append data to url
						if (s.data && (s.processData || typeof s.data === "string")) {
							cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

							// #9682: remove data so that it's not used in an eventual retry
							delete s.data;
						}

						// Add or update anti-cache param if needed
						if (s.cache === false) {
							cacheURL = cacheURL.replace(rantiCache, "$1");
							uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
						}

						// Put hash and anti-cache on the URL that will be requested (gh-1732)
						s.url = cacheURL + uncached;

						// Change '%20' to '+' if this is encoded form body content (gh-2658)
					} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
						s.data = s.data.replace(r20, "+");
					}

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if (s.ifModified) {
						if (jQuery.lastModified[cacheURL]) {
							jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
						}
						if (jQuery.etag[cacheURL]) {
							jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
						}
					}

					// Set the correct header, if data is being sent
					if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
						jqXHR.setRequestHeader("Content-Type", s.contentType);
					}

					// Set the Accepts header for the server, depending on the dataType
					jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

					// Check for headers option
					for (i in s.headers) {
						jqXHR.setRequestHeader(i, s.headers[i]);
					}

					// Allow custom headers/mimetypes and early abort
					if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

						// Abort if not done already and return
						return jqXHR.abort();
					}

					// Aborting is no longer a cancellation
					strAbort = "abort";

					// Install callbacks on deferreds
					completeDeferred.add(s.complete);
					jqXHR.done(s.success);
					jqXHR.fail(s.error);

					// Get transport
					transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

					// If no transport, we auto-abort
					if (!transport) {
						done(-1, "No Transport");
					} else {
						jqXHR.readyState = 1;

						// Send global event
						if (fireGlobals) {
							globalEventContext.trigger("ajaxSend", [jqXHR, s]);
						}

						// If request was aborted inside ajaxSend, stop there
						if (completed) {
							return jqXHR;
						}

						// Timeout
						if (s.async && s.timeout > 0) {
							timeoutTimer = window.setTimeout(function () {
								jqXHR.abort("timeout");
							}, s.timeout);
						}

						try {
							completed = false;
							transport.send(requestHeaders, done);
						} catch (e) {

							// Rethrow post-completion exceptions
							if (completed) {
								throw e;
							}

							// Propagate others as results
							done(-1, e);
						}
					}

					// Callback for when everything is done
					function done(status, nativeStatusText, responses, headers) {
						var isSuccess,
						    success,
						    error,
						    response,
						    modified,
						    statusText = nativeStatusText;

						// Ignore repeat invocations
						if (completed) {
							return;
						}

						completed = true;

						// Clear timeout if it exists
						if (timeoutTimer) {
							window.clearTimeout(timeoutTimer);
						}

						// Dereference transport for early garbage collection
						// (no matter how long the jqXHR object will be used)
						transport = undefined;

						// Cache response headers
						responseHeadersString = headers || "";

						// Set readyState
						jqXHR.readyState = status > 0 ? 4 : 0;

						// Determine if successful
						isSuccess = status >= 200 && status < 300 || status === 304;

						// Get response data
						if (responses) {
							response = ajaxHandleResponses(s, jqXHR, responses);
						}

						// Use a noop converter for missing script
						if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1) {
							s.converters["text script"] = function () {};
						}

						// Convert no matter what (that way responseXXX fields are always set)
						response = ajaxConvert(s, response, jqXHR, isSuccess);

						// If successful, handle type chaining
						if (isSuccess) {

							// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
							if (s.ifModified) {
								modified = jqXHR.getResponseHeader("Last-Modified");
								if (modified) {
									jQuery.lastModified[cacheURL] = modified;
								}
								modified = jqXHR.getResponseHeader("etag");
								if (modified) {
									jQuery.etag[cacheURL] = modified;
								}
							}

							// if no content
							if (status === 204 || s.type === "HEAD") {
								statusText = "nocontent";

								// if not modified
							} else if (status === 304) {
								statusText = "notmodified";

								// If we have data, let's convert it
							} else {
								statusText = response.state;
								success = response.data;
								error = response.error;
								isSuccess = !error;
							}
						} else {

							// Extract error from statusText and normalize for non-aborts
							error = statusText;
							if (status || !statusText) {
								statusText = "error";
								if (status < 0) {
									status = 0;
								}
							}
						}

						// Set data for the fake xhr object
						jqXHR.status = status;
						jqXHR.statusText = (nativeStatusText || statusText) + "";

						// Success/Error
						if (isSuccess) {
							deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
						} else {
							deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
						}

						// Status-dependent callbacks
						jqXHR.statusCode(_statusCode);
						_statusCode = undefined;

						if (fireGlobals) {
							globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
						}

						// Complete
						completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

						if (fireGlobals) {
							globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

							// Handle the global AJAX counter
							if (! --jQuery.active) {
								jQuery.event.trigger("ajaxStop");
							}
						}
					}

					return jqXHR;
				},

				getJSON: function getJSON(url, data, callback) {
					return jQuery.get(url, data, callback, "json");
				},

				getScript: function getScript(url, callback) {
					return jQuery.get(url, undefined, callback, "script");
				}
			});

			jQuery.each(["get", "post"], function (_i, method) {
				jQuery[method] = function (url, data, callback, type) {

					// Shift arguments if data argument was omitted
					if (isFunction(data)) {
						type = type || callback;
						callback = data;
						data = undefined;
					}

					// The url can be an options object (which then must have .url)
					return jQuery.ajax(jQuery.extend({
						url: url,
						type: method,
						dataType: type,
						data: data,
						success: callback
					}, jQuery.isPlainObject(url) && url));
				};
			});

			jQuery.ajaxPrefilter(function (s) {
				var i;
				for (i in s.headers) {
					if (i.toLowerCase() === "content-type") {
						s.contentType = s.headers[i] || "";
					}
				}
			});

			jQuery._evalUrl = function (url, options, doc) {
				return jQuery.ajax({
					url: url,

					// Make this explicit, since user can override this through ajaxSetup (#11264)
					type: "GET",
					dataType: "script",
					cache: true,
					async: false,
					global: false,

					// Only evaluate the response if it is successful (gh-4126)
					// dataFilter is not invoked for failure responses, so using it instead
					// of the default converter is kludgy but it works.
					converters: {
						"text script": function textScript() {}
					},
					dataFilter: function dataFilter(response) {
						jQuery.globalEval(response, options, doc);
					}
				});
			};

			jQuery.fn.extend({
				wrapAll: function wrapAll(html) {
					var wrap;

					if (this[0]) {
						if (isFunction(html)) {
							html = html.call(this[0]);
						}

						// The elements to wrap the target around
						wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

						if (this[0].parentNode) {
							wrap.insertBefore(this[0]);
						}

						wrap.map(function () {
							var elem = this;

							while (elem.firstElementChild) {
								elem = elem.firstElementChild;
							}

							return elem;
						}).append(this);
					}

					return this;
				},

				wrapInner: function wrapInner(html) {
					if (isFunction(html)) {
						return this.each(function (i) {
							jQuery(this).wrapInner(html.call(this, i));
						});
					}

					return this.each(function () {
						var self = jQuery(this),
						    contents = self.contents();

						if (contents.length) {
							contents.wrapAll(html);
						} else {
							self.append(html);
						}
					});
				},

				wrap: function wrap(html) {
					var htmlIsFunction = isFunction(html);

					return this.each(function (i) {
						jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
					});
				},

				unwrap: function unwrap(selector) {
					this.parent(selector).not("body").each(function () {
						jQuery(this).replaceWith(this.childNodes);
					});
					return this;
				}
			});

			jQuery.expr.pseudos.hidden = function (elem) {
				return !jQuery.expr.pseudos.visible(elem);
			};
			jQuery.expr.pseudos.visible = function (elem) {
				return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
			};

			jQuery.ajaxSettings.xhr = function () {
				try {
					return new window.XMLHttpRequest();
				} catch (e) {}
			};

			var xhrSuccessStatus = {

				// File protocol always yields status code 0, assume 200
				0: 200,

				// Support: IE <=9 only
				// #1450: sometimes IE returns 1223 when it should be 204
				1223: 204
			},
			    xhrSupported = jQuery.ajaxSettings.xhr();

			support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
			support.ajax = xhrSupported = !!xhrSupported;

			jQuery.ajaxTransport(function (options) {
				var _callback, errorCallback;

				// Cross domain only allowed if supported through XMLHttpRequest
				if (support.cors || xhrSupported && !options.crossDomain) {
					return {
						send: function send(headers, complete) {
							var i,
							    xhr = options.xhr();

							xhr.open(options.type, options.url, options.async, options.username, options.password);

							// Apply custom fields if provided
							if (options.xhrFields) {
								for (i in options.xhrFields) {
									xhr[i] = options.xhrFields[i];
								}
							}

							// Override mime type if needed
							if (options.mimeType && xhr.overrideMimeType) {
								xhr.overrideMimeType(options.mimeType);
							}

							// X-Requested-With header
							// For cross-domain requests, seeing as conditions for a preflight are
							// akin to a jigsaw puzzle, we simply never set it to be sure.
							// (it can always be set on a per-request basis or even using ajaxSetup)
							// For same-domain requests, won't change header if already provided.
							if (!options.crossDomain && !headers["X-Requested-With"]) {
								headers["X-Requested-With"] = "XMLHttpRequest";
							}

							// Set headers
							for (i in headers) {
								xhr.setRequestHeader(i, headers[i]);
							}

							// Callback
							_callback = function callback(type) {
								return function () {
									if (_callback) {
										_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

										if (type === "abort") {
											xhr.abort();
										} else if (type === "error") {

											// Support: IE <=9 only
											// On a manual native abort, IE9 throws
											// errors on any property access that is not readyState
											if (typeof xhr.status !== "number") {
												complete(0, "error");
											} else {
												complete(

												// File: protocol always yields status 0; see #8605, #14207
												xhr.status, xhr.statusText);
											}
										} else {
											complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,

											// Support: IE <=9 only
											// IE9 has no XHR2 but throws on binary (trac-11426)
											// For XHR2 non-text, let the caller handle it (gh-2498)
											(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
										}
									}
								};
							};

							// Listen to events
							xhr.onload = _callback();
							errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

							// Support: IE 9 only
							// Use onreadystatechange to replace onabort
							// to handle uncaught aborts
							if (xhr.onabort !== undefined) {
								xhr.onabort = errorCallback;
							} else {
								xhr.onreadystatechange = function () {

									// Check readyState before timeout as it changes
									if (xhr.readyState === 4) {

										// Allow onerror to be called first,
										// but that will not handle a native abort
										// Also, save errorCallback to a variable
										// as xhr.onerror cannot be accessed
										window.setTimeout(function () {
											if (_callback) {
												errorCallback();
											}
										});
									}
								};
							}

							// Create the abort callback
							_callback = _callback("abort");

							try {

								// Do send the request (this may raise an exception)
								xhr.send(options.hasContent && options.data || null);
							} catch (e) {

								// #14683: Only rethrow if this hasn't been notified as an error yet
								if (_callback) {
									throw e;
								}
							}
						},

						abort: function abort() {
							if (_callback) {
								_callback();
							}
						}
					};
				}
			});

			// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
			jQuery.ajaxPrefilter(function (s) {
				if (s.crossDomain) {
					s.contents.script = false;
				}
			});

			// Install script dataType
			jQuery.ajaxSetup({
				accepts: {
					script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
				},
				contents: {
					script: /\b(?:java|ecma)script\b/
				},
				converters: {
					"text script": function textScript(text) {
						jQuery.globalEval(text);
						return text;
					}
				}
			});

			// Handle cache's special case and crossDomain
			jQuery.ajaxPrefilter("script", function (s) {
				if (s.cache === undefined) {
					s.cache = false;
				}
				if (s.crossDomain) {
					s.type = "GET";
				}
			});

			// Bind script tag hack transport
			jQuery.ajaxTransport("script", function (s) {

				// This transport only deals with cross domain or forced-by-attrs requests
				if (s.crossDomain || s.scriptAttrs) {
					var script, _callback2;
					return {
						send: function send(_, complete) {
							script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", _callback2 = function callback(evt) {
								script.remove();
								_callback2 = null;
								if (evt) {
									complete(evt.type === "error" ? 404 : 200, evt.type);
								}
							});

							// Use native DOM manipulation to avoid our domManip AJAX trickery
							document.head.appendChild(script[0]);
						},
						abort: function abort() {
							if (_callback2) {
								_callback2();
							}
						}
					};
				}
			});

			var oldCallbacks = [],
			    rjsonp = /(=)\?(?=&|$)|\?\?/;

			// Default jsonp settings
			jQuery.ajaxSetup({
				jsonp: "callback",
				jsonpCallback: function jsonpCallback() {
					var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
					this[callback] = true;
					return callback;
				}
			});

			// Detect, normalize options and install callbacks for jsonp requests
			jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

				var callbackName,
				    overwritten,
				    responseContainer,
				    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

				// Handle iff the expected data type is "jsonp" or we have a parameter to set
				if (jsonProp || s.dataTypes[0] === "jsonp") {

					// Get callback name, remembering preexisting value associated with it
					callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

					// Insert callback into url or form data
					if (jsonProp) {
						s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
					} else if (s.jsonp !== false) {
						s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
					}

					// Use data converter to retrieve json after script execution
					s.converters["script json"] = function () {
						if (!responseContainer) {
							jQuery.error(callbackName + " was not called");
						}
						return responseContainer[0];
					};

					// Force json dataType
					s.dataTypes[0] = "json";

					// Install callback
					overwritten = window[callbackName];
					window[callbackName] = function () {
						responseContainer = arguments;
					};

					// Clean-up function (fires after converters)
					jqXHR.always(function () {

						// If previous value didn't exist - remove it
						if (overwritten === undefined) {
							jQuery(window).removeProp(callbackName);

							// Otherwise restore preexisting value
						} else {
							window[callbackName] = overwritten;
						}

						// Save back as free
						if (s[callbackName]) {

							// Make sure that re-using the options doesn't screw things around
							s.jsonpCallback = originalSettings.jsonpCallback;

							// Save the callback name for future use
							oldCallbacks.push(callbackName);
						}

						// Call if it was a function and we have a response
						if (responseContainer && isFunction(overwritten)) {
							overwritten(responseContainer[0]);
						}

						responseContainer = overwritten = undefined;
					});

					// Delegate to script
					return "script";
				}
			});

			// Support: Safari 8 only
			// In Safari 8 documents created via document.implementation.createHTMLDocument
			// collapse sibling forms: the second one becomes a child of the first one.
			// Because of that, this security measure has to be disabled in Safari 8.
			// https://bugs.webkit.org/show_bug.cgi?id=137337
			support.createHTMLDocument = function () {
				var body = document.implementation.createHTMLDocument("").body;
				body.innerHTML = "<form></form><form></form>";
				return body.childNodes.length === 2;
			}();

			// Argument "data" should be string of html
			// context (optional): If specified, the fragment will be created in this context,
			// defaults to document
			// keepScripts (optional): If true, will include scripts passed in the html string
			jQuery.parseHTML = function (data, context, keepScripts) {
				if (typeof data !== "string") {
					return [];
				}
				if (typeof context === "boolean") {
					keepScripts = context;
					context = false;
				}

				var base, parsed, scripts;

				if (!context) {

					// Stop scripts or inline event handlers from being executed immediately
					// by using document.implementation
					if (support.createHTMLDocument) {
						context = document.implementation.createHTMLDocument("");

						// Set the base href for the created document
						// so any parsed elements with URLs
						// are based on the document's URL (gh-2965)
						base = context.createElement("base");
						base.href = document.location.href;
						context.head.appendChild(base);
					} else {
						context = document;
					}
				}

				parsed = rsingleTag.exec(data);
				scripts = !keepScripts && [];

				// Single tag
				if (parsed) {
					return [context.createElement(parsed[1])];
				}

				parsed = buildFragment([data], context, scripts);

				if (scripts && scripts.length) {
					jQuery(scripts).remove();
				}

				return jQuery.merge([], parsed.childNodes);
			};

			/**
    * Load a url into a page
    */
			jQuery.fn.load = function (url, params, callback) {
				var selector,
				    type,
				    response,
				    self = this,
				    off = url.indexOf(" ");

				if (off > -1) {
					selector = stripAndCollapse(url.slice(off));
					url = url.slice(0, off);
				}

				// If it's a function
				if (isFunction(params)) {

					// We assume that it's the callback
					callback = params;
					params = undefined;

					// Otherwise, build a param string
				} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
					type = "POST";
				}

				// If we have elements to modify, make the request
				if (self.length > 0) {
					jQuery.ajax({
						url: url,

						// If "type" variable is undefined, then "GET" method will be used.
						// Make value of this field explicit since
						// user can override it through ajaxSetup method
						type: type || "GET",
						dataType: "html",
						data: params
					}).done(function (responseText) {

						// Save response for use in complete callback
						response = arguments;

						self.html(selector ?

						// If a selector was specified, locate the right elements in a dummy div
						// Exclude scripts to avoid IE 'Permission Denied' errors
						jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

						// Otherwise use the full result
						responseText);

						// If the request succeeds, this function gets "data", "status", "jqXHR"
						// but they are ignored because response was set above.
						// If it fails, this function gets "jqXHR", "status", "error"
					}).always(callback && function (jqXHR, status) {
						self.each(function () {
							callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
						});
					});
				}

				return this;
			};

			jQuery.expr.pseudos.animated = function (elem) {
				return jQuery.grep(jQuery.timers, function (fn) {
					return elem === fn.elem;
				}).length;
			};

			jQuery.offset = {
				setOffset: function setOffset(elem, options, i) {
					var curPosition,
					    curLeft,
					    curCSSTop,
					    curTop,
					    curOffset,
					    curCSSLeft,
					    calculatePosition,
					    position = jQuery.css(elem, "position"),
					    curElem = jQuery(elem),
					    props = {};

					// Set position first, in-case top/left are set even on static elem
					if (position === "static") {
						elem.style.position = "relative";
					}

					curOffset = curElem.offset();
					curCSSTop = jQuery.css(elem, "top");
					curCSSLeft = jQuery.css(elem, "left");
					calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

					// Need to be able to calculate position if either
					// top or left is auto and position is either absolute or fixed
					if (calculatePosition) {
						curPosition = curElem.position();
						curTop = curPosition.top;
						curLeft = curPosition.left;
					} else {
						curTop = parseFloat(curCSSTop) || 0;
						curLeft = parseFloat(curCSSLeft) || 0;
					}

					if (isFunction(options)) {

						// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
						options = options.call(elem, i, jQuery.extend({}, curOffset));
					}

					if (options.top != null) {
						props.top = options.top - curOffset.top + curTop;
					}
					if (options.left != null) {
						props.left = options.left - curOffset.left + curLeft;
					}

					if ("using" in options) {
						options.using.call(elem, props);
					} else {
						if (typeof props.top === "number") {
							props.top += "px";
						}
						if (typeof props.left === "number") {
							props.left += "px";
						}
						curElem.css(props);
					}
				}
			};

			jQuery.fn.extend({

				// offset() relates an element's border box to the document origin
				offset: function offset(options) {

					// Preserve chaining for setter
					if (arguments.length) {
						return options === undefined ? this : this.each(function (i) {
							jQuery.offset.setOffset(this, options, i);
						});
					}

					var rect,
					    win,
					    elem = this[0];

					if (!elem) {
						return;
					}

					// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
					// Support: IE <=11 only
					// Running getBoundingClientRect on a
					// disconnected node in IE throws an error
					if (!elem.getClientRects().length) {
						return { top: 0, left: 0 };
					}

					// Get document-relative position by adding viewport scroll to viewport-relative gBCR
					rect = elem.getBoundingClientRect();
					win = elem.ownerDocument.defaultView;
					return {
						top: rect.top + win.pageYOffset,
						left: rect.left + win.pageXOffset
					};
				},

				// position() relates an element's margin box to its offset parent's padding box
				// This corresponds to the behavior of CSS absolute positioning
				position: function position() {
					if (!this[0]) {
						return;
					}

					var offsetParent,
					    offset,
					    doc,
					    elem = this[0],
					    parentOffset = { top: 0, left: 0 };

					// position:fixed elements are offset from the viewport, which itself always has zero offset
					if (jQuery.css(elem, "position") === "fixed") {

						// Assume position:fixed implies availability of getBoundingClientRect
						offset = elem.getBoundingClientRect();
					} else {
						offset = this.offset();

						// Account for the *real* offset parent, which can be the document or its root element
						// when a statically positioned element is identified
						doc = elem.ownerDocument;
						offsetParent = elem.offsetParent || doc.documentElement;
						while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {

							offsetParent = offsetParent.parentNode;
						}
						if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

							// Incorporate borders into its offset, since they are outside its content origin
							parentOffset = jQuery(offsetParent).offset();
							parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
							parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
						}
					}

					// Subtract parent offsets and element margins
					return {
						top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
						left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
					};
				},

				// This method will return documentElement in the following cases:
				// 1) For the element inside the iframe without offsetParent, this method will return
				//    documentElement of the parent window
				// 2) For the hidden or detached element
				// 3) For body or html element, i.e. in case of the html node - it will return itself
				//
				// but those exceptions were never presented as a real life use-cases
				// and might be considered as more preferable results.
				//
				// This logic, however, is not guaranteed and can change at any point in the future
				offsetParent: function offsetParent() {
					return this.map(function () {
						var offsetParent = this.offsetParent;

						while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
							offsetParent = offsetParent.offsetParent;
						}

						return offsetParent || documentElement;
					});
				}
			});

			// Create scrollLeft and scrollTop methods
			jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
				var top = "pageYOffset" === prop;

				jQuery.fn[method] = function (val) {
					return access(this, function (elem, method, val) {

						// Coalesce documents and windows
						var win;
						if (isWindow(elem)) {
							win = elem;
						} else if (elem.nodeType === 9) {
							win = elem.defaultView;
						}

						if (val === undefined) {
							return win ? win[prop] : elem[method];
						}

						if (win) {
							win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
						} else {
							elem[method] = val;
						}
					}, method, val, arguments.length);
				};
			});

			// Support: Safari <=7 - 9.1, Chrome <=37 - 49
			// Add the top/left cssHooks using jQuery.fn.position
			// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
			// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
			// getComputedStyle returns percent when specified for top/left/bottom/right;
			// rather than make the css module depend on the offset module, just check for it here
			jQuery.each(["top", "left"], function (_i, prop) {
				jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
					if (computed) {
						computed = curCSS(elem, prop);

						// If curCSS returns percentage, fallback to offset
						return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
					}
				});
			});

			// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
			jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
				jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {

					// Margin is only for outerHeight, outerWidth
					jQuery.fn[funcName] = function (margin, value) {
						var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
						    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

						return access(this, function (elem, type, value) {
							var doc;

							if (isWindow(elem)) {

								// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
								return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
							}

							// Get document width or height
							if (elem.nodeType === 9) {
								doc = elem.documentElement;

								// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
								// whichever is greatest
								return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
							}

							return value === undefined ?

							// Get width or height on the element, requesting but not forcing parseFloat
							jQuery.css(elem, type, extra) :

							// Set width or height on the element
							jQuery.style(elem, type, value, extra);
						}, type, chainable ? margin : undefined, chainable);
					};
				});
			});

			jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
				jQuery.fn[type] = function (fn) {
					return this.on(type, fn);
				};
			});

			jQuery.fn.extend({

				bind: function bind(types, data, fn) {
					return this.on(types, null, data, fn);
				},
				unbind: function unbind(types, fn) {
					return this.off(types, null, fn);
				},

				delegate: function delegate(selector, types, data, fn) {
					return this.on(types, selector, data, fn);
				},
				undelegate: function undelegate(selector, types, fn) {

					// ( namespace ) or ( selector, types [, fn] )
					return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
				},

				hover: function hover(fnOver, fnOut) {
					return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
				}
			});

			jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {

				// Handle event binding
				jQuery.fn[name] = function (data, fn) {
					return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
				};
			});

			// Support: Android <=4.0 only
			// Make sure we trim BOM and NBSP
			var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

			// Bind a function to a context, optionally partially applying any
			// arguments.
			// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
			// However, it is not slated for removal any time soon
			jQuery.proxy = function (fn, context) {
				var tmp, args, proxy;

				if (typeof context === "string") {
					tmp = fn[context];
					context = fn;
					fn = tmp;
				}

				// Quick check to determine if target is callable, in the spec
				// this throws a TypeError, but we will just return undefined.
				if (!isFunction(fn)) {
					return undefined;
				}

				// Simulated bind
				args = _slice.call(arguments, 2);
				proxy = function proxy() {
					return fn.apply(context || this, args.concat(_slice.call(arguments)));
				};

				// Set the guid of unique handler to the same of original handler, so it can be removed
				proxy.guid = fn.guid = fn.guid || jQuery.guid++;

				return proxy;
			};

			jQuery.holdReady = function (hold) {
				if (hold) {
					jQuery.readyWait++;
				} else {
					jQuery.ready(true);
				}
			};
			jQuery.isArray = Array.isArray;
			jQuery.parseJSON = JSON.parse;
			jQuery.nodeName = nodeName;
			jQuery.isFunction = isFunction;
			jQuery.isWindow = isWindow;
			jQuery.camelCase = camelCase;
			jQuery.type = toType;

			jQuery.now = Date.now;

			jQuery.isNumeric = function (obj) {

				// As of jQuery 3.0, isNumeric is limited to
				// strings and numbers (primitives or objects)
				// that can be coerced to finite numbers (gh-2662)
				var type = jQuery.type(obj);
				return (type === "number" || type === "string") &&

				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN(obj - parseFloat(obj));
			};

			jQuery.trim = function (text) {
				return text == null ? "" : (text + "").replace(rtrim, "");
			};

			// Register as a named AMD module, since jQuery can be concatenated with other
			// files that may use define, but not via a proper concatenation script that
			// understands anonymous AMD modules. A named AMD is safest and most robust
			// way to register. Lowercase jquery is used because AMD module names are
			// derived from file names, and jQuery is normally delivered in a lowercase
			// file name. Do this after creating the global so that if an AMD module wants
			// to call noConflict to hide this version of jQuery, it will work.

			// Note that for maximum portability, libraries that are not jQuery should
			// declare themselves as anonymous modules, and avoid setting a global if an
			// AMD loader is present. jQuery is a special case. For more information, see
			// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

			if (typeof define === "function" && define.amd) {
				define("jquery", [], function () {
					return jQuery;
				});
			}

			var

			// Map over jQuery in case of overwrite
			_jQuery = window.jQuery,


			// Map over the $ in case of overwrite
			_$ = window.$;

			jQuery.noConflict = function (deep) {
				if (window.$ === jQuery) {
					window.$ = _$;
				}

				if (deep && window.jQuery === jQuery) {
					window.jQuery = _jQuery;
				}

				return jQuery;
			};

			// Expose jQuery and $ identifiers, even in AMD
			// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
			// and CommonJS for browser emulators (#13566)
			if (typeof noGlobal === "undefined") {
				window.jQuery = window.$ = jQuery;
			}

			return jQuery;
		});
	}, {}], 24: [function (require, module, exports) {
		/*!
   * Select2 4.0.13
   * https://select2.github.io
   *
   * Released under the MIT license
   * https://github.com/select2/select2/blob/master/LICENSE.md
   */
		;(function (factory) {
			if (typeof define === 'function' && define.amd) {
				// AMD. Register as an anonymous module.
				define(['jquery'], factory);
			} else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
				// Node/CommonJS
				module.exports = function (root, jQuery) {
					if (jQuery === undefined) {
						// require('jQuery') returns a factory that requires window to
						// build a jQuery instance, we normalize how we use modules
						// that require this pattern but the window provided is a noop
						// if it's defined (how jquery works)
						if (typeof window !== 'undefined') {
							jQuery = require('jquery');
						} else {
							jQuery = require('jquery')(root);
						}
					}
					factory(jQuery);
					return jQuery;
				};
			} else {
				// Browser globals
				factory(jQuery);
			}
		})(function (jQuery) {
			// This is needed so we can catch the AMD loader configuration and use it
			// The inner file should be wrapped (by `banner.start.js`) in a function that
			// returns the AMD loader references.
			var S2 = function () {
				// Restore the Select2 AMD loader so it can be used
				// Needed mostly in the language files, where the loader is not inserted
				if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
					var S2 = jQuery.fn.select2.amd;
				}
				var S2;(function () {
					if (!S2 || !S2.requirejs) {
						if (!S2) {
							S2 = {};
						} else {
							require = S2;
						}
						/**
       * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
       * Released under MIT license, http://github.com/requirejs/almond/LICENSE
       */
						//Going sloppy to avoid 'use strict' string cost, but strict practices should
						//be followed.
						/*global setTimeout: false */

						var requirejs, require, define;
						(function (undef) {
							var main,
							    _req,
							    makeMap,
							    handlers,
							    defined = {},
							    waiting = {},
							    config = {},
							    defining = {},
							    hasOwn = Object.prototype.hasOwnProperty,
							    aps = [].slice,
							    jsSuffixRegExp = /\.js$/;

							function hasProp(obj, prop) {
								return hasOwn.call(obj, prop);
							}

							/**
        * Given a relative module name, like ./something, normalize it to
        * a real name that can be mapped to a path.
        * @param {String} name the relative name
        * @param {String} baseName a real name that the name arg is relative
        * to.
        * @returns {String} normalized name
        */
							function normalize(name, baseName) {
								var nameParts,
								    nameSegment,
								    mapValue,
								    foundMap,
								    lastIndex,
								    foundI,
								    foundStarMap,
								    starI,
								    i,
								    j,
								    part,
								    normalizedBaseParts,
								    baseParts = baseName && baseName.split("/"),
								    map = config.map,
								    starMap = map && map['*'] || {};

								//Adjust any relative paths.
								if (name) {
									name = name.split('/');
									lastIndex = name.length - 1;

									// If wanting node ID compatibility, strip .js from end
									// of IDs. Have to do this here, and not in nameToUrl
									// because node allows either .js or non .js to map
									// to same file.
									if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
										name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
									}

									// Starts with a '.' so need the baseName
									if (name[0].charAt(0) === '.' && baseParts) {
										//Convert baseName to array, and lop off the last part,
										//so that . matches that 'directory' and not name of the baseName's
										//module. For instance, baseName of 'one/two/three', maps to
										//'one/two/three.js', but we want the directory, 'one/two' for
										//this normalization.
										normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
										name = normalizedBaseParts.concat(name);
									}

									//start trimDots
									for (i = 0; i < name.length; i++) {
										part = name[i];
										if (part === '.') {
											name.splice(i, 1);
											i -= 1;
										} else if (part === '..') {
											// If at the start, or previous value is still ..,
											// keep them so that when converted to a path it may
											// still work when converted to a path, even though
											// as an ID it is less than ideal. In larger point
											// releases, may be better to just kick out an error.
											if (i === 0 || i === 1 && name[2] === '..' || name[i - 1] === '..') {
												continue;
											} else if (i > 0) {
												name.splice(i - 1, 2);
												i -= 2;
											}
										}
									}
									//end trimDots

									name = name.join('/');
								}

								//Apply map config if available.
								if ((baseParts || starMap) && map) {
									nameParts = name.split('/');

									for (i = nameParts.length; i > 0; i -= 1) {
										nameSegment = nameParts.slice(0, i).join("/");

										if (baseParts) {
											//Find the longest baseName segment match in the config.
											//So, do joins on the biggest to smallest lengths of baseParts.
											for (j = baseParts.length; j > 0; j -= 1) {
												mapValue = map[baseParts.slice(0, j).join('/')];

												//baseName segment has  config, find if it has one for
												//this name.
												if (mapValue) {
													mapValue = mapValue[nameSegment];
													if (mapValue) {
														//Match, update name to the new value.
														foundMap = mapValue;
														foundI = i;
														break;
													}
												}
											}
										}

										if (foundMap) {
											break;
										}

										//Check for a star map match, but just hold on to it,
										//if there is a shorter segment match later in a matching
										//config, then favor over this star map.
										if (!foundStarMap && starMap && starMap[nameSegment]) {
											foundStarMap = starMap[nameSegment];
											starI = i;
										}
									}

									if (!foundMap && foundStarMap) {
										foundMap = foundStarMap;
										foundI = starI;
									}

									if (foundMap) {
										nameParts.splice(0, foundI, foundMap);
										name = nameParts.join('/');
									}
								}

								return name;
							}

							function makeRequire(relName, forceSync) {
								return function () {
									//A version of a require function that passes a moduleName
									//value for items that may need to
									//look up paths relative to the moduleName
									var args = aps.call(arguments, 0);

									//If first arg is not require('string'), and there is only
									//one arg, it is the array form without a callback. Insert
									//a null so that the following concat is correct.
									if (typeof args[0] !== 'string' && args.length === 1) {
										args.push(null);
									}
									return _req.apply(undef, args.concat([relName, forceSync]));
								};
							}

							function makeNormalize(relName) {
								return function (name) {
									return normalize(name, relName);
								};
							}

							function makeLoad(depName) {
								return function (value) {
									defined[depName] = value;
								};
							}

							function callDep(name) {
								if (hasProp(waiting, name)) {
									var args = waiting[name];
									delete waiting[name];
									defining[name] = true;
									main.apply(undef, args);
								}

								if (!hasProp(defined, name) && !hasProp(defining, name)) {
									throw new Error('No ' + name);
								}
								return defined[name];
							}

							//Turns a plugin!resource to [plugin, resource]
							//with the plugin being undefined if the name
							//did not have a plugin prefix.
							function splitPrefix(name) {
								var prefix,
								    index = name ? name.indexOf('!') : -1;
								if (index > -1) {
									prefix = name.substring(0, index);
									name = name.substring(index + 1, name.length);
								}
								return [prefix, name];
							}

							//Creates a parts array for a relName where first part is plugin ID,
							//second part is resource ID. Assumes relName has already been normalized.
							function makeRelParts(relName) {
								return relName ? splitPrefix(relName) : [];
							}

							/**
        * Makes a name map, normalizing the name, and using a plugin
        * for normalization if necessary. Grabs a ref to plugin
        * too, as an optimization.
        */
							makeMap = function makeMap(name, relParts) {
								var plugin,
								    parts = splitPrefix(name),
								    prefix = parts[0],
								    relResourceName = relParts[1];

								name = parts[1];

								if (prefix) {
									prefix = normalize(prefix, relResourceName);
									plugin = callDep(prefix);
								}

								//Normalize according
								if (prefix) {
									if (plugin && plugin.normalize) {
										name = plugin.normalize(name, makeNormalize(relResourceName));
									} else {
										name = normalize(name, relResourceName);
									}
								} else {
									name = normalize(name, relResourceName);
									parts = splitPrefix(name);
									prefix = parts[0];
									name = parts[1];
									if (prefix) {
										plugin = callDep(prefix);
									}
								}

								//Using ridiculous property names for space reasons
								return {
									f: prefix ? prefix + '!' + name : name, //fullName
									n: name,
									pr: prefix,
									p: plugin
								};
							};

							function makeConfig(name) {
								return function () {
									return config && config.config && config.config[name] || {};
								};
							}

							handlers = {
								require: function require(name) {
									return makeRequire(name);
								},
								exports: function exports(name) {
									var e = defined[name];
									if (typeof e !== 'undefined') {
										return e;
									} else {
										return defined[name] = {};
									}
								},
								module: function module(name) {
									return {
										id: name,
										uri: '',
										exports: defined[name],
										config: makeConfig(name)
									};
								}
							};

							main = function main(name, deps, callback, relName) {
								var cjsModule,
								    depName,
								    ret,
								    map,
								    i,
								    relParts,
								    args = [],
								    callbackType = typeof callback === "undefined" ? "undefined" : _typeof(callback),
								    usingExports;

								//Use name if no relName
								relName = relName || name;
								relParts = makeRelParts(relName);

								//Call the callback to define the module, if necessary.
								if (callbackType === 'undefined' || callbackType === 'function') {
									//Pull out the defined dependencies and pass the ordered
									//values to the callback.
									//Default to [require, exports, module] if no deps
									deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
									for (i = 0; i < deps.length; i += 1) {
										map = makeMap(deps[i], relParts);
										depName = map.f;

										//Fast path CommonJS standard dependencies.
										if (depName === "require") {
											args[i] = handlers.require(name);
										} else if (depName === "exports") {
											//CommonJS module spec 1.1
											args[i] = handlers.exports(name);
											usingExports = true;
										} else if (depName === "module") {
											//CommonJS module spec 1.1
											cjsModule = args[i] = handlers.module(name);
										} else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) {
											args[i] = callDep(depName);
										} else if (map.p) {
											map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
											args[i] = defined[depName];
										} else {
											throw new Error(name + ' missing ' + depName);
										}
									}

									ret = callback ? callback.apply(defined[name], args) : undefined;

									if (name) {
										//If setting exports via "module" is in play,
										//favor that over return value and exports. After that,
										//favor a non-undefined return value over exports use.
										if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) {
											defined[name] = cjsModule.exports;
										} else if (ret !== undef || !usingExports) {
											//Use the return value from the function.
											defined[name] = ret;
										}
									}
								} else if (name) {
									//May just be an object definition for the module. Only
									//worry about defining if have a module name.
									defined[name] = callback;
								}
							};

							requirejs = require = _req = function req(deps, callback, relName, forceSync, alt) {
								if (typeof deps === "string") {
									if (handlers[deps]) {
										//callback in this case is really relName
										return handlers[deps](callback);
									}
									//Just return the module wanted. In this scenario, the
									//deps arg is the module name, and second arg (if passed)
									//is just the relName.
									//Normalize module name, if it contains . or ..
									return callDep(makeMap(deps, makeRelParts(callback)).f);
								} else if (!deps.splice) {
									//deps is a config object, not an array.
									config = deps;
									if (config.deps) {
										_req(config.deps, config.callback);
									}
									if (!callback) {
										return;
									}

									if (callback.splice) {
										//callback is an array, which means it is a dependency list.
										//Adjust args if there are dependencies
										deps = callback;
										callback = relName;
										relName = null;
									} else {
										deps = undef;
									}
								}

								//Support require(['a'])
								callback = callback || function () {};

								//If relName is a function, it is an errback handler,
								//so remove it.
								if (typeof relName === 'function') {
									relName = forceSync;
									forceSync = alt;
								}

								//Simulate async callback;
								if (forceSync) {
									main(undef, deps, callback, relName);
								} else {
									//Using a non-zero value because of concern for what old browsers
									//do, and latest browsers "upgrade" to 4 if lower value is used:
									//http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
									//If want a value immediately, use require('id') instead -- something
									//that works in almond on the global level, but not guaranteed and
									//unlikely to work in other AMD implementations.
									setTimeout(function () {
										main(undef, deps, callback, relName);
									}, 4);
								}

								return _req;
							};

							/**
        * Just drops the config on the floor, but returns req in case
        * the config return value is used.
        */
							_req.config = function (cfg) {
								return _req(cfg);
							};

							/**
        * Expose module registry for debugging and tooling
        */
							requirejs._defined = defined;

							define = function define(name, deps, callback) {
								if (typeof name !== 'string') {
									throw new Error('See almond README: incorrect module build, no module name');
								}

								//This module may not have dependencies
								if (!deps.splice) {
									//deps is not an array, so probably means
									//an object literal or factory function for
									//the value. Adjust args.
									callback = deps;
									deps = [];
								}

								if (!hasProp(defined, name) && !hasProp(waiting, name)) {
									waiting[name] = [name, deps, callback];
								}
							};

							define.amd = {
								jQuery: true
							};
						})();

						S2.requirejs = requirejs;S2.require = require;S2.define = define;
					}
				})();
				S2.define("almond", function () {});

				/* global jQuery:false, $:false */
				S2.define('jquery', [], function () {
					var _$ = jQuery || $;

					if (_$ == null && console && console.error) {
						console.error('Select2: An instance of jQuery or a jQuery-compatible library was not ' + 'found. Make sure that you are including jQuery before Select2 on your ' + 'web page.');
					}

					return _$;
				});

				S2.define('select2/utils', ['jquery'], function ($) {
					var Utils = {};

					Utils.Extend = function (ChildClass, SuperClass) {
						var __hasProp = {}.hasOwnProperty;

						function BaseConstructor() {
							this.constructor = ChildClass;
						}

						for (var key in SuperClass) {
							if (__hasProp.call(SuperClass, key)) {
								ChildClass[key] = SuperClass[key];
							}
						}

						BaseConstructor.prototype = SuperClass.prototype;
						ChildClass.prototype = new BaseConstructor();
						ChildClass.__super__ = SuperClass.prototype;

						return ChildClass;
					};

					function getMethods(theClass) {
						var proto = theClass.prototype;

						var methods = [];

						for (var methodName in proto) {
							var m = proto[methodName];

							if (typeof m !== 'function') {
								continue;
							}

							if (methodName === 'constructor') {
								continue;
							}

							methods.push(methodName);
						}

						return methods;
					}

					Utils.Decorate = function (SuperClass, DecoratorClass) {
						var decoratedMethods = getMethods(DecoratorClass);
						var superMethods = getMethods(SuperClass);

						function DecoratedClass() {
							var unshift = Array.prototype.unshift;

							var argCount = DecoratorClass.prototype.constructor.length;

							var calledConstructor = SuperClass.prototype.constructor;

							if (argCount > 0) {
								unshift.call(arguments, SuperClass.prototype.constructor);

								calledConstructor = DecoratorClass.prototype.constructor;
							}

							calledConstructor.apply(this, arguments);
						}

						DecoratorClass.displayName = SuperClass.displayName;

						function ctr() {
							this.constructor = DecoratedClass;
						}

						DecoratedClass.prototype = new ctr();

						for (var m = 0; m < superMethods.length; m++) {
							var superMethod = superMethods[m];

							DecoratedClass.prototype[superMethod] = SuperClass.prototype[superMethod];
						}

						var calledMethod = function calledMethod(methodName) {
							// Stub out the original method if it's not decorating an actual method
							var originalMethod = function originalMethod() {};

							if (methodName in DecoratedClass.prototype) {
								originalMethod = DecoratedClass.prototype[methodName];
							}

							var decoratedMethod = DecoratorClass.prototype[methodName];

							return function () {
								var unshift = Array.prototype.unshift;

								unshift.call(arguments, originalMethod);

								return decoratedMethod.apply(this, arguments);
							};
						};

						for (var d = 0; d < decoratedMethods.length; d++) {
							var decoratedMethod = decoratedMethods[d];

							DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
						}

						return DecoratedClass;
					};

					var Observable = function Observable() {
						this.listeners = {};
					};

					Observable.prototype.on = function (event, callback) {
						this.listeners = this.listeners || {};

						if (event in this.listeners) {
							this.listeners[event].push(callback);
						} else {
							this.listeners[event] = [callback];
						}
					};

					Observable.prototype.trigger = function (event) {
						var slice = Array.prototype.slice;
						var params = slice.call(arguments, 1);

						this.listeners = this.listeners || {};

						// Params should always come in as an array
						if (params == null) {
							params = [];
						}

						// If there are no arguments to the event, use a temporary object
						if (params.length === 0) {
							params.push({});
						}

						// Set the `_type` of the first object to the event
						params[0]._type = event;

						if (event in this.listeners) {
							this.invoke(this.listeners[event], slice.call(arguments, 1));
						}

						if ('*' in this.listeners) {
							this.invoke(this.listeners['*'], arguments);
						}
					};

					Observable.prototype.invoke = function (listeners, params) {
						for (var i = 0, len = listeners.length; i < len; i++) {
							listeners[i].apply(this, params);
						}
					};

					Utils.Observable = Observable;

					Utils.generateChars = function (length) {
						var chars = '';

						for (var i = 0; i < length; i++) {
							var randomChar = Math.floor(Math.random() * 36);
							chars += randomChar.toString(36);
						}

						return chars;
					};

					Utils.bind = function (func, context) {
						return function () {
							func.apply(context, arguments);
						};
					};

					Utils._convertData = function (data) {
						for (var originalKey in data) {
							var keys = originalKey.split('-');

							var dataLevel = data;

							if (keys.length === 1) {
								continue;
							}

							for (var k = 0; k < keys.length; k++) {
								var key = keys[k];

								// Lowercase the first letter
								// By default, dash-separated becomes camelCase
								key = key.substring(0, 1).toLowerCase() + key.substring(1);

								if (!(key in dataLevel)) {
									dataLevel[key] = {};
								}

								if (k == keys.length - 1) {
									dataLevel[key] = data[originalKey];
								}

								dataLevel = dataLevel[key];
							}

							delete data[originalKey];
						}

						return data;
					};

					Utils.hasScroll = function (index, el) {
						// Adapted from the function created by @ShadowScripter
						// and adapted by @BillBarry on the Stack Exchange Code Review website.
						// The original code can be found at
						// http://codereview.stackexchange.com/q/13338
						// and was designed to be used with the Sizzle selector engine.

						var $el = $(el);
						var overflowX = el.style.overflowX;
						var overflowY = el.style.overflowY;

						//Check both x and y declarations
						if (overflowX === overflowY && (overflowY === 'hidden' || overflowY === 'visible')) {
							return false;
						}

						if (overflowX === 'scroll' || overflowY === 'scroll') {
							return true;
						}

						return $el.innerHeight() < el.scrollHeight || $el.innerWidth() < el.scrollWidth;
					};

					Utils.escapeMarkup = function (markup) {
						var replaceMap = {
							'\\': '&#92;',
							'&': '&amp;',
							'<': '&lt;',
							'>': '&gt;',
							'"': '&quot;',
							'\'': '&#39;',
							'/': '&#47;'
						};

						// Do not try to escape the markup if it's not a string
						if (typeof markup !== 'string') {
							return markup;
						}

						return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
							return replaceMap[match];
						});
					};

					// Append an array of jQuery nodes to a given element.
					Utils.appendMany = function ($element, $nodes) {
						// jQuery 1.7.x does not support $.fn.append() with an array
						// Fall back to a jQuery object collection using $.fn.add()
						if ($.fn.jquery.substr(0, 3) === '1.7') {
							var $jqNodes = $();

							$.map($nodes, function (node) {
								$jqNodes = $jqNodes.add(node);
							});

							$nodes = $jqNodes;
						}

						$element.append($nodes);
					};

					// Cache objects in Utils.__cache instead of $.data (see #4346)
					Utils.__cache = {};

					var id = 0;
					Utils.GetUniqueElementId = function (element) {
						// Get a unique element Id. If element has no id,
						// creates a new unique number, stores it in the id
						// attribute and returns the new id.
						// If an id already exists, it simply returns it.

						var select2Id = element.getAttribute('data-select2-id');
						if (select2Id == null) {
							// If element has id, use it.
							if (element.id) {
								select2Id = element.id;
								element.setAttribute('data-select2-id', select2Id);
							} else {
								element.setAttribute('data-select2-id', ++id);
								select2Id = id.toString();
							}
						}
						return select2Id;
					};

					Utils.StoreData = function (element, name, value) {
						// Stores an item in the cache for a specified element.
						// name is the cache key.
						var id = Utils.GetUniqueElementId(element);
						if (!Utils.__cache[id]) {
							Utils.__cache[id] = {};
						}

						Utils.__cache[id][name] = value;
					};

					Utils.GetData = function (element, name) {
						// Retrieves a value from the cache by its key (name)
						// name is optional. If no name specified, return
						// all cache items for the specified element.
						// and for a specified element.
						var id = Utils.GetUniqueElementId(element);
						if (name) {
							if (Utils.__cache[id]) {
								if (Utils.__cache[id][name] != null) {
									return Utils.__cache[id][name];
								}
								return $(element).data(name); // Fallback to HTML5 data attribs.
							}
							return $(element).data(name); // Fallback to HTML5 data attribs.
						} else {
							return Utils.__cache[id];
						}
					};

					Utils.RemoveData = function (element) {
						// Removes all cached items for a specified element.
						var id = Utils.GetUniqueElementId(element);
						if (Utils.__cache[id] != null) {
							delete Utils.__cache[id];
						}

						element.removeAttribute('data-select2-id');
					};

					return Utils;
				});

				S2.define('select2/results', ['jquery', './utils'], function ($, Utils) {
					function Results($element, options, dataAdapter) {
						this.$element = $element;
						this.data = dataAdapter;
						this.options = options;

						Results.__super__.constructor.call(this);
					}

					Utils.Extend(Results, Utils.Observable);

					Results.prototype.render = function () {
						var $results = $('<ul class="select2-results__options" role="listbox"></ul>');

						if (this.options.get('multiple')) {
							$results.attr('aria-multiselectable', 'true');
						}

						this.$results = $results;

						return $results;
					};

					Results.prototype.clear = function () {
						this.$results.empty();
					};

					Results.prototype.displayMessage = function (params) {
						var escapeMarkup = this.options.get('escapeMarkup');

						this.clear();
						this.hideLoading();

						var $message = $('<li role="alert" aria-live="assertive"' + ' class="select2-results__option"></li>');

						var message = this.options.get('translations').get(params.message);

						$message.append(escapeMarkup(message(params.args)));

						$message[0].className += ' select2-results__message';

						this.$results.append($message);
					};

					Results.prototype.hideMessages = function () {
						this.$results.find('.select2-results__message').remove();
					};

					Results.prototype.append = function (data) {
						this.hideLoading();

						var $options = [];

						if (data.results == null || data.results.length === 0) {
							if (this.$results.children().length === 0) {
								this.trigger('results:message', {
									message: 'noResults'
								});
							}

							return;
						}

						data.results = this.sort(data.results);

						for (var d = 0; d < data.results.length; d++) {
							var item = data.results[d];

							var $option = this.option(item);

							$options.push($option);
						}

						this.$results.append($options);
					};

					Results.prototype.position = function ($results, $dropdown) {
						var $resultsContainer = $dropdown.find('.select2-results');
						$resultsContainer.append($results);
					};

					Results.prototype.sort = function (data) {
						var sorter = this.options.get('sorter');

						return sorter(data);
					};

					Results.prototype.highlightFirstItem = function () {
						var $options = this.$results.find('.select2-results__option[aria-selected]');

						var $selected = $options.filter('[aria-selected=true]');

						// Check if there are any selected options
						if ($selected.length > 0) {
							// If there are selected options, highlight the first
							$selected.first().trigger('mouseenter');
						} else {
							// If there are no selected options, highlight the first option
							// in the dropdown
							$options.first().trigger('mouseenter');
						}

						this.ensureHighlightVisible();
					};

					Results.prototype.setClasses = function () {
						var self = this;

						this.data.current(function (selected) {
							var selectedIds = $.map(selected, function (s) {
								return s.id.toString();
							});

							var $options = self.$results.find('.select2-results__option[aria-selected]');

							$options.each(function () {
								var $option = $(this);

								var item = Utils.GetData(this, 'data');

								// id needs to be converted to a string when comparing
								var id = '' + item.id;

								if (item.element != null && item.element.selected || item.element == null && $.inArray(id, selectedIds) > -1) {
									$option.attr('aria-selected', 'true');
								} else {
									$option.attr('aria-selected', 'false');
								}
							});
						});
					};

					Results.prototype.showLoading = function (params) {
						this.hideLoading();

						var loadingMore = this.options.get('translations').get('searching');

						var loading = {
							disabled: true,
							loading: true,
							text: loadingMore(params)
						};
						var $loading = this.option(loading);
						$loading.className += ' loading-results';

						this.$results.prepend($loading);
					};

					Results.prototype.hideLoading = function () {
						this.$results.find('.loading-results').remove();
					};

					Results.prototype.option = function (data) {
						var option = document.createElement('li');
						option.className = 'select2-results__option';

						var attrs = {
							'role': 'option',
							'aria-selected': 'false'
						};

						var matches = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;

						if (data.element != null && matches.call(data.element, ':disabled') || data.element == null && data.disabled) {
							delete attrs['aria-selected'];
							attrs['aria-disabled'] = 'true';
						}

						if (data.id == null) {
							delete attrs['aria-selected'];
						}

						if (data._resultId != null) {
							option.id = data._resultId;
						}

						if (data.title) {
							option.title = data.title;
						}

						if (data.children) {
							attrs.role = 'group';
							attrs['aria-label'] = data.text;
							delete attrs['aria-selected'];
						}

						for (var attr in attrs) {
							var val = attrs[attr];

							option.setAttribute(attr, val);
						}

						if (data.children) {
							var $option = $(option);

							var label = document.createElement('strong');
							label.className = 'select2-results__group';

							var $label = $(label);
							this.template(data, label);

							var $children = [];

							for (var c = 0; c < data.children.length; c++) {
								var child = data.children[c];

								var $child = this.option(child);

								$children.push($child);
							}

							var $childrenContainer = $('<ul></ul>', {
								'class': 'select2-results__options select2-results__options--nested'
							});

							$childrenContainer.append($children);

							$option.append(label);
							$option.append($childrenContainer);
						} else {
							this.template(data, option);
						}

						Utils.StoreData(option, 'data', data);

						return option;
					};

					Results.prototype.bind = function (container, $container) {
						var self = this;

						var id = container.id + '-results';

						this.$results.attr('id', id);

						container.on('results:all', function (params) {
							self.clear();
							self.append(params.data);

							if (container.isOpen()) {
								self.setClasses();
								self.highlightFirstItem();
							}
						});

						container.on('results:append', function (params) {
							self.append(params.data);

							if (container.isOpen()) {
								self.setClasses();
							}
						});

						container.on('query', function (params) {
							self.hideMessages();
							self.showLoading(params);
						});

						container.on('select', function () {
							if (!container.isOpen()) {
								return;
							}

							self.setClasses();

							if (self.options.get('scrollAfterSelect')) {
								self.highlightFirstItem();
							}
						});

						container.on('unselect', function () {
							if (!container.isOpen()) {
								return;
							}

							self.setClasses();

							if (self.options.get('scrollAfterSelect')) {
								self.highlightFirstItem();
							}
						});

						container.on('open', function () {
							// When the dropdown is open, aria-expended="true"
							self.$results.attr('aria-expanded', 'true');
							self.$results.attr('aria-hidden', 'false');

							self.setClasses();
							self.ensureHighlightVisible();
						});

						container.on('close', function () {
							// When the dropdown is closed, aria-expended="false"
							self.$results.attr('aria-expanded', 'false');
							self.$results.attr('aria-hidden', 'true');
							self.$results.removeAttr('aria-activedescendant');
						});

						container.on('results:toggle', function () {
							var $highlighted = self.getHighlightedResults();

							if ($highlighted.length === 0) {
								return;
							}

							$highlighted.trigger('mouseup');
						});

						container.on('results:select', function () {
							var $highlighted = self.getHighlightedResults();

							if ($highlighted.length === 0) {
								return;
							}

							var data = Utils.GetData($highlighted[0], 'data');

							if ($highlighted.attr('aria-selected') == 'true') {
								self.trigger('close', {});
							} else {
								self.trigger('select', {
									data: data
								});
							}
						});

						container.on('results:previous', function () {
							var $highlighted = self.getHighlightedResults();

							var $options = self.$results.find('[aria-selected]');

							var currentIndex = $options.index($highlighted);

							// If we are already at the top, don't move further
							// If no options, currentIndex will be -1
							if (currentIndex <= 0) {
								return;
							}

							var nextIndex = currentIndex - 1;

							// If none are highlighted, highlight the first
							if ($highlighted.length === 0) {
								nextIndex = 0;
							}

							var $next = $options.eq(nextIndex);

							$next.trigger('mouseenter');

							var currentOffset = self.$results.offset().top;
							var nextTop = $next.offset().top;
							var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

							if (nextIndex === 0) {
								self.$results.scrollTop(0);
							} else if (nextTop - currentOffset < 0) {
								self.$results.scrollTop(nextOffset);
							}
						});

						container.on('results:next', function () {
							var $highlighted = self.getHighlightedResults();

							var $options = self.$results.find('[aria-selected]');

							var currentIndex = $options.index($highlighted);

							var nextIndex = currentIndex + 1;

							// If we are at the last option, stay there
							if (nextIndex >= $options.length) {
								return;
							}

							var $next = $options.eq(nextIndex);

							$next.trigger('mouseenter');

							var currentOffset = self.$results.offset().top + self.$results.outerHeight(false);
							var nextBottom = $next.offset().top + $next.outerHeight(false);
							var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

							if (nextIndex === 0) {
								self.$results.scrollTop(0);
							} else if (nextBottom > currentOffset) {
								self.$results.scrollTop(nextOffset);
							}
						});

						container.on('results:focus', function (params) {
							params.element.addClass('select2-results__option--highlighted');
						});

						container.on('results:message', function (params) {
							self.displayMessage(params);
						});

						if ($.fn.mousewheel) {
							this.$results.on('mousewheel', function (e) {
								var top = self.$results.scrollTop();

								var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

								var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
								var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

								if (isAtTop) {
									self.$results.scrollTop(0);

									e.preventDefault();
									e.stopPropagation();
								} else if (isAtBottom) {
									self.$results.scrollTop(self.$results.get(0).scrollHeight - self.$results.height());

									e.preventDefault();
									e.stopPropagation();
								}
							});
						}

						this.$results.on('mouseup', '.select2-results__option[aria-selected]', function (evt) {
							var $this = $(this);

							var data = Utils.GetData(this, 'data');

							if ($this.attr('aria-selected') === 'true') {
								if (self.options.get('multiple')) {
									self.trigger('unselect', {
										originalEvent: evt,
										data: data
									});
								} else {
									self.trigger('close', {});
								}

								return;
							}

							self.trigger('select', {
								originalEvent: evt,
								data: data
							});
						});

						this.$results.on('mouseenter', '.select2-results__option[aria-selected]', function (evt) {
							var data = Utils.GetData(this, 'data');

							self.getHighlightedResults().removeClass('select2-results__option--highlighted');

							self.trigger('results:focus', {
								data: data,
								element: $(this)
							});
						});
					};

					Results.prototype.getHighlightedResults = function () {
						var $highlighted = this.$results.find('.select2-results__option--highlighted');

						return $highlighted;
					};

					Results.prototype.destroy = function () {
						this.$results.remove();
					};

					Results.prototype.ensureHighlightVisible = function () {
						var $highlighted = this.getHighlightedResults();

						if ($highlighted.length === 0) {
							return;
						}

						var $options = this.$results.find('[aria-selected]');

						var currentIndex = $options.index($highlighted);

						var currentOffset = this.$results.offset().top;
						var nextTop = $highlighted.offset().top;
						var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

						var offsetDelta = nextTop - currentOffset;
						nextOffset -= $highlighted.outerHeight(false) * 2;

						if (currentIndex <= 2) {
							this.$results.scrollTop(0);
						} else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
							this.$results.scrollTop(nextOffset);
						}
					};

					Results.prototype.template = function (result, container) {
						var template = this.options.get('templateResult');
						var escapeMarkup = this.options.get('escapeMarkup');

						var content = template(result, container);

						if (content == null) {
							container.style.display = 'none';
						} else if (typeof content === 'string') {
							container.innerHTML = escapeMarkup(content);
						} else {
							$(container).append(content);
						}
					};

					return Results;
				});

				S2.define('select2/keys', [], function () {
					var KEYS = {
						BACKSPACE: 8,
						TAB: 9,
						ENTER: 13,
						SHIFT: 16,
						CTRL: 17,
						ALT: 18,
						ESC: 27,
						SPACE: 32,
						PAGE_UP: 33,
						PAGE_DOWN: 34,
						END: 35,
						HOME: 36,
						LEFT: 37,
						UP: 38,
						RIGHT: 39,
						DOWN: 40,
						DELETE: 46
					};

					return KEYS;
				});

				S2.define('select2/selection/base', ['jquery', '../utils', '../keys'], function ($, Utils, KEYS) {
					function BaseSelection($element, options) {
						this.$element = $element;
						this.options = options;

						BaseSelection.__super__.constructor.call(this);
					}

					Utils.Extend(BaseSelection, Utils.Observable);

					BaseSelection.prototype.render = function () {
						var $selection = $('<span class="select2-selection" role="combobox" ' + ' aria-haspopup="true" aria-expanded="false">' + '</span>');

						this._tabindex = 0;

						if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
							this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
						} else if (this.$element.attr('tabindex') != null) {
							this._tabindex = this.$element.attr('tabindex');
						}

						$selection.attr('title', this.$element.attr('title'));
						$selection.attr('tabindex', this._tabindex);
						$selection.attr('aria-disabled', 'false');

						this.$selection = $selection;

						return $selection;
					};

					BaseSelection.prototype.bind = function (container, $container) {
						var self = this;

						var resultsId = container.id + '-results';

						this.container = container;

						this.$selection.on('focus', function (evt) {
							self.trigger('focus', evt);
						});

						this.$selection.on('blur', function (evt) {
							self._handleBlur(evt);
						});

						this.$selection.on('keydown', function (evt) {
							self.trigger('keypress', evt);

							if (evt.which === KEYS.SPACE) {
								evt.preventDefault();
							}
						});

						container.on('results:focus', function (params) {
							self.$selection.attr('aria-activedescendant', params.data._resultId);
						});

						container.on('selection:update', function (params) {
							self.update(params.data);
						});

						container.on('open', function () {
							// When the dropdown is open, aria-expanded="true"
							self.$selection.attr('aria-expanded', 'true');
							self.$selection.attr('aria-owns', resultsId);

							self._attachCloseHandler(container);
						});

						container.on('close', function () {
							// When the dropdown is closed, aria-expanded="false"
							self.$selection.attr('aria-expanded', 'false');
							self.$selection.removeAttr('aria-activedescendant');
							self.$selection.removeAttr('aria-owns');

							self.$selection.trigger('focus');

							self._detachCloseHandler(container);
						});

						container.on('enable', function () {
							self.$selection.attr('tabindex', self._tabindex);
							self.$selection.attr('aria-disabled', 'false');
						});

						container.on('disable', function () {
							self.$selection.attr('tabindex', '-1');
							self.$selection.attr('aria-disabled', 'true');
						});
					};

					BaseSelection.prototype._handleBlur = function (evt) {
						var self = this;

						// This needs to be delayed as the active element is the body when the tab
						// key is pressed, possibly along with others.
						window.setTimeout(function () {
							// Don't trigger `blur` if the focus is still in the selection
							if (document.activeElement == self.$selection[0] || $.contains(self.$selection[0], document.activeElement)) {
								return;
							}

							self.trigger('blur', evt);
						}, 1);
					};

					BaseSelection.prototype._attachCloseHandler = function (container) {

						$(document.body).on('mousedown.select2.' + container.id, function (e) {
							var $target = $(e.target);

							var $select = $target.closest('.select2');

							var $all = $('.select2.select2-container--open');

							$all.each(function () {
								if (this == $select[0]) {
									return;
								}

								var $element = Utils.GetData(this, 'element');

								$element.select2('close');
							});
						});
					};

					BaseSelection.prototype._detachCloseHandler = function (container) {
						$(document.body).off('mousedown.select2.' + container.id);
					};

					BaseSelection.prototype.position = function ($selection, $container) {
						var $selectionContainer = $container.find('.selection');
						$selectionContainer.append($selection);
					};

					BaseSelection.prototype.destroy = function () {
						this._detachCloseHandler(this.container);
					};

					BaseSelection.prototype.update = function (data) {
						throw new Error('The `update` method must be defined in child classes.');
					};

					/**
      * Helper method to abstract the "enabled" (not "disabled") state of this
      * object.
      *
      * @return {true} if the instance is not disabled.
      * @return {false} if the instance is disabled.
      */
					BaseSelection.prototype.isEnabled = function () {
						return !this.isDisabled();
					};

					/**
      * Helper method to abstract the "disabled" state of this object.
      *
      * @return {true} if the disabled option is true.
      * @return {false} if the disabled option is false.
      */
					BaseSelection.prototype.isDisabled = function () {
						return this.options.get('disabled');
					};

					return BaseSelection;
				});

				S2.define('select2/selection/single', ['jquery', './base', '../utils', '../keys'], function ($, BaseSelection, Utils, KEYS) {
					function SingleSelection() {
						SingleSelection.__super__.constructor.apply(this, arguments);
					}

					Utils.Extend(SingleSelection, BaseSelection);

					SingleSelection.prototype.render = function () {
						var $selection = SingleSelection.__super__.render.call(this);

						$selection.addClass('select2-selection--single');

						$selection.html('<span class="select2-selection__rendered"></span>' + '<span class="select2-selection__arrow" role="presentation">' + '<b role="presentation"></b>' + '</span>');

						return $selection;
					};

					SingleSelection.prototype.bind = function (container, $container) {
						var self = this;

						SingleSelection.__super__.bind.apply(this, arguments);

						var id = container.id + '-container';

						this.$selection.find('.select2-selection__rendered').attr('id', id).attr('role', 'textbox').attr('aria-readonly', 'true');
						this.$selection.attr('aria-labelledby', id);

						this.$selection.on('mousedown', function (evt) {
							// Only respond to left clicks
							if (evt.which !== 1) {
								return;
							}

							self.trigger('toggle', {
								originalEvent: evt
							});
						});

						this.$selection.on('focus', function (evt) {
							// User focuses on the container
						});

						this.$selection.on('blur', function (evt) {
							// User exits the container
						});

						container.on('focus', function (evt) {
							if (!container.isOpen()) {
								self.$selection.trigger('focus');
							}
						});
					};

					SingleSelection.prototype.clear = function () {
						var $rendered = this.$selection.find('.select2-selection__rendered');
						$rendered.empty();
						$rendered.removeAttr('title'); // clear tooltip on empty
					};

					SingleSelection.prototype.display = function (data, container) {
						var template = this.options.get('templateSelection');
						var escapeMarkup = this.options.get('escapeMarkup');

						return escapeMarkup(template(data, container));
					};

					SingleSelection.prototype.selectionContainer = function () {
						return $('<span></span>');
					};

					SingleSelection.prototype.update = function (data) {
						if (data.length === 0) {
							this.clear();
							return;
						}

						var selection = data[0];

						var $rendered = this.$selection.find('.select2-selection__rendered');
						var formatted = this.display(selection, $rendered);

						$rendered.empty().append(formatted);

						var title = selection.title || selection.text;

						if (title) {
							$rendered.attr('title', title);
						} else {
							$rendered.removeAttr('title');
						}
					};

					return SingleSelection;
				});

				S2.define('select2/selection/multiple', ['jquery', './base', '../utils'], function ($, BaseSelection, Utils) {
					function MultipleSelection($element, options) {
						MultipleSelection.__super__.constructor.apply(this, arguments);
					}

					Utils.Extend(MultipleSelection, BaseSelection);

					MultipleSelection.prototype.render = function () {
						var $selection = MultipleSelection.__super__.render.call(this);

						$selection.addClass('select2-selection--multiple');

						$selection.html('<ul class="select2-selection__rendered"></ul>');

						return $selection;
					};

					MultipleSelection.prototype.bind = function (container, $container) {
						var self = this;

						MultipleSelection.__super__.bind.apply(this, arguments);

						this.$selection.on('click', function (evt) {
							self.trigger('toggle', {
								originalEvent: evt
							});
						});

						this.$selection.on('click', '.select2-selection__choice__remove', function (evt) {
							// Ignore the event if it is disabled
							if (self.isDisabled()) {
								return;
							}

							var $remove = $(this);
							var $selection = $remove.parent();

							var data = Utils.GetData($selection[0], 'data');

							self.trigger('unselect', {
								originalEvent: evt,
								data: data
							});
						});
					};

					MultipleSelection.prototype.clear = function () {
						var $rendered = this.$selection.find('.select2-selection__rendered');
						$rendered.empty();
						$rendered.removeAttr('title');
					};

					MultipleSelection.prototype.display = function (data, container) {
						var template = this.options.get('templateSelection');
						var escapeMarkup = this.options.get('escapeMarkup');

						return escapeMarkup(template(data, container));
					};

					MultipleSelection.prototype.selectionContainer = function () {
						var $container = $('<li class="select2-selection__choice">' + '<span class="select2-selection__choice__remove" role="presentation">' + '&times;' + '</span>' + '</li>');

						return $container;
					};

					MultipleSelection.prototype.update = function (data) {
						this.clear();

						if (data.length === 0) {
							return;
						}

						var $selections = [];

						for (var d = 0; d < data.length; d++) {
							var selection = data[d];

							var $selection = this.selectionContainer();
							var formatted = this.display(selection, $selection);

							$selection.append(formatted);

							var title = selection.title || selection.text;

							if (title) {
								$selection.attr('title', title);
							}

							Utils.StoreData($selection[0], 'data', selection);

							$selections.push($selection);
						}

						var $rendered = this.$selection.find('.select2-selection__rendered');

						Utils.appendMany($rendered, $selections);
					};

					return MultipleSelection;
				});

				S2.define('select2/selection/placeholder', ['../utils'], function (Utils) {
					function Placeholder(decorated, $element, options) {
						this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

						decorated.call(this, $element, options);
					}

					Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
						if (typeof placeholder === 'string') {
							placeholder = {
								id: '',
								text: placeholder
							};
						}

						return placeholder;
					};

					Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
						var $placeholder = this.selectionContainer();

						$placeholder.html(this.display(placeholder));
						$placeholder.addClass('select2-selection__placeholder').removeClass('select2-selection__choice');

						return $placeholder;
					};

					Placeholder.prototype.update = function (decorated, data) {
						var singlePlaceholder = data.length == 1 && data[0].id != this.placeholder.id;
						var multipleSelections = data.length > 1;

						if (multipleSelections || singlePlaceholder) {
							return decorated.call(this, data);
						}

						this.clear();

						var $placeholder = this.createPlaceholder(this.placeholder);

						this.$selection.find('.select2-selection__rendered').append($placeholder);
					};

					return Placeholder;
				});

				S2.define('select2/selection/allowClear', ['jquery', '../keys', '../utils'], function ($, KEYS, Utils) {
					function AllowClear() {}

					AllowClear.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						if (this.placeholder == null) {
							if (this.options.get('debug') && window.console && console.error) {
								console.error('Select2: The `allowClear` option should be used in combination ' + 'with the `placeholder` option.');
							}
						}

						this.$selection.on('mousedown', '.select2-selection__clear', function (evt) {
							self._handleClear(evt);
						});

						container.on('keypress', function (evt) {
							self._handleKeyboardClear(evt, container);
						});
					};

					AllowClear.prototype._handleClear = function (_, evt) {
						// Ignore the event if it is disabled
						if (this.isDisabled()) {
							return;
						}

						var $clear = this.$selection.find('.select2-selection__clear');

						// Ignore the event if nothing has been selected
						if ($clear.length === 0) {
							return;
						}

						evt.stopPropagation();

						var data = Utils.GetData($clear[0], 'data');

						var previousVal = this.$element.val();
						this.$element.val(this.placeholder.id);

						var unselectData = {
							data: data
						};
						this.trigger('clear', unselectData);
						if (unselectData.prevented) {
							this.$element.val(previousVal);
							return;
						}

						for (var d = 0; d < data.length; d++) {
							unselectData = {
								data: data[d]
							};

							// Trigger the `unselect` event, so people can prevent it from being
							// cleared.
							this.trigger('unselect', unselectData);

							// If the event was prevented, don't clear it out.
							if (unselectData.prevented) {
								this.$element.val(previousVal);
								return;
							}
						}

						this.$element.trigger('input').trigger('change');

						this.trigger('toggle', {});
					};

					AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
						if (container.isOpen()) {
							return;
						}

						if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
							this._handleClear(evt);
						}
					};

					AllowClear.prototype.update = function (decorated, data) {
						decorated.call(this, data);

						if (this.$selection.find('.select2-selection__placeholder').length > 0 || data.length === 0) {
							return;
						}

						var removeAll = this.options.get('translations').get('removeAllItems');

						var $remove = $('<span class="select2-selection__clear" title="' + removeAll() + '">' + '&times;' + '</span>');
						Utils.StoreData($remove[0], 'data', data);

						this.$selection.find('.select2-selection__rendered').prepend($remove);
					};

					return AllowClear;
				});

				S2.define('select2/selection/search', ['jquery', '../utils', '../keys'], function ($, Utils, KEYS) {
					function Search(decorated, $element, options) {
						decorated.call(this, $element, options);
					}

					Search.prototype.render = function (decorated) {
						var $search = $('<li class="select2-search select2-search--inline">' + '<input class="select2-search__field" type="search" tabindex="-1"' + ' autocomplete="off" autocorrect="off" autocapitalize="none"' + ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' + '</li>');

						this.$searchContainer = $search;
						this.$search = $search.find('input');

						var $rendered = decorated.call(this);

						this._transferTabIndex();

						return $rendered;
					};

					Search.prototype.bind = function (decorated, container, $container) {
						var self = this;

						var resultsId = container.id + '-results';

						decorated.call(this, container, $container);

						container.on('open', function () {
							self.$search.attr('aria-controls', resultsId);
							self.$search.trigger('focus');
						});

						container.on('close', function () {
							self.$search.val('');
							self.$search.removeAttr('aria-controls');
							self.$search.removeAttr('aria-activedescendant');
							self.$search.trigger('focus');
						});

						container.on('enable', function () {
							self.$search.prop('disabled', false);

							self._transferTabIndex();
						});

						container.on('disable', function () {
							self.$search.prop('disabled', true);
						});

						container.on('focus', function (evt) {
							self.$search.trigger('focus');
						});

						container.on('results:focus', function (params) {
							if (params.data._resultId) {
								self.$search.attr('aria-activedescendant', params.data._resultId);
							} else {
								self.$search.removeAttr('aria-activedescendant');
							}
						});

						this.$selection.on('focusin', '.select2-search--inline', function (evt) {
							self.trigger('focus', evt);
						});

						this.$selection.on('focusout', '.select2-search--inline', function (evt) {
							self._handleBlur(evt);
						});

						this.$selection.on('keydown', '.select2-search--inline', function (evt) {
							evt.stopPropagation();

							self.trigger('keypress', evt);

							self._keyUpPrevented = evt.isDefaultPrevented();

							var key = evt.which;

							if (key === KEYS.BACKSPACE && self.$search.val() === '') {
								var $previousChoice = self.$searchContainer.prev('.select2-selection__choice');

								if ($previousChoice.length > 0) {
									var item = Utils.GetData($previousChoice[0], 'data');

									self.searchRemoveChoice(item);

									evt.preventDefault();
								}
							}
						});

						this.$selection.on('click', '.select2-search--inline', function (evt) {
							if (self.$search.val()) {
								evt.stopPropagation();
							}
						});

						// Try to detect the IE version should the `documentMode` property that
						// is stored on the document. This is only implemented in IE and is
						// slightly cleaner than doing a user agent check.
						// This property is not available in Edge, but Edge also doesn't have
						// this bug.
						var msie = document.documentMode;
						var disableInputEvents = msie && msie <= 11;

						// Workaround for browsers which do not support the `input` event
						// This will prevent double-triggering of events for browsers which support
						// both the `keyup` and `input` events.
						this.$selection.on('input.searchcheck', '.select2-search--inline', function (evt) {
							// IE will trigger the `input` event when a placeholder is used on a
							// search box. To get around this issue, we are forced to ignore all
							// `input` events in IE and keep using `keyup`.
							if (disableInputEvents) {
								self.$selection.off('input.search input.searchcheck');
								return;
							}

							// Unbind the duplicated `keyup` event
							self.$selection.off('keyup.search');
						});

						this.$selection.on('keyup.search input.search', '.select2-search--inline', function (evt) {
							// IE will trigger the `input` event when a placeholder is used on a
							// search box. To get around this issue, we are forced to ignore all
							// `input` events in IE and keep using `keyup`.
							if (disableInputEvents && evt.type === 'input') {
								self.$selection.off('input.search input.searchcheck');
								return;
							}

							var key = evt.which;

							// We can freely ignore events from modifier keys
							if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
								return;
							}

							// Tabbing will be handled during the `keydown` phase
							if (key == KEYS.TAB) {
								return;
							}

							self.handleSearch(evt);
						});
					};

					/**
      * This method will transfer the tabindex attribute from the rendered
      * selection to the search box. This allows for the search box to be used as
      * the primary focus instead of the selection container.
      *
      * @private
      */
					Search.prototype._transferTabIndex = function (decorated) {
						this.$search.attr('tabindex', this.$selection.attr('tabindex'));
						this.$selection.attr('tabindex', '-1');
					};

					Search.prototype.createPlaceholder = function (decorated, placeholder) {
						this.$search.attr('placeholder', placeholder.text);
					};

					Search.prototype.update = function (decorated, data) {
						var searchHadFocus = this.$search[0] == document.activeElement;

						this.$search.attr('placeholder', '');

						decorated.call(this, data);

						this.$selection.find('.select2-selection__rendered').append(this.$searchContainer);

						this.resizeSearch();
						if (searchHadFocus) {
							this.$search.trigger('focus');
						}
					};

					Search.prototype.handleSearch = function () {
						this.resizeSearch();

						if (!this._keyUpPrevented) {
							var input = this.$search.val();

							this.trigger('query', {
								term: input
							});
						}

						this._keyUpPrevented = false;
					};

					Search.prototype.searchRemoveChoice = function (decorated, item) {
						this.trigger('unselect', {
							data: item
						});

						this.$search.val(item.text);
						this.handleSearch();
					};

					Search.prototype.resizeSearch = function () {
						this.$search.css('width', '25px');

						var width = '';

						if (this.$search.attr('placeholder') !== '') {
							width = this.$selection.find('.select2-selection__rendered').width();
						} else {
							var minimumWidth = this.$search.val().length + 1;

							width = minimumWidth * 0.75 + 'em';
						}

						this.$search.css('width', width);
					};

					return Search;
				});

				S2.define('select2/selection/eventRelay', ['jquery'], function ($) {
					function EventRelay() {}

					EventRelay.prototype.bind = function (decorated, container, $container) {
						var self = this;
						var relayEvents = ['open', 'opening', 'close', 'closing', 'select', 'selecting', 'unselect', 'unselecting', 'clear', 'clearing'];

						var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting', 'clearing'];

						decorated.call(this, container, $container);

						container.on('*', function (name, params) {
							// Ignore events that should not be relayed
							if ($.inArray(name, relayEvents) === -1) {
								return;
							}

							// The parameters should always be an object
							params = params || {};

							// Generate the jQuery event for the Select2 event
							var evt = $.Event('select2:' + name, {
								params: params
							});

							self.$element.trigger(evt);

							// Only handle preventable events if it was one
							if ($.inArray(name, preventableEvents) === -1) {
								return;
							}

							params.prevented = evt.isDefaultPrevented();
						});
					};

					return EventRelay;
				});

				S2.define('select2/translation', ['jquery', 'require'], function ($, require) {
					function Translation(dict) {
						this.dict = dict || {};
					}

					Translation.prototype.all = function () {
						return this.dict;
					};

					Translation.prototype.get = function (key) {
						return this.dict[key];
					};

					Translation.prototype.extend = function (translation) {
						this.dict = $.extend({}, translation.all(), this.dict);
					};

					// Static functions

					Translation._cache = {};

					Translation.loadPath = function (path) {
						if (!(path in Translation._cache)) {
							var translations = require(path);

							Translation._cache[path] = translations;
						}

						return new Translation(Translation._cache[path]);
					};

					return Translation;
				});

				S2.define('select2/diacritics', [], function () {
					var diacritics = {
						"\u24B6": 'A',
						"\uFF21": 'A',
						"\xC0": 'A',
						"\xC1": 'A',
						"\xC2": 'A',
						"\u1EA6": 'A',
						"\u1EA4": 'A',
						"\u1EAA": 'A',
						"\u1EA8": 'A',
						"\xC3": 'A',
						"\u0100": 'A',
						"\u0102": 'A',
						"\u1EB0": 'A',
						"\u1EAE": 'A',
						"\u1EB4": 'A',
						"\u1EB2": 'A',
						"\u0226": 'A',
						"\u01E0": 'A',
						"\xC4": 'A',
						"\u01DE": 'A',
						"\u1EA2": 'A',
						"\xC5": 'A',
						"\u01FA": 'A',
						"\u01CD": 'A',
						"\u0200": 'A',
						"\u0202": 'A',
						"\u1EA0": 'A',
						"\u1EAC": 'A',
						"\u1EB6": 'A',
						"\u1E00": 'A',
						"\u0104": 'A',
						"\u023A": 'A',
						"\u2C6F": 'A',
						"\uA732": 'AA',
						"\xC6": 'AE',
						"\u01FC": 'AE',
						"\u01E2": 'AE',
						"\uA734": 'AO',
						"\uA736": 'AU',
						"\uA738": 'AV',
						"\uA73A": 'AV',
						"\uA73C": 'AY',
						"\u24B7": 'B',
						"\uFF22": 'B',
						"\u1E02": 'B',
						"\u1E04": 'B',
						"\u1E06": 'B',
						"\u0243": 'B',
						"\u0182": 'B',
						"\u0181": 'B',
						"\u24B8": 'C',
						"\uFF23": 'C',
						"\u0106": 'C',
						"\u0108": 'C',
						"\u010A": 'C',
						"\u010C": 'C',
						"\xC7": 'C',
						"\u1E08": 'C',
						"\u0187": 'C',
						"\u023B": 'C',
						"\uA73E": 'C',
						"\u24B9": 'D',
						"\uFF24": 'D',
						"\u1E0A": 'D',
						"\u010E": 'D',
						"\u1E0C": 'D',
						"\u1E10": 'D',
						"\u1E12": 'D',
						"\u1E0E": 'D',
						"\u0110": 'D',
						"\u018B": 'D',
						"\u018A": 'D',
						"\u0189": 'D',
						"\uA779": 'D',
						"\u01F1": 'DZ',
						"\u01C4": 'DZ',
						"\u01F2": 'Dz',
						"\u01C5": 'Dz',
						"\u24BA": 'E',
						"\uFF25": 'E',
						"\xC8": 'E',
						"\xC9": 'E',
						"\xCA": 'E',
						"\u1EC0": 'E',
						"\u1EBE": 'E',
						"\u1EC4": 'E',
						"\u1EC2": 'E',
						"\u1EBC": 'E',
						"\u0112": 'E',
						"\u1E14": 'E',
						"\u1E16": 'E',
						"\u0114": 'E',
						"\u0116": 'E',
						"\xCB": 'E',
						"\u1EBA": 'E',
						"\u011A": 'E',
						"\u0204": 'E',
						"\u0206": 'E',
						"\u1EB8": 'E',
						"\u1EC6": 'E',
						"\u0228": 'E',
						"\u1E1C": 'E',
						"\u0118": 'E',
						"\u1E18": 'E',
						"\u1E1A": 'E',
						"\u0190": 'E',
						"\u018E": 'E',
						"\u24BB": 'F',
						"\uFF26": 'F',
						"\u1E1E": 'F',
						"\u0191": 'F',
						"\uA77B": 'F',
						"\u24BC": 'G',
						"\uFF27": 'G',
						"\u01F4": 'G',
						"\u011C": 'G',
						"\u1E20": 'G',
						"\u011E": 'G',
						"\u0120": 'G',
						"\u01E6": 'G',
						"\u0122": 'G',
						"\u01E4": 'G',
						"\u0193": 'G',
						"\uA7A0": 'G',
						"\uA77D": 'G',
						"\uA77E": 'G',
						"\u24BD": 'H',
						"\uFF28": 'H',
						"\u0124": 'H',
						"\u1E22": 'H',
						"\u1E26": 'H',
						"\u021E": 'H',
						"\u1E24": 'H',
						"\u1E28": 'H',
						"\u1E2A": 'H',
						"\u0126": 'H',
						"\u2C67": 'H',
						"\u2C75": 'H',
						"\uA78D": 'H',
						"\u24BE": 'I',
						"\uFF29": 'I',
						"\xCC": 'I',
						"\xCD": 'I',
						"\xCE": 'I',
						"\u0128": 'I',
						"\u012A": 'I',
						"\u012C": 'I',
						"\u0130": 'I',
						"\xCF": 'I',
						"\u1E2E": 'I',
						"\u1EC8": 'I',
						"\u01CF": 'I',
						"\u0208": 'I',
						"\u020A": 'I',
						"\u1ECA": 'I',
						"\u012E": 'I',
						"\u1E2C": 'I',
						"\u0197": 'I',
						"\u24BF": 'J',
						"\uFF2A": 'J',
						"\u0134": 'J',
						"\u0248": 'J',
						"\u24C0": 'K',
						"\uFF2B": 'K',
						"\u1E30": 'K',
						"\u01E8": 'K',
						"\u1E32": 'K',
						"\u0136": 'K',
						"\u1E34": 'K',
						"\u0198": 'K',
						"\u2C69": 'K',
						"\uA740": 'K',
						"\uA742": 'K',
						"\uA744": 'K',
						"\uA7A2": 'K',
						"\u24C1": 'L',
						"\uFF2C": 'L',
						"\u013F": 'L',
						"\u0139": 'L',
						"\u013D": 'L',
						"\u1E36": 'L',
						"\u1E38": 'L',
						"\u013B": 'L',
						"\u1E3C": 'L',
						"\u1E3A": 'L',
						"\u0141": 'L',
						"\u023D": 'L',
						"\u2C62": 'L',
						"\u2C60": 'L',
						"\uA748": 'L',
						"\uA746": 'L',
						"\uA780": 'L',
						"\u01C7": 'LJ',
						"\u01C8": 'Lj',
						"\u24C2": 'M',
						"\uFF2D": 'M',
						"\u1E3E": 'M',
						"\u1E40": 'M',
						"\u1E42": 'M',
						"\u2C6E": 'M',
						"\u019C": 'M',
						"\u24C3": 'N',
						"\uFF2E": 'N',
						"\u01F8": 'N',
						"\u0143": 'N',
						"\xD1": 'N',
						"\u1E44": 'N',
						"\u0147": 'N',
						"\u1E46": 'N',
						"\u0145": 'N',
						"\u1E4A": 'N',
						"\u1E48": 'N',
						"\u0220": 'N',
						"\u019D": 'N',
						"\uA790": 'N',
						"\uA7A4": 'N',
						"\u01CA": 'NJ',
						"\u01CB": 'Nj',
						"\u24C4": 'O',
						"\uFF2F": 'O',
						"\xD2": 'O',
						"\xD3": 'O',
						"\xD4": 'O',
						"\u1ED2": 'O',
						"\u1ED0": 'O',
						"\u1ED6": 'O',
						"\u1ED4": 'O',
						"\xD5": 'O',
						"\u1E4C": 'O',
						"\u022C": 'O',
						"\u1E4E": 'O',
						"\u014C": 'O',
						"\u1E50": 'O',
						"\u1E52": 'O',
						"\u014E": 'O',
						"\u022E": 'O',
						"\u0230": 'O',
						"\xD6": 'O',
						"\u022A": 'O',
						"\u1ECE": 'O',
						"\u0150": 'O',
						"\u01D1": 'O',
						"\u020C": 'O',
						"\u020E": 'O',
						"\u01A0": 'O',
						"\u1EDC": 'O',
						"\u1EDA": 'O',
						"\u1EE0": 'O',
						"\u1EDE": 'O',
						"\u1EE2": 'O',
						"\u1ECC": 'O',
						"\u1ED8": 'O',
						"\u01EA": 'O',
						"\u01EC": 'O',
						"\xD8": 'O',
						"\u01FE": 'O',
						"\u0186": 'O',
						"\u019F": 'O',
						"\uA74A": 'O',
						"\uA74C": 'O',
						"\u0152": 'OE',
						"\u01A2": 'OI',
						"\uA74E": 'OO',
						"\u0222": 'OU',
						"\u24C5": 'P',
						"\uFF30": 'P',
						"\u1E54": 'P',
						"\u1E56": 'P',
						"\u01A4": 'P',
						"\u2C63": 'P',
						"\uA750": 'P',
						"\uA752": 'P',
						"\uA754": 'P',
						"\u24C6": 'Q',
						"\uFF31": 'Q',
						"\uA756": 'Q',
						"\uA758": 'Q',
						"\u024A": 'Q',
						"\u24C7": 'R',
						"\uFF32": 'R',
						"\u0154": 'R',
						"\u1E58": 'R',
						"\u0158": 'R',
						"\u0210": 'R',
						"\u0212": 'R',
						"\u1E5A": 'R',
						"\u1E5C": 'R',
						"\u0156": 'R',
						"\u1E5E": 'R',
						"\u024C": 'R',
						"\u2C64": 'R',
						"\uA75A": 'R',
						"\uA7A6": 'R',
						"\uA782": 'R',
						"\u24C8": 'S',
						"\uFF33": 'S',
						"\u1E9E": 'S',
						"\u015A": 'S',
						"\u1E64": 'S',
						"\u015C": 'S',
						"\u1E60": 'S',
						"\u0160": 'S',
						"\u1E66": 'S',
						"\u1E62": 'S',
						"\u1E68": 'S',
						"\u0218": 'S',
						"\u015E": 'S',
						"\u2C7E": 'S',
						"\uA7A8": 'S',
						"\uA784": 'S',
						"\u24C9": 'T',
						"\uFF34": 'T',
						"\u1E6A": 'T',
						"\u0164": 'T',
						"\u1E6C": 'T',
						"\u021A": 'T',
						"\u0162": 'T',
						"\u1E70": 'T',
						"\u1E6E": 'T',
						"\u0166": 'T',
						"\u01AC": 'T',
						"\u01AE": 'T',
						"\u023E": 'T',
						"\uA786": 'T',
						"\uA728": 'TZ',
						"\u24CA": 'U',
						"\uFF35": 'U',
						"\xD9": 'U',
						"\xDA": 'U',
						"\xDB": 'U',
						"\u0168": 'U',
						"\u1E78": 'U',
						"\u016A": 'U',
						"\u1E7A": 'U',
						"\u016C": 'U',
						"\xDC": 'U',
						"\u01DB": 'U',
						"\u01D7": 'U',
						"\u01D5": 'U',
						"\u01D9": 'U',
						"\u1EE6": 'U',
						"\u016E": 'U',
						"\u0170": 'U',
						"\u01D3": 'U',
						"\u0214": 'U',
						"\u0216": 'U',
						"\u01AF": 'U',
						"\u1EEA": 'U',
						"\u1EE8": 'U',
						"\u1EEE": 'U',
						"\u1EEC": 'U',
						"\u1EF0": 'U',
						"\u1EE4": 'U',
						"\u1E72": 'U',
						"\u0172": 'U',
						"\u1E76": 'U',
						"\u1E74": 'U',
						"\u0244": 'U',
						"\u24CB": 'V',
						"\uFF36": 'V',
						"\u1E7C": 'V',
						"\u1E7E": 'V',
						"\u01B2": 'V',
						"\uA75E": 'V',
						"\u0245": 'V',
						"\uA760": 'VY',
						"\u24CC": 'W',
						"\uFF37": 'W',
						"\u1E80": 'W',
						"\u1E82": 'W',
						"\u0174": 'W',
						"\u1E86": 'W',
						"\u1E84": 'W',
						"\u1E88": 'W',
						"\u2C72": 'W',
						"\u24CD": 'X',
						"\uFF38": 'X',
						"\u1E8A": 'X',
						"\u1E8C": 'X',
						"\u24CE": 'Y',
						"\uFF39": 'Y',
						"\u1EF2": 'Y',
						"\xDD": 'Y',
						"\u0176": 'Y',
						"\u1EF8": 'Y',
						"\u0232": 'Y',
						"\u1E8E": 'Y',
						"\u0178": 'Y',
						"\u1EF6": 'Y',
						"\u1EF4": 'Y',
						"\u01B3": 'Y',
						"\u024E": 'Y',
						"\u1EFE": 'Y',
						"\u24CF": 'Z',
						"\uFF3A": 'Z',
						"\u0179": 'Z',
						"\u1E90": 'Z',
						"\u017B": 'Z',
						"\u017D": 'Z',
						"\u1E92": 'Z',
						"\u1E94": 'Z',
						"\u01B5": 'Z',
						"\u0224": 'Z',
						"\u2C7F": 'Z',
						"\u2C6B": 'Z',
						"\uA762": 'Z',
						"\u24D0": 'a',
						"\uFF41": 'a',
						"\u1E9A": 'a',
						"\xE0": 'a',
						"\xE1": 'a',
						"\xE2": 'a',
						"\u1EA7": 'a',
						"\u1EA5": 'a',
						"\u1EAB": 'a',
						"\u1EA9": 'a',
						"\xE3": 'a',
						"\u0101": 'a',
						"\u0103": 'a',
						"\u1EB1": 'a',
						"\u1EAF": 'a',
						"\u1EB5": 'a',
						"\u1EB3": 'a',
						"\u0227": 'a',
						"\u01E1": 'a',
						"\xE4": 'a',
						"\u01DF": 'a',
						"\u1EA3": 'a',
						"\xE5": 'a',
						"\u01FB": 'a',
						"\u01CE": 'a',
						"\u0201": 'a',
						"\u0203": 'a',
						"\u1EA1": 'a',
						"\u1EAD": 'a',
						"\u1EB7": 'a',
						"\u1E01": 'a',
						"\u0105": 'a',
						"\u2C65": 'a',
						"\u0250": 'a',
						"\uA733": 'aa',
						"\xE6": 'ae',
						"\u01FD": 'ae',
						"\u01E3": 'ae',
						"\uA735": 'ao',
						"\uA737": 'au',
						"\uA739": 'av',
						"\uA73B": 'av',
						"\uA73D": 'ay',
						"\u24D1": 'b',
						"\uFF42": 'b',
						"\u1E03": 'b',
						"\u1E05": 'b',
						"\u1E07": 'b',
						"\u0180": 'b',
						"\u0183": 'b',
						"\u0253": 'b',
						"\u24D2": 'c',
						"\uFF43": 'c',
						"\u0107": 'c',
						"\u0109": 'c',
						"\u010B": 'c',
						"\u010D": 'c',
						"\xE7": 'c',
						"\u1E09": 'c',
						"\u0188": 'c',
						"\u023C": 'c',
						"\uA73F": 'c',
						"\u2184": 'c',
						"\u24D3": 'd',
						"\uFF44": 'd',
						"\u1E0B": 'd',
						"\u010F": 'd',
						"\u1E0D": 'd',
						"\u1E11": 'd',
						"\u1E13": 'd',
						"\u1E0F": 'd',
						"\u0111": 'd',
						"\u018C": 'd',
						"\u0256": 'd',
						"\u0257": 'd',
						"\uA77A": 'd',
						"\u01F3": 'dz',
						"\u01C6": 'dz',
						"\u24D4": 'e',
						"\uFF45": 'e',
						"\xE8": 'e',
						"\xE9": 'e',
						"\xEA": 'e',
						"\u1EC1": 'e',
						"\u1EBF": 'e',
						"\u1EC5": 'e',
						"\u1EC3": 'e',
						"\u1EBD": 'e',
						"\u0113": 'e',
						"\u1E15": 'e',
						"\u1E17": 'e',
						"\u0115": 'e',
						"\u0117": 'e',
						"\xEB": 'e',
						"\u1EBB": 'e',
						"\u011B": 'e',
						"\u0205": 'e',
						"\u0207": 'e',
						"\u1EB9": 'e',
						"\u1EC7": 'e',
						"\u0229": 'e',
						"\u1E1D": 'e',
						"\u0119": 'e',
						"\u1E19": 'e',
						"\u1E1B": 'e',
						"\u0247": 'e',
						"\u025B": 'e',
						"\u01DD": 'e',
						"\u24D5": 'f',
						"\uFF46": 'f',
						"\u1E1F": 'f',
						"\u0192": 'f',
						"\uA77C": 'f',
						"\u24D6": 'g',
						"\uFF47": 'g',
						"\u01F5": 'g',
						"\u011D": 'g',
						"\u1E21": 'g',
						"\u011F": 'g',
						"\u0121": 'g',
						"\u01E7": 'g',
						"\u0123": 'g',
						"\u01E5": 'g',
						"\u0260": 'g',
						"\uA7A1": 'g',
						"\u1D79": 'g',
						"\uA77F": 'g',
						"\u24D7": 'h',
						"\uFF48": 'h',
						"\u0125": 'h',
						"\u1E23": 'h',
						"\u1E27": 'h',
						"\u021F": 'h',
						"\u1E25": 'h',
						"\u1E29": 'h',
						"\u1E2B": 'h',
						"\u1E96": 'h',
						"\u0127": 'h',
						"\u2C68": 'h',
						"\u2C76": 'h',
						"\u0265": 'h',
						"\u0195": 'hv',
						"\u24D8": 'i',
						"\uFF49": 'i',
						"\xEC": 'i',
						"\xED": 'i',
						"\xEE": 'i',
						"\u0129": 'i',
						"\u012B": 'i',
						"\u012D": 'i',
						"\xEF": 'i',
						"\u1E2F": 'i',
						"\u1EC9": 'i',
						"\u01D0": 'i',
						"\u0209": 'i',
						"\u020B": 'i',
						"\u1ECB": 'i',
						"\u012F": 'i',
						"\u1E2D": 'i',
						"\u0268": 'i',
						"\u0131": 'i',
						"\u24D9": 'j',
						"\uFF4A": 'j',
						"\u0135": 'j',
						"\u01F0": 'j',
						"\u0249": 'j',
						"\u24DA": 'k',
						"\uFF4B": 'k',
						"\u1E31": 'k',
						"\u01E9": 'k',
						"\u1E33": 'k',
						"\u0137": 'k',
						"\u1E35": 'k',
						"\u0199": 'k',
						"\u2C6A": 'k',
						"\uA741": 'k',
						"\uA743": 'k',
						"\uA745": 'k',
						"\uA7A3": 'k',
						"\u24DB": 'l',
						"\uFF4C": 'l',
						"\u0140": 'l',
						"\u013A": 'l',
						"\u013E": 'l',
						"\u1E37": 'l',
						"\u1E39": 'l',
						"\u013C": 'l',
						"\u1E3D": 'l',
						"\u1E3B": 'l',
						"\u017F": 'l',
						"\u0142": 'l',
						"\u019A": 'l',
						"\u026B": 'l',
						"\u2C61": 'l',
						"\uA749": 'l',
						"\uA781": 'l',
						"\uA747": 'l',
						"\u01C9": 'lj',
						"\u24DC": 'm',
						"\uFF4D": 'm',
						"\u1E3F": 'm',
						"\u1E41": 'm',
						"\u1E43": 'm',
						"\u0271": 'm',
						"\u026F": 'm',
						"\u24DD": 'n',
						"\uFF4E": 'n',
						"\u01F9": 'n',
						"\u0144": 'n',
						"\xF1": 'n',
						"\u1E45": 'n',
						"\u0148": 'n',
						"\u1E47": 'n',
						"\u0146": 'n',
						"\u1E4B": 'n',
						"\u1E49": 'n',
						"\u019E": 'n',
						"\u0272": 'n',
						"\u0149": 'n',
						"\uA791": 'n',
						"\uA7A5": 'n',
						"\u01CC": 'nj',
						"\u24DE": 'o',
						"\uFF4F": 'o',
						"\xF2": 'o',
						"\xF3": 'o',
						"\xF4": 'o',
						"\u1ED3": 'o',
						"\u1ED1": 'o',
						"\u1ED7": 'o',
						"\u1ED5": 'o',
						"\xF5": 'o',
						"\u1E4D": 'o',
						"\u022D": 'o',
						"\u1E4F": 'o',
						"\u014D": 'o',
						"\u1E51": 'o',
						"\u1E53": 'o',
						"\u014F": 'o',
						"\u022F": 'o',
						"\u0231": 'o',
						"\xF6": 'o',
						"\u022B": 'o',
						"\u1ECF": 'o',
						"\u0151": 'o',
						"\u01D2": 'o',
						"\u020D": 'o',
						"\u020F": 'o',
						"\u01A1": 'o',
						"\u1EDD": 'o',
						"\u1EDB": 'o',
						"\u1EE1": 'o',
						"\u1EDF": 'o',
						"\u1EE3": 'o',
						"\u1ECD": 'o',
						"\u1ED9": 'o',
						"\u01EB": 'o',
						"\u01ED": 'o',
						"\xF8": 'o',
						"\u01FF": 'o',
						"\u0254": 'o',
						"\uA74B": 'o',
						"\uA74D": 'o',
						"\u0275": 'o',
						"\u0153": 'oe',
						"\u01A3": 'oi',
						"\u0223": 'ou',
						"\uA74F": 'oo',
						"\u24DF": 'p',
						"\uFF50": 'p',
						"\u1E55": 'p',
						"\u1E57": 'p',
						"\u01A5": 'p',
						"\u1D7D": 'p',
						"\uA751": 'p',
						"\uA753": 'p',
						"\uA755": 'p',
						"\u24E0": 'q',
						"\uFF51": 'q',
						"\u024B": 'q',
						"\uA757": 'q',
						"\uA759": 'q',
						"\u24E1": 'r',
						"\uFF52": 'r',
						"\u0155": 'r',
						"\u1E59": 'r',
						"\u0159": 'r',
						"\u0211": 'r',
						"\u0213": 'r',
						"\u1E5B": 'r',
						"\u1E5D": 'r',
						"\u0157": 'r',
						"\u1E5F": 'r',
						"\u024D": 'r',
						"\u027D": 'r',
						"\uA75B": 'r',
						"\uA7A7": 'r',
						"\uA783": 'r',
						"\u24E2": 's',
						"\uFF53": 's',
						"\xDF": 's',
						"\u015B": 's',
						"\u1E65": 's',
						"\u015D": 's',
						"\u1E61": 's',
						"\u0161": 's',
						"\u1E67": 's',
						"\u1E63": 's',
						"\u1E69": 's',
						"\u0219": 's',
						"\u015F": 's',
						"\u023F": 's',
						"\uA7A9": 's',
						"\uA785": 's',
						"\u1E9B": 's',
						"\u24E3": 't',
						"\uFF54": 't',
						"\u1E6B": 't',
						"\u1E97": 't',
						"\u0165": 't',
						"\u1E6D": 't',
						"\u021B": 't',
						"\u0163": 't',
						"\u1E71": 't',
						"\u1E6F": 't',
						"\u0167": 't',
						"\u01AD": 't',
						"\u0288": 't',
						"\u2C66": 't',
						"\uA787": 't',
						"\uA729": 'tz',
						"\u24E4": 'u',
						"\uFF55": 'u',
						"\xF9": 'u',
						"\xFA": 'u',
						"\xFB": 'u',
						"\u0169": 'u',
						"\u1E79": 'u',
						"\u016B": 'u',
						"\u1E7B": 'u',
						"\u016D": 'u',
						"\xFC": 'u',
						"\u01DC": 'u',
						"\u01D8": 'u',
						"\u01D6": 'u',
						"\u01DA": 'u',
						"\u1EE7": 'u',
						"\u016F": 'u',
						"\u0171": 'u',
						"\u01D4": 'u',
						"\u0215": 'u',
						"\u0217": 'u',
						"\u01B0": 'u',
						"\u1EEB": 'u',
						"\u1EE9": 'u',
						"\u1EEF": 'u',
						"\u1EED": 'u',
						"\u1EF1": 'u',
						"\u1EE5": 'u',
						"\u1E73": 'u',
						"\u0173": 'u',
						"\u1E77": 'u',
						"\u1E75": 'u',
						"\u0289": 'u',
						"\u24E5": 'v',
						"\uFF56": 'v',
						"\u1E7D": 'v',
						"\u1E7F": 'v',
						"\u028B": 'v',
						"\uA75F": 'v',
						"\u028C": 'v',
						"\uA761": 'vy',
						"\u24E6": 'w',
						"\uFF57": 'w',
						"\u1E81": 'w',
						"\u1E83": 'w',
						"\u0175": 'w',
						"\u1E87": 'w',
						"\u1E85": 'w',
						"\u1E98": 'w',
						"\u1E89": 'w',
						"\u2C73": 'w',
						"\u24E7": 'x',
						"\uFF58": 'x',
						"\u1E8B": 'x',
						"\u1E8D": 'x',
						"\u24E8": 'y',
						"\uFF59": 'y',
						"\u1EF3": 'y',
						"\xFD": 'y',
						"\u0177": 'y',
						"\u1EF9": 'y',
						"\u0233": 'y',
						"\u1E8F": 'y',
						"\xFF": 'y',
						"\u1EF7": 'y',
						"\u1E99": 'y',
						"\u1EF5": 'y',
						"\u01B4": 'y',
						"\u024F": 'y',
						"\u1EFF": 'y',
						"\u24E9": 'z',
						"\uFF5A": 'z',
						"\u017A": 'z',
						"\u1E91": 'z',
						"\u017C": 'z',
						"\u017E": 'z',
						"\u1E93": 'z',
						"\u1E95": 'z',
						"\u01B6": 'z',
						"\u0225": 'z',
						"\u0240": 'z',
						"\u2C6C": 'z',
						"\uA763": 'z',
						"\u0386": "\u0391",
						"\u0388": "\u0395",
						"\u0389": "\u0397",
						"\u038A": "\u0399",
						"\u03AA": "\u0399",
						"\u038C": "\u039F",
						"\u038E": "\u03A5",
						"\u03AB": "\u03A5",
						"\u038F": "\u03A9",
						"\u03AC": "\u03B1",
						"\u03AD": "\u03B5",
						"\u03AE": "\u03B7",
						"\u03AF": "\u03B9",
						"\u03CA": "\u03B9",
						"\u0390": "\u03B9",
						"\u03CC": "\u03BF",
						"\u03CD": "\u03C5",
						"\u03CB": "\u03C5",
						"\u03B0": "\u03C5",
						"\u03CE": "\u03C9",
						"\u03C2": "\u03C3",
						"\u2019": '\''
					};

					return diacritics;
				});

				S2.define('select2/data/base', ['../utils'], function (Utils) {
					function BaseAdapter($element, options) {
						BaseAdapter.__super__.constructor.call(this);
					}

					Utils.Extend(BaseAdapter, Utils.Observable);

					BaseAdapter.prototype.current = function (callback) {
						throw new Error('The `current` method must be defined in child classes.');
					};

					BaseAdapter.prototype.query = function (params, callback) {
						throw new Error('The `query` method must be defined in child classes.');
					};

					BaseAdapter.prototype.bind = function (container, $container) {
						// Can be implemented in subclasses
					};

					BaseAdapter.prototype.destroy = function () {
						// Can be implemented in subclasses
					};

					BaseAdapter.prototype.generateResultId = function (container, data) {
						var id = container.id + '-result-';

						id += Utils.generateChars(4);

						if (data.id != null) {
							id += '-' + data.id.toString();
						} else {
							id += '-' + Utils.generateChars(4);
						}
						return id;
					};

					return BaseAdapter;
				});

				S2.define('select2/data/select', ['./base', '../utils', 'jquery'], function (BaseAdapter, Utils, $) {
					function SelectAdapter($element, options) {
						this.$element = $element;
						this.options = options;

						SelectAdapter.__super__.constructor.call(this);
					}

					Utils.Extend(SelectAdapter, BaseAdapter);

					SelectAdapter.prototype.current = function (callback) {
						var data = [];
						var self = this;

						this.$element.find(':selected').each(function () {
							var $option = $(this);

							var option = self.item($option);

							data.push(option);
						});

						callback(data);
					};

					SelectAdapter.prototype.select = function (data) {
						var self = this;

						data.selected = true;

						// If data.element is a DOM node, use it instead
						if ($(data.element).is('option')) {
							data.element.selected = true;

							this.$element.trigger('input').trigger('change');

							return;
						}

						if (this.$element.prop('multiple')) {
							this.current(function (currentData) {
								var val = [];

								data = [data];
								data.push.apply(data, currentData);

								for (var d = 0; d < data.length; d++) {
									var id = data[d].id;

									if ($.inArray(id, val) === -1) {
										val.push(id);
									}
								}

								self.$element.val(val);
								self.$element.trigger('input').trigger('change');
							});
						} else {
							var val = data.id;

							this.$element.val(val);
							this.$element.trigger('input').trigger('change');
						}
					};

					SelectAdapter.prototype.unselect = function (data) {
						var self = this;

						if (!this.$element.prop('multiple')) {
							return;
						}

						data.selected = false;

						if ($(data.element).is('option')) {
							data.element.selected = false;

							this.$element.trigger('input').trigger('change');

							return;
						}

						this.current(function (currentData) {
							var val = [];

							for (var d = 0; d < currentData.length; d++) {
								var id = currentData[d].id;

								if (id !== data.id && $.inArray(id, val) === -1) {
									val.push(id);
								}
							}

							self.$element.val(val);

							self.$element.trigger('input').trigger('change');
						});
					};

					SelectAdapter.prototype.bind = function (container, $container) {
						var self = this;

						this.container = container;

						container.on('select', function (params) {
							self.select(params.data);
						});

						container.on('unselect', function (params) {
							self.unselect(params.data);
						});
					};

					SelectAdapter.prototype.destroy = function () {
						// Remove anything added to child elements
						this.$element.find('*').each(function () {
							// Remove any custom data set by Select2
							Utils.RemoveData(this);
						});
					};

					SelectAdapter.prototype.query = function (params, callback) {
						var data = [];
						var self = this;

						var $options = this.$element.children();

						$options.each(function () {
							var $option = $(this);

							if (!$option.is('option') && !$option.is('optgroup')) {
								return;
							}

							var option = self.item($option);

							var matches = self.matches(params, option);

							if (matches !== null) {
								data.push(matches);
							}
						});

						callback({
							results: data
						});
					};

					SelectAdapter.prototype.addOptions = function ($options) {
						Utils.appendMany(this.$element, $options);
					};

					SelectAdapter.prototype.option = function (data) {
						var option;

						if (data.children) {
							option = document.createElement('optgroup');
							option.label = data.text;
						} else {
							option = document.createElement('option');

							if (option.textContent !== undefined) {
								option.textContent = data.text;
							} else {
								option.innerText = data.text;
							}
						}

						if (data.id !== undefined) {
							option.value = data.id;
						}

						if (data.disabled) {
							option.disabled = true;
						}

						if (data.selected) {
							option.selected = true;
						}

						if (data.title) {
							option.title = data.title;
						}

						var $option = $(option);

						var normalizedData = this._normalizeItem(data);
						normalizedData.element = option;

						// Override the option's data with the combined data
						Utils.StoreData(option, 'data', normalizedData);

						return $option;
					};

					SelectAdapter.prototype.item = function ($option) {
						var data = {};

						data = Utils.GetData($option[0], 'data');

						if (data != null) {
							return data;
						}

						if ($option.is('option')) {
							data = {
								id: $option.val(),
								text: $option.text(),
								disabled: $option.prop('disabled'),
								selected: $option.prop('selected'),
								title: $option.prop('title')
							};
						} else if ($option.is('optgroup')) {
							data = {
								text: $option.prop('label'),
								children: [],
								title: $option.prop('title')
							};

							var $children = $option.children('option');
							var children = [];

							for (var c = 0; c < $children.length; c++) {
								var $child = $($children[c]);

								var child = this.item($child);

								children.push(child);
							}

							data.children = children;
						}

						data = this._normalizeItem(data);
						data.element = $option[0];

						Utils.StoreData($option[0], 'data', data);

						return data;
					};

					SelectAdapter.prototype._normalizeItem = function (item) {
						if (item !== Object(item)) {
							item = {
								id: item,
								text: item
							};
						}

						item = $.extend({}, {
							text: ''
						}, item);

						var defaults = {
							selected: false,
							disabled: false
						};

						if (item.id != null) {
							item.id = item.id.toString();
						}

						if (item.text != null) {
							item.text = item.text.toString();
						}

						if (item._resultId == null && item.id && this.container != null) {
							item._resultId = this.generateResultId(this.container, item);
						}

						return $.extend({}, defaults, item);
					};

					SelectAdapter.prototype.matches = function (params, data) {
						var matcher = this.options.get('matcher');

						return matcher(params, data);
					};

					return SelectAdapter;
				});

				S2.define('select2/data/array', ['./select', '../utils', 'jquery'], function (SelectAdapter, Utils, $) {
					function ArrayAdapter($element, options) {
						this._dataToConvert = options.get('data') || [];

						ArrayAdapter.__super__.constructor.call(this, $element, options);
					}

					Utils.Extend(ArrayAdapter, SelectAdapter);

					ArrayAdapter.prototype.bind = function (container, $container) {
						ArrayAdapter.__super__.bind.call(this, container, $container);

						this.addOptions(this.convertToOptions(this._dataToConvert));
					};

					ArrayAdapter.prototype.select = function (data) {
						var $option = this.$element.find('option').filter(function (i, elm) {
							return elm.value == data.id.toString();
						});

						if ($option.length === 0) {
							$option = this.option(data);

							this.addOptions($option);
						}

						ArrayAdapter.__super__.select.call(this, data);
					};

					ArrayAdapter.prototype.convertToOptions = function (data) {
						var self = this;

						var $existing = this.$element.find('option');
						var existingIds = $existing.map(function () {
							return self.item($(this)).id;
						}).get();

						var $options = [];

						// Filter out all items except for the one passed in the argument
						function onlyItem(item) {
							return function () {
								return $(this).val() == item.id;
							};
						}

						for (var d = 0; d < data.length; d++) {
							var item = this._normalizeItem(data[d]);

							// Skip items which were pre-loaded, only merge the data
							if ($.inArray(item.id, existingIds) >= 0) {
								var $existingOption = $existing.filter(onlyItem(item));

								var existingData = this.item($existingOption);
								var newData = $.extend(true, {}, item, existingData);

								var $newOption = this.option(newData);

								$existingOption.replaceWith($newOption);

								continue;
							}

							var $option = this.option(item);

							if (item.children) {
								var $children = this.convertToOptions(item.children);

								Utils.appendMany($option, $children);
							}

							$options.push($option);
						}

						return $options;
					};

					return ArrayAdapter;
				});

				S2.define('select2/data/ajax', ['./array', '../utils', 'jquery'], function (ArrayAdapter, Utils, $) {
					function AjaxAdapter($element, options) {
						this.ajaxOptions = this._applyDefaults(options.get('ajax'));

						if (this.ajaxOptions.processResults != null) {
							this.processResults = this.ajaxOptions.processResults;
						}

						AjaxAdapter.__super__.constructor.call(this, $element, options);
					}

					Utils.Extend(AjaxAdapter, ArrayAdapter);

					AjaxAdapter.prototype._applyDefaults = function (options) {
						var defaults = {
							data: function data(params) {
								return $.extend({}, params, {
									q: params.term
								});
							},
							transport: function transport(params, success, failure) {
								var $request = $.ajax(params);

								$request.then(success);
								$request.fail(failure);

								return $request;
							}
						};

						return $.extend({}, defaults, options, true);
					};

					AjaxAdapter.prototype.processResults = function (results) {
						return results;
					};

					AjaxAdapter.prototype.query = function (params, callback) {
						var matches = [];
						var self = this;

						if (this._request != null) {
							// JSONP requests cannot always be aborted
							if ($.isFunction(this._request.abort)) {
								this._request.abort();
							}

							this._request = null;
						}

						var options = $.extend({
							type: 'GET'
						}, this.ajaxOptions);

						if (typeof options.url === 'function') {
							options.url = options.url.call(this.$element, params);
						}

						if (typeof options.data === 'function') {
							options.data = options.data.call(this.$element, params);
						}

						function request() {
							var $request = options.transport(options, function (data) {
								var results = self.processResults(data, params);

								if (self.options.get('debug') && window.console && console.error) {
									// Check to make sure that the response included a `results` key.
									if (!results || !results.results || !$.isArray(results.results)) {
										console.error('Select2: The AJAX results did not return an array in the ' + '`results` key of the response.');
									}
								}

								callback(results);
							}, function () {
								// Attempt to detect if a request was aborted
								// Only works if the transport exposes a status property
								if ('status' in $request && ($request.status === 0 || $request.status === '0')) {
									return;
								}

								self.trigger('results:message', {
									message: 'errorLoading'
								});
							});

							self._request = $request;
						}

						if (this.ajaxOptions.delay && params.term != null) {
							if (this._queryTimeout) {
								window.clearTimeout(this._queryTimeout);
							}

							this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
						} else {
							request();
						}
					};

					return AjaxAdapter;
				});

				S2.define('select2/data/tags', ['jquery'], function ($) {
					function Tags(decorated, $element, options) {
						var tags = options.get('tags');

						var createTag = options.get('createTag');

						if (createTag !== undefined) {
							this.createTag = createTag;
						}

						var insertTag = options.get('insertTag');

						if (insertTag !== undefined) {
							this.insertTag = insertTag;
						}

						decorated.call(this, $element, options);

						if ($.isArray(tags)) {
							for (var t = 0; t < tags.length; t++) {
								var tag = tags[t];
								var item = this._normalizeItem(tag);

								var $option = this.option(item);

								this.$element.append($option);
							}
						}
					}

					Tags.prototype.query = function (decorated, params, callback) {
						var self = this;

						this._removeOldTags();

						if (params.term == null || params.page != null) {
							decorated.call(this, params, callback);
							return;
						}

						function wrapper(obj, child) {
							var data = obj.results;

							for (var i = 0; i < data.length; i++) {
								var option = data[i];

								var checkChildren = option.children != null && !wrapper({
									results: option.children
								}, true);

								var optionText = (option.text || '').toUpperCase();
								var paramsTerm = (params.term || '').toUpperCase();

								var checkText = optionText === paramsTerm;

								if (checkText || checkChildren) {
									if (child) {
										return false;
									}

									obj.data = data;
									callback(obj);

									return;
								}
							}

							if (child) {
								return true;
							}

							var tag = self.createTag(params);

							if (tag != null) {
								var $option = self.option(tag);
								$option.attr('data-select2-tag', true);

								self.addOptions([$option]);

								self.insertTag(data, tag);
							}

							obj.results = data;

							callback(obj);
						}

						decorated.call(this, params, wrapper);
					};

					Tags.prototype.createTag = function (decorated, params) {
						var term = $.trim(params.term);

						if (term === '') {
							return null;
						}

						return {
							id: term,
							text: term
						};
					};

					Tags.prototype.insertTag = function (_, data, tag) {
						data.unshift(tag);
					};

					Tags.prototype._removeOldTags = function (_) {
						var $options = this.$element.find('option[data-select2-tag]');

						$options.each(function () {
							if (this.selected) {
								return;
							}

							$(this).remove();
						});
					};

					return Tags;
				});

				S2.define('select2/data/tokenizer', ['jquery'], function ($) {
					function Tokenizer(decorated, $element, options) {
						var tokenizer = options.get('tokenizer');

						if (tokenizer !== undefined) {
							this.tokenizer = tokenizer;
						}

						decorated.call(this, $element, options);
					}

					Tokenizer.prototype.bind = function (decorated, container, $container) {
						decorated.call(this, container, $container);

						this.$search = container.dropdown.$search || container.selection.$search || $container.find('.select2-search__field');
					};

					Tokenizer.prototype.query = function (decorated, params, callback) {
						var self = this;

						function createAndSelect(data) {
							// Normalize the data object so we can use it for checks
							var item = self._normalizeItem(data);

							// Check if the data object already exists as a tag
							// Select it if it doesn't
							var $existingOptions = self.$element.find('option').filter(function () {
								return $(this).val() === item.id;
							});

							// If an existing option wasn't found for it, create the option
							if (!$existingOptions.length) {
								var $option = self.option(item);
								$option.attr('data-select2-tag', true);

								self._removeOldTags();
								self.addOptions([$option]);
							}

							// Select the item, now that we know there is an option for it
							select(item);
						}

						function select(data) {
							self.trigger('select', {
								data: data
							});
						}

						params.term = params.term || '';

						var tokenData = this.tokenizer(params, this.options, createAndSelect);

						if (tokenData.term !== params.term) {
							// Replace the search term if we have the search box
							if (this.$search.length) {
								this.$search.val(tokenData.term);
								this.$search.trigger('focus');
							}

							params.term = tokenData.term;
						}

						decorated.call(this, params, callback);
					};

					Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
						var separators = options.get('tokenSeparators') || [];
						var term = params.term;
						var i = 0;

						var createTag = this.createTag || function (params) {
							return {
								id: params.term,
								text: params.term
							};
						};

						while (i < term.length) {
							var termChar = term[i];

							if ($.inArray(termChar, separators) === -1) {
								i++;

								continue;
							}

							var part = term.substr(0, i);
							var partParams = $.extend({}, params, {
								term: part
							});

							var data = createTag(partParams);

							if (data == null) {
								i++;
								continue;
							}

							callback(data);

							// Reset the term to not include the tokenized portion
							term = term.substr(i + 1) || '';
							i = 0;
						}

						return {
							term: term
						};
					};

					return Tokenizer;
				});

				S2.define('select2/data/minimumInputLength', [], function () {
					function MinimumInputLength(decorated, $e, options) {
						this.minimumInputLength = options.get('minimumInputLength');

						decorated.call(this, $e, options);
					}

					MinimumInputLength.prototype.query = function (decorated, params, callback) {
						params.term = params.term || '';

						if (params.term.length < this.minimumInputLength) {
							this.trigger('results:message', {
								message: 'inputTooShort',
								args: {
									minimum: this.minimumInputLength,
									input: params.term,
									params: params
								}
							});

							return;
						}

						decorated.call(this, params, callback);
					};

					return MinimumInputLength;
				});

				S2.define('select2/data/maximumInputLength', [], function () {
					function MaximumInputLength(decorated, $e, options) {
						this.maximumInputLength = options.get('maximumInputLength');

						decorated.call(this, $e, options);
					}

					MaximumInputLength.prototype.query = function (decorated, params, callback) {
						params.term = params.term || '';

						if (this.maximumInputLength > 0 && params.term.length > this.maximumInputLength) {
							this.trigger('results:message', {
								message: 'inputTooLong',
								args: {
									maximum: this.maximumInputLength,
									input: params.term,
									params: params
								}
							});

							return;
						}

						decorated.call(this, params, callback);
					};

					return MaximumInputLength;
				});

				S2.define('select2/data/maximumSelectionLength', [], function () {
					function MaximumSelectionLength(decorated, $e, options) {
						this.maximumSelectionLength = options.get('maximumSelectionLength');

						decorated.call(this, $e, options);
					}

					MaximumSelectionLength.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						container.on('select', function () {
							self._checkIfMaximumSelected();
						});
					};

					MaximumSelectionLength.prototype.query = function (decorated, params, callback) {
						var self = this;

						this._checkIfMaximumSelected(function () {
							decorated.call(self, params, callback);
						});
					};

					MaximumSelectionLength.prototype._checkIfMaximumSelected = function (_, successCallback) {
						var self = this;

						this.current(function (currentData) {
							var count = currentData != null ? currentData.length : 0;
							if (self.maximumSelectionLength > 0 && count >= self.maximumSelectionLength) {
								self.trigger('results:message', {
									message: 'maximumSelected',
									args: {
										maximum: self.maximumSelectionLength
									}
								});
								return;
							}

							if (successCallback) {
								successCallback();
							}
						});
					};

					return MaximumSelectionLength;
				});

				S2.define('select2/dropdown', ['jquery', './utils'], function ($, Utils) {
					function Dropdown($element, options) {
						this.$element = $element;
						this.options = options;

						Dropdown.__super__.constructor.call(this);
					}

					Utils.Extend(Dropdown, Utils.Observable);

					Dropdown.prototype.render = function () {
						var $dropdown = $('<span class="select2-dropdown">' + '<span class="select2-results"></span>' + '</span>');

						$dropdown.attr('dir', this.options.get('dir'));

						this.$dropdown = $dropdown;

						return $dropdown;
					};

					Dropdown.prototype.bind = function () {
						// Should be implemented in subclasses
					};

					Dropdown.prototype.position = function ($dropdown, $container) {
						// Should be implemented in subclasses
					};

					Dropdown.prototype.destroy = function () {
						// Remove the dropdown from the DOM
						this.$dropdown.remove();
					};

					return Dropdown;
				});

				S2.define('select2/dropdown/search', ['jquery', '../utils'], function ($, Utils) {
					function Search() {}

					Search.prototype.render = function (decorated) {
						var $rendered = decorated.call(this);

						var $search = $('<span class="select2-search select2-search--dropdown">' + '<input class="select2-search__field" type="search" tabindex="-1"' + ' autocomplete="off" autocorrect="off" autocapitalize="none"' + ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' + '</span>');

						this.$searchContainer = $search;
						this.$search = $search.find('input');

						$rendered.prepend($search);

						return $rendered;
					};

					Search.prototype.bind = function (decorated, container, $container) {
						var self = this;

						var resultsId = container.id + '-results';

						decorated.call(this, container, $container);

						this.$search.on('keydown', function (evt) {
							self.trigger('keypress', evt);

							self._keyUpPrevented = evt.isDefaultPrevented();
						});

						// Workaround for browsers which do not support the `input` event
						// This will prevent double-triggering of events for browsers which support
						// both the `keyup` and `input` events.
						this.$search.on('input', function (evt) {
							// Unbind the duplicated `keyup` event
							$(this).off('keyup');
						});

						this.$search.on('keyup input', function (evt) {
							self.handleSearch(evt);
						});

						container.on('open', function () {
							self.$search.attr('tabindex', 0);
							self.$search.attr('aria-controls', resultsId);

							self.$search.trigger('focus');

							window.setTimeout(function () {
								self.$search.trigger('focus');
							}, 0);
						});

						container.on('close', function () {
							self.$search.attr('tabindex', -1);
							self.$search.removeAttr('aria-controls');
							self.$search.removeAttr('aria-activedescendant');

							self.$search.val('');
							self.$search.trigger('blur');
						});

						container.on('focus', function () {
							if (!container.isOpen()) {
								self.$search.trigger('focus');
							}
						});

						container.on('results:all', function (params) {
							if (params.query.term == null || params.query.term === '') {
								var showSearch = self.showSearch(params);

								if (showSearch) {
									self.$searchContainer.removeClass('select2-search--hide');
								} else {
									self.$searchContainer.addClass('select2-search--hide');
								}
							}
						});

						container.on('results:focus', function (params) {
							if (params.data._resultId) {
								self.$search.attr('aria-activedescendant', params.data._resultId);
							} else {
								self.$search.removeAttr('aria-activedescendant');
							}
						});
					};

					Search.prototype.handleSearch = function (evt) {
						if (!this._keyUpPrevented) {
							var input = this.$search.val();

							this.trigger('query', {
								term: input
							});
						}

						this._keyUpPrevented = false;
					};

					Search.prototype.showSearch = function (_, params) {
						return true;
					};

					return Search;
				});

				S2.define('select2/dropdown/hidePlaceholder', [], function () {
					function HidePlaceholder(decorated, $element, options, dataAdapter) {
						this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

						decorated.call(this, $element, options, dataAdapter);
					}

					HidePlaceholder.prototype.append = function (decorated, data) {
						data.results = this.removePlaceholder(data.results);

						decorated.call(this, data);
					};

					HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
						if (typeof placeholder === 'string') {
							placeholder = {
								id: '',
								text: placeholder
							};
						}

						return placeholder;
					};

					HidePlaceholder.prototype.removePlaceholder = function (_, data) {
						var modifiedData = data.slice(0);

						for (var d = data.length - 1; d >= 0; d--) {
							var item = data[d];

							if (this.placeholder.id === item.id) {
								modifiedData.splice(d, 1);
							}
						}

						return modifiedData;
					};

					return HidePlaceholder;
				});

				S2.define('select2/dropdown/infiniteScroll', ['jquery'], function ($) {
					function InfiniteScroll(decorated, $element, options, dataAdapter) {
						this.lastParams = {};

						decorated.call(this, $element, options, dataAdapter);

						this.$loadingMore = this.createLoadingMore();
						this.loading = false;
					}

					InfiniteScroll.prototype.append = function (decorated, data) {
						this.$loadingMore.remove();
						this.loading = false;

						decorated.call(this, data);

						if (this.showLoadingMore(data)) {
							this.$results.append(this.$loadingMore);
							this.loadMoreIfNeeded();
						}
					};

					InfiniteScroll.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						container.on('query', function (params) {
							self.lastParams = params;
							self.loading = true;
						});

						container.on('query:append', function (params) {
							self.lastParams = params;
							self.loading = true;
						});

						this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
					};

					InfiniteScroll.prototype.loadMoreIfNeeded = function () {
						var isLoadMoreVisible = $.contains(document.documentElement, this.$loadingMore[0]);

						if (this.loading || !isLoadMoreVisible) {
							return;
						}

						var currentOffset = this.$results.offset().top + this.$results.outerHeight(false);
						var loadingMoreOffset = this.$loadingMore.offset().top + this.$loadingMore.outerHeight(false);

						if (currentOffset + 50 >= loadingMoreOffset) {
							this.loadMore();
						}
					};

					InfiniteScroll.prototype.loadMore = function () {
						this.loading = true;

						var params = $.extend({}, { page: 1 }, this.lastParams);

						params.page++;

						this.trigger('query:append', params);
					};

					InfiniteScroll.prototype.showLoadingMore = function (_, data) {
						return data.pagination && data.pagination.more;
					};

					InfiniteScroll.prototype.createLoadingMore = function () {
						var $option = $('<li ' + 'class="select2-results__option select2-results__option--load-more"' + 'role="option" aria-disabled="true"></li>');

						var message = this.options.get('translations').get('loadingMore');

						$option.html(message(this.lastParams));

						return $option;
					};

					return InfiniteScroll;
				});

				S2.define('select2/dropdown/attachBody', ['jquery', '../utils'], function ($, Utils) {
					function AttachBody(decorated, $element, options) {
						this.$dropdownParent = $(options.get('dropdownParent') || document.body);

						decorated.call(this, $element, options);
					}

					AttachBody.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						container.on('open', function () {
							self._showDropdown();
							self._attachPositioningHandler(container);

							// Must bind after the results handlers to ensure correct sizing
							self._bindContainerResultHandlers(container);
						});

						container.on('close', function () {
							self._hideDropdown();
							self._detachPositioningHandler(container);
						});

						this.$dropdownContainer.on('mousedown', function (evt) {
							evt.stopPropagation();
						});
					};

					AttachBody.prototype.destroy = function (decorated) {
						decorated.call(this);

						this.$dropdownContainer.remove();
					};

					AttachBody.prototype.position = function (decorated, $dropdown, $container) {
						// Clone all of the container classes
						$dropdown.attr('class', $container.attr('class'));

						$dropdown.removeClass('select2');
						$dropdown.addClass('select2-container--open');

						$dropdown.css({
							position: 'absolute',
							top: -999999
						});

						this.$container = $container;
					};

					AttachBody.prototype.render = function (decorated) {
						var $container = $('<span></span>');

						var $dropdown = decorated.call(this);
						$container.append($dropdown);

						this.$dropdownContainer = $container;

						return $container;
					};

					AttachBody.prototype._hideDropdown = function (decorated) {
						this.$dropdownContainer.detach();
					};

					AttachBody.prototype._bindContainerResultHandlers = function (decorated, container) {

						// These should only be bound once
						if (this._containerResultsHandlersBound) {
							return;
						}

						var self = this;

						container.on('results:all', function () {
							self._positionDropdown();
							self._resizeDropdown();
						});

						container.on('results:append', function () {
							self._positionDropdown();
							self._resizeDropdown();
						});

						container.on('results:message', function () {
							self._positionDropdown();
							self._resizeDropdown();
						});

						container.on('select', function () {
							self._positionDropdown();
							self._resizeDropdown();
						});

						container.on('unselect', function () {
							self._positionDropdown();
							self._resizeDropdown();
						});

						this._containerResultsHandlersBound = true;
					};

					AttachBody.prototype._attachPositioningHandler = function (decorated, container) {
						var self = this;

						var scrollEvent = 'scroll.select2.' + container.id;
						var resizeEvent = 'resize.select2.' + container.id;
						var orientationEvent = 'orientationchange.select2.' + container.id;

						var $watchers = this.$container.parents().filter(Utils.hasScroll);
						$watchers.each(function () {
							Utils.StoreData(this, 'select2-scroll-position', {
								x: $(this).scrollLeft(),
								y: $(this).scrollTop()
							});
						});

						$watchers.on(scrollEvent, function (ev) {
							var position = Utils.GetData(this, 'select2-scroll-position');
							$(this).scrollTop(position.y);
						});

						$(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent, function (e) {
							self._positionDropdown();
							self._resizeDropdown();
						});
					};

					AttachBody.prototype._detachPositioningHandler = function (decorated, container) {
						var scrollEvent = 'scroll.select2.' + container.id;
						var resizeEvent = 'resize.select2.' + container.id;
						var orientationEvent = 'orientationchange.select2.' + container.id;

						var $watchers = this.$container.parents().filter(Utils.hasScroll);
						$watchers.off(scrollEvent);

						$(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
					};

					AttachBody.prototype._positionDropdown = function () {
						var $window = $(window);

						var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
						var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

						var newDirection = null;

						var offset = this.$container.offset();

						offset.bottom = offset.top + this.$container.outerHeight(false);

						var container = {
							height: this.$container.outerHeight(false)
						};

						container.top = offset.top;
						container.bottom = offset.top + container.height;

						var dropdown = {
							height: this.$dropdown.outerHeight(false)
						};

						var viewport = {
							top: $window.scrollTop(),
							bottom: $window.scrollTop() + $window.height()
						};

						var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
						var enoughRoomBelow = viewport.bottom > offset.bottom + dropdown.height;

						var css = {
							left: offset.left,
							top: container.bottom
						};

						// Determine what the parent element is to use for calculating the offset
						var $offsetParent = this.$dropdownParent;

						// For statically positioned elements, we need to get the element
						// that is determining the offset
						if ($offsetParent.css('position') === 'static') {
							$offsetParent = $offsetParent.offsetParent();
						}

						var parentOffset = {
							top: 0,
							left: 0
						};

						if ($.contains(document.body, $offsetParent[0]) || $offsetParent[0].isConnected) {
							parentOffset = $offsetParent.offset();
						}

						css.top -= parentOffset.top;
						css.left -= parentOffset.left;

						if (!isCurrentlyAbove && !isCurrentlyBelow) {
							newDirection = 'below';
						}

						if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
							newDirection = 'above';
						} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
							newDirection = 'below';
						}

						if (newDirection == 'above' || isCurrentlyAbove && newDirection !== 'below') {
							css.top = container.top - parentOffset.top - dropdown.height;
						}

						if (newDirection != null) {
							this.$dropdown.removeClass('select2-dropdown--below select2-dropdown--above').addClass('select2-dropdown--' + newDirection);
							this.$container.removeClass('select2-container--below select2-container--above').addClass('select2-container--' + newDirection);
						}

						this.$dropdownContainer.css(css);
					};

					AttachBody.prototype._resizeDropdown = function () {
						var css = {
							width: this.$container.outerWidth(false) + 'px'
						};

						if (this.options.get('dropdownAutoWidth')) {
							css.minWidth = css.width;
							css.position = 'relative';
							css.width = 'auto';
						}

						this.$dropdown.css(css);
					};

					AttachBody.prototype._showDropdown = function (decorated) {
						this.$dropdownContainer.appendTo(this.$dropdownParent);

						this._positionDropdown();
						this._resizeDropdown();
					};

					return AttachBody;
				});

				S2.define('select2/dropdown/minimumResultsForSearch', [], function () {
					function countResults(data) {
						var count = 0;

						for (var d = 0; d < data.length; d++) {
							var item = data[d];

							if (item.children) {
								count += countResults(item.children);
							} else {
								count++;
							}
						}

						return count;
					}

					function MinimumResultsForSearch(decorated, $element, options, dataAdapter) {
						this.minimumResultsForSearch = options.get('minimumResultsForSearch');

						if (this.minimumResultsForSearch < 0) {
							this.minimumResultsForSearch = Infinity;
						}

						decorated.call(this, $element, options, dataAdapter);
					}

					MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
						if (countResults(params.data.results) < this.minimumResultsForSearch) {
							return false;
						}

						return decorated.call(this, params);
					};

					return MinimumResultsForSearch;
				});

				S2.define('select2/dropdown/selectOnClose', ['../utils'], function (Utils) {
					function SelectOnClose() {}

					SelectOnClose.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						container.on('close', function (params) {
							self._handleSelectOnClose(params);
						});
					};

					SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
						if (params && params.originalSelect2Event != null) {
							var event = params.originalSelect2Event;

							// Don't select an item if the close event was triggered from a select or
							// unselect event
							if (event._type === 'select' || event._type === 'unselect') {
								return;
							}
						}

						var $highlightedResults = this.getHighlightedResults();

						// Only select highlighted results
						if ($highlightedResults.length < 1) {
							return;
						}

						var data = Utils.GetData($highlightedResults[0], 'data');

						// Don't re-select already selected resulte
						if (data.element != null && data.element.selected || data.element == null && data.selected) {
							return;
						}

						this.trigger('select', {
							data: data
						});
					};

					return SelectOnClose;
				});

				S2.define('select2/dropdown/closeOnSelect', [], function () {
					function CloseOnSelect() {}

					CloseOnSelect.prototype.bind = function (decorated, container, $container) {
						var self = this;

						decorated.call(this, container, $container);

						container.on('select', function (evt) {
							self._selectTriggered(evt);
						});

						container.on('unselect', function (evt) {
							self._selectTriggered(evt);
						});
					};

					CloseOnSelect.prototype._selectTriggered = function (_, evt) {
						var originalEvent = evt.originalEvent;

						// Don't close if the control key is being held
						if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
							return;
						}

						this.trigger('close', {
							originalEvent: originalEvent,
							originalSelect2Event: evt
						});
					};

					return CloseOnSelect;
				});

				S2.define('select2/i18n/en', [], function () {
					// English
					return {
						errorLoading: function errorLoading() {
							return 'The results could not be loaded.';
						},
						inputTooLong: function inputTooLong(args) {
							var overChars = args.input.length - args.maximum;

							var message = 'Please delete ' + overChars + ' character';

							if (overChars != 1) {
								message += 's';
							}

							return message;
						},
						inputTooShort: function inputTooShort(args) {
							var remainingChars = args.minimum - args.input.length;

							var message = 'Please enter ' + remainingChars + ' or more characters';

							return message;
						},
						loadingMore: function loadingMore() {
							return 'Loading more results…';
						},
						maximumSelected: function maximumSelected(args) {
							var message = 'You can only select ' + args.maximum + ' item';

							if (args.maximum != 1) {
								message += 's';
							}

							return message;
						},
						noResults: function noResults() {
							return 'No results found';
						},
						searching: function searching() {
							return 'Searching…';
						},
						removeAllItems: function removeAllItems() {
							return 'Remove all items';
						}
					};
				});

				S2.define('select2/defaults', ['jquery', 'require', './results', './selection/single', './selection/multiple', './selection/placeholder', './selection/allowClear', './selection/search', './selection/eventRelay', './utils', './translation', './diacritics', './data/select', './data/array', './data/ajax', './data/tags', './data/tokenizer', './data/minimumInputLength', './data/maximumInputLength', './data/maximumSelectionLength', './dropdown', './dropdown/search', './dropdown/hidePlaceholder', './dropdown/infiniteScroll', './dropdown/attachBody', './dropdown/minimumResultsForSearch', './dropdown/selectOnClose', './dropdown/closeOnSelect', './i18n/en'], function ($, require, ResultsList, SingleSelection, MultipleSelection, Placeholder, AllowClear, SelectionSearch, EventRelay, Utils, Translation, DIACRITICS, SelectData, ArrayData, AjaxData, Tags, Tokenizer, MinimumInputLength, MaximumInputLength, MaximumSelectionLength, Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll, AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect, EnglishTranslation) {
					function Defaults() {
						this.reset();
					}

					Defaults.prototype.apply = function (options) {
						options = $.extend(true, {}, this.defaults, options);

						if (options.dataAdapter == null) {
							if (options.ajax != null) {
								options.dataAdapter = AjaxData;
							} else if (options.data != null) {
								options.dataAdapter = ArrayData;
							} else {
								options.dataAdapter = SelectData;
							}

							if (options.minimumInputLength > 0) {
								options.dataAdapter = Utils.Decorate(options.dataAdapter, MinimumInputLength);
							}

							if (options.maximumInputLength > 0) {
								options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumInputLength);
							}

							if (options.maximumSelectionLength > 0) {
								options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumSelectionLength);
							}

							if (options.tags) {
								options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
							}

							if (options.tokenSeparators != null || options.tokenizer != null) {
								options.dataAdapter = Utils.Decorate(options.dataAdapter, Tokenizer);
							}

							if (options.query != null) {
								var Query = require(options.amdBase + 'compat/query');

								options.dataAdapter = Utils.Decorate(options.dataAdapter, Query);
							}

							if (options.initSelection != null) {
								var InitSelection = require(options.amdBase + 'compat/initSelection');

								options.dataAdapter = Utils.Decorate(options.dataAdapter, InitSelection);
							}
						}

						if (options.resultsAdapter == null) {
							options.resultsAdapter = ResultsList;

							if (options.ajax != null) {
								options.resultsAdapter = Utils.Decorate(options.resultsAdapter, InfiniteScroll);
							}

							if (options.placeholder != null) {
								options.resultsAdapter = Utils.Decorate(options.resultsAdapter, HidePlaceholder);
							}

							if (options.selectOnClose) {
								options.resultsAdapter = Utils.Decorate(options.resultsAdapter, SelectOnClose);
							}
						}

						if (options.dropdownAdapter == null) {
							if (options.multiple) {
								options.dropdownAdapter = Dropdown;
							} else {
								var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

								options.dropdownAdapter = SearchableDropdown;
							}

							if (options.minimumResultsForSearch !== 0) {
								options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, MinimumResultsForSearch);
							}

							if (options.closeOnSelect) {
								options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, CloseOnSelect);
							}

							if (options.dropdownCssClass != null || options.dropdownCss != null || options.adaptDropdownCssClass != null) {
								var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');

								options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, DropdownCSS);
							}

							options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, AttachBody);
						}

						if (options.selectionAdapter == null) {
							if (options.multiple) {
								options.selectionAdapter = MultipleSelection;
							} else {
								options.selectionAdapter = SingleSelection;
							}

							// Add the placeholder mixin if a placeholder was specified
							if (options.placeholder != null) {
								options.selectionAdapter = Utils.Decorate(options.selectionAdapter, Placeholder);
							}

							if (options.allowClear) {
								options.selectionAdapter = Utils.Decorate(options.selectionAdapter, AllowClear);
							}

							if (options.multiple) {
								options.selectionAdapter = Utils.Decorate(options.selectionAdapter, SelectionSearch);
							}

							if (options.containerCssClass != null || options.containerCss != null || options.adaptContainerCssClass != null) {
								var ContainerCSS = require(options.amdBase + 'compat/containerCss');

								options.selectionAdapter = Utils.Decorate(options.selectionAdapter, ContainerCSS);
							}

							options.selectionAdapter = Utils.Decorate(options.selectionAdapter, EventRelay);
						}

						// If the defaults were not previously applied from an element, it is
						// possible for the language option to have not been resolved
						options.language = this._resolveLanguage(options.language);

						// Always fall back to English since it will always be complete
						options.language.push('en');

						var uniqueLanguages = [];

						for (var l = 0; l < options.language.length; l++) {
							var language = options.language[l];

							if (uniqueLanguages.indexOf(language) === -1) {
								uniqueLanguages.push(language);
							}
						}

						options.language = uniqueLanguages;

						options.translations = this._processTranslations(options.language, options.debug);

						return options;
					};

					Defaults.prototype.reset = function () {
						function stripDiacritics(text) {
							// Used 'uni range + named function' from http://jsperf.com/diacritics/18
							function match(a) {
								return DIACRITICS[a] || a;
							}

							return text.replace(/[^\u0000-\u007E]/g, match);
						}

						function matcher(params, data) {
							// Always return the object if there is nothing to compare
							if ($.trim(params.term) === '') {
								return data;
							}

							// Do a recursive check for options with children
							if (data.children && data.children.length > 0) {
								// Clone the data object if there are children
								// This is required as we modify the object to remove any non-matches
								var match = $.extend(true, {}, data);

								// Check each child of the option
								for (var c = data.children.length - 1; c >= 0; c--) {
									var child = data.children[c];

									var matches = matcher(params, child);

									// If there wasn't a match, remove the object in the array
									if (matches == null) {
										match.children.splice(c, 1);
									}
								}

								// If any children matched, return the new object
								if (match.children.length > 0) {
									return match;
								}

								// If there were no matching children, check just the plain object
								return matcher(params, match);
							}

							var original = stripDiacritics(data.text).toUpperCase();
							var term = stripDiacritics(params.term).toUpperCase();

							// Check if the text contains the term
							if (original.indexOf(term) > -1) {
								return data;
							}

							// If it doesn't contain the term, don't return anything
							return null;
						}

						this.defaults = {
							amdBase: './',
							amdLanguageBase: './i18n/',
							closeOnSelect: true,
							debug: false,
							dropdownAutoWidth: false,
							escapeMarkup: Utils.escapeMarkup,
							language: {},
							matcher: matcher,
							minimumInputLength: 0,
							maximumInputLength: 0,
							maximumSelectionLength: 0,
							minimumResultsForSearch: 0,
							selectOnClose: false,
							scrollAfterSelect: false,
							sorter: function sorter(data) {
								return data;
							},
							templateResult: function templateResult(result) {
								return result.text;
							},
							templateSelection: function templateSelection(selection) {
								return selection.text;
							},
							theme: 'default',
							width: 'resolve'
						};
					};

					Defaults.prototype.applyFromElement = function (options, $element) {
						var optionLanguage = options.language;
						var defaultLanguage = this.defaults.language;
						var elementLanguage = $element.prop('lang');
						var parentLanguage = $element.closest('[lang]').prop('lang');

						var languages = Array.prototype.concat.call(this._resolveLanguage(elementLanguage), this._resolveLanguage(optionLanguage), this._resolveLanguage(defaultLanguage), this._resolveLanguage(parentLanguage));

						options.language = languages;

						return options;
					};

					Defaults.prototype._resolveLanguage = function (language) {
						if (!language) {
							return [];
						}

						if ($.isEmptyObject(language)) {
							return [];
						}

						if ($.isPlainObject(language)) {
							return [language];
						}

						var languages;

						if (!$.isArray(language)) {
							languages = [language];
						} else {
							languages = language;
						}

						var resolvedLanguages = [];

						for (var l = 0; l < languages.length; l++) {
							resolvedLanguages.push(languages[l]);

							if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
								// Extract the region information if it is included
								var languageParts = languages[l].split('-');
								var baseLanguage = languageParts[0];

								resolvedLanguages.push(baseLanguage);
							}
						}

						return resolvedLanguages;
					};

					Defaults.prototype._processTranslations = function (languages, debug) {
						var translations = new Translation();

						for (var l = 0; l < languages.length; l++) {
							var languageData = new Translation();

							var language = languages[l];

							if (typeof language === 'string') {
								try {
									// Try to load it with the original name
									languageData = Translation.loadPath(language);
								} catch (e) {
									try {
										// If we couldn't load it, check if it wasn't the full path
										language = this.defaults.amdLanguageBase + language;
										languageData = Translation.loadPath(language);
									} catch (ex) {
										// The translation could not be loaded at all. Sometimes this is
										// because of a configuration problem, other times this can be
										// because of how Select2 helps load all possible translation files
										if (debug && window.console && console.warn) {
											console.warn('Select2: The language file for "' + language + '" could ' + 'not be automatically loaded. A fallback will be used instead.');
										}
									}
								}
							} else if ($.isPlainObject(language)) {
								languageData = new Translation(language);
							} else {
								languageData = language;
							}

							translations.extend(languageData);
						}

						return translations;
					};

					Defaults.prototype.set = function (key, value) {
						var camelKey = $.camelCase(key);

						var data = {};
						data[camelKey] = value;

						var convertedData = Utils._convertData(data);

						$.extend(true, this.defaults, convertedData);
					};

					var defaults = new Defaults();

					return defaults;
				});

				S2.define('select2/options', ['require', 'jquery', './defaults', './utils'], function (require, $, Defaults, Utils) {
					function Options(options, $element) {
						this.options = options;

						if ($element != null) {
							this.fromElement($element);
						}

						if ($element != null) {
							this.options = Defaults.applyFromElement(this.options, $element);
						}

						this.options = Defaults.apply(this.options);

						if ($element && $element.is('input')) {
							var InputCompat = require(this.get('amdBase') + 'compat/inputData');

							this.options.dataAdapter = Utils.Decorate(this.options.dataAdapter, InputCompat);
						}
					}

					Options.prototype.fromElement = function ($e) {
						var excludedData = ['select2'];

						if (this.options.multiple == null) {
							this.options.multiple = $e.prop('multiple');
						}

						if (this.options.disabled == null) {
							this.options.disabled = $e.prop('disabled');
						}

						if (this.options.dir == null) {
							if ($e.prop('dir')) {
								this.options.dir = $e.prop('dir');
							} else if ($e.closest('[dir]').prop('dir')) {
								this.options.dir = $e.closest('[dir]').prop('dir');
							} else {
								this.options.dir = 'ltr';
							}
						}

						$e.prop('disabled', this.options.disabled);
						$e.prop('multiple', this.options.multiple);

						if (Utils.GetData($e[0], 'select2Tags')) {
							if (this.options.debug && window.console && console.warn) {
								console.warn('Select2: The `data-select2-tags` attribute has been changed to ' + 'use the `data-data` and `data-tags="true"` attributes and will be ' + 'removed in future versions of Select2.');
							}

							Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
							Utils.StoreData($e[0], 'tags', true);
						}

						if (Utils.GetData($e[0], 'ajaxUrl')) {
							if (this.options.debug && window.console && console.warn) {
								console.warn('Select2: The `data-ajax-url` attribute has been changed to ' + '`data-ajax--url` and support for the old attribute will be removed' + ' in future versions of Select2.');
							}

							$e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
							Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
						}

						var dataset = {};

						function upperCaseLetter(_, letter) {
							return letter.toUpperCase();
						}

						// Pre-load all of the attributes which are prefixed with `data-`
						for (var attr = 0; attr < $e[0].attributes.length; attr++) {
							var attributeName = $e[0].attributes[attr].name;
							var prefix = 'data-';

							if (attributeName.substr(0, prefix.length) == prefix) {
								// Get the contents of the attribute after `data-`
								var dataName = attributeName.substring(prefix.length);

								// Get the data contents from the consistent source
								// This is more than likely the jQuery data helper
								var dataValue = Utils.GetData($e[0], dataName);

								// camelCase the attribute name to match the spec
								var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);

								// Store the data attribute contents into the dataset since
								dataset[camelDataName] = dataValue;
							}
						}

						// Prefer the element's `dataset` attribute if it exists
						// jQuery 1.x does not correctly handle data attributes with multiple dashes
						if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
							dataset = $.extend(true, {}, $e[0].dataset, dataset);
						}

						// Prefer our internal data cache if it exists
						var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);

						data = Utils._convertData(data);

						for (var key in data) {
							if ($.inArray(key, excludedData) > -1) {
								continue;
							}

							if ($.isPlainObject(this.options[key])) {
								$.extend(this.options[key], data[key]);
							} else {
								this.options[key] = data[key];
							}
						}

						return this;
					};

					Options.prototype.get = function (key) {
						return this.options[key];
					};

					Options.prototype.set = function (key, val) {
						this.options[key] = val;
					};

					return Options;
				});

				S2.define('select2/core', ['jquery', './options', './utils', './keys'], function ($, Options, Utils, KEYS) {
					var Select2 = function Select2($element, options) {
						if (Utils.GetData($element[0], 'select2') != null) {
							Utils.GetData($element[0], 'select2').destroy();
						}

						this.$element = $element;

						this.id = this._generateId($element);

						options = options || {};

						this.options = new Options(options, $element);

						Select2.__super__.constructor.call(this);

						// Set up the tabindex

						var tabindex = $element.attr('tabindex') || 0;
						Utils.StoreData($element[0], 'old-tabindex', tabindex);
						$element.attr('tabindex', '-1');

						// Set up containers and adapters

						var DataAdapter = this.options.get('dataAdapter');
						this.dataAdapter = new DataAdapter($element, this.options);

						var $container = this.render();

						this._placeContainer($container);

						var SelectionAdapter = this.options.get('selectionAdapter');
						this.selection = new SelectionAdapter($element, this.options);
						this.$selection = this.selection.render();

						this.selection.position(this.$selection, $container);

						var DropdownAdapter = this.options.get('dropdownAdapter');
						this.dropdown = new DropdownAdapter($element, this.options);
						this.$dropdown = this.dropdown.render();

						this.dropdown.position(this.$dropdown, $container);

						var ResultsAdapter = this.options.get('resultsAdapter');
						this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
						this.$results = this.results.render();

						this.results.position(this.$results, this.$dropdown);

						// Bind events

						var self = this;

						// Bind the container to all of the adapters
						this._bindAdapters();

						// Register any DOM event handlers
						this._registerDomEvents();

						// Register any internal event handlers
						this._registerDataEvents();
						this._registerSelectionEvents();
						this._registerDropdownEvents();
						this._registerResultsEvents();
						this._registerEvents();

						// Set the initial state
						this.dataAdapter.current(function (initialData) {
							self.trigger('selection:update', {
								data: initialData
							});
						});

						// Hide the original select
						$element.addClass('select2-hidden-accessible');
						$element.attr('aria-hidden', 'true');

						// Synchronize any monitored attributes
						this._syncAttributes();

						Utils.StoreData($element[0], 'select2', this);

						// Ensure backwards compatibility with $element.data('select2').
						$element.data('select2', this);
					};

					Utils.Extend(Select2, Utils.Observable);

					Select2.prototype._generateId = function ($element) {
						var id = '';

						if ($element.attr('id') != null) {
							id = $element.attr('id');
						} else if ($element.attr('name') != null) {
							id = $element.attr('name') + '-' + Utils.generateChars(2);
						} else {
							id = Utils.generateChars(4);
						}

						id = id.replace(/(:|\.|\[|\]|,)/g, '');
						id = 'select2-' + id;

						return id;
					};

					Select2.prototype._placeContainer = function ($container) {
						$container.insertAfter(this.$element);

						var width = this._resolveWidth(this.$element, this.options.get('width'));

						if (width != null) {
							$container.css('width', width);
						}
					};

					Select2.prototype._resolveWidth = function ($element, method) {
						var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

						if (method == 'resolve') {
							var styleWidth = this._resolveWidth($element, 'style');

							if (styleWidth != null) {
								return styleWidth;
							}

							return this._resolveWidth($element, 'element');
						}

						if (method == 'element') {
							var elementWidth = $element.outerWidth(false);

							if (elementWidth <= 0) {
								return 'auto';
							}

							return elementWidth + 'px';
						}

						if (method == 'style') {
							var style = $element.attr('style');

							if (typeof style !== 'string') {
								return null;
							}

							var attrs = style.split(';');

							for (var i = 0, l = attrs.length; i < l; i = i + 1) {
								var attr = attrs[i].replace(/\s/g, '');
								var matches = attr.match(WIDTH);

								if (matches !== null && matches.length >= 1) {
									return matches[1];
								}
							}

							return null;
						}

						if (method == 'computedstyle') {
							var computedStyle = window.getComputedStyle($element[0]);

							return computedStyle.width;
						}

						return method;
					};

					Select2.prototype._bindAdapters = function () {
						this.dataAdapter.bind(this, this.$container);
						this.selection.bind(this, this.$container);

						this.dropdown.bind(this, this.$container);
						this.results.bind(this, this.$container);
					};

					Select2.prototype._registerDomEvents = function () {
						var self = this;

						this.$element.on('change.select2', function () {
							self.dataAdapter.current(function (data) {
								self.trigger('selection:update', {
									data: data
								});
							});
						});

						this.$element.on('focus.select2', function (evt) {
							self.trigger('focus', evt);
						});

						this._syncA = Utils.bind(this._syncAttributes, this);
						this._syncS = Utils.bind(this._syncSubtree, this);

						if (this.$element[0].attachEvent) {
							this.$element[0].attachEvent('onpropertychange', this._syncA);
						}

						var observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

						if (observer != null) {
							this._observer = new observer(function (mutations) {
								self._syncA();
								self._syncS(null, mutations);
							});
							this._observer.observe(this.$element[0], {
								attributes: true,
								childList: true,
								subtree: false
							});
						} else if (this.$element[0].addEventListener) {
							this.$element[0].addEventListener('DOMAttrModified', self._syncA, false);
							this.$element[0].addEventListener('DOMNodeInserted', self._syncS, false);
							this.$element[0].addEventListener('DOMNodeRemoved', self._syncS, false);
						}
					};

					Select2.prototype._registerDataEvents = function () {
						var self = this;

						this.dataAdapter.on('*', function (name, params) {
							self.trigger(name, params);
						});
					};

					Select2.prototype._registerSelectionEvents = function () {
						var self = this;
						var nonRelayEvents = ['toggle', 'focus'];

						this.selection.on('toggle', function () {
							self.toggleDropdown();
						});

						this.selection.on('focus', function (params) {
							self.focus(params);
						});

						this.selection.on('*', function (name, params) {
							if ($.inArray(name, nonRelayEvents) !== -1) {
								return;
							}

							self.trigger(name, params);
						});
					};

					Select2.prototype._registerDropdownEvents = function () {
						var self = this;

						this.dropdown.on('*', function (name, params) {
							self.trigger(name, params);
						});
					};

					Select2.prototype._registerResultsEvents = function () {
						var self = this;

						this.results.on('*', function (name, params) {
							self.trigger(name, params);
						});
					};

					Select2.prototype._registerEvents = function () {
						var self = this;

						this.on('open', function () {
							self.$container.addClass('select2-container--open');
						});

						this.on('close', function () {
							self.$container.removeClass('select2-container--open');
						});

						this.on('enable', function () {
							self.$container.removeClass('select2-container--disabled');
						});

						this.on('disable', function () {
							self.$container.addClass('select2-container--disabled');
						});

						this.on('blur', function () {
							self.$container.removeClass('select2-container--focus');
						});

						this.on('query', function (params) {
							if (!self.isOpen()) {
								self.trigger('open', {});
							}

							this.dataAdapter.query(params, function (data) {
								self.trigger('results:all', {
									data: data,
									query: params
								});
							});
						});

						this.on('query:append', function (params) {
							this.dataAdapter.query(params, function (data) {
								self.trigger('results:append', {
									data: data,
									query: params
								});
							});
						});

						this.on('keypress', function (evt) {
							var key = evt.which;

							if (self.isOpen()) {
								if (key === KEYS.ESC || key === KEYS.TAB || key === KEYS.UP && evt.altKey) {
									self.close(evt);

									evt.preventDefault();
								} else if (key === KEYS.ENTER) {
									self.trigger('results:select', {});

									evt.preventDefault();
								} else if (key === KEYS.SPACE && evt.ctrlKey) {
									self.trigger('results:toggle', {});

									evt.preventDefault();
								} else if (key === KEYS.UP) {
									self.trigger('results:previous', {});

									evt.preventDefault();
								} else if (key === KEYS.DOWN) {
									self.trigger('results:next', {});

									evt.preventDefault();
								}
							} else {
								if (key === KEYS.ENTER || key === KEYS.SPACE || key === KEYS.DOWN && evt.altKey) {
									self.open();

									evt.preventDefault();
								}
							}
						});
					};

					Select2.prototype._syncAttributes = function () {
						this.options.set('disabled', this.$element.prop('disabled'));

						if (this.isDisabled()) {
							if (this.isOpen()) {
								this.close();
							}

							this.trigger('disable', {});
						} else {
							this.trigger('enable', {});
						}
					};

					Select2.prototype._isChangeMutation = function (evt, mutations) {
						var changed = false;
						var self = this;

						// Ignore any mutation events raised for elements that aren't options or
						// optgroups. This handles the case when the select element is destroyed
						if (evt && evt.target && evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP') {
							return;
						}

						if (!mutations) {
							// If mutation events aren't supported, then we can only assume that the
							// change affected the selections
							changed = true;
						} else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
							for (var n = 0; n < mutations.addedNodes.length; n++) {
								var node = mutations.addedNodes[n];

								if (node.selected) {
									changed = true;
								}
							}
						} else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
							changed = true;
						} else if ($.isArray(mutations)) {
							$.each(mutations, function (evt, mutation) {
								if (self._isChangeMutation(evt, mutation)) {
									// We've found a change mutation.
									// Let's escape from the loop and continue
									changed = true;
									return false;
								}
							});
						}
						return changed;
					};

					Select2.prototype._syncSubtree = function (evt, mutations) {
						var changed = this._isChangeMutation(evt, mutations);
						var self = this;

						// Only re-pull the data if we think there is a change
						if (changed) {
							this.dataAdapter.current(function (currentData) {
								self.trigger('selection:update', {
									data: currentData
								});
							});
						}
					};

					/**
      * Override the trigger method to automatically trigger pre-events when
      * there are events that can be prevented.
      */
					Select2.prototype.trigger = function (name, args) {
						var actualTrigger = Select2.__super__.trigger;
						var preTriggerMap = {
							'open': 'opening',
							'close': 'closing',
							'select': 'selecting',
							'unselect': 'unselecting',
							'clear': 'clearing'
						};

						if (args === undefined) {
							args = {};
						}

						if (name in preTriggerMap) {
							var preTriggerName = preTriggerMap[name];
							var preTriggerArgs = {
								prevented: false,
								name: name,
								args: args
							};

							actualTrigger.call(this, preTriggerName, preTriggerArgs);

							if (preTriggerArgs.prevented) {
								args.prevented = true;

								return;
							}
						}

						actualTrigger.call(this, name, args);
					};

					Select2.prototype.toggleDropdown = function () {
						if (this.isDisabled()) {
							return;
						}

						if (this.isOpen()) {
							this.close();
						} else {
							this.open();
						}
					};

					Select2.prototype.open = function () {
						if (this.isOpen()) {
							return;
						}

						if (this.isDisabled()) {
							return;
						}

						this.trigger('query', {});
					};

					Select2.prototype.close = function (evt) {
						if (!this.isOpen()) {
							return;
						}

						this.trigger('close', { originalEvent: evt });
					};

					/**
      * Helper method to abstract the "enabled" (not "disabled") state of this
      * object.
      *
      * @return {true} if the instance is not disabled.
      * @return {false} if the instance is disabled.
      */
					Select2.prototype.isEnabled = function () {
						return !this.isDisabled();
					};

					/**
      * Helper method to abstract the "disabled" state of this object.
      *
      * @return {true} if the disabled option is true.
      * @return {false} if the disabled option is false.
      */
					Select2.prototype.isDisabled = function () {
						return this.options.get('disabled');
					};

					Select2.prototype.isOpen = function () {
						return this.$container.hasClass('select2-container--open');
					};

					Select2.prototype.hasFocus = function () {
						return this.$container.hasClass('select2-container--focus');
					};

					Select2.prototype.focus = function (data) {
						// No need to re-trigger focus events if we are already focused
						if (this.hasFocus()) {
							return;
						}

						this.$container.addClass('select2-container--focus');
						this.trigger('focus', {});
					};

					Select2.prototype.enable = function (args) {
						if (this.options.get('debug') && window.console && console.warn) {
							console.warn('Select2: The `select2("enable")` method has been deprecated and will' + ' be removed in later Select2 versions. Use $element.prop("disabled")' + ' instead.');
						}

						if (args == null || args.length === 0) {
							args = [true];
						}

						var disabled = !args[0];

						this.$element.prop('disabled', disabled);
					};

					Select2.prototype.data = function () {
						if (this.options.get('debug') && arguments.length > 0 && window.console && console.warn) {
							console.warn('Select2: Data can no longer be set using `select2("data")`. You ' + 'should consider setting the value instead using `$element.val()`.');
						}

						var data = [];

						this.dataAdapter.current(function (currentData) {
							data = currentData;
						});

						return data;
					};

					Select2.prototype.val = function (args) {
						if (this.options.get('debug') && window.console && console.warn) {
							console.warn('Select2: The `select2("val")` method has been deprecated and will be' + ' removed in later Select2 versions. Use $element.val() instead.');
						}

						if (args == null || args.length === 0) {
							return this.$element.val();
						}

						var newVal = args[0];

						if ($.isArray(newVal)) {
							newVal = $.map(newVal, function (obj) {
								return obj.toString();
							});
						}

						this.$element.val(newVal).trigger('input').trigger('change');
					};

					Select2.prototype.destroy = function () {
						this.$container.remove();

						if (this.$element[0].detachEvent) {
							this.$element[0].detachEvent('onpropertychange', this._syncA);
						}

						if (this._observer != null) {
							this._observer.disconnect();
							this._observer = null;
						} else if (this.$element[0].removeEventListener) {
							this.$element[0].removeEventListener('DOMAttrModified', this._syncA, false);
							this.$element[0].removeEventListener('DOMNodeInserted', this._syncS, false);
							this.$element[0].removeEventListener('DOMNodeRemoved', this._syncS, false);
						}

						this._syncA = null;
						this._syncS = null;

						this.$element.off('.select2');
						this.$element.attr('tabindex', Utils.GetData(this.$element[0], 'old-tabindex'));

						this.$element.removeClass('select2-hidden-accessible');
						this.$element.attr('aria-hidden', 'false');
						Utils.RemoveData(this.$element[0]);
						this.$element.removeData('select2');

						this.dataAdapter.destroy();
						this.selection.destroy();
						this.dropdown.destroy();
						this.results.destroy();

						this.dataAdapter = null;
						this.selection = null;
						this.dropdown = null;
						this.results = null;
					};

					Select2.prototype.render = function () {
						var $container = $('<span class="select2 select2-container">' + '<span class="selection"></span>' + '<span class="dropdown-wrapper" aria-hidden="true"></span>' + '</span>');

						$container.attr('dir', this.options.get('dir'));

						this.$container = $container;

						this.$container.addClass('select2-container--' + this.options.get('theme'));

						Utils.StoreData($container[0], 'element', this.$element);

						return $container;
					};

					return Select2;
				});

				S2.define('jquery-mousewheel', ['jquery'], function ($) {
					// Used to shim jQuery.mousewheel for non-full builds.
					return $;
				});

				S2.define('jquery.select2', ['jquery', 'jquery-mousewheel', './select2/core', './select2/defaults', './select2/utils'], function ($, _, Select2, Defaults, Utils) {
					if ($.fn.select2 == null) {
						// All methods that should return the element
						var thisMethods = ['open', 'close', 'destroy'];

						$.fn.select2 = function (options) {
							options = options || {};

							if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === 'object') {
								this.each(function () {
									var instanceOptions = $.extend(true, {}, options);

									var instance = new Select2($(this), instanceOptions);
								});

								return this;
							} else if (typeof options === 'string') {
								var ret;
								var args = Array.prototype.slice.call(arguments, 1);

								this.each(function () {
									var instance = Utils.GetData(this, 'select2');

									if (instance == null && window.console && console.error) {
										console.error('The select2(\'' + options + '\') method was called on an ' + 'element that is not using Select2.');
									}

									ret = instance[options].apply(instance, args);
								});

								// Check if we should be returning `this`
								if ($.inArray(options, thisMethods) > -1) {
									return this;
								}

								return ret;
							} else {
								throw new Error('Invalid arguments for Select2: ' + options);
							}
						};
					}

					if ($.fn.select2.defaults == null) {
						$.fn.select2.defaults = Defaults;
					}

					return Select2;
				});

				// Return the AMD loader configuration so it can be used outside of this file
				return {
					define: S2.define,
					require: S2.require
				};
			}();

			// Autoload the jQuery bindings
			// We know that all of the modules exist above this, so we're safe
			var select2 = S2.require('jquery.select2');

			// Hold the AMD module references on the jQuery function that was just loaded
			// This allows Select2 to use the internal loader outside of this file, such
			// as in the language files.
			jQuery.fn.select2.amd = S2;

			// Return the Select2 instance for anyone who is importing it.
			return select2;
		});
	}, { "jquery": 23 }], 25: [function (require, module, exports) {
		/*
       _ _      _       _
   ___| (_) ___| | __  (_)___
  / __| | |/ __| |/ /  | / __|
  \__ \ | | (__|   < _ | \__ \
  |___/_|_|\___|_|\_(_)/ |___/
                     |__/
  
   Version: 1.8.1
    Author: Ken Wheeler
   Website: http://kenwheeler.github.io
      Docs: http://kenwheeler.github.io/slick
      Repo: http://github.com/kenwheeler/slick
    Issues: http://github.com/kenwheeler/slick/issues
  
   */
		/* global window, document, define, jQuery, setInterval, clearInterval */
		;(function (factory) {
			'use strict';

			if (typeof define === 'function' && define.amd) {
				define(['jquery'], factory);
			} else if (typeof exports !== 'undefined') {
				module.exports = factory(require('jquery'));
			} else {
				factory(jQuery);
			}
		})(function ($) {
			'use strict';

			var Slick = window.Slick || {};

			Slick = function () {

				var instanceUid = 0;

				function Slick(element, settings) {

					var _ = this,
					    dataSettings;

					_.defaults = {
						accessibility: true,
						adaptiveHeight: false,
						appendArrows: $(element),
						appendDots: $(element),
						arrows: true,
						asNavFor: null,
						prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
						nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
						autoplay: false,
						autoplaySpeed: 3000,
						centerMode: false,
						centerPadding: '50px',
						cssEase: 'ease',
						customPaging: function customPaging(slider, i) {
							return $('<button type="button" />').text(i + 1);
						},
						dots: false,
						dotsClass: 'slick-dots',
						draggable: true,
						easing: 'linear',
						edgeFriction: 0.35,
						fade: false,
						focusOnSelect: false,
						focusOnChange: false,
						infinite: true,
						initialSlide: 0,
						lazyLoad: 'ondemand',
						mobileFirst: false,
						pauseOnHover: true,
						pauseOnFocus: true,
						pauseOnDotsHover: false,
						respondTo: 'window',
						responsive: null,
						rows: 1,
						rtl: false,
						slide: '',
						slidesPerRow: 1,
						slidesToShow: 1,
						slidesToScroll: 1,
						speed: 500,
						swipe: true,
						swipeToSlide: false,
						touchMove: true,
						touchThreshold: 5,
						useCSS: true,
						useTransform: true,
						variableWidth: false,
						vertical: false,
						verticalSwiping: false,
						waitForAnimate: true,
						zIndex: 1000
					};

					_.initials = {
						animating: false,
						dragging: false,
						autoPlayTimer: null,
						currentDirection: 0,
						currentLeft: null,
						currentSlide: 0,
						direction: 1,
						$dots: null,
						listWidth: null,
						listHeight: null,
						loadIndex: 0,
						$nextArrow: null,
						$prevArrow: null,
						scrolling: false,
						slideCount: null,
						slideWidth: null,
						$slideTrack: null,
						$slides: null,
						sliding: false,
						slideOffset: 0,
						swipeLeft: null,
						swiping: false,
						$list: null,
						touchObject: {},
						transformsEnabled: false,
						unslicked: false
					};

					$.extend(_, _.initials);

					_.activeBreakpoint = null;
					_.animType = null;
					_.animProp = null;
					_.breakpoints = [];
					_.breakpointSettings = [];
					_.cssTransitions = false;
					_.focussed = false;
					_.interrupted = false;
					_.hidden = 'hidden';
					_.paused = true;
					_.positionProp = null;
					_.respondTo = null;
					_.rowCount = 1;
					_.shouldClick = true;
					_.$slider = $(element);
					_.$slidesCache = null;
					_.transformType = null;
					_.transitionType = null;
					_.visibilityChange = 'visibilitychange';
					_.windowWidth = 0;
					_.windowTimer = null;

					dataSettings = $(element).data('slick') || {};

					_.options = $.extend({}, _.defaults, settings, dataSettings);

					_.currentSlide = _.options.initialSlide;

					_.originalSettings = _.options;

					if (typeof document.mozHidden !== 'undefined') {
						_.hidden = 'mozHidden';
						_.visibilityChange = 'mozvisibilitychange';
					} else if (typeof document.webkitHidden !== 'undefined') {
						_.hidden = 'webkitHidden';
						_.visibilityChange = 'webkitvisibilitychange';
					}

					_.autoPlay = $.proxy(_.autoPlay, _);
					_.autoPlayClear = $.proxy(_.autoPlayClear, _);
					_.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
					_.changeSlide = $.proxy(_.changeSlide, _);
					_.clickHandler = $.proxy(_.clickHandler, _);
					_.selectHandler = $.proxy(_.selectHandler, _);
					_.setPosition = $.proxy(_.setPosition, _);
					_.swipeHandler = $.proxy(_.swipeHandler, _);
					_.dragHandler = $.proxy(_.dragHandler, _);
					_.keyHandler = $.proxy(_.keyHandler, _);

					_.instanceUid = instanceUid++;

					// A simple way to check for HTML strings
					// Strict HTML recognition (must start with <)
					// Extracted from jQuery v1.11 source
					_.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

					_.registerBreakpoints();
					_.init(true);
				}

				return Slick;
			}();

			Slick.prototype.activateADA = function () {
				var _ = this;

				_.$slideTrack.find('.slick-active').attr({
					'aria-hidden': 'false'
				}).find('a, input, button, select').attr({
					'tabindex': '0'
				});
			};

			Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

				var _ = this;

				if (typeof index === 'boolean') {
					addBefore = index;
					index = null;
				} else if (index < 0 || index >= _.slideCount) {
					return false;
				}

				_.unload();

				if (typeof index === 'number') {
					if (index === 0 && _.$slides.length === 0) {
						$(markup).appendTo(_.$slideTrack);
					} else if (addBefore) {
						$(markup).insertBefore(_.$slides.eq(index));
					} else {
						$(markup).insertAfter(_.$slides.eq(index));
					}
				} else {
					if (addBefore === true) {
						$(markup).prependTo(_.$slideTrack);
					} else {
						$(markup).appendTo(_.$slideTrack);
					}
				}

				_.$slides = _.$slideTrack.children(this.options.slide);

				_.$slideTrack.children(this.options.slide).detach();

				_.$slideTrack.append(_.$slides);

				_.$slides.each(function (index, element) {
					$(element).attr('data-slick-index', index);
				});

				_.$slidesCache = _.$slides;

				_.reinit();
			};

			Slick.prototype.animateHeight = function () {
				var _ = this;
				if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
					var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
					_.$list.animate({
						height: targetHeight
					}, _.options.speed);
				}
			};

			Slick.prototype.animateSlide = function (targetLeft, callback) {

				var animProps = {},
				    _ = this;

				_.animateHeight();

				if (_.options.rtl === true && _.options.vertical === false) {
					targetLeft = -targetLeft;
				}
				if (_.transformsEnabled === false) {
					if (_.options.vertical === false) {
						_.$slideTrack.animate({
							left: targetLeft
						}, _.options.speed, _.options.easing, callback);
					} else {
						_.$slideTrack.animate({
							top: targetLeft
						}, _.options.speed, _.options.easing, callback);
					}
				} else {

					if (_.cssTransitions === false) {
						if (_.options.rtl === true) {
							_.currentLeft = -_.currentLeft;
						}
						$({
							animStart: _.currentLeft
						}).animate({
							animStart: targetLeft
						}, {
							duration: _.options.speed,
							easing: _.options.easing,
							step: function step(now) {
								now = Math.ceil(now);
								if (_.options.vertical === false) {
									animProps[_.animType] = 'translate(' + now + 'px, 0px)';
									_.$slideTrack.css(animProps);
								} else {
									animProps[_.animType] = 'translate(0px,' + now + 'px)';
									_.$slideTrack.css(animProps);
								}
							},
							complete: function complete() {
								if (callback) {
									callback.call();
								}
							}
						});
					} else {

						_.applyTransition();
						targetLeft = Math.ceil(targetLeft);

						if (_.options.vertical === false) {
							animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
						} else {
							animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
						}
						_.$slideTrack.css(animProps);

						if (callback) {
							setTimeout(function () {

								_.disableTransition();

								callback.call();
							}, _.options.speed);
						}
					}
				}
			};

			Slick.prototype.getNavTarget = function () {

				var _ = this,
				    asNavFor = _.options.asNavFor;

				if (asNavFor && asNavFor !== null) {
					asNavFor = $(asNavFor).not(_.$slider);
				}

				return asNavFor;
			};

			Slick.prototype.asNavFor = function (index) {

				var _ = this,
				    asNavFor = _.getNavTarget();

				if (asNavFor !== null && (typeof asNavFor === "undefined" ? "undefined" : _typeof(asNavFor)) === 'object') {
					asNavFor.each(function () {
						var target = $(this).slick('getSlick');
						if (!target.unslicked) {
							target.slideHandler(index, true);
						}
					});
				}
			};

			Slick.prototype.applyTransition = function (slide) {

				var _ = this,
				    transition = {};

				if (_.options.fade === false) {
					transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
				} else {
					transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
				}

				if (_.options.fade === false) {
					_.$slideTrack.css(transition);
				} else {
					_.$slides.eq(slide).css(transition);
				}
			};

			Slick.prototype.autoPlay = function () {

				var _ = this;

				_.autoPlayClear();

				if (_.slideCount > _.options.slidesToShow) {
					_.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
				}
			};

			Slick.prototype.autoPlayClear = function () {

				var _ = this;

				if (_.autoPlayTimer) {
					clearInterval(_.autoPlayTimer);
				}
			};

			Slick.prototype.autoPlayIterator = function () {

				var _ = this,
				    slideTo = _.currentSlide + _.options.slidesToScroll;

				if (!_.paused && !_.interrupted && !_.focussed) {

					if (_.options.infinite === false) {

						if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
							_.direction = 0;
						} else if (_.direction === 0) {

							slideTo = _.currentSlide - _.options.slidesToScroll;

							if (_.currentSlide - 1 === 0) {
								_.direction = 1;
							}
						}
					}

					_.slideHandler(slideTo);
				}
			};

			Slick.prototype.buildArrows = function () {

				var _ = this;

				if (_.options.arrows === true) {

					_.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
					_.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

					if (_.slideCount > _.options.slidesToShow) {

						_.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
						_.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

						if (_.htmlExpr.test(_.options.prevArrow)) {
							_.$prevArrow.prependTo(_.options.appendArrows);
						}

						if (_.htmlExpr.test(_.options.nextArrow)) {
							_.$nextArrow.appendTo(_.options.appendArrows);
						}

						if (_.options.infinite !== true) {
							_.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
						}
					} else {

						_.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
							'aria-disabled': 'true',
							'tabindex': '-1'
						});
					}
				}
			};

			Slick.prototype.buildDots = function () {

				var _ = this,
				    i,
				    dot;

				if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

					_.$slider.addClass('slick-dotted');

					dot = $('<ul />').addClass(_.options.dotsClass);

					for (i = 0; i <= _.getDotCount(); i += 1) {
						dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
					}

					_.$dots = dot.appendTo(_.options.appendDots);

					_.$dots.find('li').first().addClass('slick-active');
				}
			};

			Slick.prototype.buildOut = function () {

				var _ = this;

				_.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

				_.slideCount = _.$slides.length;

				_.$slides.each(function (index, element) {
					$(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
				});

				_.$slider.addClass('slick-slider');

				_.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

				_.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
				_.$slideTrack.css('opacity', 0);

				if (_.options.centerMode === true || _.options.swipeToSlide === true) {
					_.options.slidesToScroll = 1;
				}

				$('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

				_.setupInfinite();

				_.buildArrows();

				_.buildDots();

				_.updateDots();

				_.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

				if (_.options.draggable === true) {
					_.$list.addClass('draggable');
				}
			};

			Slick.prototype.buildRows = function () {

				var _ = this,
				    a,
				    b,
				    c,
				    newSlides,
				    numOfSlides,
				    originalSlides,
				    slidesPerSection;

				newSlides = document.createDocumentFragment();
				originalSlides = _.$slider.children();

				if (_.options.rows > 0) {

					slidesPerSection = _.options.slidesPerRow * _.options.rows;
					numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

					for (a = 0; a < numOfSlides; a++) {
						var slide = document.createElement('div');
						for (b = 0; b < _.options.rows; b++) {
							var row = document.createElement('div');
							for (c = 0; c < _.options.slidesPerRow; c++) {
								var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
								if (originalSlides.get(target)) {
									row.appendChild(originalSlides.get(target));
								}
							}
							slide.appendChild(row);
						}
						newSlides.appendChild(slide);
					}

					_.$slider.empty().append(newSlides);
					_.$slider.children().children().children().css({
						'width': 100 / _.options.slidesPerRow + '%',
						'display': 'inline-block'
					});
				}
			};

			Slick.prototype.checkResponsive = function (initial, forceUpdate) {

				var _ = this,
				    breakpoint,
				    targetBreakpoint,
				    respondToWidth,
				    triggerBreakpoint = false;
				var sliderWidth = _.$slider.width();
				var windowWidth = window.innerWidth || $(window).width();

				if (_.respondTo === 'window') {
					respondToWidth = windowWidth;
				} else if (_.respondTo === 'slider') {
					respondToWidth = sliderWidth;
				} else if (_.respondTo === 'min') {
					respondToWidth = Math.min(windowWidth, sliderWidth);
				}

				if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

					targetBreakpoint = null;

					for (breakpoint in _.breakpoints) {
						if (_.breakpoints.hasOwnProperty(breakpoint)) {
							if (_.originalSettings.mobileFirst === false) {
								if (respondToWidth < _.breakpoints[breakpoint]) {
									targetBreakpoint = _.breakpoints[breakpoint];
								}
							} else {
								if (respondToWidth > _.breakpoints[breakpoint]) {
									targetBreakpoint = _.breakpoints[breakpoint];
								}
							}
						}
					}

					if (targetBreakpoint !== null) {
						if (_.activeBreakpoint !== null) {
							if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
								_.activeBreakpoint = targetBreakpoint;
								if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
									_.unslick(targetBreakpoint);
								} else {
									_.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
									if (initial === true) {
										_.currentSlide = _.options.initialSlide;
									}
									_.refresh(initial);
								}
								triggerBreakpoint = targetBreakpoint;
							}
						} else {
							_.activeBreakpoint = targetBreakpoint;
							if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
								_.unslick(targetBreakpoint);
							} else {
								_.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
								if (initial === true) {
									_.currentSlide = _.options.initialSlide;
								}
								_.refresh(initial);
							}
							triggerBreakpoint = targetBreakpoint;
						}
					} else {
						if (_.activeBreakpoint !== null) {
							_.activeBreakpoint = null;
							_.options = _.originalSettings;
							if (initial === true) {
								_.currentSlide = _.options.initialSlide;
							}
							_.refresh(initial);
							triggerBreakpoint = targetBreakpoint;
						}
					}

					// only trigger breakpoints during an actual break. not on initialize.
					if (!initial && triggerBreakpoint !== false) {
						_.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
					}
				}
			};

			Slick.prototype.changeSlide = function (event, dontAnimate) {

				var _ = this,
				    $target = $(event.currentTarget),
				    indexOffset,
				    slideOffset,
				    unevenOffset;

				// If target is a link, prevent default action.
				if ($target.is('a')) {
					event.preventDefault();
				}

				// If target is not the <li> element (ie: a child), find the <li>.
				if (!$target.is('li')) {
					$target = $target.closest('li');
				}

				unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
				indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

				switch (event.data.message) {

					case 'previous':
						slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
						if (_.slideCount > _.options.slidesToShow) {
							_.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
						}
						break;

					case 'next':
						slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
						if (_.slideCount > _.options.slidesToShow) {
							_.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
						}
						break;

					case 'index':
						var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

						_.slideHandler(_.checkNavigable(index), false, dontAnimate);
						$target.children().trigger('focus');
						break;

					default:
						return;
				}
			};

			Slick.prototype.checkNavigable = function (index) {

				var _ = this,
				    navigables,
				    prevNavigable;

				navigables = _.getNavigableIndexes();
				prevNavigable = 0;
				if (index > navigables[navigables.length - 1]) {
					index = navigables[navigables.length - 1];
				} else {
					for (var n in navigables) {
						if (index < navigables[n]) {
							index = prevNavigable;
							break;
						}
						prevNavigable = navigables[n];
					}
				}

				return index;
			};

			Slick.prototype.cleanUpEvents = function () {

				var _ = this;

				if (_.options.dots && _.$dots !== null) {

					$('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));

					if (_.options.accessibility === true) {
						_.$dots.off('keydown.slick', _.keyHandler);
					}
				}

				_.$slider.off('focus.slick blur.slick');

				if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
					_.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
					_.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

					if (_.options.accessibility === true) {
						_.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
						_.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
					}
				}

				_.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
				_.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
				_.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
				_.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

				_.$list.off('click.slick', _.clickHandler);

				$(document).off(_.visibilityChange, _.visibility);

				_.cleanUpSlideEvents();

				if (_.options.accessibility === true) {
					_.$list.off('keydown.slick', _.keyHandler);
				}

				if (_.options.focusOnSelect === true) {
					$(_.$slideTrack).children().off('click.slick', _.selectHandler);
				}

				$(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

				$(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

				$('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

				$(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
			};

			Slick.prototype.cleanUpSlideEvents = function () {

				var _ = this;

				_.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
				_.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
			};

			Slick.prototype.cleanUpRows = function () {

				var _ = this,
				    originalSlides;

				if (_.options.rows > 0) {
					originalSlides = _.$slides.children().children();
					originalSlides.removeAttr('style');
					_.$slider.empty().append(originalSlides);
				}
			};

			Slick.prototype.clickHandler = function (event) {

				var _ = this;

				if (_.shouldClick === false) {
					event.stopImmediatePropagation();
					event.stopPropagation();
					event.preventDefault();
				}
			};

			Slick.prototype.destroy = function (refresh) {

				var _ = this;

				_.autoPlayClear();

				_.touchObject = {};

				_.cleanUpEvents();

				$('.slick-cloned', _.$slider).detach();

				if (_.$dots) {
					_.$dots.remove();
				}

				if (_.$prevArrow && _.$prevArrow.length) {

					_.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

					if (_.htmlExpr.test(_.options.prevArrow)) {
						_.$prevArrow.remove();
					}
				}

				if (_.$nextArrow && _.$nextArrow.length) {

					_.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

					if (_.htmlExpr.test(_.options.nextArrow)) {
						_.$nextArrow.remove();
					}
				}

				if (_.$slides) {

					_.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
						$(this).attr('style', $(this).data('originalStyling'));
					});

					_.$slideTrack.children(this.options.slide).detach();

					_.$slideTrack.detach();

					_.$list.detach();

					_.$slider.append(_.$slides);
				}

				_.cleanUpRows();

				_.$slider.removeClass('slick-slider');
				_.$slider.removeClass('slick-initialized');
				_.$slider.removeClass('slick-dotted');

				_.unslicked = true;

				if (!refresh) {
					_.$slider.trigger('destroy', [_]);
				}
			};

			Slick.prototype.disableTransition = function (slide) {

				var _ = this,
				    transition = {};

				transition[_.transitionType] = '';

				if (_.options.fade === false) {
					_.$slideTrack.css(transition);
				} else {
					_.$slides.eq(slide).css(transition);
				}
			};

			Slick.prototype.fadeSlide = function (slideIndex, callback) {

				var _ = this;

				if (_.cssTransitions === false) {

					_.$slides.eq(slideIndex).css({
						zIndex: _.options.zIndex
					});

					_.$slides.eq(slideIndex).animate({
						opacity: 1
					}, _.options.speed, _.options.easing, callback);
				} else {

					_.applyTransition(slideIndex);

					_.$slides.eq(slideIndex).css({
						opacity: 1,
						zIndex: _.options.zIndex
					});

					if (callback) {
						setTimeout(function () {

							_.disableTransition(slideIndex);

							callback.call();
						}, _.options.speed);
					}
				}
			};

			Slick.prototype.fadeSlideOut = function (slideIndex) {

				var _ = this;

				if (_.cssTransitions === false) {

					_.$slides.eq(slideIndex).animate({
						opacity: 0,
						zIndex: _.options.zIndex - 2
					}, _.options.speed, _.options.easing);
				} else {

					_.applyTransition(slideIndex);

					_.$slides.eq(slideIndex).css({
						opacity: 0,
						zIndex: _.options.zIndex - 2
					});
				}
			};

			Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

				var _ = this;

				if (filter !== null) {

					_.$slidesCache = _.$slides;

					_.unload();

					_.$slideTrack.children(this.options.slide).detach();

					_.$slidesCache.filter(filter).appendTo(_.$slideTrack);

					_.reinit();
				}
			};

			Slick.prototype.focusHandler = function () {

				var _ = this;

				_.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {

					event.stopImmediatePropagation();
					var $sf = $(this);

					setTimeout(function () {

						if (_.options.pauseOnFocus) {
							_.focussed = $sf.is(':focus');
							_.autoPlay();
						}
					}, 0);
				});
			};

			Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

				var _ = this;
				return _.currentSlide;
			};

			Slick.prototype.getDotCount = function () {

				var _ = this;

				var breakPoint = 0;
				var counter = 0;
				var pagerQty = 0;

				if (_.options.infinite === true) {
					if (_.slideCount <= _.options.slidesToShow) {
						++pagerQty;
					} else {
						while (breakPoint < _.slideCount) {
							++pagerQty;
							breakPoint = counter + _.options.slidesToScroll;
							counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
						}
					}
				} else if (_.options.centerMode === true) {
					pagerQty = _.slideCount;
				} else if (!_.options.asNavFor) {
					pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
				} else {
					while (breakPoint < _.slideCount) {
						++pagerQty;
						breakPoint = counter + _.options.slidesToScroll;
						counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
					}
				}

				return pagerQty - 1;
			};

			Slick.prototype.getLeft = function (slideIndex) {

				var _ = this,
				    targetLeft,
				    verticalHeight,
				    verticalOffset = 0,
				    targetSlide,
				    coef;

				_.slideOffset = 0;
				verticalHeight = _.$slides.first().outerHeight(true);

				if (_.options.infinite === true) {
					if (_.slideCount > _.options.slidesToShow) {
						_.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
						coef = -1;

						if (_.options.vertical === true && _.options.centerMode === true) {
							if (_.options.slidesToShow === 2) {
								coef = -1.5;
							} else if (_.options.slidesToShow === 1) {
								coef = -2;
							}
						}
						verticalOffset = verticalHeight * _.options.slidesToShow * coef;
					}
					if (_.slideCount % _.options.slidesToScroll !== 0) {
						if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
							if (slideIndex > _.slideCount) {
								_.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
								verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
							} else {
								_.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
								verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
							}
						}
					}
				} else {
					if (slideIndex + _.options.slidesToShow > _.slideCount) {
						_.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
						verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
					}
				}

				if (_.slideCount <= _.options.slidesToShow) {
					_.slideOffset = 0;
					verticalOffset = 0;
				}

				if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
					_.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
				} else if (_.options.centerMode === true && _.options.infinite === true) {
					_.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
				} else if (_.options.centerMode === true) {
					_.slideOffset = 0;
					_.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
				}

				if (_.options.vertical === false) {
					targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
				} else {
					targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
				}

				if (_.options.variableWidth === true) {

					if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
						targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
					} else {
						targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
					}

					if (_.options.rtl === true) {
						if (targetSlide[0]) {
							targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
						} else {
							targetLeft = 0;
						}
					} else {
						targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
					}

					if (_.options.centerMode === true) {
						if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
							targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
						} else {
							targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
						}

						if (_.options.rtl === true) {
							if (targetSlide[0]) {
								targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
							} else {
								targetLeft = 0;
							}
						} else {
							targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
						}

						targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
					}
				}

				return targetLeft;
			};

			Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

				var _ = this;

				return _.options[option];
			};

			Slick.prototype.getNavigableIndexes = function () {

				var _ = this,
				    breakPoint = 0,
				    counter = 0,
				    indexes = [],
				    max;

				if (_.options.infinite === false) {
					max = _.slideCount;
				} else {
					breakPoint = _.options.slidesToScroll * -1;
					counter = _.options.slidesToScroll * -1;
					max = _.slideCount * 2;
				}

				while (breakPoint < max) {
					indexes.push(breakPoint);
					breakPoint = counter + _.options.slidesToScroll;
					counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
				}

				return indexes;
			};

			Slick.prototype.getSlick = function () {

				return this;
			};

			Slick.prototype.getSlideCount = function () {

				var _ = this,
				    slidesTraversed,
				    swipedSlide,
				    centerOffset;

				centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

				if (_.options.swipeToSlide === true) {
					_.$slideTrack.find('.slick-slide').each(function (index, slide) {
						if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
							swipedSlide = slide;
							return false;
						}
					});

					slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

					return slidesTraversed;
				} else {
					return _.options.slidesToScroll;
				}
			};

			Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

				var _ = this;

				_.changeSlide({
					data: {
						message: 'index',
						index: parseInt(slide)
					}
				}, dontAnimate);
			};

			Slick.prototype.init = function (creation) {

				var _ = this;

				if (!$(_.$slider).hasClass('slick-initialized')) {

					$(_.$slider).addClass('slick-initialized');

					_.buildRows();
					_.buildOut();
					_.setProps();
					_.startLoad();
					_.loadSlider();
					_.initializeEvents();
					_.updateArrows();
					_.updateDots();
					_.checkResponsive(true);
					_.focusHandler();
				}

				if (creation) {
					_.$slider.trigger('init', [_]);
				}

				if (_.options.accessibility === true) {
					_.initADA();
				}

				if (_.options.autoplay) {

					_.paused = false;
					_.autoPlay();
				}
			};

			Slick.prototype.initADA = function () {
				var _ = this,
				    numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
				    tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
					return val >= 0 && val < _.slideCount;
				});

				_.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
					'aria-hidden': 'true',
					'tabindex': '-1'
				}).find('a, input, button, select').attr({
					'tabindex': '-1'
				});

				if (_.$dots !== null) {
					_.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
						var slideControlIndex = tabControlIndexes.indexOf(i);

						$(this).attr({
							'role': 'tabpanel',
							'id': 'slick-slide' + _.instanceUid + i,
							'tabindex': -1
						});

						if (slideControlIndex !== -1) {
							var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
							if ($('#' + ariaButtonControl).length) {
								$(this).attr({
									'aria-describedby': ariaButtonControl
								});
							}
						}
					});

					_.$dots.attr('role', 'tablist').find('li').each(function (i) {
						var mappedSlideIndex = tabControlIndexes[i];

						$(this).attr({
							'role': 'presentation'
						});

						$(this).find('button').first().attr({
							'role': 'tab',
							'id': 'slick-slide-control' + _.instanceUid + i,
							'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
							'aria-label': i + 1 + ' of ' + numDotGroups,
							'aria-selected': null,
							'tabindex': '-1'
						});
					}).eq(_.currentSlide).find('button').attr({
						'aria-selected': 'true',
						'tabindex': '0'
					}).end();
				}

				for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
					if (_.options.focusOnChange) {
						_.$slides.eq(i).attr({ 'tabindex': '0' });
					} else {
						_.$slides.eq(i).removeAttr('tabindex');
					}
				}

				_.activateADA();
			};

			Slick.prototype.initArrowEvents = function () {

				var _ = this;

				if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
					_.$prevArrow.off('click.slick').on('click.slick', {
						message: 'previous'
					}, _.changeSlide);
					_.$nextArrow.off('click.slick').on('click.slick', {
						message: 'next'
					}, _.changeSlide);

					if (_.options.accessibility === true) {
						_.$prevArrow.on('keydown.slick', _.keyHandler);
						_.$nextArrow.on('keydown.slick', _.keyHandler);
					}
				}
			};

			Slick.prototype.initDotEvents = function () {

				var _ = this;

				if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
					$('li', _.$dots).on('click.slick', {
						message: 'index'
					}, _.changeSlide);

					if (_.options.accessibility === true) {
						_.$dots.on('keydown.slick', _.keyHandler);
					}
				}

				if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

					$('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
				}
			};

			Slick.prototype.initSlideEvents = function () {

				var _ = this;

				if (_.options.pauseOnHover) {

					_.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
					_.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
				}
			};

			Slick.prototype.initializeEvents = function () {

				var _ = this;

				_.initArrowEvents();

				_.initDotEvents();
				_.initSlideEvents();

				_.$list.on('touchstart.slick mousedown.slick', {
					action: 'start'
				}, _.swipeHandler);
				_.$list.on('touchmove.slick mousemove.slick', {
					action: 'move'
				}, _.swipeHandler);
				_.$list.on('touchend.slick mouseup.slick', {
					action: 'end'
				}, _.swipeHandler);
				_.$list.on('touchcancel.slick mouseleave.slick', {
					action: 'end'
				}, _.swipeHandler);

				_.$list.on('click.slick', _.clickHandler);

				$(document).on(_.visibilityChange, $.proxy(_.visibility, _));

				if (_.options.accessibility === true) {
					_.$list.on('keydown.slick', _.keyHandler);
				}

				if (_.options.focusOnSelect === true) {
					$(_.$slideTrack).children().on('click.slick', _.selectHandler);
				}

				$(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

				$(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

				$('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

				$(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
				$(_.setPosition);
			};

			Slick.prototype.initUI = function () {

				var _ = this;

				if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

					_.$prevArrow.show();
					_.$nextArrow.show();
				}

				if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

					_.$dots.show();
				}
			};

			Slick.prototype.keyHandler = function (event) {

				var _ = this;
				//Dont slide if the cursor is inside the form fields and arrow keys are pressed
				if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
					if (event.keyCode === 37 && _.options.accessibility === true) {
						_.changeSlide({
							data: {
								message: _.options.rtl === true ? 'next' : 'previous'
							}
						});
					} else if (event.keyCode === 39 && _.options.accessibility === true) {
						_.changeSlide({
							data: {
								message: _.options.rtl === true ? 'previous' : 'next'
							}
						});
					}
				}
			};

			Slick.prototype.lazyLoad = function () {

				var _ = this,
				    loadRange,
				    cloneRange,
				    rangeStart,
				    rangeEnd;

				function loadImages(imagesScope) {

					$('img[data-lazy]', imagesScope).each(function () {

						var image = $(this),
						    imageSource = $(this).attr('data-lazy'),
						    imageSrcSet = $(this).attr('data-srcset'),
						    imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
						    imageToLoad = document.createElement('img');

						imageToLoad.onload = function () {

							image.animate({ opacity: 0 }, 100, function () {

								if (imageSrcSet) {
									image.attr('srcset', imageSrcSet);

									if (imageSizes) {
										image.attr('sizes', imageSizes);
									}
								}

								image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
									image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
								});
								_.$slider.trigger('lazyLoaded', [_, image, imageSource]);
							});
						};

						imageToLoad.onerror = function () {

							image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

							_.$slider.trigger('lazyLoadError', [_, image, imageSource]);
						};

						imageToLoad.src = imageSource;
					});
				}

				if (_.options.centerMode === true) {
					if (_.options.infinite === true) {
						rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
						rangeEnd = rangeStart + _.options.slidesToShow + 2;
					} else {
						rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
						rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
					}
				} else {
					rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
					rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
					if (_.options.fade === true) {
						if (rangeStart > 0) rangeStart--;
						if (rangeEnd <= _.slideCount) rangeEnd++;
					}
				}

				loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

				if (_.options.lazyLoad === 'anticipated') {
					var prevSlide = rangeStart - 1,
					    nextSlide = rangeEnd,
					    $slides = _.$slider.find('.slick-slide');

					for (var i = 0; i < _.options.slidesToScroll; i++) {
						if (prevSlide < 0) prevSlide = _.slideCount - 1;
						loadRange = loadRange.add($slides.eq(prevSlide));
						loadRange = loadRange.add($slides.eq(nextSlide));
						prevSlide--;
						nextSlide++;
					}
				}

				loadImages(loadRange);

				if (_.slideCount <= _.options.slidesToShow) {
					cloneRange = _.$slider.find('.slick-slide');
					loadImages(cloneRange);
				} else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
					cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
					loadImages(cloneRange);
				} else if (_.currentSlide === 0) {
					cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
					loadImages(cloneRange);
				}
			};

			Slick.prototype.loadSlider = function () {

				var _ = this;

				_.setPosition();

				_.$slideTrack.css({
					opacity: 1
				});

				_.$slider.removeClass('slick-loading');

				_.initUI();

				if (_.options.lazyLoad === 'progressive') {
					_.progressiveLazyLoad();
				}
			};

			Slick.prototype.next = Slick.prototype.slickNext = function () {

				var _ = this;

				_.changeSlide({
					data: {
						message: 'next'
					}
				});
			};

			Slick.prototype.orientationChange = function () {

				var _ = this;

				_.checkResponsive();
				_.setPosition();
			};

			Slick.prototype.pause = Slick.prototype.slickPause = function () {

				var _ = this;

				_.autoPlayClear();
				_.paused = true;
			};

			Slick.prototype.play = Slick.prototype.slickPlay = function () {

				var _ = this;

				_.autoPlay();
				_.options.autoplay = true;
				_.paused = false;
				_.focussed = false;
				_.interrupted = false;
			};

			Slick.prototype.postSlide = function (index) {

				var _ = this;

				if (!_.unslicked) {

					_.$slider.trigger('afterChange', [_, index]);

					_.animating = false;

					if (_.slideCount > _.options.slidesToShow) {
						_.setPosition();
					}

					_.swipeLeft = null;

					if (_.options.autoplay) {
						_.autoPlay();
					}

					if (_.options.accessibility === true) {
						_.initADA();

						if (_.options.focusOnChange) {
							var $currentSlide = $(_.$slides.get(_.currentSlide));
							$currentSlide.attr('tabindex', 0).focus();
						}
					}
				}
			};

			Slick.prototype.prev = Slick.prototype.slickPrev = function () {

				var _ = this;

				_.changeSlide({
					data: {
						message: 'previous'
					}
				});
			};

			Slick.prototype.preventDefault = function (event) {

				event.preventDefault();
			};

			Slick.prototype.progressiveLazyLoad = function (tryCount) {

				tryCount = tryCount || 1;

				var _ = this,
				    $imgsToLoad = $('img[data-lazy]', _.$slider),
				    image,
				    imageSource,
				    imageSrcSet,
				    imageSizes,
				    imageToLoad;

				if ($imgsToLoad.length) {

					image = $imgsToLoad.first();
					imageSource = image.attr('data-lazy');
					imageSrcSet = image.attr('data-srcset');
					imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
					imageToLoad = document.createElement('img');

					imageToLoad.onload = function () {

						if (imageSrcSet) {
							image.attr('srcset', imageSrcSet);

							if (imageSizes) {
								image.attr('sizes', imageSizes);
							}
						}

						image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');

						if (_.options.adaptiveHeight === true) {
							_.setPosition();
						}

						_.$slider.trigger('lazyLoaded', [_, image, imageSource]);
						_.progressiveLazyLoad();
					};

					imageToLoad.onerror = function () {

						if (tryCount < 3) {

							/**
        * try to load the image 3 times,
        * leave a slight delay so we don't get
        * servers blocking the request.
        */
							setTimeout(function () {
								_.progressiveLazyLoad(tryCount + 1);
							}, 500);
						} else {

							image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

							_.$slider.trigger('lazyLoadError', [_, image, imageSource]);

							_.progressiveLazyLoad();
						}
					};

					imageToLoad.src = imageSource;
				} else {

					_.$slider.trigger('allImagesLoaded', [_]);
				}
			};

			Slick.prototype.refresh = function (initializing) {

				var _ = this,
				    currentSlide,
				    lastVisibleIndex;

				lastVisibleIndex = _.slideCount - _.options.slidesToShow;

				// in non-infinite sliders, we don't want to go past the
				// last visible index.
				if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
					_.currentSlide = lastVisibleIndex;
				}

				// if less slides than to show, go to start.
				if (_.slideCount <= _.options.slidesToShow) {
					_.currentSlide = 0;
				}

				currentSlide = _.currentSlide;

				_.destroy(true);

				$.extend(_, _.initials, { currentSlide: currentSlide });

				_.init();

				if (!initializing) {

					_.changeSlide({
						data: {
							message: 'index',
							index: currentSlide
						}
					}, false);
				}
			};

			Slick.prototype.registerBreakpoints = function () {

				var _ = this,
				    breakpoint,
				    currentBreakpoint,
				    l,
				    responsiveSettings = _.options.responsive || null;

				if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

					_.respondTo = _.options.respondTo || 'window';

					for (breakpoint in responsiveSettings) {

						l = _.breakpoints.length - 1;

						if (responsiveSettings.hasOwnProperty(breakpoint)) {
							currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

							// loop through the breakpoints and cut out any existing
							// ones with the same breakpoint number, we don't want dupes.
							while (l >= 0) {
								if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
									_.breakpoints.splice(l, 1);
								}
								l--;
							}

							_.breakpoints.push(currentBreakpoint);
							_.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
						}
					}

					_.breakpoints.sort(function (a, b) {
						return _.options.mobileFirst ? a - b : b - a;
					});
				}
			};

			Slick.prototype.reinit = function () {

				var _ = this;

				_.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

				_.slideCount = _.$slides.length;

				if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
					_.currentSlide = _.currentSlide - _.options.slidesToScroll;
				}

				if (_.slideCount <= _.options.slidesToShow) {
					_.currentSlide = 0;
				}

				_.registerBreakpoints();

				_.setProps();
				_.setupInfinite();
				_.buildArrows();
				_.updateArrows();
				_.initArrowEvents();
				_.buildDots();
				_.updateDots();
				_.initDotEvents();
				_.cleanUpSlideEvents();
				_.initSlideEvents();

				_.checkResponsive(false, true);

				if (_.options.focusOnSelect === true) {
					$(_.$slideTrack).children().on('click.slick', _.selectHandler);
				}

				_.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

				_.setPosition();
				_.focusHandler();

				_.paused = !_.options.autoplay;
				_.autoPlay();

				_.$slider.trigger('reInit', [_]);
			};

			Slick.prototype.resize = function () {

				var _ = this;

				if ($(window).width() !== _.windowWidth) {
					clearTimeout(_.windowDelay);
					_.windowDelay = window.setTimeout(function () {
						_.windowWidth = $(window).width();
						_.checkResponsive();
						if (!_.unslicked) {
							_.setPosition();
						}
					}, 50);
				}
			};

			Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

				var _ = this;

				if (typeof index === 'boolean') {
					removeBefore = index;
					index = removeBefore === true ? 0 : _.slideCount - 1;
				} else {
					index = removeBefore === true ? --index : index;
				}

				if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
					return false;
				}

				_.unload();

				if (removeAll === true) {
					_.$slideTrack.children().remove();
				} else {
					_.$slideTrack.children(this.options.slide).eq(index).remove();
				}

				_.$slides = _.$slideTrack.children(this.options.slide);

				_.$slideTrack.children(this.options.slide).detach();

				_.$slideTrack.append(_.$slides);

				_.$slidesCache = _.$slides;

				_.reinit();
			};

			Slick.prototype.setCSS = function (position) {

				var _ = this,
				    positionProps = {},
				    x,
				    y;

				if (_.options.rtl === true) {
					position = -position;
				}
				x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
				y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

				positionProps[_.positionProp] = position;

				if (_.transformsEnabled === false) {
					_.$slideTrack.css(positionProps);
				} else {
					positionProps = {};
					if (_.cssTransitions === false) {
						positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
						_.$slideTrack.css(positionProps);
					} else {
						positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
						_.$slideTrack.css(positionProps);
					}
				}
			};

			Slick.prototype.setDimensions = function () {

				var _ = this;

				if (_.options.vertical === false) {
					if (_.options.centerMode === true) {
						_.$list.css({
							padding: '0px ' + _.options.centerPadding
						});
					}
				} else {
					_.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
					if (_.options.centerMode === true) {
						_.$list.css({
							padding: _.options.centerPadding + ' 0px'
						});
					}
				}

				_.listWidth = _.$list.width();
				_.listHeight = _.$list.height();

				if (_.options.vertical === false && _.options.variableWidth === false) {
					_.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
					_.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
				} else if (_.options.variableWidth === true) {
					_.$slideTrack.width(5000 * _.slideCount);
				} else {
					_.slideWidth = Math.ceil(_.listWidth);
					_.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
				}

				var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
				if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
			};

			Slick.prototype.setFade = function () {

				var _ = this,
				    targetLeft;

				_.$slides.each(function (index, element) {
					targetLeft = _.slideWidth * index * -1;
					if (_.options.rtl === true) {
						$(element).css({
							position: 'relative',
							right: targetLeft,
							top: 0,
							zIndex: _.options.zIndex - 2,
							opacity: 0
						});
					} else {
						$(element).css({
							position: 'relative',
							left: targetLeft,
							top: 0,
							zIndex: _.options.zIndex - 2,
							opacity: 0
						});
					}
				});

				_.$slides.eq(_.currentSlide).css({
					zIndex: _.options.zIndex - 1,
					opacity: 1
				});
			};

			Slick.prototype.setHeight = function () {

				var _ = this;

				if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
					var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
					_.$list.css('height', targetHeight);
				}
			};

			Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

				/**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */

				var _ = this,
				    l,
				    item,
				    option,
				    value,
				    refresh = false,
				    type;

				if ($.type(arguments[0]) === 'object') {

					option = arguments[0];
					refresh = arguments[1];
					type = 'multiple';
				} else if ($.type(arguments[0]) === 'string') {

					option = arguments[0];
					value = arguments[1];
					refresh = arguments[2];

					if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

						type = 'responsive';
					} else if (typeof arguments[1] !== 'undefined') {

						type = 'single';
					}
				}

				if (type === 'single') {

					_.options[option] = value;
				} else if (type === 'multiple') {

					$.each(option, function (opt, val) {

						_.options[opt] = val;
					});
				} else if (type === 'responsive') {

					for (item in value) {

						if ($.type(_.options.responsive) !== 'array') {

							_.options.responsive = [value[item]];
						} else {

							l = _.options.responsive.length - 1;

							// loop through the responsive object and splice out duplicates.
							while (l >= 0) {

								if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

									_.options.responsive.splice(l, 1);
								}

								l--;
							}

							_.options.responsive.push(value[item]);
						}
					}
				}

				if (refresh) {

					_.unload();
					_.reinit();
				}
			};

			Slick.prototype.setPosition = function () {

				var _ = this;

				_.setDimensions();

				_.setHeight();

				if (_.options.fade === false) {
					_.setCSS(_.getLeft(_.currentSlide));
				} else {
					_.setFade();
				}

				_.$slider.trigger('setPosition', [_]);
			};

			Slick.prototype.setProps = function () {

				var _ = this,
				    bodyStyle = document.body.style;

				_.positionProp = _.options.vertical === true ? 'top' : 'left';

				if (_.positionProp === 'top') {
					_.$slider.addClass('slick-vertical');
				} else {
					_.$slider.removeClass('slick-vertical');
				}

				if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
					if (_.options.useCSS === true) {
						_.cssTransitions = true;
					}
				}

				if (_.options.fade) {
					if (typeof _.options.zIndex === 'number') {
						if (_.options.zIndex < 3) {
							_.options.zIndex = 3;
						}
					} else {
						_.options.zIndex = _.defaults.zIndex;
					}
				}

				if (bodyStyle.OTransform !== undefined) {
					_.animType = 'OTransform';
					_.transformType = '-o-transform';
					_.transitionType = 'OTransition';
					if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
				}
				if (bodyStyle.MozTransform !== undefined) {
					_.animType = 'MozTransform';
					_.transformType = '-moz-transform';
					_.transitionType = 'MozTransition';
					if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
				}
				if (bodyStyle.webkitTransform !== undefined) {
					_.animType = 'webkitTransform';
					_.transformType = '-webkit-transform';
					_.transitionType = 'webkitTransition';
					if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
				}
				if (bodyStyle.msTransform !== undefined) {
					_.animType = 'msTransform';
					_.transformType = '-ms-transform';
					_.transitionType = 'msTransition';
					if (bodyStyle.msTransform === undefined) _.animType = false;
				}
				if (bodyStyle.transform !== undefined && _.animType !== false) {
					_.animType = 'transform';
					_.transformType = 'transform';
					_.transitionType = 'transition';
				}
				_.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
			};

			Slick.prototype.setSlideClasses = function (index) {

				var _ = this,
				    centerOffset,
				    allSlides,
				    indexOffset,
				    remainder;

				allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

				_.$slides.eq(index).addClass('slick-current');

				if (_.options.centerMode === true) {

					var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

					centerOffset = Math.floor(_.options.slidesToShow / 2);

					if (_.options.infinite === true) {

						if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
							_.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
						} else {

							indexOffset = _.options.slidesToShow + index;
							allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
						}

						if (index === 0) {

							allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
						} else if (index === _.slideCount - 1) {

							allSlides.eq(_.options.slidesToShow).addClass('slick-center');
						}
					}

					_.$slides.eq(index).addClass('slick-center');
				} else {

					if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

						_.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
					} else if (allSlides.length <= _.options.slidesToShow) {

						allSlides.addClass('slick-active').attr('aria-hidden', 'false');
					} else {

						remainder = _.slideCount % _.options.slidesToShow;
						indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

						if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

							allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
						} else {

							allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
						}
					}
				}

				if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
					_.lazyLoad();
				}
			};

			Slick.prototype.setupInfinite = function () {

				var _ = this,
				    i,
				    slideIndex,
				    infiniteCount;

				if (_.options.fade === true) {
					_.options.centerMode = false;
				}

				if (_.options.infinite === true && _.options.fade === false) {

					slideIndex = null;

					if (_.slideCount > _.options.slidesToShow) {

						if (_.options.centerMode === true) {
							infiniteCount = _.options.slidesToShow + 1;
						} else {
							infiniteCount = _.options.slidesToShow;
						}

						for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
							slideIndex = i - 1;
							$(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
						}
						for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
							slideIndex = i;
							$(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
						}
						_.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
							$(this).attr('id', '');
						});
					}
				}
			};

			Slick.prototype.interrupt = function (toggle) {

				var _ = this;

				if (!toggle) {
					_.autoPlay();
				}
				_.interrupted = toggle;
			};

			Slick.prototype.selectHandler = function (event) {

				var _ = this;

				var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

				var index = parseInt(targetElement.attr('data-slick-index'));

				if (!index) index = 0;

				if (_.slideCount <= _.options.slidesToShow) {

					_.slideHandler(index, false, true);
					return;
				}

				_.slideHandler(index);
			};

			Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

				var targetSlide,
				    animSlide,
				    oldSlide,
				    slideLeft,
				    targetLeft = null,
				    _ = this,
				    navTarget;

				sync = sync || false;

				if (_.animating === true && _.options.waitForAnimate === true) {
					return;
				}

				if (_.options.fade === true && _.currentSlide === index) {
					return;
				}

				if (sync === false) {
					_.asNavFor(index);
				}

				targetSlide = index;
				targetLeft = _.getLeft(targetSlide);
				slideLeft = _.getLeft(_.currentSlide);

				_.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

				if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
					if (_.options.fade === false) {
						targetSlide = _.currentSlide;
						if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
							_.animateSlide(slideLeft, function () {
								_.postSlide(targetSlide);
							});
						} else {
							_.postSlide(targetSlide);
						}
					}
					return;
				} else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
					if (_.options.fade === false) {
						targetSlide = _.currentSlide;
						if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
							_.animateSlide(slideLeft, function () {
								_.postSlide(targetSlide);
							});
						} else {
							_.postSlide(targetSlide);
						}
					}
					return;
				}

				if (_.options.autoplay) {
					clearInterval(_.autoPlayTimer);
				}

				if (targetSlide < 0) {
					if (_.slideCount % _.options.slidesToScroll !== 0) {
						animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
					} else {
						animSlide = _.slideCount + targetSlide;
					}
				} else if (targetSlide >= _.slideCount) {
					if (_.slideCount % _.options.slidesToScroll !== 0) {
						animSlide = 0;
					} else {
						animSlide = targetSlide - _.slideCount;
					}
				} else {
					animSlide = targetSlide;
				}

				_.animating = true;

				_.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

				oldSlide = _.currentSlide;
				_.currentSlide = animSlide;

				_.setSlideClasses(_.currentSlide);

				if (_.options.asNavFor) {

					navTarget = _.getNavTarget();
					navTarget = navTarget.slick('getSlick');

					if (navTarget.slideCount <= navTarget.options.slidesToShow) {
						navTarget.setSlideClasses(_.currentSlide);
					}
				}

				_.updateDots();
				_.updateArrows();

				if (_.options.fade === true) {
					if (dontAnimate !== true) {

						_.fadeSlideOut(oldSlide);

						_.fadeSlide(animSlide, function () {
							_.postSlide(animSlide);
						});
					} else {
						_.postSlide(animSlide);
					}
					_.animateHeight();
					return;
				}

				if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
					_.animateSlide(targetLeft, function () {
						_.postSlide(animSlide);
					});
				} else {
					_.postSlide(animSlide);
				}
			};

			Slick.prototype.startLoad = function () {

				var _ = this;

				if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

					_.$prevArrow.hide();
					_.$nextArrow.hide();
				}

				if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

					_.$dots.hide();
				}

				_.$slider.addClass('slick-loading');
			};

			Slick.prototype.swipeDirection = function () {

				var xDist,
				    yDist,
				    r,
				    swipeAngle,
				    _ = this;

				xDist = _.touchObject.startX - _.touchObject.curX;
				yDist = _.touchObject.startY - _.touchObject.curY;
				r = Math.atan2(yDist, xDist);

				swipeAngle = Math.round(r * 180 / Math.PI);
				if (swipeAngle < 0) {
					swipeAngle = 360 - Math.abs(swipeAngle);
				}

				if (swipeAngle <= 45 && swipeAngle >= 0) {
					return _.options.rtl === false ? 'left' : 'right';
				}
				if (swipeAngle <= 360 && swipeAngle >= 315) {
					return _.options.rtl === false ? 'left' : 'right';
				}
				if (swipeAngle >= 135 && swipeAngle <= 225) {
					return _.options.rtl === false ? 'right' : 'left';
				}
				if (_.options.verticalSwiping === true) {
					if (swipeAngle >= 35 && swipeAngle <= 135) {
						return 'down';
					} else {
						return 'up';
					}
				}

				return 'vertical';
			};

			Slick.prototype.swipeEnd = function (event) {

				var _ = this,
				    slideCount,
				    direction;

				_.dragging = false;
				_.swiping = false;

				if (_.scrolling) {
					_.scrolling = false;
					return false;
				}

				_.interrupted = false;
				_.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

				if (_.touchObject.curX === undefined) {
					return false;
				}

				if (_.touchObject.edgeHit === true) {
					_.$slider.trigger('edge', [_, _.swipeDirection()]);
				}

				if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

					direction = _.swipeDirection();

					switch (direction) {

						case 'left':
						case 'down':

							slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

							_.currentDirection = 0;

							break;

						case 'right':
						case 'up':

							slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

							_.currentDirection = 1;

							break;

						default:

					}

					if (direction != 'vertical') {

						_.slideHandler(slideCount);
						_.touchObject = {};
						_.$slider.trigger('swipe', [_, direction]);
					}
				} else {

					if (_.touchObject.startX !== _.touchObject.curX) {

						_.slideHandler(_.currentSlide);
						_.touchObject = {};
					}
				}
			};

			Slick.prototype.swipeHandler = function (event) {

				var _ = this;

				if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
					return;
				} else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
					return;
				}

				_.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

				_.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

				if (_.options.verticalSwiping === true) {
					_.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
				}

				switch (event.data.action) {

					case 'start':
						_.swipeStart(event);
						break;

					case 'move':
						_.swipeMove(event);
						break;

					case 'end':
						_.swipeEnd(event);
						break;

				}
			};

			Slick.prototype.swipeMove = function (event) {

				var _ = this,
				    edgeWasHit = false,
				    curLeft,
				    swipeDirection,
				    swipeLength,
				    positionOffset,
				    touches,
				    verticalSwipeLength;

				touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

				if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
					return false;
				}

				curLeft = _.getLeft(_.currentSlide);

				_.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
				_.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

				_.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

				verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

				if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
					_.scrolling = true;
					return false;
				}

				if (_.options.verticalSwiping === true) {
					_.touchObject.swipeLength = verticalSwipeLength;
				}

				swipeDirection = _.swipeDirection();

				if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
					_.swiping = true;
					event.preventDefault();
				}

				positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
				if (_.options.verticalSwiping === true) {
					positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
				}

				swipeLength = _.touchObject.swipeLength;

				_.touchObject.edgeHit = false;

				if (_.options.infinite === false) {
					if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
						swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
						_.touchObject.edgeHit = true;
					}
				}

				if (_.options.vertical === false) {
					_.swipeLeft = curLeft + swipeLength * positionOffset;
				} else {
					_.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
				}
				if (_.options.verticalSwiping === true) {
					_.swipeLeft = curLeft + swipeLength * positionOffset;
				}

				if (_.options.fade === true || _.options.touchMove === false) {
					return false;
				}

				if (_.animating === true) {
					_.swipeLeft = null;
					return false;
				}

				_.setCSS(_.swipeLeft);
			};

			Slick.prototype.swipeStart = function (event) {

				var _ = this,
				    touches;

				_.interrupted = true;

				if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
					_.touchObject = {};
					return false;
				}

				if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
					touches = event.originalEvent.touches[0];
				}

				_.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
				_.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

				_.dragging = true;
			};

			Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

				var _ = this;

				if (_.$slidesCache !== null) {

					_.unload();

					_.$slideTrack.children(this.options.slide).detach();

					_.$slidesCache.appendTo(_.$slideTrack);

					_.reinit();
				}
			};

			Slick.prototype.unload = function () {

				var _ = this;

				$('.slick-cloned', _.$slider).remove();

				if (_.$dots) {
					_.$dots.remove();
				}

				if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
					_.$prevArrow.remove();
				}

				if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
					_.$nextArrow.remove();
				}

				_.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
			};

			Slick.prototype.unslick = function (fromBreakpoint) {

				var _ = this;
				_.$slider.trigger('unslick', [_, fromBreakpoint]);
				_.destroy();
			};

			Slick.prototype.updateArrows = function () {

				var _ = this,
				    centerOffset;

				centerOffset = Math.floor(_.options.slidesToShow / 2);

				if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

					_.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
					_.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

					if (_.currentSlide === 0) {

						_.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
						_.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
					} else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

						_.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
						_.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
					} else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

						_.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
						_.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
					}
				}
			};

			Slick.prototype.updateDots = function () {

				var _ = this;

				if (_.$dots !== null) {

					_.$dots.find('li').removeClass('slick-active').end();

					_.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
				}
			};

			Slick.prototype.visibility = function () {

				var _ = this;

				if (_.options.autoplay) {

					if (document[_.hidden]) {

						_.interrupted = true;
					} else {

						_.interrupted = false;
					}
				}
			};

			$.fn.slick = function () {
				var _ = this,
				    opt = arguments[0],
				    args = Array.prototype.slice.call(arguments, 1),
				    l = _.length,
				    i,
				    ret;
				for (i = 0; i < l; i++) {
					if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
					if (typeof ret != 'undefined') return ret;
				}
				return _;
			};
		});
	}, { "jquery": 23 }] }, {}, [2]);